{
  "Linecker.Portal.Service.AuthenticationService.LearningSuite.NoOnboardingCoursesAvailableError": "Für deine Standorte sind keine Onboarding-Kurse verfügbar.",
  "Linecker.Portal.Service.AuthenticationService.LearningSuite.LineckerEmployeeSsoNotAllowedError": "Linecker-Mitarbeiter melden sich bei der Onboarding-Plattform mit ihrem eigenen Passwort an, nicht über das Lipp Portal.",
  "Linecker.Portal.Service.AuthenticationService.LearningSuite.TestAccountsOnlyOutsideProductionError": "In dieser Testumgebung ist die Anmeldung bei der Onboarding-Plattform nur mit Testkonten (@linecker.at, @lipp.cloud) möglich.",
  "Linecker.Portal.Service.AuthenticationService.Oidc.OidcInvalidAuthorizationRequestError": "Die Anmeldeanfrage ist ungültig.",
  "Linecker.Portal.Service.AuthenticationService.Oidc.Mcp.McpInvalidAuthorizationRequestError": "Die Anfrage der KI-Anwendung ist ungültig oder abgelaufen. Bitte starte die Verbindung in der Anwendung neu.",
  "Linecker.Portal.Service.AuthenticationService.Oidc.Mcp.McpConnectedAppNotFoundError": "Diese Verbindung gibt es nicht mehr.",
  "Linecker.Shared.Abstractions.Result.Messages.GenericExceptionError": "Etwas ist schiefgelaufen.",
  "Linecker.Shared.Abstractions.Result.Messages.Portal.Permissions.UserNotPermittedToAccessEnterpriseError": "Der Benutzer hat keine Berechtigung, um auf den Betrieb {0} zuzugreifen.",
  "Linecker.Shared.Abstractions.Result.Messages.Permissions.NotPermittedError": "Der Benutzer hat keine Berechtigung für diese Aktion!",
  "Linecker.Lipp.Connect.POS.SystemManagement.Messages.ErrorMessages.CannotDeactivateLastActiveVoucherTypeError": "Die letzte aktive Gutscheinart kann nicht deaktiviert werden.",
  "Lipp.Abstractions.Messages.NoFreeIntegrationSlotsMessage": "An keinem Grundabo der Station ist ein Integrations-Slot frei.",
  "Lipp.Abstractions.Messages.NoFreeExtensionSlotsMessage": "An keinem Grundabo der Station ist ein Erweiterungs-Slot frei.",
  "Lipp.Abstractions.Messages.ModuleFamilyMismatchMessage": "Dieses Modul gehört zu einem anderen Grundabo.",
  "Lipp.Abstractions.Messages.ModuleKindMismatchMessage": "Dieses Modul passt nicht zu dieser Slot-Art.",
  "Lipp.Abstractions.Messages.IntegrationSlotsInUseMessage": "{0} Slots sind belegt, gewünscht sind {1}. Zuerst Integrationen freigeben.",
  "Lipp.Abstractions.Messages.ExtensionSlotsInUseMessage": "{0} Erweiterungs-Slots sind belegt, gewünscht sind {1}.",
  "Lipp.Abstractions.Messages.PmsActiveRoomsExceedMessage": "Im PMS sind {0} Zimmer aktiv. Bitte zuerst dort Zimmer stilllegen, dann auf {1} senken.",
  "Lipp.Abstractions.Messages.PmsDashboardInvalidRequestMessage": "Die Anfrage an das PMS-Dashboard ist ungültig.",
  "Lipp.Abstractions.Messages.PmsUnreachableMessage": "Das PMS ist gerade nicht erreichbar, die Zimmerzahl kann deshalb nicht gesenkt werden.",
  "Lipp.Abstractions.Messages.StationNotFoundMessage": "Der Standort mit der ID {0} wurde nicht gefunden.",
  "Lipp.Abstractions.Messages.SubscriptionNotFoundMessage": "Das Abo für Standort {0} und Modul \"{1}\" wurde nicht gefunden.",
  "Lipp.Abstractions.Messages.TooManyPreparedLippPOSMessage": "Der Standort {0} hat bereits die maximale Anzahl vorbereiteter Abos (eines pro Laufzeitgruppe).",
  "Messages": {
    "HttpError": {
      "0": "Es konnte keine Verbindung hergestellt werden.",
      "204": "[204] No Content",
      "400": "[400] Bad Request",
      "401": "[401] Unauthorized",
      "403": "[403] Forbidden",
      "404": "[404] Not Found",
      "405": "[405] Method not allowed",
      "408": "[408] Request Timeout",
      "415": "[415] Unsupported Media Type",
      "499": "[499] Client Closed Request",
      "500": "[500] Internal Server Error",
      "502": "[502] Bad Gateway",
      "503": "[503] Service Unavailable",
      "504": "[504] Gateway Timeout"
    },
    "CustomError": {
      "NoModuleSubscribed": "Kein Modul ist abonniert.",
      "GzipFailed": "Die Gzip Methode ist fehlgeschlagen.",
      "UngzipFailed": "Die Ungzip Methode ist fehlgeschlagen.",
      "NoUserLoggedIn": "Kein Benutzer ist angemeldet.",
      "SelectedStationIdNotSet": "SelectedStationId ist nicht gesetzt.",
      "NoRoomPlanSettingsFound": "Keine Zimmerplan-Einstellungen gefunden.",
      "UnknownError": "Etwas ist schiefgelaufen."
    },
    "GraphQL": {
      "Workstation": {
        "NumberTaken": "Nummer bereits vergeben."
      },
      "User": {
        "PinTaken": "Code bereits vergeben.",
        "NotFoundById": "Benutzer konnte nicht gefunden werden.",
        "NoUsersFound": "Keine Benutzer gefunden."
      },
      "MailAccount": {
        "CannotFindKeyOrSalt": "Key oder Salt zum Verschlüsseln des Passworts konnte nicht gefunden werden.",
        "NotFoundById": "E-Mail Konto konnte nicht gefunden werden."
      },
      "MailTemplate": {
        "NotFoundById": "E-Mail Vorlage konnte nicht gefunden werden."
      },
      "Department": {
        "NotFoundById": "Abteilung konnte nicht gefunden werden.",
        "NoDepartmentsFound": "Keine Abteilungen gefunden."
      },
      "Setting": {
        "NotFoundById": "Einstellung konnte nicht gefunden werden.",
        "DefaultSettingNotFound": "Standard-Einstellung konnte nicht gefunden werden."
      },
      "BookingCancellationReason": {
        "NotFoundById": "Stornogrund konnte nicht gefunden werden.",
        "DefaultSettingNotFound": "Einstellung des Standard-Stornogrunds konnte nicht gefunden werden.",
        "NoCancellationReasonsFound": "Keine Stornogründe gefunden."
      },
      "Course": {
        "NotFoundById": "Gang konnte nicht gefunden werden.",
        "NoCoursesFound": "Keine Gänge gefunden."
      },
      "Table": {
        "NotFoundById": "Tisch konnte nicht gefunden werden.",
        "NumberTaken": "Nummer bereits vergeben.",
        "RetailDepartmentNotFound": "Handels-Abteilung konnte nicht gefunden werden.",
        "HasOpenBookings": "Der Tisch \"{0}\" hat offene Buchungen und kann nicht zum Fassungstisch werden. Bitte zuerst abrechnen.",
        "HasOpenRequisition": "Auf dem Fassungstisch \"{0}\" liegt eine offene Fassung. Bitte zuerst erstellen oder leeren."
      },
      "PaymentMethod": {
        "NotFoundById": "Zahlungsmethode konnte nicht gefunden werden."
      },
      "Macro": {
        "NotFoundById": "Makro konnte nicht gefunden werden.",
        "NoMacrosFound": "Keine Makros gefunden.",
        "AssignmentsNotSupported": "Die Zuweisung zu Umsatz-, Warengruppen und Artikeln braucht Lipp POS {0} oder neuer."
      },
      "NumberRange": {
        "NotFoundById": "Nummernkreis konnte nicht gefunden werden."
      },
      "Customer": {
        "NotFoundById": "Kunde konnte nicht gefunden werden.",
        "NumberRangeNotFound": "Nummernkreis der Kunden konnte nicht gefunden werden.",
        "ProfileImageNotFound": "Bild konnte nicht gefunden werden."
      },
      "CommodityGroup": {
        "NotFoundById": "Warengruppe konnte nicht gefunden werden.",
        "NoCommodityGroupsFound": "Keine Warengruppen gefunden.",
        "ArticlesStillAssigned": "Deaktivieren nicht möglich. Der Warengruppe sind noch Artikel zugeordnet.",
        "CannotDeactivateTipOrDiscount": "Deaktivieren nicht möglich. Die Warengruppe wird für Trinkgeld bzw. Ermäßigung benötigt."
      },
      "CommunicationService": {
        "NotFoundById": "Kommunikationsserver konnte nicht gefunden werden."
      },
      "Article": {
        "NotFoundById": "Artikel konnte nicht gefunden werden.",
        "NumberTaken": "Art.-Nr. bereits vergeben.",
        "BarcodeTaken": "Barcode {0} bereits vergeben.",
        "PricelistNotFound": "Preisliste für den Artikel konnte nicht gefunden werden.",
        "DefaultPricelistNotFound": "Standard-Preisliste konnte nicht gefunden werden.",
        "AssignedCommodityGroupNotActive": "Aktivieren nicht möglich. Die zugeordnete Warengruppe {0} ist inaktiv.",
        "CannotDeactivateTipOrDiscount": "Deaktivieren nicht möglich. Der Artikel wird für Trinkgeld bzw. Ermäßigung benötigt.",
        "WeightTareNegative": "Die Tara eines Gewichtsartikels darf nicht negativ sein.",
        "WeightArticleInPackage": "Der Artikel steckt im Artikelpaket {0} und kann deshalb nicht nach Gewicht verkauft werden. Bitte zuerst aus dem Paket entfernen."
      },
      "Printer": {
        "NotFoundById": "Drucker konnte nicht gefunden werden.",
        "NoPrintersFound": "Keine Drucker gefunden.",
        "ArticlesStillAssigned": "Löschen nicht möglich. Dem Drucker sind noch Artikel zugeordnet.",
        "WorkstationsStillAssigned": "Löschen nicht möglich. Dem Drucker sind noch Arbeitsstationen zugeordnet.",
        "PrinterRedirectionsStillAssigned": "Löschen nicht möglich. Dem Drucker sind noch Druckumleitungen oder zusätzliche Drucke zugeordnet."
      },
      "Interface": {
        "NotFoundById": "Integration konnte nicht gefunden werden.",
        "NotFoundByName": "Integration konnte nicht gefunden werden.",
        "NoComSvcAssigned": "Es wurde noch kein Kommunikationsserver zugewiesen.",
        "ComPortTaken": "COM-Port {0} wird bereits von der aktiven Integration '{1}' verwendet."
      },
      "InterfaceSetting": {
        "NotFoundById": "Einstellung konnte nicht gefunden werden."
      },
      "PermissionRole": {
        "NotFoundById": "Berechtigungsrolle konnte nicht gefunden werden.",
        "UsersStillAssigned": "Löschen nicht möglich. Der Berechtigungsrolle sind noch Benutzer zugeordnet."
      },
      "CrossStation": {
        "NotWritten": "Nicht geschrieben, weil ein anderer Standort gescheitert ist.",
        "InvalidRequest": "Es muss genau ein Artikel zum Anlegen oder Bearbeiten übergeben werden.",
        "NumberMissing": "Bitte eine Artikelnummer angeben.",
        "ArticleNotInAllStations": "Artikel {0} ist nicht in allen Standorten gleich vorhanden ({1}).",
        "NoDefaultPricelist": "In {0} gibt es keine aktive Standard-Preisliste.",
        "NumberTaken": "Die Artikelnummer {0} ist in {1} bereits vergeben.",
        "BarcodeTaken": "Der Barcode {0} ist in {1} bereits vergeben.",
        "WeightArticleInPackage": "Artikel {0} ist in {1} Bestandteil eines Pakets und kann dort nicht nach Gewicht verkauft werden.",
        "PackagePartIsWeightArticle": "Artikel {0} wird in {1} nach Gewicht verkauft und kann dort kein Paketbestandteil sein.",
        "DefaultPriceMissing": "Artikel {0} hat in {1} keinen Preis in der Standard-Preisliste.",
        "ImageMissing": "Zum Artikel {0} fehlt in {1} die Bilddatei.",
        "CommodityGroupMissing": "Die Warengruppe {0} gibt es in {1} nicht (oder nicht eindeutig mit diesem Steuersatz und dieser Umsatzgruppe).",
        "CommodityGroupInactive": "In {0} ist die Warengruppe {1} inaktiv; der Artikel lässt sich dort nicht aktivieren.",
        "PackageGroupLocked": "In {0} enthält die Auswahlgruppe \"{1}\" den Bestandteil \"{2}\", den es nicht in allen Standorten gibt. Die Gruppe kann deshalb nicht entfernt oder umbenannt werden.",
        "FullSyncRunning": "In {0} läuft gerade ein Vollabgleich der Kassa; Stammdaten sind dort bis zu seinem Ende gesperrt.",
        "ArticleMissing": "Den Artikel gibt es in {0} nicht (mehr).",
        "NumberDuplicate": "Die Artikelnummer {0} ist in {1} mehrfach vergeben.",
        "NoStations": "Es wurde kein Standort ausgewählt.",
        "PosVersionTooOld": "Betriebsübergreifend lassen sich nur Standorte ab Lipp POS {0} bearbeiten: {1}.",
        "LayoutProfileMissing": "Die Layoutgruppe gibt es in {0} nicht (mehr).",
        "LayoutProfileMissingOrDuplicate": "Die Layoutgruppe \"{0}\" gibt es in {1} nicht (oder mehrfach).",
        "LayoutProfileNameMissing": "Die Layoutgruppe braucht einen Namen.",
        "LayoutProfileDuplicate": "Die Layoutgruppe \"{0}\" gibt es in {1} mehrfach.",
        "LayoutProfileExists": "Die Layoutgruppe \"{0}\" gibt es schon in allen gewählten Standorten."
      },
      "CrossStationUsers": {
        "UserMissing": "Den Benutzer {0} gibt es an den gewählten Standorten nicht (mehr).",
        "NameNotUnique": "Den Benutzer {0} gibt es in {1} mehrfach. Bitte dort zuerst einen davon umbenennen.",
        "PermissionRoleMissing": "Die Berechtigungsrolle gibt es in {0} nicht (mehr). Bitte eine andere wählen.",
        "PinTaken": "Die PIN von {0} ist in {1} schon an einen anderen Benutzer vergeben. Bitte {0} dort auf der Seite des Standorts mit einer anderen PIN anlegen.",
        "InvalidRequest": "Ein Standort der Zuweisung ist nicht ausgewählt. Bitte neu laden."
      },
      "LayoutProfile": {
        "NotFoundById": "Die Layoutgruppe wurde nicht gefunden.",
        "WorkstationsStillAssigned": "Layoutgruppe '{0}' kann nicht gelöscht werden, weil sie noch folgenden Workstations zugewiesen ist: {1}. Bitte zuerst eine andere Layoutgruppe in der Workstation hinterlegen.",
        "UsersStillAssigned": "Layoutgruppe '{0}' kann nicht gelöscht werden, weil sie noch folgenden Benutzern zugewiesen ist: {1}.",
        "CannotDeleteLast": "Die letzte Layoutgruppe kann nicht gelöscht werden. Es muss mindestens eine Layoutgruppe vorhanden sein."
      },
      "PriceList": {
        "NotFoundById": "Preisliste konnte nicht gefunden werden.",
        "PricesStillAssigned": "Löschen nicht möglich. Der Preisliste sind noch Preise zugeordnet."
      },
      "BookingLock": {
        "NotFoundById": "Buchungssperre konnte nicht gefunden werden.",
        "UsersStillAssigned": "Löschen nicht möglich. Der Buchungssperre sind noch Benutzer zugeordnet."
      },
      "Team": {
        "NotFoundById": "Team konnte nicht gefunden werden.",
        "UsersStillAssigned": "Löschen nicht möglich. Dem Team sind noch Benutzer zugeordnet."
      }
    },
    "Authentication": {
      "ResetPasswordEmailSent": "E-Mail zum Zurücksetzen des Passworts wurde versendet.",
      "PasswordHasBeenReset": "Dein Passwort wurde erfolgreich geändert.",
      "InterfaceUserStationNotFoundError": "Der Standort mit dem Code {0} wurde nicht gefunden.",
      "NoLoginTokenError": "Für die E-Mail-Adresse {0} wurde kein Login-Token erstellt.",
      "PasswordPolicyRequirementsNotMetError": "Das Passwort erfüllt nicht die Anforderungen: min. 8 Zeichen, Groß- und Kleinbuchstaben, min. 1 Zahl.",
      "UserAlreadyConfirmedError": "Der Benutzer wurde bereits bestätigt.",
      "UserCannotChangePasswordError": "Der Benutzer {0} kann das Passwort nicht ändern.",
      "UserChangePasswordOldPasswordIncorrectError": "Das alte Passwort ist nicht korrekt.",
      "UserConfirmationConfirmationTokenInvalidError": "Der Bestätigungstoken ist nicht gültig.",
      "UserConfirmationNoConfirmationTokenProvidedError": "Es wurde kein Bestätigungstoken übergeben.",
      "UserNotActiveError": "Der Benutzer {0} ist nicht aktiv.",
      "UserNotAllowedToLoginError": "Der Benutzer {0} hat keine Berechtigung, um sich einzuloggen.",
      "UserNotAuthorizedError": "Der Benutzer {0} hat keine Authorisierung, um sich einzuloggen.",
      "UserNotConfirmedError": "Der Benutzer {0} wurde noch nicht bestätigt.",
      "UserNotFoundByLoginNameError": "Es wurde kein Benutzer mit der E-Mail-Adresse {0} gefunden.",
      "UserNotInterfaceUserForStation": "Dieser Benutzer ist kein Schnittstellenbenutzer.",
      "UserResetPasswordNoResetTokenProvidedError": "Es wurde kein Passwort-Resettoken übergeben.",
      "UserResetPasswordResetTokenInvalidError": "Der Passwort-Resettoken ist nicht gültig.",
      "UserRegistered": "Benutzer wurde erfolgreich bestätigt."
    },
    "CoreDataService": {
      "Taxes": {
        "TaxNotFoundByIdError": "Der Steuercode mit der ID {0} wurde nicht gefunden."
      },
      "TextTemplates": {
        "DefaultTextTemplateCannotBeDeletedError": "Die Textvorlage mit der ID {0} kann nicht gelöscht werden, da es sich um eine Standardtextvorlage handelt."
      }
    },
    "InvoicingService": {
      "InvalidCreateInvoiceForStationModuleOrderTokenError": "Der Token ist nicht gültig.",
      "InvalidSetInvoicePdfGenerationStateTokenError": "Der Token ist nicht gültig.",
      "LineckerInvoiceFileNotFoundByLineckerInvoiceFileIdError": "Die PDF-Rechnungsdatei mit der ID {0} konnte nicht gefunden werden.",
      "LineckerInvoiceFileNotYetGeneratedError": "Die PDF-Rechnungsdatei wurde noch nicht erstellt.",
      "LineckerInvoiceHeaderNotFoundByIdError": "Der Rechnungskopf mit der ID {0} konnte nicht gefunden werden.",
      "StationModuleNotFoundByIdError": "Das Standortmodul mit der ID {0} konnte nicht gefunden werden.",
      "StationModuleNotFoundByStationModuleOrderIdError": "<<OBSOLETE>>",
      "StationModuleOrderIsNotReadyForBillingWarning": "<<OBSOLETE>>",
      "LineckerInvoiceHeaderAlreadyFullyCancelledError": "Die Rechnung mit der ID {0} wurde bereits komplett storniert.",
      "LineckerInvoiceHeaderAmountToCancelToBigError": "Der Bruttobetrag zum Stornieren {0} ist zu groß.",
      "CreateCancellationInvoiceNoAssociatedPaymentFoundError": "Es wurde keine zugehörige Zahlung für die Invoice mit der ID {0} gefunden.",
      "LineckerInvoiceHeaderIsCurrentlyExportingToPdfError": "Die Rechnung mit der ID {0} wird derzeit exportiert.",
      "LineckerInvoiceHeaderIsCurrentlyBeingSentPerEmailError": "Die Rechnung mit der ID {0} wird derzeit per E-Mail versendet."
    },
    "LicensingService": {
      "InvalidAddStationModuleTransactionLogTokenError": "Der Token ist nicht gültig.",
      "InvalidSetStationModuleStateTokenError": "Der Token ist nicht gültig.",
      "InvalidSetSubscriptionStateTokenError": "Der Token ist nicht gültig.",
      "StationModuleNotFoundByIdError": "Das Standortmodul mit der ID {0} konnte nicht gefunden werden.",
      "StationModuleOrders.InvalidSetStationModuleOrderStateTokenError": "<<OBSOLETE>>",
      "StationModuleOrders.StationModuleOrderNotFoundByIdError": "<<OBSOLETE>>",
      "SubscriptionPriceLevelDetailNotFoundByIdError": "Das DetailPreismodell mit der ID {0} konnte nicht gefunden werden.",
      "SubscriptionPriceLevelDetailNotInUserSubscriptionPriceLevel": "Das Detailpreismodell mit der ID {0} konnte nicht auf das Benutzer-Detailpreismodell mit der ID {1} zugeordnet werden.",
      "SubscriptionPriceLevelNotFoundByIdError": "Das Preismodell mit der ID {0} konnte nicht gefunden werden.",
      "TrialNotAvailableError": "Für dieses Modul ist entweder keine Testphase verfügbar, oder die Testphase wurde bereits in Anspruch genommen.",
      "ModuleAlreadyActivatedError": "Dieses Modul wurde bereits aktiviert!",
      "StationModulePaymentLandingPageNotFoundError": "Die Seite konnte nicht gefunden werden!",
      "StationModulePaymentLandingPageAlreadyConfirmedError": "Die Zahlung für das Modul wurde bereits bestätigt!",
      "StationModulePaymentLandingPageNotFoundByUrlError": "Die Seite konnte nicht gefunden werden!",
      "StationModulePaymentLandingPageInactiveError": "Die Seite ist nicht mehr aktiv!",
      "NoPaymentMethodsDefinedForEnterpriseError": "Der Betrieb mit der ID {0} und der Stripe Kundennummer {1} hat keine Zahlungsmethoden hinterlegt!",
      "NoPaymentMethodsDefinedForStationIdError": "Der Standort mit der ID {0} hat keine Zahlungsmethoden beim zugehörigen Betrieb hinterlegt!",
      "PaymentMethodNotAvailableError": "Die Zahlungsmethode {0} ist nicht verfügbar. Entweder sie ist abgelaufen oder existiert nicht mehr.",
      "ActivateStationModuleHasPaymentMethodsDefinedError": "Bitte wähle eine Zahlungsmethode aus!",
      "ActivateStationModuleMultipeDTOsDefinedError": "Keine mehrfachen DTOs zulässig!",
      "PaymentMethodExpiredError": "Die Zahlungsmethode ist abgelaufen und kann nicht verwendet werden.",
      "GetFreshdeskCustomerError": "Kunde ist nicht im Freshdesk vorhanden. Bitte kontrollieren!"
    },
    "LippVoucherService": {
      "InitialLippVoucherBookingCannotBeUndoneError": "Die Erstbuchung eines Gutscheins kann nicht gelöscht werden.",
      "InvalidCreateLippVoucherTokenError": "Der Token ist nicht gültig.",
      "InvalidDeactivateLippVoucherTokenError": "Der Token ist nicht gültig.",
      "InvalidGetLippVoucherTokenError": "Der Token ist nicht gültig.",
      "InvalidSetLippVoucherPdfGenerationStatusTokenError": "Der Token ist nicht gültig.",
      "InvalidSetLippVoucherSendStatusTokenError": "Der Token ist nicht gültig.",
      "LippVoucherAlreadyBilledError": "Für den Gutschein wurde bereits eine Rechnung erstellt und kann daher nicht deaktiviert werden.",
      "LippVoucherBlockedByOtherUserError": "Der Gutschein {0} wird aktuell durch einen anderen Benutzer bearbeitet.",
      "LippVoucherBookingIsAlreadyUndoneError": "Die Buchung mit der Transaktions-ID {0} wurde bereits rückgängig gemacht.",
      "LippVoucherBookingNotFoundByIdentifierAndTransactionIdError": "Eine Buchung mit der Gutscheinkennung {0} und der Transaktions-ID {1} konnte nicht gefunden werden.",
      "LippVoucherFileNotFoundByLippVoucherFileIdError": "Die PDF-Gutscheindatei mit der ID {0} konnte nicht gefunden werden.",
      "LippVoucherHasNoRestAmountError": "Der Gutschein {0} hat kein Restguthaben.",
      "LippVoucherInsufficientRestAmountError": "Der Gutschein {0} hat nicht ausreichend Restguthaben.",
      "LippVoucherNotActiveError": "Der Gutschein {0} ist nicht aktiv. Grund: {1}",
      "LippVoucherNotFoundByIdentifierError": "Ein Gutschein mit der Kennung {0} konnte nicht gefunden werden.",
      "LippVoucherNotFoundByIdError": "Ein Gutschein mit der ID {0} konnte nicht gefunden werden.",
      "LippVoucherToCancelIsInactiveError": "Der zu stornierende Gutschein ist inaktiv (Grund: {0}) und kann deshalb nicht storniert werden.",
      "LippVoucherToCancelNotFoundByIdError": "Der zu stornierende Gutschein mit der ID {0} konnte nicht gefunden werden."
    },
    "MessagingService": {
      "BadRequestError": "Der SMS-Versanddienst gab den Fehler 400 - Bad Request zurück.",
      "FromNameTooLongError": "Der SMS-Absendername ist zu lang. Es sind maximal 11 Zeichen möglich."
    },
    "NumberRangeService": {
      "InvalidChangeReservationStateTokenError": "Der Token ist nicht gültig.",
      "InvalidGetNumberWithTokenError": "Der Token ist nicht gültig.",
      "NumberRangeCannotBeDeletedHasDependentDataError": "Der Nummernkreis mit der ID {0} kann nicht gelöscht werden, da noch davon abhängige Daten existieren.",
      "NumberRangeJournalCannotFreeAlreadyFixedError": "Der Nummernkreis-Journaleintrag mit der ID {0} wurde bereits auf Status \"Fixiert\" gestellt und kann deshalb nicht auf Status \"Frei\" gestellt werden."
    },
    "PaymentsService": {
      "InvalidCancelSubscriptionForStationModuleTokenError": "Der Token ist nicht gültig.",
      "NoModulesForPurchaseDefinedError": "Es wurden keine zum Kauf verfügbaren Module definiert.",
      "Stripe": {
        "StationIdAssociatedWithStripeSessionIdNotFoundError": "Die zur Stripe-Sitzung gehörende Standort-ID konnte nicht ermittelt werden.",
        "StripeSessionIdNotFoundError": "Die ID der Stripe-Sitzung konnte nicht ermittelt werden.",
        "NoCustomerIdDefinedInEnterpriseError": "Es wurde keine Stripe Kundennummer für die Betrieb-ID {0} gefunden.",
        "UnknownPaymentMethodError": "Die Zahlungsmethode {0} ist unbekannt bzw. wird nicht unterstützt."
      },
      "CannotSetDefaultPaymentMethodCreditCardExpiresIn30DaysOrLessError": "Standardzahlungsmethode muss noch mind. 30 Tage gültig sein.",
      "NoDefaultPaymentMethodDefinedError": "Es wurde keine Standardzahlungsmethode für den Betrieb mit ID {0} gefunden.",
      "PaymentProviderPaymentMethodNotFoundByIdError": "Die Zahlungsmethode mit ID {0} wurde nicht gefunden für den Zahlungsanbieter {1}.",
      "PaymentProviderPaymentMethodAlreadyExpiredError": "Die Zahlungsmethode mit ID {0} für den Zahlungsanbieter {1} ist bereits abgelaufen.",
      "CannotDeleteDefaultPaymentMethodError": "Die Standardzahlungsmethode kann nicht gelöscht werden.",
      "UpdateExistingPaymentMethodTokenCurrentlyReplacingError": "Der Prozess zum Aktualisieren der Zahlungsmethode mit dem Token {0} wird derzeit ausgeführt.",
      "UpdateExistingPaymentMethodTokenNotFoundError": "Der Token {0} zum Aktualisieren der Zahlungsmethode konnte nicht gefunden werden.",
      "UpdateExistingPaymentMethodTokenAlreadyReplacedError": "Der Token {0} zum Aktualisieren der Zahlungsmethode wurde bereits benutzt.",
      "PaymentInfoIdNotAssociatedWithCustomerIdError": "Die Zahlungsmethode mit ID {0} ist nicht mit der mit dem Kunden mit der ID {1} verknüpft."
    },
    "ProtocolService": {
      "InvalidGetProtocolEntriesTokenError": "Der Token ist nicht gültig."
    },
    "ReportingService": {
      "RenderLineckerInvoiceCurrentlyBlockedByAnotherProcess": "Die \"RenderLineckerInvoice\"-Methode wird aktuell von einem anderen Prozess gesperrt."
    },
    "RoomReservationService": {
      "NoSearchParametersDefinedError": "Es wurden keine Suchparameter übergeben."
    },
    "Shared": {
      "CustomFieldDefinitionNotFoundError": "Es wurde kein freies Feld mit der ID {0} gefunden.",
      "DefaultValueDatatypeNotValidError": "Der übergebene Standardwert stimmt nicht mit dem ausgewählten Datentyp überein.",
      "InvalidVatIdLengthError": "Die Länge der UID-Nummer ist ungültig. Diese muss aus mindestens 9 Zeichen bestehen.",
      "InvalidVatIdStartError": "Eine UID-Nummer muss mit zwei Buchstaben beginnen.",
      "ModuleNotFoundByIdError": "Ein Module mit der ID {0} konnte nicht gefunden werden.",
      "NoTokenProvidedError": "Es wurde kein Token übergeben, welcher jedoch für diese Operation nötig ist.",
      "Settings": {
        "LevelMustBeGreaterThanZeroError": "Der Wert der Eigenschaft \"Level\" muss größer als 0 sein."
      },
      "Validation": {
        "ValidationError": "N/A"
      },
      "Messaging": {
        "Mailer": {
          "NoRecipientDefinedError": "Es wurde kein Empfänger angegeben.",
          "NoSubjectDefinedError": "Es wurde kein Betreff angegeben."
        }
      }
    },
    "SignalRGatewayService": {
      "LinkedRoomReservationNotFoundBySourceId": "Die verknüpfte Reservierung mit der Herkunfts-ID {0} konnte nicht gefunden werden.",
      "ReservationGroupNotFoundBySourceId": "Die Reservierungsgruppe mit der Herkunfts-ID {0} konnte nicht gefunden werden.",
      "RoomCategoryNotDefinedError": "Eine Zimmerkategorie mit der Herkunfts-ID {0} wurde nicht definiert.",
      "RoomCategoryNotFoundError": "Eine Zimmerkategorie mit der Herkunfts-ID {0} konnte nicht gefunden werden.",
      "RoomCleaningStateNotFoundError": "Der Zimmerreinigungsstatus mit der Herkunfts-ID {0} konnte nicht gefunden werden.",
      "RoomNotDefinedForReservationError": "Für die Reservierung mit der Herkunfts-ID {0} wurde kein Zimmer definiert.",
      "RoomNotDefinedForRoomLockError": "<<OBSOLETE>>",
      "RoomNotFoundForReservationBySourceIdError": "Ein Zimmer mit der Herkunfts-ID {0} konnte nicht gefunden werden.",
      "RoomNotFoundForRoomLockBySourceIdError": "<<OBSOLETE>>"
    },
    "TableReservationService": {
      "AssignedTableDoesNotExistError": "Der zugewiesene Tisch mit der ID {0} existiert nicht.",
      "AssignedTablesDoNotExistError": "Die zugewiesenen Tische existieren nicht.",
      "DepartmentNotFoundByIdError": "Eine Abteilung mit der ID {0} existiert nicht.",
      "ExceedingTheMaximumNumberOfPersonsError": "Die maximale Anzahl an Personen wurde überschritten.",
      "FallingBelowTheMinimumNumberOfPersonsError": "Die minimale Anzahl an Personen wurde unterschritten.",
      "InvalidTableReservationPaymentStatusTokenError": "Der Token ist nicht gültig.",
      "NoOvercrowdingAllowedError": "Eine Überbelegung ist nicht erlaubt. Der Tisch / die Tische haben nicht genügend Sitzplätze.",
      "TableAvailableCheckNotInOpeningHoursError": "Der angefragte Zeitraum ist außerhalb der Öffnungszeiten.",
      "TableIsAlreadyBookedError": "Min. einer der ausgewählten Tische ist in diesem Zeitraum bereits belegt.",
      "TableIsNotActiveError": "Der Tisch mit der ID {0} ist nicht aktiv oder nicht für Reservierungen verfügbar.",
      "TableNotFoundByIdError": "Ein Tisch mit der ID {0} konnte nicht gefunden werden.",
      "TableReservationAutoConfirmNotAllPaxAssignedWarning": "Nicht alle Personen in der Tischreservierung mit der ID {0} konnten automatisch einem Tisch zugeteilt werden. Folgende Person(en) müssen noch zugeteilt werden: {1}.",
      "TableReservationCustomerInformationNotFoundError": "Die Kundeninformation mit der ID {0} konnte nicht gefunden werden.",
      "TableReservationIsInThePastError": "Die Tischreservierung liegt in der Vergangenheit.",
      "TableReservationNotFoundByIdError": "Eine Tischreservierung mit der ID {0} konnte nicht gefunden werden.",
      "TableReservationNotInOpeningHoursError": "Die Tischreservierung liegt außerhalb der Öffnungszeiten.",
      "TableReservationNotInOpeningHoursOfDepartmentError": "Die Tischreservierung liegt außerhalb der Öffnungszeiten der Abteilung {0}.",
      "TableReservationSnippetNotFoundError": "Für den Standort mit der ID {0} konnte kein Tischreservierungs-Widget gefunden werden.",
      "TableReservationSnippetNotFoundForSnippetIdError": "Ein Tischreservierungs-Widget mit der ID {0} konnte nicht gefunden werden.",
      "TableSeatsExceededError": "Der Tisch hat nicht genügend Sitzplätze."
    },
    "GenericExceptionAsWarning": "N/A",
    "GenericExceptionError": "N/A",
    "Licenses": {
      "ProvidedModuleNotLicensedError": "Das übergebene Modul {0} ist entweder nicht lizenziert oder hat eine falsche Lizenzanzahl."
    },
    "Permissions": {
      "NotPermittedError": "Der Benutzer hat keine Berechtigung für diese Aktion!",
      "UserNotPermittedToAccessEnterpriseError": "Der Benutzer hat keine Berechtigung, um auf den Betrieb {0} zuzugreifen."
    }
  },
  "Portal": {
    "Messages": {
      "ClientsService": {
        "EnterpriseNotFoundByIdError": "Ein Betrieb mit der ID {0} konnte nicht gefunden werden.",
        "EnterpriseWithStationOverviewToDateLessThanFromDateError": "Das übergebene Datum ist kleiner als das Von-Datum.",
        "NoStationIdsDefinedError": "Es wurden keine Standort-IDs definiert.",
        "StationBusinessHolidayNotFoundByIdError": "<<OBSOLETE>>",
        "StationBusinessHolidayToDateLessThanFromDateError": "<<OBSOLETE>>",
        "StationBusinessHourNotFoundByIdError": "<<OBSOLETE>>",
        "StationNotFoundByIdError": "Ein Standort mit der ID {0} konnte nicht gefunden werden.",
        "StationNotFoundByStationCodeError": "Ein Standort mit der Standortcode {0} konnte nicht gefunden werden.",
        "StationTimePlanHasNoTimePlansDefinedInfo": "Der Standort mit der ID {0} hat keine Zeitpläne definiert.",
        "StationTimePlanNotDeletableDueToDependentDataError": "Der Zeitplan mit der ID {0} kann nicht gelöscht werden, da davon abhängige Daten existieren.",
        "StationTimePlanNotFoundByIdError": "Ein Zeitplan mit der ID {0} konnte nicht gefunden werden.",
        "StationTimePlanPeriodDayNotFoundByIdError": "Eine Zeitplanperiodentag mit der ID {0} konnte nicht gefunden werden.",
        "StationTimePlanPeriodNotFoundByIdError": "Eine Zeitplanperiode mit der ID {0} konnte nicht gefunden werden.",
        "TransferStationStationAlreadyAssignedToTargetEnterpriseIdError": "Der Standort mit der ID {0} ist bereits dem Betrieb mit der ID {1} zugewiesen.",
        "UserGroupHasUsersAssignedError": "Die Benutzergruppe mit der ID {0} hat darauf zugewiesene Benutzer.",
        "UserGroupNotFoundByIdError": "Eine Benutzergruppe mit der ID {0} konnte nicht gefunden werden.",
        "UserNotFoundByIdError": "Ein Benutzer mit der ID {0} konnte nicht gefunden werden.",
        "UserNotFoundByLoginNameError": "Ein Benutzer mit der E-Mail-Adresse {0} konnte nicht gefunden werden.",
        "UserNotFoundError": "Der Benutzer konnte nicht gefunden werden.",
        "UserNotPermittedForAnyOfProvidedStationIdsError": "Der Benutzer hat auf keinem der übergebenen Standorte Berechtigungen.",
        "UserWithLoginNameAlreadyExistsError": "Ein Benutzer mit der E-Mail-Adresse {0} existiert bereits.",
        "LineckerCustomerNoAlreadyInUseWarning": "Die Kundennummer ist bereits in {0} anderen Betrieben in Verwendung: <ul>{1}</ul>Bitte prüfe, ob diese Mehrfachverwendung tatsächlich in Ordnung ist! Die Daten wurden dennoch gespeichert.",
        "StripeCustomerNoAlreadyInUseWarning": "Die Stripe Kundennummer ist bereits in {0} anderen Betrieben in Verwendung: <ul>{1}</ul>Bitte prüfe, ob diese Mehrfachverwendung tatsächlich in Ordnung ist! Die Daten wurden dennoch gespeichert."
      },
      "FileService": {
        "FileNotFoundError": "Eine Datei mit der ID {0} konnte nicht gefunden werden.",
        "InvalidGetFilesWithActionTokenError": "Der Token ist nicht gültig.",
        "InvalidGetFileWithActionTokenError": "Der Token ist nicht gültig."
      },
      "MessagingService": {
        "MessagingTokenInvalidError": "Der Token ist nicht gültig.",
        "InvalidSmtpConfigurationError": "Die SMTP-Konfiguration ist nicht korrekt."
      }
    }
  },
  "Errors": {
    "Required": "Bitte fülle das Feld aus.",
    "BelowMinimum": "Der eingegebene Wert ist zu klein.",
    "InvalidEmail": "Bitte gültige E-Mail eingeben.",
    "InvalidUrl": "Bitte gültige URL eingeben.",
    "InvalidVatId": "Bitte gültige UID-Nummer eingeben.",
    "CountryAndVatIdNotMatching": "Das Land stimmt nicht mit der UID-Nummer überein.",
    "EmailNotUnique": "Die E-Mail ist bereits vergeben.",
    "PasswordsNotMatching": "Die Passwörter stimmen nicht überein.",
    "PasswordDoesNotMeetRequirements": "Das Passwort muss mindestens 8 Zeichen lang sein, Groß- und Kleinbuchstaben und eine Zahl enthalten.",
    "MultiInput": {
      "Duplicate": "Diesen Eintrag gibt es bereits.",
      "NaN": "Bitte gültige Nummer eingeben."
    },
    "UnknownError": "Etwas ist schiefgelaufen."
  },
  "FatalError": {
    "LoadingApiInfo": "API-Info konnte nicht geladen werden",
    "LoadingCountries": "Länder konnten nicht geladen werden",
    "LoadingCurrencies": "Währungen konnten nicht geladen werden",
    "LoadingSalutations": "Anreden konnten nicht geladen werden",
    "LoadingUser": "Benutzer konnte nicht geladen werden",
    "LoadingSettings": "Einstellungen konnten nicht geladen werden",
    "LoadingPermissions": "Berechtigungen konnten nicht geladen werden",
    "LoadingPartnerEnterprise": "Partnerbetrieb konnte nicht geladen werden",
    "LoadingSelectedEnterprise": "Ausgewählter Betrieb konnte nicht geladen werden",
    "LoadingEnterprises": "Betriebe konnte nicht geladen werden",
    "SignalRNotConnected": "Verbindung zum Server nicht aufgebaut. Bitte Seite neu laden."
  },
  "Authentication": {
    "Login": {
      "Title": "Anmeldung",
      "Email": "E-Mail",
      "Password": "Passwort",
      "ForgotPassword": "Passwort vergessen?",
      "Login": "Anmelden",
      "PasswordExpiredInfo": {
        "Title": "Passwort abgelaufen",
        "Description": "Das Passwort für die E-Mail <b>{0}</b> muss geändert werden."
      }
    },
    "ForgotPassword": {
      "Title": "Passwort vergessen?",
      "Info": "Bitte E-Mail zum Zurücksetzen des Passworts eingeben.",
      "Email": "E-Mail",
      "BackToLogin": "Zurück zur Anmeldung",
      "ResetPassword": "Passwort zurücksetzen"
    },
    "ChangePassword": {
      "Title": "Passwort ändern",
      "Email": "E-Mail",
      "NewPassword": "Neues Passwort",
      "RepeatNewPassword": "Neues Passwort wiederholen",
      "Change": "Ändern",
      "BackToLogin": "Zurück zur Anmeldung"
    },
    "RegisterUser": {
      "Title": "Registrierung betätigen",
      "Firstname": "Vorname",
      "Lastname": "Nachname",
      "Password": "Passwort",
      "RepeatPassword": "Passwort wiederholen",
      "Confirm": "Bestätigen"
    },
    "SessionExpired": "Sitzung abgelaufen"
  },
  "InfoPage": {
    "BackToLippPortal": "Zurück zum Lipp Portal"
  },
  "ConfirmRegistration": {
    "Successful": {
      "Title": "Deine Registrierung wurde erfolgreich bestätigt.",
      "Description": "Du wirst in Kürze automatisch zum Lipp Portal weitergeleitet..."
    },
    "Failed": {
      "Title": "Leider konnten wir deine Registrierung nicht bestätigen."
    }
  },
  "Maintenance": {
    "Title": "Wir sind gleich wieder zurück!",
    "Description": "Wartungsarbeiten im Lipp Portal werden durchgeführt...",
    "ReloadPage": "Seite neu laden"
  },
  "Error": {
    "Title": "Leider ist etwas schiefgelaufen.",
    "Description": "Bitte versuche es noch einmal.",
    "ReloadPage": "Seite neu laden"
  },
  "Payment": {
    "Failed": {
      "Title": "Leider ist deine Zahlung fehlgeschlagen.",
      "Description": "Du wirst in Kürze automatisch zum Lipp Portal weitergeleitet...",
      "BackToLippPortal": "Zurück zum Lipp Portal"
    },
    "Successful": {
      "Title": "Vielen Dank! Deine Zahlung war erfolgreich.",
      "Description": "Du wirst in Kürze automatisch zum Lipp Portal weitergeleitet...",
      "BackToLippPortal": "Zurück zum Lipp Portal"
    },
    "Pay": {
      "ErrorLoading": "Zahlungslink konnte nicht geladen werden"
    },
    "Confirm": {
      "Title": "Wir freuen uns, dass du dich für ein Lipp Produkt entschieden hast!",
      "Description": "In wenigen Schritten hast du's geschafft. *Nettopreise*",
      "Subscribe": "Kostenpflichtig abonnieren",
      "Order": "Kostenpflichtig bestellen",
      "SelectPaymentInterval": "Zahlungsintervall auswählen",
      "SelectPaymentMethod": "Zahlungsmethode auswählen",
      "Policy": "Ich habe die <a href='https://www.linecker.at/datenschutzerklaerung/' target='_blank'>Datenschutzbestimmungen</a> & <a href='https://www.linecker.at/agb/' target='_blank'>AGB</a> gelesen und stimme ihnen zu.",
      "Costs": "Kostenaufstellung",
      "Total": "Gesamt",
      "ErrorLoading": "Modul konnte nicht geladen werden",
      "PaymentFailed": "Zahlung fehlgeschlagen",
      "PaymentNotCompleted": "Die Zahlung wurde nicht abgeschlossen.",
      "3DSConfirmationFailed": "Die 3DS Bestätigung für die Zahlungs ist fehlgeschlagen.",
      "Test": "{0} testen",
      "TrialUntil": "Kostenlos bis {0}",
      "TrialInfo": "Nach Ablauf des Testzeitraums wird das Abonnement gestartet und die bereits von dir eingegebenen Daten bleiben erhalten.",
      "Start": "Starten",
      "Devices": "Geräte",
      "LippCare": "Lipp Care (All-in-Sorglos)",
      "Aliquotation": {
        "Title": "Erhöhung {0}x {1} auf {2}x {3}",
        "Costs": "Kostenaufstellung aliquot",
        "LippCareTitle": "Erhöhung Lipp Care"
      },
      "Reduction": {
        "Title": "Reduzierung {0}x {1} auf {2}x {3}",
        "Costs": "Kostenaufstellung"
      }
    },
    "ConfirmationMail": "E-Mail (Bestätigungslink)"
  },
  "Invoices": {
    "Title": "Rechnungen",
    "Partner": "Partner",
    "CustomerNumber": "Kundennummer",
    "InvoiceNumber": "Rechnungsnummer",
    "InvoiceDate": "Rechnungsdatum",
    "PaidAtUTC": "Einzugsdatum",
    "PaymentReference": "Zahlungsreferenz",
    "Enterprise": "Betrieb",
    "Station": "Standort",
    "Subscription": "Abonnement",
    "Amount": "Betrag",
    "ErrorOpening": "Rechnung konnte nicht geöffnet werden",
    "ErrorDownloading": "Rechnung konnte nicht heruntergeladen werden",
    "SendEmail": {
      "Title": "Rechnung per E-Mail versenden",
      "Recipient": "Empfänger",
      "Success": {
        "Title": "Rechnung gesendet",
        "Description": "Die Rechnung wurde per E-Mail an <b>{0}</b> gesendet."
      },
      "Error": "Rechnung konnte nicht gesendet werden",
      "And": "und"
    },
    "PdfNotGeneratedTooltip": "Rechnung wird generiert...",
    "ContextMenu": {
      "Correct": "Rechnungsadresse korrigieren",
      "Credit": "Gutschrift erstellen",
      "Cancel": "Vollständig stornieren",
      "Stripe": "Stripe Datensatz"
    },
    "ErrorGettingStripeUrl": "Stripe Datensatz konnte nicht geladen werden",
    "StripeLinkNotAvailable": "Der Link zu Stripe ist nicht verfügbar.",
    "MonthlyReport": "Monatsbericht",
    "ErrorDownloadingMonthlyReport": "Monatsbericht konnte nicht heruntergeladen werden",
    "NoDataInThisPeriod": "Keine Daten in diesem Zeitraum verfügbar.",
    "BMDExport": "BMD-Export",
    "ErrorDownloadingBMDExport": "BMD-Export konnte nicht heruntergeladen werden"
  },
  "Profile": {
    "Title": "Profileinstellungen",
    "RemoveProfileImage": "Profilbild entfernen",
    "Email": "E-Mail",
    "FirstName": "Vorname",
    "LastName": "Nachname",
    "Language": "Sprache",
    "CurrentPassword": "Aktuelles Passwort",
    "NewPassword": "Neues Passwort",
    "RepeatNewPassword": "Neues Passwort wiederholen",
    "Theme": {
      "Title": "Darstellung",
      "Browser": "Browserbasiert",
      "Light": "Hell",
      "Dark": "Dunkel"
    },
    "SuccessChanging": {
      "Title": "Benutzer geändert",
      "Description": "Der Benutzer <b>{0}</b> wurde erfolgreich geändert."
    },
    "ErrorChanging": "Benutzer konnte nicht geändert werden",
    "ConnectedApps": {
      "Title": "Verbundene Anwendungen",
      "Description": "Anwendungen wie ChatGPT oder Claude, denen du Zugriff auf dein Lipp Portal gegeben hast. Ein Trennen wirkt sofort.",
      "None": "Keine verbundenen Anwendungen.",
      "ConnectedSince": "verbunden seit {0}",
      "LastUsed": "zuletzt benutzt {0}",
      "Revoke": "Trennen",
      "Revoked": {
        "Title": "Verbindung getrennt",
        "Description": "<b>{0}</b> hat keinen Zugriff mehr auf dein Lipp Portal."
      },
      "RevokeError": "Verbindung konnte nicht getrennt werden",
      "LoadError": "Die verbundenen Anwendungen konnten nicht geladen werden.",
      "Retry": "Erneut laden"
    },
    "McpUrl": {
      "Title": "Adresse für KI-Anwendungen (MCP-Server)",
      "Copy": "Kopieren",
      "Copied": "Adresse kopiert",
      "CopyError": "Adresse konnte nicht kopiert werden",
      "Description": "Diese Adresse trägst du in ChatGPT, Claude oder einer anderen KI-Anwendung als MCP-Server ein. Beim ersten Verbinden meldest du dich mit deinem Lipp-Portal-Konto an und gibst den Zugriff frei; danach steht die Anwendung oben in dieser Liste."
    }
  },
  "Header": {
    "Profile": {
      "User": "Benutzer",
      "ProfileSettings": "Profileinstellungen",
      "Invoices": "Rechnungen",
      "Logout": "Abmelden"
    },
    "Help": {
      "Title": "Hilfe",
      "Tutorials": "Erklärvideos",
      "TutorialsError": "Erklärvideos konnten nicht geöffnet werden",
      "Updates": "Updates"
    }
  },
  "Sidebar": {
    "Dashboard": "Dashboard",
    "Enterprises": "Betriebe",
    "Users": "Benutzer",
    "Marketplace": "Marktplatz",
    "SearchStationsPlaceholder": "Standorte suchen...",
    "CrossEnterprise": {
      "Long": "Betriebsübergreifend",
      "Short": "BÜ"
    },
    "Modules": {
      "Statistics": "Auswertungen",
      "TableReservation": "Tischreservierung",
      "RoomPlan": "Zimmerplan",
      "CloudBackup": "Cloudsicherung",
      "LippBon": "Lipp Bon",
      "DigitalReceipt": "Digitaler Beleg",
      "LippCare": "Lipp Care",
      "LippPOS": "Lipp POS",
      "LippPMS": "Lipp PMS",
      "Vouchers": "Gutscheinverwaltung"
    },
    "FooterDialog": {
      "Name": "Linecker GmbH",
      "Sales": "Beratung & Verkauf",
      "PosSupport": "Kassensupport",
      "HotelSupport": "Hotelsupport",
      "Accounting": "Buchhaltung",
      "T&C": "AGB",
      "PrivacyPolicy": "Datenschutz"
    }
  },
  "Dashboard": {
    "TotalProfit": {
      "Title": "Gesamtgewinn",
      "Monthly": "Monatlich",
      "Yearly": "Jährlich",
      "ErrorLoading": "Gesamtgewinn konnte nicht geladen werden"
    },
    "Actives": {
      "Title": "Kennzahlen",
      "Enterprises": "Aktive Betriebe",
      "Stations": "Aktive Standorte",
      "Users": "Aktive Benutzer",
      "OccupiedCloudStorage": "Belegter Cloudspeicher",
      "ErrorLoading": "Kennzahlen konnten nicht geladen werden"
    },
    "Facts": {
      "Title": "Fakten",
      "ActivatedModules": "Aktivierte Module",
      "DeactivatedModules": "Deaktivierte Module",
      "LoginsLippPortal": "Lipp Website Anmeldungen",
      "LoginsLippApp": "Lipp App Anmeldungen",
      "ErrorLoading": "Fakten konnten nicht geladen werden"
    },
    "ActivatedModules": {
      "Title": "Aktivierte Module",
      "Count": "Anzahl",
      "Enterprises": "Betriebe",
      "CountMonthly": "Anzahl monatl.",
      "SumMonthly": "Summe monatl.",
      "CountYearly": "Anzahl jährlich",
      "SumYearly": "Summe jährlich",
      "SumMonthlyOfAllModules": "Summe monatl. alle Module",
      "Total": "Gesamt",
      "AllPartners": "Alle Partner",
      "AllPaymentMethods": "Alle Zahlungsarten",
      "ErrorLoading": "Aktivierte Module konnten nicht geladen werden",
      "ErrorLoadingPartners": "Partnerbetriebe konnten nicht geladen werden"
    },
    "CustomModules": {
      "Title": "Individuelle Module",
      "Count": "Anzahl",
      "Enterprises": "Betriebe",
      "CountMonthly": "Anzahl monatl.",
      "CostsMonthly": "EK monatl.",
      "SumMonthly": "Summe monatl.",
      "CountYearly": "Anzahl jährlich",
      "CostsYearly": "EK jährlich",
      "SumYearly": "Summe jährlich",
      "SumMonthlyOfAllModules": "Summe monatl. alle Module (Gewinn)",
      "Total": "Gesamt",
      "ErrorLoading": "Individuelle Module konnten nicht geladen werden"
    }
  },
  "Modules": {
    "Overview": {
      "Title": "Module",
      "Module": "Modul",
      "ErrorLoadingModules": "Module konnten nicht geladen werden",
      "Activated": "Aktiviert",
      "NoModulesActivated": "Es wurden noch keine Module aktiviert.",
      "NotActivated": "Nicht aktiviert",
      "CancelModules": "Module kündigen",
      "ErrorLoadingCancelableModules": "Kündbare Module konnten nicht geladen werden",
      "ErrorStartingTrial": "Testzeitraum konnte nicht gestartet werden",
      "ErrorRedirectingToCheckout": "Weiterleitung zur Zahlung fehlerhaft",
      "ErrorLoadingPaymentMethods": "Zahlungmethoden konnten nicht geladen werden",
      "AddPaymentMethod": "Bitte <u>Zahlungsmethode</u> hinzufügen!"
    },
    "Shop": {
      "Title": "Shop",
      "Tooltip": "In Kürze verfügbar!"
    },
    "Log": {
      "Title": "Änderungsprotokoll",
      "ModuleName": "Modulname",
      "Description": "Beschreibung",
      "InternalNotes": "Interne Notizen",
      "User": "Benutzer",
      "DateTime": "Datum/Uhrzeit"
    },
    "TableReservation": {
      "Title": "Tischreservierung",
      "Description": "Erziele durch Reservierungen eine optimale Auslastung deiner Tische. Inklusive Buchungswidget für deine Website."
    },
    "RoomPlan": {
      "Title": "Hotelpaket",
      "Description": "Live-Auswertungen, Zimmerplan, Reservierung suchen & Zimmer blockieren."
    },
    "LippBon": {
      "Title": "Lipp Bon",
      "Description": "Hybrid Bonier App <br> WLAN, Mobilfunk und Offline in 1 App.",
      "Description1": "Hybrid Bonier App",
      "Description2": "WLAN, Mobilfunk und Offline",
      "Description3": "in 1 App.",
      "Tooltip": "Offline ist das Buchen möglich, jedoch wird für die Abrechnung (Bar, Rechnung, PMS Transfer, usw.) eine Verbindung zur Kassa benötigt.",
      "GPtom": {
        "Title": "Genius mobile pay",
        "Description": "Kombiniert mit Lipp Bon können NFC-Kartenzahlungen direkt über das Android-Smartphone abgewickelt werden."
      },
      "Incert": {
        "Title": "Incert",
        "Description": "Einlösen der Gutscheine, anhand der Lipp Bon (Hybrid Bonier-App), via Incert."
      },
      "POSit": {
        "Title": "POSit",
        "Description": "Kombiniert mit Lipp Bon können NFC-Kartenzahlungen direkt über das Android-Smartphone abgewickelt werden."
      }
    },
    "LippPMS": {
      "Title": "Lipp PMS",
      "Description": "Die Hotelsoftware für deinen Betrieb. Cloudsicherung, Erklärvideos, Kundenservice und Erstinstallation inklusive.",
      "Room": {
        "Title": "Zimmer",
        "Description": "Je Zimmer im Lipp PMS."
      },
      "IntegrationSlot": {
        "Title": "Integrationsslot",
        "Description": "Ein Platz für eine Schnittstelle im Lipp PMS."
      },
      "LippPos": {
        "Title": "Lipp POS",
        "Description": "Lipp PMS und Lipp POS arbeiten direkt zusammen: Eingecheckte Gäste sind an der Kassa sofort buchbar, Restaurantrechnungen landen auf dem Zimmer. Inklusive."
      },
      "ManualRegistration": {
        "Title": "Meldewesen manuell",
        "Description": "Meldeblätter werden wie gewohnt angelegt und nummeriert, ausgedruckt und vom Gast unterschrieben – ohne elektronische Meldestelle. Inklusive."
      },
      "FeratelRegistration": {
        "Title": "feratel Meldewesen",
        "Description": "Lipp PMS übermittelt die Gästemeldungen automatisch an feratel."
      },
      "CardXperts": {
        "Title": "cardXperts Meldewesen",
        "Description": "Meldeblätter als Datei für cardXissue."
      },
      "ExternalPos": {
        "Title": "Fremdkassa",
        "Description": "Eine Kassa eines anderen Herstellers über die offene Partner-Schnittstelle anbinden: Die Kassa sieht, wer im Haus ist, und bucht Restaurantrechnungen auf das Zimmer."
      },
      "Incert": {
        "Title": "Incert",
        "Description": "Gutscheine und Wertkarten von Incert direkt auf der Rechnung einlösen und Karten im Tagesgeschäft aufladen."
      },
      "SmartnessRevenue": {
        "Title": "Smartness",
        "Description": "Lipp PMS meldet Zimmerkategorien, Kontingente und Reservierungen an Smartness und übernimmt die dort berechneten Preise und Mindestaufenthalte."
      },
      "SaltoSpace": {
        "Title": "Salto Space",
        "Description": "Zutrittskarten werden für die Reservierung codiert und beim Check-out, Storno oder Zimmerwechsel automatisch entwertet. Angebunden über den Lipp PMS Connector im Haus."
      },
      "ZvtTerminal": {
        "Title": "ZVT Zahlungsterminal",
        "Description": "Kartenzahlung an Rechnung und Anzahlung über ein ZVT-Terminal im Haus, angebunden über den Lipp PMS Connector."
      },
      "SixTimTerminal": {
        "Title": "SIX TIM",
        "Description": "Worldline/SIX-Zahlungsterminals (TIM-Protokoll) für Kartenzahlungen an Rechnung und Anzahlung, samt Tagesabschluss am Terminal. Angebunden über den Lipp PMS Connector im Haus."
      },
      "Fias": {
        "Title": "FIAS",
        "Description": "Telefonanlage und Schließanlage im Haus (z. B. Loxone) über das FIAS-Protokoll anbinden. Angebunden über den Lipp PMS Connector."
      },
      "AlpineBits": {
        "Title": "AlpineBits",
        "Description": "Offener Standard der Channel Manager im Alpenraum: Lipp PMS meldet Kontingente und Preise und holt Buchungen automatisch ab."
      },
      "Vioma": {
        "Title": "vioma",
        "Description": "Lipp PMS meldet Verfügbarkeit, Preise und Restriktionen an die vioma Clearing Station und holt Buchungen automatisch ab."
      },
      "Interalp": {
        "Title": "Interalp",
        "Description": "Lipp PMS meldet die Kontingente an Interalp und holt Preise und Reservierungen von dort ab."
      },
      "Dirs21": {
        "Title": "DIRS21",
        "Description": "Channel Manager und Buchungsmaschine: Lipp PMS meldet Verfügbarkeit, Preise und Restriktionen und holt Reservierungen automatisch ab."
      },
      "FeratelChannel": {
        "Title": "feratel Deskline",
        "Description": "Channel Manager der Tourismusdestinationen: Lipp PMS meldet Verfügbarkeit, Preise und Restriktionen und holt Buchungen automatisch ab."
      },
      "CapCorn": {
        "Title": "CapCorn",
        "Description": "Buchungsmaschine und Channel Manager: Lipp PMS meldet Verfügbarkeit und Restriktionen und holt Buchungen ab – sofort, sobald CapCorn eine neue meldet."
      },
      "Seekda": {
        "Title": "seekda",
        "Description": "Channel Manager und Buchungsmaschine von seekda."
      },
      "Channex": {
        "Title": "Channex (Booking.com)",
        "Description": "Channel Manager Channex, zum Start für Booking.com: Lipp PMS meldet Verfügbarkeit, Preise und Restriktionen und holt Buchungen automatisch ab."
      },
      "Websline": {
        "Title": "Websline",
        "Description": "Website und Buchungsmaschine von Websline: Buchungen, Zahlungen und Vorab-Check-in kommen direkt ins Lipp PMS, Websline-Gutscheine werden auf der Rechnung eingelöst."
      },
      "Guestnet": {
        "Title": "Guestnet",
        "Description": "Digitale Gästemappe: Der Gast sieht seinen Aufenthalt, checkt vorab ein, bucht auf sein Zimmer, bezahlt und reist bei ausgeglichenem Saldo selbst ab."
      },
      "Brandnamic": {
        "Title": "Brandnamic",
        "Description": "Gastbeziehung und Marketing: Lipp PMS übergibt Angebote und Reservierungen an Brandnamic, das daraus die Korrespondenz mit dem Gast erstellt. Mit der Gutschein-App von Brandnamic werden auch Gutscheine auf der Rechnung eingelöst."
      },
      "Reguest": {
        "Title": "Re:Guest",
        "Description": "Anfragen, Angebote und Gästekommunikation: Re:Guest holt Zimmertypen, Ratenpläne und Verfügbarkeit aus dem Lipp PMS und schickt angenommene Reservierungen direkt ins Lipp PMS."
      },
      "KunLeiSys": {
        "Title": "KunLeiSys",
        "Description": "Gästeclub mit Treuepunkten, Gaststufen und Gutscheinen: Punkte und Stufe stehen in der Gästekartei, Punkte und Gutscheine werden auf der Rechnung eingelöst."
      },
      "Trakklab": {
        "Title": "trakklab",
        "Description": "Anrufmanagement und Anruferkennung: trakklab erkennt anhand der Gäste und Reservierungen aus dem Lipp PMS, wer anruft."
      },
      "BmdExport": {
        "Title": "BMD",
        "Description": "Rechnungen eines Zeitraums als BMD-Datei für die Steuerberatung exportieren. BMD und DATEV schließen einander aus."
      },
      "DatevExport": {
        "Title": "DATEV",
        "Description": "Rechnungen eines Zeitraums als DATEV-Buchungsstapel für die Steuerkanzlei exportieren. BMD und DATEV schließen einander aus."
      },
      "ExtensionSlot": {
        "Title": "Erweiterungsslot",
        "Description": "Ein Platz für eine Erweiterung im Lipp PMS."
      },
      "WebsiteBooking": {
        "Title": "Buchung eigene Website",
        "Description": "Gäste buchen provisionsfrei direkt auf deiner Website, und die Reservierung landet sofort im Lipp PMS."
      },
      "Seminarplan": {
        "Title": "Seminarverwaltung",
        "Description": "Seminarräume im Wochenplan mit Serienterminen, Verpflegung je Termin und Material. Eingerichtet wird im Lipp PMS."
      },
      "RevenueManagement": {
        "Title": "Revenue Management",
        "Description": "Auslastung, Durchschnittspreis und RevPAR im Blick, Zimmerpreise nach eigenen Regeln an die Nachfrage angepasst. Eingerichtet wird im Lipp PMS."
      },
      "Newsletter": {
        "Title": "Newsletter",
        "Description": "Newsletter an Gäste mit Einwilligung, mit Zielgruppen aus der Gästekartei, Bausteinen in den Hausfarben und Versand zur passenden Zeit. Eingerichtet wird im Lipp PMS."
      }
    },
    "LippPOS": {
      "Title": "Lipp POS",
      "Description": "Mit der Lipp POS Kassensoftware steuerst du deinen Betrieb so einfach wie noch nie - intuitiv, cloudbasiert und gesetzeskonform.",
      "BMD": {
        "Title": "BMD",
        "Description": "Export der Buchungsdaten zur Weiterverarbeitung in BMD."
      },
      "DATEV": {
        "Title": "DATEV",
        "Description": "Export der Buchungsdaten zur Weiterverarbeitung in DATEV."
      },
      "AidaX": {
        "Title": "AIDA.x",
        "Description": "Lipp POS überträgt PMS Transfers sowie alle relevanten Umsätze automatisch an die Hotelsoftware AIDA.x - für einen reibungslosen Ablauf zwischen Kasse und Rezeption."
      },
      "Eucasoft": {
        "Title": "Eucasoft",
        "Description": "Lipp POS überträgt PMS Transfers sowie alle relevanten Umsätze automatisch an die Hotelsoftware Eucasoft - für einen reibungslosen Ablauf zwischen Kasse und Rezeption."
      },
      "AsaASCII": {
        "Title": "ASA Ascii",
        "Description": "Lipp POS überträgt PMS Transfers automatisch an die Hotelsoftware über die ASA-Ascii-Schnittstelle - für einen reibungslosen Ablauf zwischen Kasse und Rezeption."
      },
      "Sihot": {
        "Title": "SIHOT",
        "Description": "Lipp POS überträgt PMS Transfers sowie alle relevanten Umsätze automatisch an die Hotelsoftware SIHOT - für einen reibungslosen Ablauf zwischen Kasse und Rezeption."
      },
      "Scale": {
        "Title": "Waage",
        "Description": "Anbindung von Theken-Waagen über das Protokoll Checkout Dialog 06. Gewicht und Preis werden an der Waage ermittelt und direkt in die Buchung übernommen – ohne Abtippen."
      },
      "BookIn": {
        "Title": "book-in",
        "Description": "Lipp POS überträgt PMS Transfers automatisch an die Hotelsoftware book-in - für einen reibungslosen Ablauf zwischen Kasse und Rezeption."
      },
      "Apaleo": {
        "Title": "Apaleo",
        "Description": "Lipp POS überträgt PMS Transfers automatisch an die Hotelsoftware Apaleo - für einen reibungslosen Ablauf zwischen Kasse und Rezeption."
      },
      "FoodNotify": {
        "Title": "FoodNotify",
        "Description": "Lipp POS überträgt Artikelstamm und Verkäufe automatisch an die Warenwirtschaft FoodNotify - für einen genauen Wareneinsatz ohne doppelte Erfassung."
      },
      "EProtocol": {
        "Title": "E-Protokoll",
        "Description": "Anbindung an Schankanlagen über das klassische E-Protokoll (seriell oder TCP). Buchungen werden direkt in Lipp POS übernommen und Credits zurück an die Schank gesendet."
      },
      "Cascade3": {
        "Title": "Cascade 3 (Hart++ / Hart 96)",
        "Description": "Anbindung an Schankanlagen über das Cascade3-Protokoll (Hart++ / Hart 96, seriell oder TCP). Buchungen werden direkt in Lipp POS übernommen und Credits zurück an die Schank gesendet."
      },
      "Smartschank": {
        "Title": "Smartschank",
        "Description": "Anbindung an Smartschank-Schankanlagen von Dirmeier. Beim Bonieren entsteht ein Getränke-Credit, den der Gast über seine Kennung (Customer-ID) am Gerät einlöst. Je Anlage wählbar: Credits in der Hersteller-Cloud (SelfserviceCash, filialübergreifend) oder direkt an ein Gerät im LAN."
      },
        "Tbt": {
        "Title": "TBT",
        "Description": "Anbindung an TBT-Schankanlagen (seriell oder TCP, Multi-Drop). Buchungen werden direkt in Lipp POS übernommen und Credits zurück an die Schank gesendet."
      },
      "Incert": {
        "Title": "Incert",
        "Description": "Einlösung von Incert-Gutscheinen direkt an der Lipp POS."
      },
      "Websline": {
        "Title": "Websline",
        "Description": "Einlösung von Websline-Gutscheinen direkt an der Lipp POS."
      },
      "GruberVMPS": {
        "Title": "Gruber VMPS",
        "Description": "Anbindung an Schankanlagen über das Gruber-VMPS-Protokoll (UDP). Schankvorgänge laufen direkt über die Lipp POS.",
        "SchankSettings": {
          "Title": "Schankeinstellungen"
        },
        "Tabs": {
          "Systems": "Schankanlagen",
          "Articles": "Schankartikel"
        },
        "Deactivate": {
          "Button": "Integration deaktivieren",
          "Error": "Schank-Integration konnte nicht deaktiviert werden"
        },
        "Systems": {
          "Title": "Schank-Anlagen",
          "Empty": "Noch keine Schank-Anlagen angelegt."
        },
        "System": {
          "Add": "Schankanlage",
          "Articles": "Artikel",
          "Field": {
            "Name": "Bezeichnung",
            "IPAddress": "IP-Adresse",
            "Port": "Port",
            "Protocol": "Protokoll",
            "IsActive": "Aktiv",
            "Assignment": "Zuordnung",
            "CommunicationServer": "Kommunikationsserver"
          },
          "Saved": {
            "Title": "Schank-Anlage gespeichert",
            "Error": "Schank-Anlage konnte nicht gespeichert werden"
          },
          "Delete": {
            "Confirm": "Soll die Schank-Anlage \"{0}\" wirklich gelöscht werden?",
            "Error": "Schank-Anlage konnte nicht gelöscht werden"
          }
        },
        "Articles": {
          "Title": "Artikel-Zuordnungen",
          "Empty": "Noch keine Artikel zugeordnet.",
          "NoSystems": "Lege zuerst eine Schank-Anlage an, bevor du Artikel zuordnest.",
          "SystemSelector": "Schank-Anlage:",
          "OnlyAssigned": "Nur zugeordnete anzeigen",
          "AllArticlesEmpty": "Keine Artikel verfügbar."
        },
        "Article": {
          "Add": "Artikel hinzufügen",
          "Field": {
            "ArticleId": "Artikel-ID",
            "ArticleNumber": "Schank-Artikelnummer",
            "Mode": "Modus",
            "Name": "Bezeichnung",
            "Number": "Art.-Nr.",
            "CommodityGroup": "Warengruppe",
            "DispenserArticleNumber": "Schankanlage - Art.-Nr.",
            "DispenserArticleNumberPlaceholder": "Art.-Nr."
          },
          "Mode": {
            "Debit": "Soll (Debit)",
            "Credit": "Haben (Kredit)",
            "Both": "Beides"
          },
          "Saved": {
            "Error": "Artikel-Zuordnung konnte nicht gespeichert werden"
          },
          "Delete": {
            "Confirm": "Soll diese Artikel-Zuordnung wirklich gelöscht werden?",
            "Error": "Artikel-Zuordnung konnte nicht gelöscht werden"
          }
        }
      },
      "RKSV": {
        "Title": "RKSV 2017"
      },
      "Additional": {
        "Title": "Lipp POS (zusätzliche)"
      },
      "IntegrationSlot": {
        "Title": "Integrationsslot"
      },
      "ExtensionSlot": {
        "Title": "Erweiterungsslot"
      },
      "CashJournal": {
        "Title": "Kassenbuch",
        "Description": "Bareinnahmen werden automatisch erfasst, du fügst Ausgaben hinzu, nutzt praktische Vorlagen und exportierst deine Daten mit nur einem Klick."
      },
      "VoucherManagement": {
        "Title": "Gutscheinverwaltung",
        "Description": "Einfaches Erstellen, Einlösen und Verwalten von Gutscheinen direkt im Kassensystem."
      },
      "TimeTracking": {
        "Title": "Zeiterfassung",
        "Description": "Mitarbeitende stempeln Arbeits- und Pausenzeiten direkt am Kassensystem. Zeiterfassungsarten werden im Portal verwaltet, Einträge sind jederzeit einsehbar und exportierbar."
      },
      "WarehouseManagement": {
        "Title": "Lagerverwaltung",
        "Description": "Verwalte Lagerbestände, Wareneingänge, Umlagerungen, Rezepturen und Lieferanten - direkt im Portal."
      },
      "DeliveryNotes": {
        "Title": "Lieferscheinverwaltung",
        "Description": "Mit der Lieferscheinverwaltung gibst du Ware gegen Lieferschein aus und verrechnest sie später – auf Wunsch mehrere Lieferscheine desselben Kunden in einer Rechnung. Retouren erfasst du direkt am Lieferschein."
      },
      "NotifcationCenter": {
        "Title": "Nachrichtenzentrale",
        "Description": "Mit der Nachrichtenzentrale schickst du Nachrichten an alle oder ausgewählte Mitarbeitende – sofort, zu einem festen Zeitpunkt oder wiederkehrend. Die Nachricht erscheint beim Benutzer als Hinweis und wird mit OK bestätigt."
      },
      "BonusSystem": {
        "Title": "Bonussystem",
        "Description": "Ein Kundenkonto mit Guthaben und Punkten für jeden Kunden der Kundenkartei – ohne Karte, nur mit der Kundennummer. Im Voraus aufladen oder im Nachhinein begleichen und an Kasse und Handheld damit bezahlen."
      },
      "TableReservation": {
        "Title": "Tischreservierung",
        "Description": "Erziele durch Reservierungen eine optimale Auslastung deiner Tische. Inklusive Buchungswidget für deine Website."
      },
      "OpenItems": {
        "Title": "Offene-Posten-Verwaltung",
        "Description": "Mit der Offene-Posten-Verwaltung behältst du alle noch nicht beglichenen Rechnungen im Blick – du siehst sofort, welche Beträge noch offen sind."
      },
      "DigitalReceipt": {
        "Title": "Digitaler Beleg",
        "Description": "Rechnung wird vom Gast gescannt (QR-Code). Zusätzliche Bewertung der Gäste für den Aufenthalt. Spart Kosten in der Anschaffung von Thermopapier & -drucker. Alle digitalen Belege sind 30 Tage nach Rechnungserstellung noch abrufbar."
      },
      "CustomerDisplay2L": {
        "Title": "Kundendisplay 2-zeilig",
        "Description": "Anzeige von Artikeln und Rechnungsbeträgen - für ein einfaches, transparentes Kundenerlebnis."
      },
      "CashDrawer": {
        "Title": "Kassenlade",
        "Description": "Das Kassensystem öffnet automatisch die Kassenlade, wenn bestimmte Zahlungsarten gewählt werden."
      },
      "WaiterKey": {
        "Title": "Kellnerschloss Addimat",
        "Description": "Mitarbeitende können sich schnell und sicher per Kellnerschlüssel am Kellnerschloss Addimat authentifizieren."
      },
      "Keycard": {
        "Title": "Kartenleser",
        "Description": "Karten am Lesegerät erfassen und als Kundenkarte, Guthaben- oder Mitarbeiterkarte verwenden — aufladen, damit bezahlen und Punkte sammeln."
      },
      "GPtom": {
        "Title": "Genius mobile pay",
        "Description": "Kombiniert mit Lipp POS können NFC-Kartenzahlungen direkt über das Android- oder iOS-Smartphone abgewickelt werden."
      },
      "POSit": {
        "Title": "POSit",
        "Description": "Kombiniert mit Lipp POS können NFC-Kartenzahlungen direkt über das Android- oder iOS-Smartphone abgewickelt werden."
      },
      "LippPay": {
        "Title": "Lipp Pay",
        "Description": "Kombiniert mit Lipp POS können NFC-Kartenzahlungen direkt über das Android- oder iOS-Smartphone abgewickelt werden."
      },
      "PayOne": {
        "Title": "PAYONE",
        "Description": "Kombiniert mit Lipp POS können NFC-Kartenzahlungen mit PAYONE Tap on Mobile direkt über das Android-Smartphone abgewickelt werden."
      },
      "VRPayMe": {
        "Title": "VR PayMe",
        "Description": "Kombiniert mit Lipp POS können NFC-Kartenzahlungen mit VR PayMe direkt über das Android-Smartphone abgewickelt werden."
      },
      "Nexi": {
        "Title": "Nexi",
        "Description": "Kombiniert mit Lipp POS können NFC-Kartenzahlungen mit Nexi SoftPOS direkt über das Android-Smartphone abgewickelt werden."
      },
      "CustomerDisplay": {
        "Title": "Kundendisplay",
        "Description": "Anzeige von Artikeln, Rechnungsbeträgen und Werbeinhalten - für ein modernes, transparentes Kundenerlebnis."
      },
      "ZVT": {
        "Title": "ZVT Zahlungsterminal",
        "Description": "Kommunikation zwischen Lipp POS und angeschlossenen Zahlungsterminals für eine automatisierte Zahlungsabwicklung."
      },
      "SixTIM": {
        "Title": "SIX TIM",
        "Description": "Worldline/SIX Zahlungsterminals (TIM-Protokoll) direkt an die Kasse anbinden – Zahlung, Storno, Trinkgeld und automatischer Tagesabschluss."
      },
      "AsaSoap": {
        "Title": "ASA-SOAP",
        "Description": "Anbindung an das ASA Hotel Cloud-PMS (SOAP)."
      }
    },
    "Reporting": {
      "AidaTouch": {
        "Title": "Auswertungen",
        "Description": "Live-Auswertungen der Kassensoftware - jederzeit & überall abrufbar."
      }
    },
    "Messaging": {
      "SMS": {
        "Title": "SMS Benachrichtigung",
        "Description": "Benachrichtigungen an den Gast per SMS."
      }
    },
    "CloudBackupPOS": {
      "Title": "Cloudsicherung",
      "Description": "Für maximale Ausfallsicherheit werden ausgewählte Dateien deiner Kassensoftware verschlüsselt in die dezentrale Cloud gesichert."
    },
    "CloudBackupPMS": {
      "Title": "Cloudsicherung",
      "Description": "Für maximale Ausfallsicherheit werden ausgewählte Dateien deiner Hotelsoftware verschlüsselt in die dezentrale Cloud gesichert."
    },
    "DigitalReceipt": {
      "Title": "Digitaler Beleg",
      "Description": "Rechnung wird vom Gast gescannt (QR-Code). Zusätzliche Bewertung der Gäste für den Aufenthalt. Spart Kosten in der Anschaffung von Thermopapier & -drucker → kein Papierchaos. Alle digitalen Belege sind 30 Tage nach Rechnungserstellung noch abrufbar."
    },
    "ERegistrationWPrecheckin": {
      "Title": "e-Meldeblatt MIT Pre-Checkin",
      "Description": "Anforderung der Meldedaten werden dem Gast vor Anreise elektronisch übermittelt. Kurzentschlossene Gäste können direkt an der Rezeption via Tablet die Meldedaten ausfüllen. Die Daten werden über die PMS-Schnittstelle digital für die nächsten 7 Jahre aufbewahrt.<br><i class=\"fas fa-triangle-exclamation\"></i><span><i>Tablet ist nicht im Preis enthalten!</i></span>"
    },
    "ERegistrationWOPrecheckin": {
      "Title": "e-Meldeblatt OHNE Pre-Checkin",
      "Description": "Gäste können direkt an der Rezeption via Tablet die Meldedaten ausfüllen. Die Daten werden über die PMS-Schnittstelle digital für die nächsten 7 Jahre aufbewahrt.<br><i class=\"fas fa-triangle-exclamation\"></i><span><i>Tablet ist nicht im Preis enthalten!</i></span>"
    },
    "CustomModule": {
      "POS": {
        "Title": "Kassensystem"
      },
      "PMS": {
        "Title": "Hotelsoftware"
      },
      "Misc": {
        "Title": "Divers"
      }
    },
    "Support": {
      "Report": {
        "Title": "Spezialbericht",
        "Description": "Gerne erstellen wir für dich einen individuellen Bericht, ganz nach deinen Vorstellungen."
      },
      "Training": {
        "Title": "Schulung via Fernwartung",
        "Description": "Wir versuchen all deine Fragen & Anliegen zu beantworten und gehen gezielt auf deine Schulungsbedürfnisse ein."
      },
      "ExtHardware": {
        "Title": "Fremdhardware einrichten",
        "Description": "Auch wenn das Gerät nicht von uns stammt, versuchen wir es, für dich, in unser System zu integrieren."
      },
      "SysCheck": {
        "Title": "Systemcheck",
        "Description": "Durch eine gründliche Überprüfung versuchen wir etwaige Risiken/Bedrohungen deines Systems auszuschließen.",
        "Description1": "Durch eine gründliche Überprüfung",
        "Description2": "versuchen wir etwaige Risiken/Bedrohungen deines Systems auszuschließen.",
        "Tooltip": {
          "Item1": "Datensicherungen und Datensicherungskopien kontrollieren",
          "Item2": "Datenerfassungsprotokolle kontrollieren",
          "Item3": "Windows auf Fehler überprüfen",
          "Item4": "Festplatte auf Fehler überprüfen",
          "Item5": "Windows Updates",
          "Item6": "Temporäre Dateien löschen",
          "Item7": "Festplatte defragmentieren",
          "Item8": "Teamviewer updaten",
          "Item9": "Kassensoftware updaten (kostenlos)",
          "Item10": "Ordermansoftware updaten (kostenlos)"
        }
      },
      "TseStick": {
        "Title": "Technische Sicherheitseinrichtung (TSE)",
        "Description": "Sicherheitseinrichtung für Deutschland. Speicherkapazität & Gültigkeit des Zertifikats für 5 Jahre.",
        "Description1": "Sicherheitseinrichtung für Deutschland",
        "Description2": "Speicherkapazität & Gültigkeit des Zertifikats für 5 Jahre"
      },
      "SetUpBottleDeposit": {
        "Title": "Pfand einrichten",
        "Description": "Wir hinterlegen dir das Pfandsystem auf deine gewünschten Artikel."
      },
      "RKSV": {
        "Title": "RKSV 2017",
        "Description": "Wähle zwischen Basic, Advanced oder Premium für die Registrierkassen-sicherheitsverordnung 2017.",
        "Basic": {
          "Title": "RKSV Basic",
          "Description": "Bis zu 10.000 Signaturen / Jahr"
        },
        "Advanced": {
          "Title": "RKSV Advanced",
          "Description": "Bis zu 30.000 Signaturen / Jahr"
        },
        "Premium": {
          "Title": "RKSV Premium",
          "Description": "Unbegrenzte Signaturen"
        }
      }
    },
    "Custom": {
      "Title": "Custom",
      "AIDATouch": {
        "Title": "Betreuung AIDA-Touch"
      },
      "AIDAx": {
        "Title": "Betreuung AIDA.x"
      },
      "Software": {
        "Title": "Softwaremiete"
      },
      "MaintenanceSoftware": {
        "Title": "Softwaremiete inkl. Betreuung"
      }
    },
    "Units": {
      "Hour": "Stunde",
      "SMS": "SMS",
      "Report": "Bericht",
      "POS": "Kassa",
      "Device": "Gerät",
      "5Years": "5 Jahre",
      "Station": "Standort"
    },
    "POS": {
      "Title": "Kassensystem"
    },
    "PMS": {
      "Title": "Hotelsoftware"
    },
    "Misc": {
      "Title": "Divers"
    },
    "LippCare": {
      "Title": "Lipp Care",
      "Description": "Alles drin, keine unerwarteten Nebenkosten - Anfahrt, Arbeitszeit und Reparaturen inklusive."
    }
  },
  "QuickDateRanges": {
    "Today": "Heute",
    "Yesterday": "Gestern",
    "CurrentWeek": "Aktuelle Woche",
    "CurrentMonth": "Aktuelles Monat",
    "CurrentYear": "Aktuelles Jahr",
    "LastWeek": "Letzte Woche",
    "LastMonth": "Letztes Monat",
    "LastYear": "Letztes Jahr",
    "LastDays": "Letzten {0} Tage",
    "Total": "Gesamt",
    "Custom": "Benutzerdefiniert"
  },
  "Options": {
    "Save": "Speichern",
    "Discard": "Verwerfen",
    "Send": "Senden",
    "Create": "Erstellen",
    "Edit": "Bearbeiten",
    "Change": "Ändern",
    "Deactivate": "Deaktivieren",
    "Activate": "Aktivieren",
    "Synchronize": "Synchronisieren",
    "Next": "Weiter",
    "Back": "Zurück",
    "Delete": "Löschen",
    "Remove": "Entfernen",
    "Reset": "Zurücksetzen",
    "Start": "Starten",
    "Select": "Auswählen",
    "Add": "Hinzufügen",
    "Update": "Aktualisieren",
    "Yes": "Ja",
    "No": "Nein",
    "Replace": "Ersetzen",
    "Confirm": "Bestätigen",
    "Cancel": "Abbrechen",
    "Close": "Schließen"
  },
  "Enterprises": {
    "Title": "Betriebe",
    "Partner": "Partner",
    "CustomerNumber": "Kundennummer",
    "EnterpriseName": "Betriebsname",
    "Street": "Straße",
    "ZipCode": "PLZ",
    "City": "Ort",
    "Country": "Land",
    "CreatedOn": "Erstellt am",
    "ActiveInactive": "Aktiv/Inaktiv",
    "Enterprise": "Betrieb",
    "ActivatedEnterprise": {
      "Success": {
        "Title": "Betrieb aktiviert",
        "Description": "Der Betrieb <b>{0}</b> wurde erfolgreich aktiviert."
      },
      "Error": "Betrieb konnte nicht aktiviert werden"
    },
    "ErrorLoadingEnterprise": "Betrieb konnte nicht geladen werden",
    "CannotDeactivatePartnerEnterprise": "Partnerbetriebe können nicht deaktiviert werden!"
  },
  "TableReservation": {
    "Title": "Reservierungen",
    "Reservation": "Reservierung",
    "List": {
      "ReservationNumber": "Res.-Nr.",
      "FirstName": "Vorname",
      "LastName": "Nachname",
      "Date": "Datum",
      "From": "Von",
      "To": "Bis",
      "Pax": "Pers.",
      "PhoneNumber": "Telefon",
      "Note": "Notiz",
      "GuestNote": "Gastnotiz",
      "InternalNote": "Interne Notiz",
      "Status": {
        "Waiting": "Wartend",
        "Confirmed": "Akzeptiert",
        "Rejected": "Abgelehnt",
        "Canceled": "Storniert"
      },
      "PaymentStatus": {
        "Title": "Zahlungsstatus",
        "Due": "Offen",
        "Paid": "Bezahlt",
        "PaymentFailed": "Fehlgeschlagen",
        "PaymentDataDeposited": "Zahlungsdaten hinterlegt"
      },
      "Tables": "Tische"
    },
    "Overview": {
      "Department": "Abteilung",
      "Table": "Tisch",
      "Seats": "Plätze",
      "ErrorLoadingTables": "Tische konnten nicht geladen werden",
      "ErrorLoadingReservation": "Reservierung konnte nicht geladen werden",
      "ErrorLoadingReservations": "Reservierungen konnten nicht geladen werden",
      "ErrorLoadingSettings": "Einstellungen konnten nicht geladen werden",
      "ErrorLoadingCustomFields": "Freie Felder konnten nicht geladen werden",
      "InternalNote": "Interne Notiz",
      "GuestNote": "Gastnotiz",
      "CreatedInfo": "Erstellt von / am",
      "ModifiedInfo": "Geändert von / am",
      "LockDragAxis": "Verschieben auf eine Richtung beschränken",
      "CheckIn": {
        "Success": {
          "Title": "Check-in erfolgreich",
          "Description": "Die Reservierung mit der Reservierungsnummer <b>{0}</b> wurde eingecheckt."
        },
        "Error": "Check-in fehlgeschlagen"
      }
    },
    "ContextMenu": {
      "Edit": "Reservierung bearbeiten",
      "ChangeColor": "Reservierungsfarbe ändern",
      "CheckIn": "Check-in",
      "Cancel": "Stornieren"
    },
    "DepartmentsAndTables": "Abteilungen & Tische",
    "Reports": {
      "Title": "Berichte",
      "Selection": {
        "Title": "Auswahl",
        "Type": "Typ",
        "Types": {
          "ReservationList": "Reservierungsliste",
          "PlaceCards": "Tischkarten"
        },
        "Period": "Zeitraum",
        "DateFrom": "Datum von",
        "DateTo": "Datum bis",
        "Reports": "Berichte",
        "Print": "Drucken"
      },
      "Criteria": {
        "Title": "Kriterien",
        "Select": "Kriterien auswählen",
        "Save": "Kriterien speichern",
        "Delete": "Kriterien löschen",
        "Criterion": {
          "Departments": {
            "Title": "Abteilungen"
          },
          "Status": {
            "Title": "Status",
            "Waiting": "Wartend",
            "Accepted": "Akzeptiert",
            "Rejected": "Abgelehnt",
            "Cancelled": "Storniert"
          }
        }
      },
      "Preview": {
        "Title": "Vorschau",
        "ReportDesigner": "Bericht Designer",
        "PreviewInfo": "Für deine Auswahl/Kriterien kannst du eine Vorschau erzeugen.",
        "Preview": "Vorschau"
      },
      "ErrorLoadingReports": "Berichte konnten nicht geladen werden",
      "ErrorLoadingPreview": "Vorschau konnte nicht geladen werden",
      "ErrorPrinting": "Bericht konnte nicht gedruckt werden",
      "ErrorDownloading": "Bericht konnte nicht heruntergeladen werden",
      "ErrorLoadingReportDesigner": "Bericht Designer konnte nicht geladen werden"
    },
    "Settings": {
      "Title": "Einstellungen",
      "BasicSettings": {
        "Title": "Grundeinstellungen",
        "MinimumNumberOfPersons": "Mindestpersonenzahl",
        "MaximumNumberOfPersons": "Maximalpersonenanzahl",
        "LeadTime": "Vorlaufzeit Reservierung (Stunden)",
        "DefaultReservationPeriod": "Standard Reservierungsdauer (Minuten)",
        "ReservationHours": "Reservierungszeiten",
        "CheckInColor": "Check-in Farbe",
        "AutomaticRejectionWhenFullyBooked": "Automatische Ablehnung wenn ausgebucht",
        "AutomaticConfirmationWhenFree": "Automatische Bestätigung wenn frei",
        "SuggestAlternativeDatesAutomatically": "Alternative Termine automatisch vorschlagen",
        "DaysIntoTheFuture": "Tag(e) in die Zukunft",
        "SyncTablesAndDepartmentsFromCashSystem": "Abteilungen/Tische vom Kassensystem synchronisieren",
        "PaymentMethods": {
          "Title": "Zahlungsvariante",
          "PaymentRequired": "Zahlung erforderlich",
          "DepositPaymentData": "Zahlungsdaten hinterlegen"
        },
        "UrlAfterFailedPayment": "URL nach fehlgeschlagener Zahlung",
        "PaymentFailedUrl": "https://deine-domain.de/zahlung-fehlgeschlagen",
        "UrlAfterSuccessfulPayment": "URL nach erfolgreicher Zahlung",
        "PaymentSuccessfulUrl": "https://deine-domain.de/zahlung-erfolgreich",
        "RefundAsVoucher": "Erstattung als Gutschein",
        "VoucherPerPax": "Gutschein pro Person",
        "SendAutomatically": "Automatisch versenden",
        "AvailablePaymentMethods": {
          "Title": "Zulässige Zahlungsmethoden",
          "Card": "Kreditkarte",
          "SepaDebit": "SEPA-Lastschrift"
        },
        "SuccessChanging": {
          "Title": "Grundeinstellungen geändert",
          "Description": "Die Grundeinstellungen wurden erfolgreich geändert."
        },
        "ErrorChanging": "Grundeinstellungen konnten nicht geändert werden",
        "SuccessSynchronizing": {
          "Title": "Synchronisierung angestoßen",
          "Description": "Die Synchronisierung der Abteilungen/Tische aus dem Kassensystem wurde erfolgreich angestoßen."
        },
        "ErrorSynchronizing": "Synchronisierung fehlgeschlagen",
        "DataSyncedByPOS": "Daten werden vom Kassensystem synchronisiert!"
      },
      "Departments": {
        "Title": "Abteilungen",
        "Department": "Abteilung",
        "Name": "Bezeichnung",
        "TimePlan": "Zeitplan",
        "Available": "Verfügbar",
        "IsOneTimeSlotBooking": "Einmalige Slot-Buchung",
        "ActiveInactive": "Aktiv/Inaktiv",
        "ErrorChanging": "Abteilung konnte nicht geändert werden",
        "Activated": {
          "Success": {
            "Title": "Abteilung aktiviert",
            "Description": "Die Abteilung <b>{0}</b> wurde erfolgreich aktiviert."
          },
          "Error": "Abteilung konnte nicht aktiviert werden"
        }
      },
      "Tables": {
        "Title": "Tische",
        "Table": "Tisch",
        "Name": "Tischnummer / Bezeichnung",
        "Seats": "Plätze",
        "Department": "Abteilung",
        "Available": "Verfügbar",
        "ActiveInactive": "Aktiv/Inaktiv",
        "ErrorChangingIsAvailable": "Verfügbarkeit konnte nicht geändert werden",
        "Activated": {
          "Success": {
            "Title": "Tisch aktiviert",
            "Description": "Der Tisch <b>{0}</b> wurde erfolgreich aktiviert."
          },
          "Error": "Tisch konnte nicht aktiviert werden"
        }
      },
      "Snippet": {
        "Title": "Widget für die eigene Website",
        "WidgetInfo": "Um das Widget auf der Webseite zu betreiben, müssen folgende Codezeilen eingebunden werden:",
        "Script": "Script",
        "ScriptCopied": "Script kopiert",
        "Widget": "Widget",
        "WidgetCopied": "Widget kopiert",
        "PredefinedValuesInfo": "Vordefinierte Werte können mit folgender Funktion optional eingestellt werden:",
        "FunctionCopied": "Funktion kopiert",
        "NameOfVariable": "VARIABLENNAME",
        "Value": "WERT",
        "NumberOfPersons": "Anzahl der Personen",
        "DateTime": "Datum und Uhrzeit",
        "Name": "Name",
        "Email": "E-Mail",
        "PhoneNumber": "Telefonnummer",
        "Message": "Nachricht",
        "German": "Deutsch",
        "English": "Englisch",
        "French": "Französisch",
        "Headline": "Überschrift",
        "ButtonText": "Button-Text",
        "InfoText": "Info-Text",
        "ConfirmationText": "Bestätigungstext",
        "WidgetField": "Widgetfeld",
        "Display": "Anzeigen",
        "Required": "Pflichtfeld",
        "Colors": "Widget-Farben",
        "WidgetBackgroundColor": "Widget - Hintergrund",
        "WidgetTextColor": "Widget - Text",
        "ButtonBackgroundColor": "Button - Hintergrund",
        "ButtonTextColor": "Button - Text",
        "ButtonBorderColor": "Button - Rahmen",
        "ButtonHoverBackgroundColor": "Button (Highlight) - Hintergrund",
        "ButtonHoverTextColor": "Button (Highlight) - Text",
        "ButtonHoverBorderColor": "Button (Highlight) - Rahmen",
        "InputBackgroundColor": "Eingabefeld - Hintergrund",
        "InputTextColor": "Eingabefeld - Text",
        "InputPlaceholderTextColor": "Eingabefeld (Platzhalter) - Text",
        "ErrorTextColor": "Fehler - Text",
        "LoadingSpinnerColor": "Ladeanimation",
        "Preview": "Vorschau",
        "ErrorLoading": "Widget konnte nicht geladen werden",
        "SuccessChanging": {
          "Title": "Widget geändert",
          "Description": "Das Widget wurde erfolgreich geändert."
        },
        "ErrorChanging": "Widget konnte nicht geändert werden"
      },
      "CustomFields": {
        "Title": "Freie Felder",
        "CustomField": "Freies Feld",
        "FieldType": "Feld-Typ",
        "FieldTypes": {
          "String": "Text",
          "Number": "Zahl",
          "Date": "Datum/Uhrzeit",
          "Selection": "Dropdown-Auswahl",
          "CheckBox": "Checkbox",
          "MultiSelect": "Mehrfach-Auswahl"
        },
        "Name": "Name",
        "DefaultValue": "Standardwert",
        "RequiredInLipp": "Pflichtfeld im Portal",
        "DisplayInWidget": "Anzeige im Widget",
        "RequiredInWidget": "Pflichtfeld im Widget",
        "ActiveInactive": "Aktiv/Inaktiv",
        "ErrorChangingIsMandatory": "Pflichtfeld konnte nicht geändert werden",
        "Email": "E-Mail",
        "PhoneNumber": "Telefonnummer",
        "Message": "Nachricht",
        "EmailDefault": "Ihre E-Mail-Adresse",
        "PhoneNumberDefault": "Ihre Telefonnummer",
        "MessageDefault": "Haben Sie noch eine Anmerkung?",
        "Activated": {
          "Success": {
            "Title": "Freies Feld aktiviert",
            "Description": "Das Freie Feld <b>{0}</b> wurde erfolgreich aktiviert."
          },
          "Error": "Freies Feld konnte nicht aktiviert werden"
        }
      },
      "CustomerInformation": {
        "Title": "Kundeninformationen",
        "Singular": "Kundeninformation",
        "Type": "Typ",
        "Types": {
          "Info": "Info",
          "Warning": "Warnung"
        },
        "Text": "Text",
        "TimePlan": "Zeitplan"
      },
      "QuickLink": {
        "Title": "Quick-Links",
        "List": "Reservierungsliste",
        "Overview": "Reservierungsübersicht",
        "ErrorLoading": "Quick-Links konnten nicht geladen werden",
        "ErrorCreating": "Quick-Links konnten nicht aktualisiert werden"
      }
    },
    "ReservationReceived": {
      "Title": "Tischreservierung eingegangen",
      "Description": "Reservierung von <b>{0} (#{1})</b> beim Betrieb <b>{2}</b> (<b>{3}</b>) eingegangen."
    }
  },
  "LippBon": {
    "Workstations": {
      "Title": "Arbeitsstationen",
      "AmountSelected": "{0} ausgewählt",
      "WorkstationNumber": "AS-Nr.",
      "AppVersion": "App-Version",
      "LastSync": "Letzter Sync",
      "OnOff": "On/Off"
    },
    "Settings": {
      "Title": "Einstellungen",
      "SendToSelectedWorkStations": "Auf ausgewählte AS übertragen",
      "General": {
        "Title": "Allgemein",
        "ShowArticlesInOneColumn": "Artikelanzeige in einer Spalte",
        "ShowQRCodeOnBeltPrinterOrderReceipt": "QR-Code auf Bestellbons am Gürteldrucker anzeigen",
        "HideArticlePackageDetails": "Artikelpaketdetails ausblenden",
        "TipPopupForGuests": "Trinkgeld-Eingabe für den Gast (bei NFC-Kartenzahlung & PMS Transfer)"
      },
      "PrinterNumbers": {
        "Title": "Druckernummern auf Gürteldrucker drucken"
      },
      "CardPayment": {
        "Title": "Kartenzahlung",
        "GpTom": {
          "Title": "Genius mobile pay von Global Payments",
          "InUse": "{0} von {1} verwendet",
          "DisabledText": "Ausgewählte Arbeitsstationen überschreiten Lizenzanzahl",
          "ManageLicenses": "Lizenzen verwalten"
        },
        "PosIt": {
          "Title": "POSit von Hobex",
          "InUse": "{0} von {1} verwendet",
          "DisabledText": "Ausgewählte Arbeitsstationen überschreiten Lizenzanzahl",
          "ManageLicenses": "Lizenzen verwalten"
        }
      },
      "LoggingLevel": "Änderungsprotokoll Level",
      "SuccessChanging": {
        "Title": "Lipp Bon Einstellungen geändert",
        "Description": "Die Einstellungen für die ausgewählten Arbeitsstationen wurden erfolgreich geändert."
      },
      "ErrorChanging": "Lipp Bon Einstellungen konnten nicht geändert werden"
    },
    "Log": {
      "Title": "Änderungsprotokoll",
      "WorkstationNumber": "AS-Nr.",
      "Description": "Beschreibung",
      "Type": "Typ",
      "Types": {
        "Mobile": "Mobil",
        "Web": "Web"
      },
      "User": "Benutzer",
      "DateTime": "Datum/Uhrzeit"
    }
  },
  "CloudBackup": {
    "Title": "Cloudsicherung",
    "Log": "Änderungsprotokoll",
    "LatestBackupAgo": "Zuletzt gesichert vor {0}",
    "LatestBackupOn": "Zuletzt gesichert am {0}",
    "OccupiedStorage": "Belegter Cloudspeicher: {0}",
    "ErrorDownloading": "Dateien konnten nicht heruntergeladen werden",
    "ErrorDownloadingLog": "Änderungsprotokoll konnte nicht heruntergeladen werden",
    "ErrorLoadingInfo": "Infos konnten nicht geladen werden",
    "CannotDownloadLogTooltip": "Der Cloudbackup-Dienst ist offline, daher kann das Änderungsprotokoll nicht heruntergeladen werden."
  },
  "Reports": {
    "TableReservation": {
      "List": {
        "Default": "Tischreservierungsliste A4",
        "WithNotes": "Tischreservierungsliste inkl. Notizen A4"
      },
      "TableCards": {
        "Default": "Tischkarte A4",
        "A4": {
          "TwoReservations": "Tischkarte A4 (2 Reservierungen)"
        },
        "A5": "Tischkarte A5"
      }
    }
  },
  "StationSettings": {
    "EmailDispatch": {
      "Title": "E-Mail Versand",
      "SenderName": "Absender Name",
      "SenderEmail": "Absender E-Mail",
      "ReplyEmail": "Antwort E-Mail",
      "Host": "Postausgangsserver (SMTP)",
      "Port": "Port",
      "UseSSL": "SSL benutzen",
      "Username": "Benutzername",
      "Password": "Passwort",
      "ErrorLoading": "E-Mail Versand konnte nicht geladen werden",
      "SuccessChanging": {
        "Title": "E-Mail Versand geändert",
        "Description": "Die Einstellungen vom E-Mail Versand wurden erfolgreich geändert."
      },
      "ErrorChanging": "E-Mail Versand konnte nicht geändert werden",
      "TestEmail": {
        "Title": "Test E-Mail",
        "Recipient": "Empfänger",
        "Message": "Nachricht",
        "Success": {
          "Title": "Test E-Mail gesendet",
          "Description": "Die Test E-Mail wurde an <b>{0}</b> gesendet."
        },
        "Error": {
          "Title": "Test E-Mail konnte nicht gesendet werden"
        }
      }
    },
    "TextTemplates": {
      "Title": "Textvorlagen",
      "Type": "Typ",
      "Types": {
        "None": " ",
        "Internal": "Intern",
        "Customer": "Kunde",
        "Guest": "Gast"
      },
      "Category": "Kategorie",
      "Categories": {
        "1": "Tischreservierung",
        "2": "Gutscheine",
        "9999": "Sonstiges"
      },
      "Name": "Name",
      "Description": "Beschreibung",
      "NotificationType": "Benachrichtigungsart",
      "NotificationTypes": {
        "None": " ",
        "Email": "E-Mail",
        "SMS": "SMS"
      },
      "Notification": "Benachrichtigung",
      "SmsNotificationCheckboxDisiabledTooltip": "Um diese Benachrichtigung nutzen zu können, muss zuerst \"SMS Benachrichtigung\" abonnieren.",
      "ErrorChangingSendNotification": "Benachrichtigung konnte nicht geändert werden"
    },
    "Schedules": {
      "Title": "Zeitpläne",
      "OpeningHours": "Öffnungszeiten",
      "CreateOpeningHours": "Öffnungszeiten erstellen",
      "EditOpeningHours": "Öffnungszeiten bearbeiten",
      "ClosingDays": "Schließtage",
      "CreateClosingDays": "Schließtage erstellen",
      "EditClosingDays": "Schließtage bearbeiten",
      "SpecialDays": "Spezialtage",
      "CreateSpecialDays": "Spezialtage erstellen",
      "EditSpecialDays": "Spezialtage bearbeiten",
      "Name": "Name",
      "Description": "Beschreibung",
      "Periods": "Zeiträume",
      "From": "Von",
      "To": "Bis",
      "Weekday": "Wochentag",
      "Weekdays": {
        "General": "Allgemein",
        "Monday": "Montag",
        "Tuesday": "Dienstag",
        "Wednesday": "Mittwoch",
        "Thursday": "Donnerstag",
        "Friday": "Freitag",
        "Saturday": "Samstag",
        "Sunday": "Sonntag"
      },
      "FullDay": "Ganztägig",
      "ApplyToOpeningHours": "Auf Öffnungszeiten anwenden",
      "PeriodOrDayEmpty": "Bitte fülle alle Felder bei den Zeiträumen aus.",
      "NoLinkedScheduleSelected": "Bitte wähle einen Zeitplan aus",
      "Created": {
        "Success": {
          "Title": "Zeitplan erstellt",
          "Description": "Der Zeitplan <b>{0}</b> wurde erfolgreich erstellt."
        },
        "Error": "Zeitplan konnte nicht erstellt werden"
      },
      "Changed": {
        "Success": {
          "Title": "Zeitplan geändert",
          "Description": "Der Zeitplan <b>{0}</b> wurde erfolgreich geändert."
        },
        "Error": "Zeitplan konnte nicht geändert werden"
      },
      "ClosingDaysOrSpecialDaysWarning": "Im ausgewählten Zeitraum befinden sich Schließtage/Spezialtage!",
      "ErrorLoadingOpeningHoursSchedules": "Zeitpläne konnten nicht geladen werden",
      "ApplyToSchedule": "Auf Zeitplan anwenden"
    },
    "DeactivateStation": "Standort deaktiveren"
  },
  "PdfViewer": {
    "AutomaticZoom": "Automatisch",
    "ActualSize": "Originalgröße",
    "PageFit": "Seitengröße",
    "PageWidth": "Seitenbreite"
  },
  "EnterpriseSettings": {
    "Title": "Betriebseinstellungen",
    "Stations": {
      "Title": "Standorte",
      "Station": "Standort",
      "OnOff": "On/Off",
      "Type": "Typ",
      "Name": "Bezeichnung",
      "StationCode": "Schnittstellencode",
      "SystemPassword": "Systempasswort",
      "SoftwareVersion": "Software-Version",
      "ActiveInactive": "Aktiv/Inaktiv",
      "CopiedStationCode": "Schnittstellencode kopiert",
      "CopiedSystemPassword": "Systempassword kopiert",
      "Types": {
        "Hotel": "Hotel",
        "Restaurant": "Restaurant",
        "Retail": "Handel"
      },
      "ErrorLoadingStation": "Standort <b>{0}</b> konnte nicht geladen werden"
    },
    "EnterpriseData": {
      "Title": "Betriebsdaten",
      "EnterpriseName": "Betriebsname",
      "VatId": "UID-Nummer",
      "Street": "Straße",
      "Zip": "PLZ",
      "City": "Ort",
      "Country": "Land",
      "Currency": "Währung",
      "CustomerId": "Kundennummer",
      "StripeCustomerId": "Stripe Kundennummer",
      "PhoneNumber": "Telefonnummer",
      "Email": "E-Mail",
      "Website": "Website",
      "Logo": "Logo",
      "ErrorLoading": "Betriebsdaten konnten nicht geladen werden",
      "SuccessChanging": {
        "Title": "Betriebsdaten geändert",
        "Description": "Die Betriebsdaten wurden erfolgreich geändert."
      },
      "ErrorChanging": "Betriebsdaten konnten nicht geändert werden",
      "PaymentViaHogast": "Zahlung via Hogast",
      "HogastCompany": "Mitglied bei",
      "HogastCustomerId": "Mitgliedsnummer",
      "DemoEnterprise": "Demobetrieb",
      "AccountSheet": {
        "Button": "Kontenblatt",
        "Success": {
          "Title": "Kontenblatt exportiert",
          "Description": "Das Kontenblatt wurde erfolgreich als PDF heruntergeladen."
        },
        "Error": "Fehler beim Erstellen des Kontenblatts",
        "NoDataInPeriod": "Im gewählten Zeitraum wurden keine Rechnungen gefunden."
      }
    },
    "BillingAddress": {
      "Title": "Abw. Rechnungsadresse",
      "Salutation": "Anrede",
      "CompanyName": "Firmenname",
      "VatId": "UID-Nummer",
      "Street": "Straße",
      "Zip": "PLZ",
      "City": "Ort",
      "Country": "Land",
      "TitleLabel": "Titel",
      "FirstName": "Vorname",
      "LastName": "Nachname",
      "Email": "E-Mail Rechnung",
      "ErrorLoading": "Abw. Rechnungsadresse konnte nicht geladen werden",
      "SuccessChanging": {
        "Title": "Abw. Rechnungsadresse geändert",
        "Description": "Die abw. Rechnungsadresse wurde erfolgreich geändert."
      },
      "ErrorChanging": "Abw. Rechnungsadresse konnte nicht geändert werden"
    },
    "Permissions": {
      "Title": "Berechtigungen",
      "Categories": "Kategorien",
      "PermissionDetails": "Berechtigungsdetails",
      "Stations": "Standorte",
      "CannotDoThisWithoutSavingTooltip": "Änderungen müssen gespeichert werden um diese Aktion auszuführen.",
      "UserGroups": {
        "Title": "Benutzergruppen",
        "UserGroup": "Benutzergruppe",
        "Staff": "Personal",
        "Admins": "Admins"
      },
      "Users": {
        "Title": "Benutzer",
        "User": "Benutzer"
      },
      "ClientsService": {
        "Title": "Stammdaten",
        "IsStationAdmin": "Standort Admin",
        "ReadStation": "Standort anzeigen"
      },
      "RoomPlanService": {
        "Title": "Hotelpaket",
        "ReadReservations": "Reservierungen anzeigen",
        "BlockRooms": "Zimmer blockieren",
        "ReadStationPmsStatistics": "Auswertungen anzeigen"
      },
      "TableReservationService": {
        "Title": "Tischreservierung",
        "ReadTableReservation": "Reservierungen anzeigen",
        "CreateTableReservation": "Reservierungen erstellen",
        "EditTableReservationStatus": "Reservierungen bearbeiten",
        "ReadTableReservationSettings": "Einstellungen anzeigen",
        "EditTableReservationSettings": "Einstellungen bearbeiten",
        "ReportingOpenReport": "Berichte anzeigen",
        "ReportingEditReport": "Berichte bearbeiten"
      },
      "LippBon": {
        "Title": "Lipp Bon",
        "ReadLippBon": "Einstellungen anzeigen"
      },
      "LippPOS": {
        "Title": "Lipp POS",
        "ListsAndInvoicesOnly": "Nur Listen & Rechnungen"
      },
      "PosStatistics": {
        "Title": "Auswertungen",
        "ReadStationStatistics": "Auswertungen anzeigen"
      },
      "FileService": {
        "Title": "Digitaler Beleg",
        "ReadDigitalReceiptsRatings": "Gästefeedback anzeigen",
        "ReadDigitalReceiptsInvoices": "Rechnungen anzeigen"
      },
      "ErrorLoading": "Berechtigungen konnten nicht geladen werden",
      "SuccessChanging": {
        "Title": "Berechtigungen geändert",
        "Description": "Die Berechtigungen wurden erfolgreich geändert."
      },
      "ErrorChanging": "Berechtigungen konnten nicht geändert werden"
    },
    "UserAdministration": {
      "Title": "Benutzerverwaltung",
      "User": "Benutzer",
      "Email": "E-Mail",
      "Confirmed": "Bestätigt",
      "NotConfirmed": "Nicht bestätigt",
      "SendConfirmationLink": {
        "Title": "Bestätigungslink senden",
        "Success": {
          "Title": "E-Mail gesendet",
          "Description": "E-Mail zum Bestätigen des Benutzers <b>{0}</b> wurde versendet."
        },
        "Error": "E-Mail konnte nicht gesendet werden"
      },
      "ResetPassword": {
        "Title": "Passwort zurücksetzen",
        "Success": {
          "Title": "E-Mail gesendet",
          "Description": "E-Mail zum Zurücksetzen des Passworts für den Benutzer <b>{0}</b> wurde versendet."
        },
        "Error": "Passwort konnte nicht zurückgesetzt werden"
      },
      "ChangeIsEnterpriseAdmin": {
        "Error": "Betriebsadmin konnte nicht geändert werden"
      },
      "Name": "Name",
      "EnterpriseAdmin": "Betriebsadmin",
      "Language": "Sprache"
    },
    "DeactivateEnterprise": {
      "Title": "Betrieb deaktivieren",
      "Dialog": {
        "Text1": "Willst du den Betrieb <b>{0}</b> wirklich deaktivieren?",
        "Text2": "Auf Inhalte von deaktivierten Betrieben (z.B. Standorte, Abonnements, etc.) kann nicht mehr zugegriffen werden!",
        "Text3": "Alle Abonnements aller Standorte des Betriebs werden dabei gekündigt. Abonnements mit laufender Bindung enden erst mit deren Ablauf und werden bis dahin weiter verrechnet.",
        "Success": {
          "Title": "Betrieb deaktiviert",
          "Description": "Der Betrieb <b>{0}</b> wurde erfolgreich deaktiviert."
        },
        "Error": {
          "Title": "Betrieb konnte nicht deaktiviert werden"
        }
      }
    },
    "ActivatedStation": {
      "Success": {
        "Title": "Standort aktiviert",
        "Description": "Der Standort <b>{0}</b> wurde erfolgreich aktiviert."
      },
      "Error": "Standort konnte nicht aktiviert werden"
    },
    "DeactivateStationDialog": {
      "Title": "Standort deaktivieren",
      "Text1": "Willst du den Standort <b>{0}</b> wirklich deaktivieren?",
      "Text2": "Auf Inhalte von deaktivierten Standorten (z.B. Abonnements, Zeitpläne, etc.) kann nicht mehr zugegriffen werden!",
      "Text3": "Alle Abonnements des Standorts werden dabei gekündigt. Abonnements mit laufender Bindung enden erst mit deren Ablauf und werden bis dahin weiter verrechnet.",
      "Success": {
        "Title": "Standort deaktiviert",
        "Description": "Der Standort <b>{0}</b> wurde erfolgreich deaktiviert."
      },
      "Error": {
        "Title": "Standort konnte nicht deaktiviert werden"
      }
    },
    "UserDialog": {
      "AddUser": "Benutzer hinzufügen",
      "EditUser": "Benutzer bearbeiten",
      "Email": "E-Mail",
      "Language": "Sprache",
      "Password": "Passwort",
      "RepeatPassword": "Passwort wiederholen",
      "FirstName": "Vorname",
      "LastName": "Nachname",
      "Station": "Standort",
      "UserGroup": "Benutzergruppe",
      "EnterpriseAdmin": "Betriebsadmin",
      "ErrorLoadingUser": "Benutzer konnte nicht geladen werden",
      "ErrorLoadingUserGroups": "Benutzergruppen konnten nicht geladen werden",
      "Create": {
        "Success": {
          "Title": "Benutzer erstellt",
          "Description": "Der Benutzer <b>{0}</b> wurde erfolgreich erstellt."
        },
        "Error": "Benutzer konnte nicht erstellt werden"
      },
      "Assign": {
        "Info": "Benutzer existiert bereits und wird daher zugewiesen.",
        "ErrorInfo": "Benutzer existiert bereits.",
        "Success": {
          "Title": "Benutzer zugewiesen",
          "Description": "Der Benutzer <b>{0}</b> wurde erfolgreich zugewiesen."
        },
        "Error": "Benutzer konnte nicht zugewiesen werden"
      },
      "Change": {
        "Success": {
          "Title": "Benutzer geändert",
          "Description": "Der Benutzer <b>{0}</b> wurde erfolgreich geändert."
        },
        "Error": "Benutzer konnte nicht geändert werden"
      }
    },
    "UserGroupDialog": {
      "Title": {
        "Create": "Benutzergruppe erstellen",
        "Edit": "Benutzergruppe bearbeiten"
      },
      "Name": "Name",
      "Create": {
        "Success": {
          "Title": "Benutzergruppe erstellt",
          "Description": "Die Benutzergruppe <b>{0}</b> wurde erfolgreich erstellt."
        },
        "Error": "Benutzergruppe konnte nicht erstellt werden"
      },
      "Change": {
        "Success": {
          "Title": "Benutzergruppe geändert",
          "Description": "Die Benutzergruppe <b>{0}</b> wurde erfolgreich geändert."
        },
        "Error": "Benutzergruppe konnte nicht geändert werden"
      }
    },
    "DeleteUserGroupDialog": {
      "Title": "Benutzergruppe löschen",
      "Description": "Willst du die Benutzergruppe <b>{0}</b> wirklich löschen?",
      "Success": {
        "Title": "Benutzergruppe gelöscht",
        "Description": "Die Benutzergruppe <b>{0}</b> wurde erfolgreich gelöscht."
      },
      "Error": {
        "Title": "Benutzergruppe konnte nicht gelöscht werden"
      }
    },
    "RemoveUserDialog": {
      "Title": "Benutzer entfernen",
      "Description": "Willst du den Benutzer <b>{0}</b> wirklich vom Betrieb <b>{1}</b> entfernen?",
      "Success": {
        "Title": "Benutzer entfernt",
        "Description": "Der Benutzer <b>{0}</b> wurde erfolgreich vom Betrieb <b>{1}</b> entfernt."
      },
      "Error": "Benutzer konnte nicht entfernt werden"
    },
    "StationDialog": {
      "Title": {
        "Create": "Standort erstellen",
        "Edit": "Standort bearbeiten"
      },
      "Name": "Bezeichnung",
      "Type": "Typ",
      "Types": {
        "Hotel": "Hotel",
        "Restaurant": "Restaurant",
        "Retail": "Handel"
      },
      "SuccessCreating": {
        "Title": "Standort erstellt",
        "Description": "Der Standort <b>{0}</b> wurde erfolgreich erstellt."
      },
      "ErrorCreating": "Standort konnte nicht erstellt werden",
      "SuccessChanging": {
        "Title": "Standort geändert",
        "Description": "Der Standort <b>{0}</b> wurde erfolgreich geändert."
      },
      "ErrorChanging": "Standort konnte nicht geändert werden"
    },
    "AdminUser": {
      "Title": "Admin-Benutzer",
      "Create": {
        "Title": "Admin-Benutzer erstellen",
        "Email": "E-Mail",
        "Password": "Passwort",
        "RepeatPassword": "Passwort wiederholen",
        "FirstName": "Vorname",
        "LastName": "Nachname",
        "Language": "Sprache",
        "UserMustBeAssigned": "Benutzer existiert bereits und muss daher zugewiesen werden."
      },
      "Assign": {
        "Title": "Admin-Benutzer zuweisen",
        "SearchUser": "Name/E-Mail suchen..."
      },
      "EmptyMessage": "Es muss ein Admin-Benutzer zugewiesen oder erstellt werden."
    }
  },
  "VatId": {
    "Error": {
      "Title": "UID-Nummer konnte nicht überprüft werden"
    }
  },
  "CreateEnterpriseDialog": {
    "Title": "Betrieb erstellen",
    "Success": {
      "Title": "Betrieb erstellt",
      "Description": "Der Betrieb <b>{0}</b> wurde erfolgreich erstellt."
    },
    "Error": "Betrieb konnte nicht erstellt werden",
    "ErrorLoadingAssignableUsers": "Zuweisbare Benutzer konnten nicht geladen werden"
  },
  "Empty": {
    "AppAndWebSolutions": "App- & Weblösungen",
    "ByLinecker": "by Linecker"
  },
  "UniqueUserEmailInput": {
    "ErrorLoading": "E-Mail konnte nicht geprüft werden"
  },
  "Languages": {
    "German": "Deutsch",
    "English": "Englisch",
    "Short": {
      "de": "Deutsch",
      "en": "Englisch"
    }
  },
  "TextTemplateDialog": {
    "ErrorLoadingTextTemplates": "Textvorlage konnte nicht geladen werden",
    "ErrorLoadingPlaceholders": "Platzhalter konnten nicht geladen werden",
    "ErrorChangingTextTemplates": "Textvorlage konnte nicht geändert werden",
    "SuccessChangingTextTemplates": {
      "Title": "Textvorlage geändert",
      "Description": "Die Textvorlage <b>{0}</b> wurde erfolgreich geändert."
    }
  },
  "ResetTextTemplateDialog": {
    "Title": "Textvorlage zurücksetzen",
    "Description": "Willst du die Textvorlage <b>{0}</b> wirklich auf den Standardwert zurücksetzen?",
    "Success": {
      "Title": "Textvorlage zurückgesetzt",
      "Description": "Die Textvorlage <b>{0}</b> wurde erfolgreich zurückgesetzt."
    },
    "Error": "Textvorlage konnte nicht zurückgesetzt werden"
  },
  "DeleteScheduleDialog": {
    "Title": "Zeitplan löschen",
    "Description": "Willst du den Zeitplan <b>{0}</b> wirklich löschen?",
    "Success": {
      "Title": "Zeitplan gelöscht",
      "Description": "Der Zeitplan <b>{0}</b> wurde erfolgreich gelöscht."
    },
    "Error": "Zeitplan konnte nicht gelöscht werden"
  },
  "DepartmentDialog": {
    "Title": {
      "Create": "Abteilung erstellen",
      "Edit": "Abteilung bearbeiten"
    },
    "Name": "Bezeichnung",
    "Schedule": "Zeitplan",
    "Available": "Verfügbar",
    "OneTimeSlotBooking": "Einmalige Slot-Buchung",
    "Create": {
      "Success": {
        "Title": "Abteilung erstellt",
        "Description": "Die Abteilung <b>{0}</b> wurde erfolgreich erstellt."
      },
      "Error": "Abteilung konnte nicht erstellt werden"
    },
    "Edit": {
      "Success": {
        "Title": "Abteilung geändert",
        "Description": "Die Abteilung <b>{0}</b> wurde erfolgreich geändert."
      },
      "Error": "Abteilung konnte nicht geändert werden"
    }
  },
  "DeactivateDepartmentDialog": {
    "Title": "Abteilung deaktivieren",
    "Description": "Willst du die Abteilung <b>{0}</b> wirklich deaktivieren?",
    "Success": {
      "Title": "Abteilung deaktiviert",
      "Description": "Die Abteilung <b>{0}</b> wurde erfolgreich deaktiviert."
    },
    "Error": "Abteilung konnte nicht deaktiviert werden"
  },
  "TableDialog": {
    "Title": {
      "Create": "Tisch erstellen",
      "Edit": "Tisch bearbeiten"
    },
    "Name": "Tischnummer / Bezeichnung",
    "Seats": "Plätze",
    "Department": "Abteilung",
    "AdditionalSeats": "Zusätzliche Plätze (Überbelegung)",
    "Available": "Verfügbar",
    "Create": {
      "Success": {
        "Title": "Tisch erstellt",
        "Description": "Der Tisch <b>{0}</b> wurde erfolgreich erstellt."
      },
      "Error": "Tisch konnte nicht erstellt werden"
    },
    "Edit": {
      "Success": {
        "Title": "Tisch geändert",
        "Description": "Der Tisch <b>{0}</b> wurde erfolgreich geändert."
      },
      "Error": "Tisch konnte nicht geändert werden"
    }
  },
  "DeactivateTableDialog": {
    "Title": "Tisch deaktivieren",
    "Description": "Willst du den Tisch <b>{0}</b> wirklich deaktivieren?",
    "Success": {
      "Title": "Tisch deaktiviert",
      "Description": "Der Tisch <b>{0}</b> wurde erfolgreich deaktiviert."
    },
    "Error": "Tisch konnte nicht deaktiviert werden"
  },
  "SsoAuthorize": {
    "ErrorTitle": "Anmeldung nicht möglich"
  },
  "OAuthConsent": {
    "Title": "{0} möchte auf dein Lipp Portal zugreifen",
    "RedirectHost": "Der Zugriff geht an {0}",
    "LoopbackWarning": "Die Anwendung läuft auf diesem Gerät (localhost). Erlaube den Zugriff nur, wenn du die Verbindung gerade selbst gestartet hast.",
    "Account": "Angemeldet als",
    "Permissions": "Die Anwendung darf",
    "Scopes": {
      "Read": "Daten lesen, die du im Lipp Portal siehst: Umsätze, Rechnungen, Artikel, Kassenbuch, Kassenstatus, Tischreservierungen, Abos und die Rechnungen von Linecker",
      "NoWrite": "nichts ändern, buchen oder löschen"
    },
    "LineckerAccount": "Mit deinem Linecker-Konto ist der Zugriff nur lesend. Verwende ihn nur mit dem Firmenkonto von Claude bzw. ChatGPT, nicht mit einem privaten Konto.",
    "RevokeInfo": "Du kannst den Zugriff jederzeit in den Profileinstellungen unter „Verbundene Anwendungen“ trennen.",
    "Allow": "Zugriff erlauben",
    "Deny": "Ablehnen",
    "ErrorTitle": "Verbindung nicht möglich",
    "Framed": "Diese Seite lässt sich nur direkt im Browser öffnen, nicht eingebettet in eine andere Seite."
  },
  "Statistics": {
    "POS": {
      "ErrorLoadingOnlineStatus": "Online-Status konnte nicht geladen werden",
      "Overview": {
        "Title": "Übersicht",
        "Billed": "Abgerechnet",
        "Open": "Offen",
        "Total": "Gesamt",
        "ErrorLoading": "Übersicht konnte nicht geladen werden"
      },
      "MonthlyOverview": {
        "Title": "30-Tage Übersicht",
        "ErrorLoading": "30-Tage Übersicht konnte nicht geladen werden"
      },
      "DetailedStatistics": {
        "Title": "Detaillierte Auswertungen",
        "ErrorLoading": "Detaillierte Auswertungen konnten nicht geladen werden",
        "CommodityGroups": {
          "Title": "Warengruppen",
          "Billed": "Abgerechnet",
          "Open": "Offen",
          "Total": "Gesamt",
          "Sum": "Summe"
        },
        "Users": {
          "Title": "Benutzer"
        },
        "PaymentMethods": {
          "Title": "Zahlungsmittel",
          "PerPaymentMethod": "pro ZM",
          "PerInvoice": "pro Rechnung",
          "Total": "Gesamt"
        }
      },
      "Reports": {
        "Title": "Berichte",
        "EmptyMessage": "Keine Berichte",
        "OfflineMessage": "Berichte können nur geladen werden, wenn das Kassensystem online ist.",
        "ErrorLoading": "Berichte konnten nicht geladen werden",
        "ErrorLoadingReport": "Bericht konnte nicht geladen werden"
      }
    },
    "PMS": {
      "ErrorLoadingOnlineStatus": "Online-Status konnte nicht geladen werden",
      "Overview": {
        "Title": "Übersicht",
        "OccupancyRate": "Auslastung",
        "OvernightStays": "Nächtigungen",
        "Billed": "Abgerechnet",
        "Open": "Offen",
        "Total": "Gesamt",
        "ErrorLoading": "Übersicht konnte nicht geladen werden"
      },
      "MonthlyOverview": {
        "Title": "30-Tage Übersicht",
        "ErrorLoading": "30-Tage Übersicht konnte nicht geladen werden"
      },
      "DetailedStatistics": {
        "Title": "Detaillierte Auswertungen",
        "ErrorLoading": "Detaillierte Auswertungen konnten nicht geladen werden",
        "Guests": {
          "Title": "Gäste",
          "Arrival": "Anreise",
          "Inhouse": "Inhouse",
          "Departure": "Abreise",
          "PaxRooms": "Pers. / Zim.",
          "PerGuest": "pro Gast",
          "Total": "Gesamt",
          "Guests": "Gäste",
          "Groups": "Gruppen",
          "RoomPax": "Zi (Pers.)",
          "GuestName": "Gastname",
          "Group": "Gruppe",
          "Pax": "Pers.",
          "Rooms": "Zimmer"
        },
        "CommodityGroups": {
          "Title": "Warengruppen",
          "InvoiceJournal": "Rechnungsjournal",
          "SalesReport": "Umsatzbericht",
          "Invoices": "Rechnungen",
          "PerInvoice": "pro Rechnung",
          "Total": "Gesamt",
          "PerDay": "pro Tag"
        },
        "Channels": {
          "Title": "Kanäle",
          "NumberOfBookings": "Anzahl Buchungen",
          "PerChannel": "pro Kanal",
          "Total": "Gesamt"
        },
        "PaymentMethods": {
          "Title": "Zahlungsmittel",
          "PerPaymentMethod": "pro ZM",
          "PerInvoice": "pro Rechnung",
          "Total": "Gesamt"
        }
      }
    }
  },
  "Stations": {
    "Modules": {
      "Title": "Modulübersicht",
      "Module": "Modul",
      "Activated": "Aktiviert",
      "NotActivated": "Nicht aktiviert",
      "Modules": "Module",
      "Trial": "Testzeitraum",
      "StartTrial": "Testzeitraum starten",
      "Subscribe": "Abonnieren",
      "Order": "Bestellen",
      "ChangeLicenceQuantity": "Lizenzmenge ändern",
      "ChangeLicenceQuantityDisabledTooltip": "Um die Lizenzmenge ändern zu können, muss das Modul vorerst gekündigt und erneut mit der gewünschten Menge lizenziert werden.",
      "EditModule": "Modul bearbeiten",
      "Settings": "Einstellungen",
      "Licence": "Lizenz",
      "Licences": "Lizenzen",
      "Day": "Tag",
      "Week": "Woche",
      "Month": "Monat",
      "Year": "Jahr",
      "TrialUntil": "Kostenlos bis {0}",
      "AvailableUntil": "{0}x {1} verfügbar bis {2}",
      "CancelSubscription": "Modul(e) kündigen",
      "Cancel": "Kündigen",
      "Warning": "Achtung!",
      "WarningText": "Auf Inhalte von gekündigten Modulen kann nicht mehr zugegriffen werden!",
      "CanceledOn": "per {0}",
      "DeactivationOn": "Deaktivierung am {0}",
      "ActivationOn": "Aktivierung am {0}",
      "CertificateExpiresOn": "Zertifikat läuft ab am {0}",
      "PaymentPending": "Zahlung ausstehend",
      "WaitingForPaymentReceipt": "Warten auf Zahlungseingang",
      "NoModulesActivated": "Es wurden noch keine Module aktiviert.",
      "AllModulesActivated": "Es wurden bereits alle Module aktiviert.",
      "AddPaymentMethodTooltip": "Bitte Zahlungsmethode hinzufügen!",
      "SwitchToManualPayment": "Auf manuelle Zahlung umstellen",
      "StartPayment": "Zahlung starten",
      "SwitchedToManualPayment": {
        "Success": {
          "Title": "Zahlung umgestellt",
          "Description": "Die Zahlung wurde erfolgreich auf manuelle Abbuchung umgestellt."
        },
        "Error": "Zahlung konnte nicht umgestellt werden"
      },
      "StartTrialDialog": {
        "Title": "{0} testen",
        "Description1": "Willst du <b>{0}</b> bis zum <b>{1}</b> kostenlos aktivieren?",
        "Description2": "Nach Ablauf des Testzeitraums wird das Abonnement gestartet und die bereits von dir eingegebenen Daten bleiben erhalten."
      },
      "SubscriptionDialog": {
        "PaymentIntervals": {
          "Title": "Zahlungsintervall auswählen",
          "Monthly": "monatlich",
          "OneYearInAdvance": "jährlich",
          "YearsCommitment": "jährlich ({0} Jahre Bindung)",
          "Seasonal": "saisonell",
          "MonthPerDevice": "Monat pro Gerät",
          "YearPerDevice": "Jahr pro Gerät",
          "YearsPerDevice": "Jahr pro Gerät",
          "OneTime": "einmalig"
        },
        "MonthSingular": "Monat",
        "MonthPlural": "Monate",
        "Save": "{0} jährlich sparen!",
        "ToCheckout": "Zur Zahlung",
        "CheckoutProcess": "Zahlungsprozess",
        "SelectAmount": "Anzahl auswählen",
        "DiscountFrom": "ab {0}",
        "ReadPrivacyPolicy": "Ich habe die <a href='https://www.linecker.at/datenschutzerklaerung/' target='_blank'>Datenschutzbestimmungen</a> gelesen und stimme ihnen zu.",
        "ReadTermsAndConditions": "Ich bin mit den <a href='https://www.linecker.at/agb/' target='_blank'>Allgemeinen Geschäftsbedingungen</a> einverstanden.",
        "PaymentLink": "Zahlungslink",
        "PaymentStart": "Zahlungsstart"
      },
      "LippBonDisabledToolTip": "Für die Verwaltung der Lipp Bon Lizenzen kontaktiere bitte unseren Vertrieb +43 7755 20 995-70 / verkauf@linecker.at",
      "CreateModuleDialog": {
        "Title": "Modul erstellen",
        "ModuleName": "Modulname",
        "ModuleDescription": "Modulbeschreibung",
        "InternalNotes": "Interne Notizen",
        "MiscellaneousModule": "Kategorie \"diverses Modul\"",
        "PaymentInterval": {
          "Title": "Zahlungsintervall",
          "Monthly": "monatlich",
          "Yearly": "jährlich"
        },
        "Price": "Betrag (netto)",
        "PaymentStart": "Zahlungsstart",
        "Costs": "Einkauf",
        "CostsPerMonth": "EK-Preis / Monat",
        "CostsPerYear": "EK-Preis / Jahr",
        "Profit": "Gewinn"
      },
      "EditModuleDialog": {
        "Title": "Modul bearbeiten"
      },
      "Log": {
        "Title": "Änderungsprotokoll",
        "ModuleName": "Modulname",
        "Description": "Beschreibung",
        "InternalNotes": "Interne Notizen",
        "User": "Benutzer",
        "DateTime": "Datum/Uhrzeit",
        "ProtocolTypes": {
          "10000": "Sonstiges.",
          "10010": "Rechnung wurde erstellt.",
          "10019": "Rechnung wurde versendet.",
          "10025": "Testzeitraum wurde aktiviert.",
          "10026": "Testzeitraum endet in Kürze.",
          "10029": "Testzeitraum ist abgelaufen.",
          "10040": "Zahlungsvorgang war erfolgreich.",
          "10050": "1. Zahlungsvorgang ist fehlgeschlagen.",
          "10051": "Ein weiterer Zahlungsvorgang ist fehlgeschlagen.",
          "10059": "Zahlungsvorgang ist entgültig fehlgeschlagen.",
          "10060": "Modul wurde gekündigt.",
          "10070": "Modul wurde abonniert.",
          "10071": "Lizenzmenge wurde von {0} auf {1} geändert.",
          "10072": "Modul wurde nicht bezahlt.",
          "10073": "Modul wurde deaktiviert."
        }
      },
      "From": "ab",
      "PaymentMethod": "Zahlung via {0}",
      "PaymentMethods": {
        "0": "Unbekannt",
        "1": "Kreditkarte",
        "2": "S€PA",
        "3": "Hogast",
        "9999": "manueller Abbuchung"
      },
      "AlreadyActive": "Bereits aktiv",
      "Activate": "Aktivieren",
      "Deactivate": "Deaktivieren",
      "ErrorTogglingIntegration": "Integration konnte nicht geändert werden",
      "ErrorTogglingExtension": "Erweiterung konnte nicht geändert werden",
      "CardPaymentIntegrationAlreadyActive": "Es ist bereits eine Integration mit NFC-Kartenzahlung aktiv.",
      "AllLicencesInUse": "Alle Lizenzen bereits in Verwendung."
    }
  },
  "CopyToClipboard": {
    "LinkCopied": "Link kopiert"
  },
  "PaymentLinkDialog": {
    "Title": "Zahlungslink"
  },
  "CustomModuleDialog": {
    "Create": "Abonnement erstellen",
    "Edit": "Abonnement bearbeiten",
    "Category": "Kategorie",
    "ModuleDescription": "Beschreibung",
    "InternalNotes": "Interne Notizen",
    "MiscellaneousModule": "Kategorie \"diverses\"",
    "PaymentInterval": {
      "Title": "Zahlungsintervall",
      "Monthly": "monatlich",
      "Yearly": "jährlich",
      "YearsCommitment": "jährlich ({0} Jahre Bindung)"
    },
    "Price": "Betrag (netto)",
    "PaymentStart": "Zahlungsstart",
    "Costs": "Einkauf",
    "CostsPerMonth": "EK-Preis / Monat",
    "CostsPerYear": "EK-Preis / Jahr",
    "Profit": "Gewinn",
    "ErrorLoadingModule": "Abonnement konnte nicht geladen werden",
    "SuccessCreating": {
      "Title": "Abonnement erstellen",
      "Description": "Das Abonnement <b>{0}</b> wurde erfolgreich erstellt."
    },
    "ErrorCreating": "Abonnement konnte nicht erstellt werden",
    "SuccessChanging": {
      "Title": "Abonnement bearbeitet",
      "Description": "Das Abonnement <b>{0}</b> wurde erfolgreich bearbeitet."
    },
    "ErrorChanging": "Abonnement konnte nicht bearbeitet werden"
  },
  "ModuleTrialDialog": {
    "Title": "{0} testen",
    "Description1": "Willst du <b>{0}</b> bis zum <b>{1}</b> kostenlos aktivieren?",
    "Description2": "Nach Ablauf des Testzeitraums wird das Abonnement gestartet und die bereits von dir eingegebenen Daten bleiben erhalten.",
    "Success": {
      "Title": "Testzeitraum gestartet",
      "Description": "Testzeitraum <b>{0}</b> wurde erfolgreich gestartet."
    },
    "Error": "Testzeitraum konnte nicht gestartet werden"
  },
  "ModuleSubscriptionDialog": {
    "Title": {
      "Subscribe": "{0} abonnieren",
      "Order": "{0} bestellen",
      "ChangeLicenceQuantity": "{0} - Lizenzmenge ändern"
    },
    "PaymentIntervals": {
      "Title": "Zahlungsintervall auswählen",
      "Monthly": "monatlich",
      "OneYearInAdvance": "jährlich",
      "YearsCommitment": "jährlich ({0} Jahre Bindung)",
      "Seasonal": "saisonell",
      "MonthPerDevice": "Monat pro Gerät",
      "YearPerDevice": "Jahr pro Gerät",
      "YearsPerDevice": "Jahr pro Gerät",
      "OneTime": "einmalig"
    },
    "MonthSingular": "Monat",
    "MonthPlural": "Monate",
    "Save": "{0} jährlich sparen!",
    "ToCheckout": "Zur Zahlung",
    "CheckoutProcess": "Zahlungsprozess",
    "SelectAmount": "Anzahl auswählen",
    "DiscountFrom": "ab {0}",
    "PaymentLink": "Zahlungslink",
    "ReadPrivacyPolicy": "Ich habe die <a href='https://www.linecker.at/datenschutzerklaerung/' target='_blank'>Datenschutzbestimmungen</a> gelesen und stimme ihnen zu.",
    "ReadTermsAndConditions": "Ich bin mit den <a href='https://www.linecker.at/agb/' target='_blank'>Allgemeinen Geschäftsbedingungen</a> einverstanden.",
    "SuccessSubscribing": {
      "Title": "<b>{0}</b> abonniert",
      "Description": "<b>{0}</b> wurde erfolgreich abonniert."
    },
    "ErrorSubscribing": "<b>{0}</b> konnte nicht abonniert werden",
    "SuccessChangingLicenceQuantity": {
      "Title": "Lizenzmenge geändert",
      "Description": "Die Lizenzmenge von <b>{0}</b> wurde erfolgreich geändert."
    },
    "ErrorChangingLicenceQuantity": "Lizenzmenge konnte nicht geändert werden",
    "SendMail": "Bestätigungsmail senden",
    "SentMail": {
      "Title": "Bestätigungsmail gesendet",
      "Description": "Die E-Mail mit dem Bestätigungslink wurde versendet."
    }
  },
  "RoomPlan": {
    "Title": "Zimmerplan",
    "BlockRoom": "Zimmer blockieren",
    "Room": "Zimmer",
    "Category": "Kategorie",
    "ErrorLoadingReservations": "Reservierungen konnten nicht geladen werden",
    "ErrorLoadingRooms": "Zimmer konnten nicht geladen werden",
    "ErrorLoadingSettings": "Einstellungen konnten nicht geladen werden",
    "ReservationLocked": "Reservierung gesperrt",
    "DepositState": {
      "Done": "Anzahlung eingegangen",
      "Outstanding": "Anzahlung ausstehend",
      "Overdue": "Anzahlung überfällig"
    },
    "Source": "Quelle: {0}",
    "Accessible": "Barrierefrei"
  },
  "RejectReservationDialog": {
    "Title": "Reservierung ablehnen",
    "Description": "Willst du die Reservierung von <b>{0}</b> mit der Reservierungsnummer <b>{1}</b> wirklich ablehnen?",
    "Reject": "Ablehnen",
    "Success": {
      "Title": "Reservierung abgelehnt",
      "Description": "Die Reservierung mit der Reservierungsnummer <b>{0}</b> wurde erfolgreich abgelehnt."
    },
    "Error": "Reservierung konnte nicht abgelehnt werden"
  },
  "CancelReservationDialog": {
    "Title": "Reservierung stornieren",
    "Description": "Willst du die Reservierung von <b>{0}</b> mit der Reservierungsnummer <b>{1}</b> wirklich stornieren?",
    "Cancel": "Stornieren",
    "Success": {
      "Title": "Reservierung storniert",
      "Description": "Die Reservierung mit der Reservierungsnummer <b>{0}</b> wurde erfolgreich storniert."
    },
    "Error": "Reservierung konnte nicht storniert werden"
  },
  "ReservationColorDialog": {
    "Title": "Reservierungsfarbe ändern",
    "Color": "Farbe",
    "Success": {
      "Title": "Reservierungsfarbe geändert",
      "Description": "Die Farbe der Reservierung mit der Reservierungsnummer <b>{0}</b> wurde erfolgreich geändert."
    },
    "Error": "Reservierungsfarbe konnte nicht geändert werden"
  },
  "CloneReportDialog": {
    "Title": "Bericht duplizieren",
    "Name": "Name",
    "Clone": "Duplizieren",
    "Copy": "Kopie",
    "Success": {
      "Title": "Bericht dupliziert",
      "Description": "Der Bericht <b>{0}</b> wurde erfolgreich dupliziert."
    },
    "Error": "Bericht konnte nicht dupliziert werden"
  },
  "RenameReportDialog": {
    "Title": "Bericht umbenennen",
    "Name": "Name",
    "Success": {
      "Title": "Bericht umbenannt",
      "Description": "Der Bericht <b>{0}</b> wurde erfolgreich umbenannt."
    },
    "Error": "Bericht konnte nicht umbenannt werden"
  },
  "ResetReportDialog": {
    "Title": "Bericht zurücksetzen",
    "Description": "Willst du den Bericht <b>{0}</b> wirklich zurücksetzen?",
    "Success": {
      "Title": "Bericht zurückgesetzt",
      "Description": "Der Bericht <b>{0}</b> wurde erfolgreich zurückgesetzt."
    },
    "Error": "Bericht konnte nicht zurückgesetzt werden"
  },
  "ReportDataSourcesDialog": {
    "Title": "Datenquellen",
    "ErrorLoading": "Datenquellen konnten nicht geladen werden",
    "NoData": "Keine Daten gefunden."
  },
  "ReportCriteriaDialog": {
    "Title": "Kriterien auswählen",
    "Presets": "Gespeicherte Kriterien"
  },
  "ReportPresetDialog": {
    "Title": "Kriterien speichern",
    "Name": "Name",
    "Success": {
      "Title": "Kriterien gespeichert",
      "Description": "Die Kriterien wurden erfolgreich als <b>{0}</b> gespeichert."
    },
    "Error": "Kriterien konnten nicht gespeichert werden"
  },
  "DeletePresetDialog": {
    "Title": "Gespeicherte Kriterien löschen",
    "Description": "Willst du die gespeicherten Kriterien <b>{0}</b> wirklich löschen?",
    "Success": {
      "Title": "Gespeicherte Kriterien gelöscht",
      "Description": "Die gespeicherte Kriterien <b>{0}</b> wurden erfolgreich gelöscht."
    },
    "Error": "Gespeicherte Kriterien konnten nicht gelöscht werden"
  },
  "CustomerInformationDialog": {
    "Title": {
      "Create": "Kundeninformation erstellen",
      "Edit": "Kundeninformation bearbeiten"
    },
    "Type": "Typ",
    "Types": {
      "Info": "Info",
      "Warning": "Warnung"
    },
    "Schedule": "Zeitplan",
    "Text": "Text",
    "Create": {
      "Success": {
        "Title": "Kundeninformation erstellt",
        "Description": "Die Kundeninformation wurde erfolgreich erstellt."
      },
      "Error": "Kundeninformation konnte nicht erstellt werden"
    },
    "Edit": {
      "Success": {
        "Title": "Kundeninformation geändert",
        "Description": "Die Kundeninformation wurde erfolgreich geändert."
      },
      "Error": "Kundeninformation konnte nicht geändert werden"
    }
  },
  "DeleteCustomerInformationDialog": {
    "Title": "Kundeninformation löschen",
    "Description": "Willst du die Kundeninformation wirklich löschen?",
    "Success": {
      "Title": "Kundeninformation gelöscht",
      "Description": "Die Kundeninformation wurde erfolgreich gelöscht."
    },
    "Error": "Kundeninformation konnte nicht gelöscht werden"
  },
  "CustomFieldDialog": {
    "Title": {
      "Create": "Freies Feld erstellen",
      "Edit": "Freies Feld bearbeiten"
    },
    "Type": "Typ",
    "Types": {
      "String": "Text",
      "Number": "Zahl",
      "DateTime": "Datum/Uhrzeit",
      "Checkbox": "Checkbox",
      "Dropdown": "Dropdown-Auswahl",
      "MultiSelect": "Mehrfach-Auswahl"
    },
    "Name": "Name",
    "Description": "Beschreibung",
    "IsMandatoryInLipp": "Pflichtfeld im Portal",
    "DisplayInWidget": "Anzeige im Widget",
    "IsMandatoryInWidget": "Pflichtfeld im Widget",
    "DefaultValue": "Standardwert",
    "Items": "Einträge",
    "Create": {
      "Success": {
        "Title": "Freies Feld erstellt",
        "Description": "Das Freies Feld <b>{0}</b> wurde erfolgreich erstellt."
      },
      "Error": "Freies Feld konnte nicht erstellt werden"
    },
    "Edit": {
      "Success": {
        "Title": "Freies Feld geändert",
        "Description": "Das Freies Feld <b>{0}</b> wurde erfolgreich geändert."
      },
      "Error": "Freies Feld konnte nicht geändert werden"
    }
  },
  "DeactivateCustomFieldDialog": {
    "Title": "Freies Feld deaktivieren",
    "Description": "Willst du das freie Feld <b>{0}</b> wirklich deaktivieren?",
    "Success": {
      "Title": "Freies Feld deaktiviert",
      "Description": "Das freie Feld <b>{0}</b> wurde erfolgreich deaktiviert."
    },
    "Error": "Freies Feld konnte nicht deaktiviert werden"
  },
  "TableReservationDialog": {
    "Title": {
      "Create": "Reservierung erstellen",
      "Edit": "Reservierung bearbeiten"
    },
    "Pax": "Personen",
    "From": "Von",
    "To": "Bis",
    "FirstName": "Vorname",
    "LastName": "Nachname",
    "Email": "E-Mail",
    "PhoneNumber": "Telefonnummer",
    "InternalNote": "Interne Notiz",
    "GuestNote": "Gastnotiz",
    "ReservationColor": "Reservierungsfarbe",
    "SelectedSeatsForPersons": "{0} Plätze für {1} Personen ausgewählt",
    "AvailableTables": "Verfügbar",
    "SelectedTables": "Ausgewählt",
    "Seats": "Plätze",
    "SearchTablesAndDepartments": "Tische/Abteilungen suchen...",
    "Available": "verfügbar",
    "NotAvailable": "nicht verfügbar",
    "24hReminder": "Reservierungserinnerung (24h vorab)",
    "Reject": "Ablehnen",
    "Cancel": "Stornieren",
    "Create": {
      "Success": {
        "Title": "Reservierung erstellt",
        "Description": "Die Reservierung für <b>{0} (#{1})</b> wurde erfolgreich erstellt."
      },
      "Error": "Reservierung konnte nicht erstellt werden"
    },
    "Edit": {
      "Success": {
        "Title": "Reservierung geändert",
        "Description": "Die Reservierung von <b>{0} (#{1})</b> wurde erfolgreich geändert."
      },
      "Error": "Reservierung konnte nicht geändert werden"
    },
    "ErrorLoadingTables": "Tische konnten nicht geladen werden"
  },
  "SearchReservationDialog": {
    "Title": "Reservierung suchen",
    "Name": "Name",
    "Arrival": "Ankunft",
    "Departure": "Abreise",
    "ReservationNumber": "Reservierungsnummer",
    "BookingNumber": "Buchungsnummer",
    "Search": "Suchen",
    "ErrorSearching": "Suchergebnisse konnten nicht geladen werden",
    "SearchResults": "Suchergebnisse",
    "ReservationNo": "Res.-Nr.",
    "BookingNo": "Bu.-Nr.",
    "BackToSearch": "Zurück zur Suche"
  },
  "BlockRoomDialog": {
    "Title": "Zimmer blockieren",
    "Arrival": "Ankunft",
    "Departure": "Abreise",
    "FirstName": "Vorname",
    "LastName": "Nachname",
    "Email": "E-Mail",
    "PhoneNumber": "Telefonnummer",
    "Notes": "Notizen",
    "Block": "Blockieren",
    "ErrorLoadingAvailableRoomCategories": "Zimmer konnten nicht geladen werden",
    "NoCategory": "Keine Kategorie",
    "Success": {
      "Title": "Zimmer blockiert",
      "Description": "Die ausgewählten Zimmer wurden erfolgreich blockiert."
    },
    "ErrorBlocking": "Zimmer konnten nicht blockiert werden"
  },
  "ReservationInfoDialog": {
    "ErrorLoading": "Reservierungsinfos konnten nicht geladen werden"
  },
  "DigitalReceipt": {
    "Invoices": {
      "Title": "Belege",
      "InvoiceNumber": "Nummer",
      "DateTime": "Datum/Uhrzeit",
      "Gross": "Brutto",
      "User": "Benutzer",
      "ScannedOn": "Gescannt am {0}",
      "Room": "Zimmer",
      "Signed": "Vom Gast unterschrieben"
    },
    "TotalFeedback": {
      "Title": "Gästefeedback Gesamt",
      "Rating": "{0} von {1}",
      "NoEntries": "Keine Einträge",
      "ErrorLoading": "Gästefeedback Gesamt konnte nicht geladen werden"
    },
    "UserFeedback": {
      "Title": "Gästefeedback pro Benutzer",
      "Name": "Name",
      "Count": "Anzahl Feedback",
      "Average": "Durchschnitt"
    }
  },
  "OpenApi": {
    "Title": "Open API",
    "ApiKey": "API-Schlüssel",
    "Station": "Standort",
    "Name": "Bezeichnung",
    "NoName": "Ohne Bezeichnung",
    "Key": "Schlüssel",
    "CreatedOn": "Erstellt am",
    "CreatedBy": "Erstellt von",
    "LastUsedOn": "Zuletzt benutzt",
    "Never": "Nie",
    "TotalCalls": "Aufrufe gesamt",
    "CallsLast30Days": "Aufrufe 30 Tage",
    "ErrorsLast30Days": "Fehler 30 Tage",
    "SearchPlaceholder": "Suchen",
    "NoKeys": "Noch keine API-Schlüssel",
    "NoSearchResults": "Keine Treffer",
    "CopyShareLink": "Einmal-Link kopieren",
    "Usage": "Auswertung",
    "Rename": "Bezeichnung ändern",
    "Delete": "Löschen",
    "ShareLinkCopied": "Einmal-Link kopiert",
    "ShareLinkCopiedDescription": "Der Link gilt 7 Tage und lässt sich nur einmal öffnen.",
    "Created": "API-Schlüssel angelegt",
    "Renamed": "Bezeichnung geändert",
    "Deleted": "API-Schlüssel gelöscht",
    "DeletedDescription": "Anbieter mit diesem Schlüssel werden spätestens nach 1 Minute abgewiesen.",
    "ErrorLoading": "API-Schlüssel konnten nicht geladen werden",
    "ErrorLoadingRetry": "Die API-Schlüssel konnten nicht geladen werden. Bitte über „Aktualisieren“ erneut versuchen.",
    "ErrorCreating": "API-Schlüssel konnte nicht angelegt werden",
    "ErrorRenaming": "Bezeichnung konnte nicht geändert werden",
    "ErrorDeleting": "API-Schlüssel konnte nicht gelöscht werden",
    "ErrorShareLink": "Einmal-Link konnte nicht erstellt werden",
    "Errors": {
      "NotLineckerEmployee": "Die Lipp API hat nicht bestätigt, dass du Linecker-Mitarbeiter bist. Nur Linecker-Mitarbeiter können API-Schlüssel verwalten. Ist die Anmeldung abgelaufen, bitte neu anmelden.",
      "StationRequired": "Bitte einen Standort wählen.",
      "NameRequired": "Bitte eine Bezeichnung eingeben.",
      "NameTooLong": "Die Bezeichnung darf höchstens 100 Zeichen lang sein.",
      "NoLippPosRegistered": "An diesem Standort ist keine Lipp POS angemeldet.",
      "KeyNotFound": "Diesen API-Schlüssel gibt es nicht mehr. Bitte die Liste aktualisieren.",
      "ShareLinkFailed": "onetimesecret.com ist gerade nicht erreichbar. Bitte später erneut versuchen.",
      "ShareLinkFailedAfterCreate": "Der Einmal-Link konnte nicht erstellt werden. Bitte über das Kopier-Symbol erneut versuchen.",
      "NotAvailableYet": "Diese Funktion ist in Lipp Connect noch nicht verfügbar."
    },
    "Dialogs": {
      "Key": {
        "CreateTitle": "Neuer API-Schlüssel",
        "RenameTitle": "Bezeichnung ändern",
        "NamePlaceholder": "z. B. Name des Anbieters",
        "CreateHint": "Nach dem Anlegen liegt ein Einmal-Link zum Schlüssel in der Zwischenablage."
      },
      "Usage": {
        "Title": "Auswertung",
        "Calls": "Aufrufe",
        "CallsSummary": "{0} gesamt · {1} in 30 Tagen · {2} Fehler in 30 Tagen",
        "Endpoints": "Aufrufe je Endpunkt",
        "Endpoint": "Endpunkt",
        "CountValue": "Aufrufe: {0}",
        "ErrorsValue": "Fehler: {0}",
        "LastCall": "Zuletzt",
        "LastCalls": "Letzte Aufrufe",
        "Time": "Zeit",
        "Status": "Status",
        "Duration": "Dauer",
        "NoCalls": "Mit diesem Schlüssel gab es noch keine Aufrufe.",
        "ErrorLoading": "Die Auswertung konnte nicht geladen werden."
      },
      "Delete": {
        "Title": "API-Schlüssel löschen",
        "Question": "API-Schlüssel „{0}“ ({1}…) des Standorts {2} löschen?",
        "Hint": "Anbieter, die ihn verwenden, werden spätestens nach 1 Minute abgewiesen. Das lässt sich nicht rückgängig machen.",
        "LippPmsHint": "Diesen Schlüssel hat das Lipp PMS ausgestellt. Nach dem Löschen erreicht das Lipp PMS diese Lipp POS nicht mehr."
      },
      "ShareLink": {
        "Title": "Einmal-Link"
      }
    }
  },
  "PaymentMethods": {
    "Title": "Zahlungsmethoden",
    "PaymentMethod": "Zahlungsmethode",
    "StripeInfo": "Die Zahlungsdaten werden via <a href=\"https://stripe.com\" target=\"_blank\"><img src=\"{0}\" /></a> gespeichert und NICHT im Lipp Portal!",
    "Default": "Standard",
    "ErrorChangingDefaultPaymentMethod": "Standardzahlungsmethode konnte nicht geändert werden",
    "Type": "Typ",
    "Types": {
      "Card": "Kreditkarte",
      "SEPA": "Bankkonto"
    },
    "Name": "Name des Konto-/Karteninhabers",
    "ExpiryDate": "Ablaufdatum",
    "NoExpiryDate": "Kein Ablaufdatum",
    "DefaultPaymentMethod30DaysInfo": "Standardzahlungsmethode muss noch mind. 30 Tage gültig sein."
  },
  "Pages": {
    "Login": "Anmeldung",
    "ForgotPassword": "Passwort vergessen?",
    "ResetPassword": "Passwort ändern",
    "Dashboard": "Dashboard",
    "Enterprises": "Betriebe",
    "Users": "Benutzer",
    "Invoices": "Rechnungen",
    "Profile": "Profileinstellungen",
    "CloudBackup": "Cloudsicherung",
    "DigitalReceipt": "Digitaler Beleg",
    "LippBon": "Lipp Bon",
    "LippCare": "Lipp Care",
    "LippPOS": "Lipp POS",
    "Marketplace": "Marktplatz",
    "RoomPlan": "Zimmerplan",
    "Statistics": "Auswertungen",
    "TableReservation": "Tischreservierung",
    "EnterpriseSettings": "Betriebseinstellungen",
    "PaymentMethods": "Zahlungsmethoden",
    "OpenApi": "Open API",
    "PosDashboard": "Dashboard",
    "PmsDashboard": "Dashboard",
    "Error": "Fehler",
    "Download": "Download",
    "Maintenance": "Wartung",
    "ConfirmRegistration": "Registrierung bestätigen",
    "PaymentPay": "Zahlung",
    "PaymentSuccessful": "Zahlung erfolgreich",
    "PaymentFailed": "Zahlung fehlgeschlagen",
    "PaymentConfirm": "Zahlung bestätigen",
    "Payment3DS": "Zahlung 3DS",
    "Tutorials": "Erklärvideos",
    "Updates": "Updates",
    "RegisterUser": "Registrierung bestätigen",
    "CrossEnterprise": {
      "LippPOS": "Lipp POS - Betriebsübergreifend",
      "Vouchers": "Gutscheinverwaltung - Betriebsübergreifend",
      "OnlineVouchers": "Online-Gutscheinverkauf - Betriebsübergreifend"
    }
  },
  "PmsDashboard": {
    "Reports": {
      "Occupancy": "Belegung",
      "Logis": "Logisumsatz",
      "AdrRevpar": "Durchschnittsrate & RevPAR",
      "Channels": "Buchungskanäle",
      "Weekdays": "Wochentage",
      "Origins": "Herkunftsländer",
      "Categories": "Zimmerkategorien",
      "LeadTime": "Buchungsvorlauf",
      "StayLength": "Aufenthaltsdauer",
      "Pickup": "Pickup",
      "Cancellation": "Stornoquote",
      "Today": "Tagesgeschäft heute"
    },
    "Defaults": {
      "Mine": "Mein Dashboard",
      "Revenue": "Revenue & Belegung",
      "Sales": "Gäste & Vertrieb",
      "Reception": "Rezeption heute"
    },
    "Filters": {
      "Properties": "Betriebe",
      "Categories": "Zimmerkategorien",
      "Channels": "Kanäle"
    },
    "Stats": {
      "Average": "Ø",
      "AveragePerSection": "Ø je Abschnitt",
      "Total": "Gesamt",
      "AverageRate": "Ø Rate",
      "RevPar": "RevPAR",
      "Logis": "Logis",
      "Rooms": "Zimmer",
      "Nights": "Nächtigungen",
      "Strongest": "Stärkster Tag",
      "Weakest": "Schwächster Tag",
      "Net": "Netto",
      "PerDay": "Ø je Tag",
      "Cancelled": "Storniert",
      "Bookings": "Buchungen",
      "InHouse": "Inhaus",
      "Occupancy": "Belegung",
      "Deviation": "Abweichung",
      "Guests": "Gäste",
      "AverageDays": "Ø Tage",
      "AverageNights": "Ø Nächte"
    },
    "Series": {
      "Occupancy": "Belegung"
    },
    "Tooltip": {
      "New": "Neu gebucht",
      "Cancelled": "Storniert",
      "Net": "Netto",
      "Rooms": "Zimmernächte",
      "Occupancy": "Belegung",
      "AverageRate": "Ø Rate"
    },
    "Unit": {
      "Reservations": "Reservierungen",
      "Rooms": "Zimmer",
      "RoomNights": "Zimmernächte"
    },
    "Today": {
      "Arrivals": "Anreisen",
      "Departures": "Abreisen",
      "RoomsCleaned": "Zimmer gereinigt",
      "PreCheckIn": "Vorab-Check-in",
      "FreeRooms": "Freie Zimmer"
    },
    "States": {
      "Unreachable": "PMS nicht erreichbar",
      "NotLinked": "Dieser Betrieb ist im PMS noch nicht verknüpft",
      "CurrencyMix": "Die gewählten Betriebe haben verschiedene Währungen. Beträge werden nicht zusammengezählt.",
      "RangeTooLong": "Zeitraum zu lang, höchstens 366 Tage",
      "NoStation": "Kein Betrieb gewählt",
      "LoadFailed": "Die Zahlen konnten nicht geladen werden",
      "UnknownReport": "Unbekannter Bericht"
    },
    "Notes": {
      "NoCompareData": "Keine Vergleichsdaten",
      "CompareTrimmed": "Vergleich auf gleiche Länge gekürzt",
      "ExcludedBookings": "{0} importierte Buchungen ohne echtes Buchungsdatum sind nicht enthalten",
      "LeadTime": "Tage zwischen Buchung und Anreise",
      "StayLength": "Nächte je Buchung, grün: Wochenaufenthalt",
      "CategoryColor": "Farbe nach Belegung der Kategorie"
    },
    "Pill": {
      "Last30Days": "Letzte 30 Tage"
    },
    "PreviewHint": "Zahlen erscheinen nach dem Speichern",
    "Thresholds": {
      "Custom": "Eigene Werte",
      "Description": "Eigene Grenzen für Grün und Orange, in der Einheit des Panels"
    },
    "NoChannel": "Ohne Kanal",
    "UnknownCountry": "Ohne Angabe",
    "Other": "Sonstige",
    "FilterLoadError": "Filter konnten nicht geladen werden"
  },
  "PosDashboard": {
    "DefaultName": "Mein Dashboard",
    "DashboardsHeading": "Dashboards",
    "AddDashboard": "Dashboard",
    "AvailableReports": "Verfügbare Berichte",
    "SearchReports": "Berichte suchen...",
    "RemoveZone": "vom Dashboard entfernen?",
    "RemoveWidget": "Widget entfernen",
    "EmptyDashboard": "Beginne mit der Erstellung deines Dashboards.",
    "EmptyDashboardHint": "Ziehe verfügbare Berichte aus der rechten Seitenleiste hierhin.",
    "EmptyDashboardEdit": "Ziehe verfügbare Berichte aus der rechten Seitenleiste hierhin.",
    "BaseLabel": "Basis",
    "NoDashboard": "Kein Dashboard ausgewählt.",
    "NoData": "Keine Daten für ausgewählte Kriterien / ausgewähltem Zeitraum verfügbar",
    "NoOpenTables": "Aktuell keine offenen Tische für ausgewählte Kriterien verfügbar.",
    "TablePrefix": "Tisch",
    "OtherSegment": "Sonstige",
    "Kinds": {
      "ALL": "Alle",
      "POS": "POS",
      "PMS": "PMS"
    },
    "NoStation": "Kein Betrieb gewählt",
    "MetricRevenue": "Umsatz",
    "MetricQuantity": "Anzahl",
    "LoadFailed": "Daten konnten nicht geladen werden.",
    "Average": "Ø",
    "Total": "Gesamt",
    "Comparison": "Vergleich",
    "Save": "Speichern",
    "Discard": "Verwerfen",
    "Refresh": "Aktualisieren",
    "Export": "Exportieren",
    "ComparisonSeparator": "vs.",
    "SelectAll": "Alle auswählen",
    "All": "Alle",
    "NoFilterOptions": "Keine Optionen",
    "Filters": {
      "Stations": "Betriebe & Standorte",
      "Users": "Benutzer",
      "Departments": "Abteilungen",
      "ProductGroups": "Warengruppen"
    },
    "Locations": "Standorte",
    "CopySuffix": "(Kopie)",
    "SaveError": "Das Dashboard konnte nicht gespeichert werden.",
    "SaveBlocked": "Änderungen werden nicht gespeichert, weil die Dashboards nicht geladen werden konnten. Bitte Seite neu laden.",
    "LoadError": "Dashboards konnten nicht geladen werden",
    "LoadErrorDetail": "Bitte laden Sie die Seite neu. Ihre gespeicherten Dashboards bleiben unverändert.",
    "ExportError": "Export fehlgeschlagen",
    "ExportErrorDetail": "Das Dashboard konnte nicht exportiert werden. Bitte versuchen Sie es erneut.",
    "Menu": {
      "Edit": "Bearbeiten",
      "Rename": "Umbenennen",
      "Duplicate": "Duplizieren",
      "Delete": "Löschen"
    },
    "NameDialog": {
      "CreateTitle": "Dashboard erstellen",
      "RenameTitle": "Dashboard umbenennen",
      "Label": "Bezeichnung",
      "Confirm": "Erstellen",
      "ConfirmRename": "Ändern"
    },
    "DeleteDialog": {
      "Title": "Dashboard löschen",
      "Message": "Willst du das Dashboard {name} wirklich löschen?",
      "Confirm": "Löschen"
    },
    "DateRange": {
      "Today": "Heute",
      "Yesterday": "Gestern",
      "ThisWeek": "Aktuelle Woche",
      "LastWeek": "Letzte Woche",
      "ThisMonth": "Aktuelles Monat",
      "LastMonth": "Letztes Monat",
      "ThisYear": "Aktuelles Jahr",
      "LastYear": "Letztes Jahr",
      "NoComparison": "Kein Vergleich",
      "PreviousPeriod": "Vorperiode",
      "PreviousYear": "Gleicher Zeitraum Vorjahr"
    },
    "Weekday": {
      "Mon": "Montag",
      "Tue": "Dienstag",
      "Wed": "Mittwoch",
      "Thu": "Donnerstag",
      "Fri": "Freitag",
      "Sat": "Samstag",
      "Sun": "Sonntag"
    },
    "MonthShort": {
      "1": "Jän",
      "2": "Feb",
      "3": "Mär",
      "4": "Apr",
      "5": "Mai",
      "6": "Jun",
      "7": "Jul",
      "8": "Aug",
      "9": "Sep",
      "10": "Okt",
      "11": "Nov",
      "12": "Dez"
    },
    "SystemGroup": {
      "Comment": "Kommentar",
      "Discount": "Ermäßigung",
      "Tip": "Trinkgeld"
    },
    "DeletedArticle": "Gelöschter Artikel",
    "DeletedTable": "Gelöschter Tisch",
    "DeletedCommodityGroup": "Gelöschte Warengruppe",
    "DeletedUser": "Gelöschter Benutzer",
    "Reports": {
      "Revenue": "Umsatz",
      "RevenueTrend": "Umsatzverlauf",
      "WeekdayRevenue": "Wochentage",
      "MonthlyRevenue": "Monatsumsatz",
      "DailyRevenue": "Tagesumsatz",
      "TopArticles": "Top Artikel",
      "TopUsers": "Benutzer",
      "ProductGroups": "Warengruppen",
      "PaymentMethods": "Zahlungsarten",
      "CancellationRate": "Stornoquote",
      "OpenTables": "Aktuell offene Tische",
      "InvoicedArticlesDaily": "Abgerechnete Artikel pro Tag",
      "InvoicedGroupsDaily": "Abgerechnete Warengruppen pro Tag"
    },
    "Thresholds": {
      "Title": "Persönliche Wertdefinition",
      "Description": "Lege in Prozent fest, ab wann ein Artikel Gut, Mittel oder Schlecht eingestuft wird – bezogen auf den höchsten Wert.",
      "DescriptionInverted": "Lege in Prozent fest, ab wann ein Tisch Schlecht, Mittel oder Gut eingestuft wird – bezogen auf den höchsten Wert.",
      "Good": "Gut",
      "Medium": "Mittel",
      "Bad": "Schlecht",
      "ValueFrom": "ab",
      "BadHint": "Wenn der Wert unter {0} liegt.",
      "Save": "Speichern"
    },
    "OpenTableDialog": {
      "Quantity": "Menge",
      "Article": "Artikel",
      "Amount": "Betrag",
      "Total": "Offener Gesamtbetrag",
      "Empty": "Auf diesem Tisch sind keine offenen Artikel.",
      "LoadFailed": "Die Tischdetails konnten nicht geladen werden."
    }
  },
  "DeletePaymentMethod": {
    "Title": "Zahlungsmethode löschen",
    "Description1": "Willst du die Zahlungsmethode",
    "Description2": "wirklich löschen?",
    "Success": {
      "Title": "Zahlungsmethode gelöscht",
      "Description": "Die Zahlungsmethode <b>{0}</b> wurde erfolgreich gelöscht."
    },
    "Error": "Zahlungsmethode konnte nicht gelöscht werden"
  },
  "CreatePaymentMethod": {
    "Title": "Zahlungsmethode erstellen",
    "DefaultPaymentMethod": "Als Standardzahlungsmethode verwenden",
    "ErrorPreparing": "Zahlungsmethode erstellen konnte nicht vorbereitet werden",
    "Success": {
      "Title": "Zahlungsmethode erstellt",
      "Description": "Die Zahlungsmethode wurde erfolgreich erstellt."
    },
    "Error": "Zahlungsmethode konnte nicht erstellt werden"
  },
  "ReplacePaymentMethod": {
    "Title": "Zahlungsmethode ersetzen",
    "DefaultPaymentMethod": "Als Standardzahlungsmethode verwenden",
    "ErrorPreparing": "Zahlungsmethode ersetzen konnte nicht vorbereitet werden",
    "Success": {
      "Title": "Zahlungsmethode ersetzt",
      "Description": "Die Zahlungsmethode wurde erfolgreich ersetzt."
    },
    "Error": "Zahlungsmethode konnte nicht ersetzt werden"
  },
  "IncertSettings": {
    "Title": "Incert Einstellungen",
    "ClientId": "Client ID",
    "ClientSecret": "Client Secret",
    "ApiKey": "API Key",
    "ApiUrl": "API URL",
    "Success": {
      "Title": "Einstellungen geändert",
      "Description": "Die Einstellungen von Incert wurden erfolgreich geändert."
    },
    "Error": "Einstellungen konnten nicht geändert werden",
    "ErrorLoading": "Einstellungen konnten nicht geladen werden"
  },
  "CancelInvoiceDialog": {
    "Title": "Rechnung stornieren",
    "Description": "Willst du die Rechnung <b>{0}</b> vom Betrieb <b>{1}</b> wirklich vollständig stornieren?",
    "Reason": "Grund",
    "Note": "Anmerkung",
    "Cancel": "Stornieren",
    "Success": {
      "Title": "Rechnung storniert",
      "Description": "Die Rechnung <b>{0}</b> wurde erfolgreich vollständig storniert."
    },
    "Error": "Rechnung konnte nicht storniert werden",
    "Refund": "Rückerstattung"
  },
  "CreateCreditNoteDialog": {
    "Title": "Gutschrift erstellen",
    "AmountNet": "Betrag (netto)",
    "AmountGross": "Betrag (brutto)",
    "Reason": "Grund",
    "Note": "Anmerkung",
    "Success": {
      "Title": "Gutschrift erstellt",
      "Description": "Eine Gutschrift für die Rechnung <b>{0}</b> wurde erfolgreich erstellt."
    },
    "Error": "Gutschrift konnte nicht erstellt werden"
  },
  "CorrectInvoiceDialog": {
    "Title": "Rechnung korrigieren",
    "Correct": "Korrigieren",
    "Success": {
      "Title": "Rechnung korrigiert",
      "Description": "Die Rechnung <b>{0}</b> wurde erfolgreich korrigiert."
    },
    "Error": "Rechnung konnte nicht korrigiert werden",
    "ErrorLoadingEnterprise": "Betrieb konnte nicht geladen werden"
  },
  "CountriesDropdown": {
    "SearchBarPlaceholder": "Land suchen..."
  },
  "LippPOS": {
    "Automations": {
      "Title": "Automatisierungen",
      "Add": "Automatisierung",
      "NewName": "Neue Automatisierung",
      "CopyName": "{0} (Kopie)",
      "CopyNameNumbered": "{0} (Kopie {1})",
      "Rename": "Umbenennen",
      "Duplicate": "Duplizieren",
      "Pause": "Pausieren",
      "Resume": "Fortsetzen",
      "Delete": "Löschen",
      "Flow": "Ablauf",
      "FlowEmpty": "Links eine Automatisierung wählen — ihr Ablauf steht dann hier.",
      "Trigger": "Auslöser",
      "Condition": "Bedingung",
      "Action": "Aktion",
      "AddCondition": "Bedingung einfügen",
      "AddAction": "Aktion anhängen",
      "RemoveStep": "Schritt entfernen",
      "Next": "Weiter",
      "Save": "Speichern",
      "DayOfMonthLast": "Monatsletzter",
      "State": {
        "Active": "Gespeichert und aktiv",
        "Unsaved": "Nicht gespeichert",
        "Paused": "Pausiert",
        "LastRunFailed": "Der letzte Lauf ist gescheitert",
        "LastRunFailedWithReason": "Der letzte Lauf ist gescheitert: {0}"
      },
      "TriggerKind": {
        "event": "Wenn etwas passiert",
        "schedule": "Zu einem Zeitpunkt"
      },
      "Event": {
        "daily_closing": {
          "created": "Tagesabschluss erstellt"
        },
        "invoice": {
          "cancelled": "Rechnung storniert",
          "recalled": "Rechnung zurückgeholt",
          "corrected": "Rechnung korrigiert"
        },
        "booking": {
          "cancelled": "Position storniert",
          "instant_cancelled": "Sofortstorno"
        },
        "discount": {
          "changed": "Rabatt geändert"
        },
        "price": {
          "changed": "Preis geändert"
        },
        "proforma": {
          "created": "Proforma erstellt"
        }
      },
      "Cadence": {
        "daily": "täglich",
        "weekly": "wöchentlich",
        "monthly": "monatlich"
      },
      "Weekday": {
        "1": "Montag",
        "2": "Dienstag",
        "3": "Mittwoch",
        "4": "Donnerstag",
        "5": "Freitag",
        "6": "Samstag",
        "7": "Sonntag"
      },
      "Period": {
        "previous_day": "Vortag",
        "previous_week": "Vorwoche",
        "previous_month": "Vormonat",
        "current_month": "Laufender Monat",
        "current_year": "Laufendes Jahr"
      },
      "ConditionField": {
        "revenue": "Umsatz (brutto)",
        "invoice_count": "Anzahl Rechnungen",
        "cancellation_amount": "Stornobetrag",
        "cancellation_count": "Anzahl Stornos",
        "average_invoice": "Ø je Rechnung",
        "effort_amount": "Aufwände (brutto)",
        "booking_cancellation_count": "Anzahl Positionsstornos",
        "instant_cancellation_count": "Anzahl Sofortstornos",
        "amount": "Betrag",
        "quantity": "Menge",
        "user": "Benutzer",
        "workstation": "Arbeitsstation",
        "table": "Tisch",
        "article": "Artikel",
        "reason": "Stornogrund",
        "discount_percent": "Rabatt in %",
        "discount_amount": "Rabatt in €",
        "price": "Neuer Preis"
      },
      "Operator": {
        "is": "ist",
        "is_not": "ist nicht",
        "greater": "größer als",
        "less": "kleiner als",
        "contains": "enthält"
      },
      "Join": {
        "and": "UND",
        "or": "ODER"
      },
      "ActionKind": {
        "mail": "E-Mail senden",
        "print": "Drucken"
      },
      "Format": {
        "pdf": "PDF",
        "excel": "Excel"
      },
      "Attachment": {
        "CashJournal": "Kassenbuch",
        "OpenItems": "Offene Posten",
        "AccountingExport": "Buchhaltungs-Export (BMD/DATEV)"
      },
      "Summary": {
        "OnDay": "am {0}.",
        "At": "um {0}",
        "Attachments": "{0} Anhang/Anhänge",
        "Quoted": "„{0}“"
      },
      "Fields": {
        "Name": "Bezeichnung",
        "TriggerKind": "Art",
        "Event": "Ereignis",
        "Cadence": "Takt",
        "Weekday": "Wochentag",
        "DayOfMonth": "Tag im Monat",
        "Time": "Uhrzeit",
        "Period": "Zeitraum der Daten",
        "Field": "Feld",
        "Operator": "Vergleich",
        "Value": "Wert",
        "ActionKind": "Art",
        "MailAccount": "Absender-Mailkonto",
        "To": "Empfänger",
        "Cc": "Kopie (CC)",
        "Subject": "Betreff",
        "Body": "Text der E-Mail",
        "Attachments": "Anhänge",
        "Format": "Format",
        "Users": "Benutzer der Benutzerabrechnung",
        "PrintReport": "Bericht",
        "Printer": "Drucker"
      },
      "Hints": {
        "Event": {
          "daily_closing": {
            "created": "Läuft einmal je abgeschlossenem Tag — an der Kasse oder im Lipp Portal abgeschlossen. Ausgewertet wird der abgeschlossene Tag."
          },
          "invoice": {
            "cancelled": "Läuft bei jedem Rechnungsstorno an der Kasse (ohne Zurückholen). Anhänge zeigen den Geschäftstag des Stornos.",
            "recalled": "Läuft, wenn eine Rechnung an der Kasse auf den Tisch zurückgeholt wird. Anhänge zeigen den Geschäftstag.",
            "corrected": "Läuft, wenn an der Kasse die Zahlungsart einer Rechnung korrigiert wird."
          },
          "booking": {
            "cancelled": "Läuft bei jedem Storno einer schon gebuchten Position (mit Stornogrund) — auch bei Retouren und Stornos von Lieferscheinen, wie im Änderungsprotokoll.",
            "instant_cancelled": "Läuft, wenn eine noch nicht weggeschickte Position entfernt oder in der Menge verringert wird. Hat eine Rolle das Recht, ohne Protokoll zu entfernen, entsteht für sie kein Eintrag und die Automatisierung läuft nicht."
          },
          "discount": {
            "changed": "Läuft, wenn an der Kasse der Rabatt einer Position geändert wird."
          },
          "price": {
            "changed": "Läuft, wenn an der Kasse der Preis einer Position geändert wird."
          },
          "proforma": {
            "created": "Läuft, wenn an der Kasse eine Proformarechnung gedruckt wird."
          }
        },
        "DayOfMonth": "Gibt es den Tag im Monat nicht (z. B. den 31.), läuft die Automatisierung am Monatsletzten.",
        "Time": "Uhrzeit der Station. Bitte nach dem Tageswechsel der Station wählen — davor läuft noch der vorige Geschäftstag, und der Zeitraum zählt von ihm aus.",
        "Period": "Welcher Zeitraum ausgewertet wird, in Geschäftstagen (Tageswechsel der Station) — nicht, wann sie läuft.",
        "Field": {
          "revenue": "Summe brutto der Rechnungen im Zeitraum ohne Aufwände, Stornos abgezogen — wie die Summe unter „Normal“ in der Rechnungsstatistik. Dezimalstellen mit Punkt.",
          "invoice_count": "Anzahl der Rechnungen im Zeitraum, ohne Stornobelege.",
          "cancellation_amount": "Summe der Stornobelege im Zeitraum. Dezimalstellen mit Punkt.",
          "cancellation_count": "Anzahl der Stornobelege im Zeitraum (Storno und Zurückholen).",
          "average_invoice": "Umsatz geteilt durch die Anzahl der Rechnungen, die nicht storniert sind. Dezimalstellen mit Punkt.",
          "effort_amount": "Summe brutto der Aufwände im Zeitraum, Stornos abgezogen. Dezimalstellen mit Punkt.",
          "booking_cancellation_count": "Anzahl „Storno Buchung“ im Änderungsprotokoll des Zeitraums (auch Retouren und Stornos von Lieferscheinen).",
          "instant_cancellation_count": "Anzahl „Sofortstorno“ im Änderungsprotokoll des Zeitraums.",
          "amount": "Betrag brutto — bei Storno und Zurückholen der Betrag der Originalrechnung. Dezimalstellen mit Punkt.",
          "quantity": "Stornierte bzw. entfernte Menge. Dezimalstellen mit Punkt.",
          "user": "Wer es an der Kasse getan hat.",
          "workstation": "An welcher Arbeitsstation es geschah.",
          "table": "Name des Tisches, wie an der Kasse.",
          "article": "Text der Position bzw. Name des Artikels.",
          "reason": "Der an der Kasse gewählte Stornogrund.",
          "discount_percent": "Der neue Rabatt in Prozent. Dezimalstellen mit Punkt.",
          "discount_amount": "Der neue Rabatt je Stück in Euro. Dezimalstellen mit Punkt.",
          "price": "Der neue Preis brutto je Stück. Dezimalstellen mit Punkt."
        },
        "Recipients": "Mehrere Adressen mit Komma oder Strichpunkt trennen.",
        "MailAccount": "Ein Mailkonto der Station, über das Lipp Connect senden kann.",
        "NoMailAccount": "Die Station hat kein Mailkonto, über das Lipp Connect senden kann. Unter Stammdaten → E-Mail Konten eines anlegen.",
        "Attachments": "Die Listen mit den Daten des Zeitraums. Ohne Anhang geht nur der Text hinaus.",
        "Users": "Leer: alle aktiven Benutzer. Je Benutzer eine Abrechnung, per E-Mail bei mehreren Benutzern als Zip.",
        "PrintNeedsVersion": "Drucken braucht Lipp POS 1.38.0 oder neuer an der Hauptkasse."
      },
      "Dialogs": {
        "create": "Neue Automatisierung",
        "createConfirm": "Anlegen",
        "rename": "Automatisierung umbenennen",
        "renameConfirm": "Ändern",
        "delete": "Automatisierung löschen",
        "deleteQuestion": "Soll {0} wirklich gelöscht werden?",
        "discard": "Änderungen verwerfen",
        "discardQuestion": "Die Änderungen an {0} sind nicht gespeichert. Sollen sie verworfen werden?",
        "discardConfirm": "Verwerfen",
        "keepEditing": "Weiter bearbeiten"
      },
      "Errors": {
        "LoadError": "Die Automatisierungen konnten nicht geladen werden.",
        "LoadStationData": "Berichte, Drucker oder Benutzer der Station konnten nicht geladen werden — die Auswahl ist unvollständig.",
        "SaveError": "Die Automatisierung konnte nicht gespeichert werden.",
        "DeleteError": "Die Automatisierung konnte nicht gelöscht werden.",
        "FixFields": "Bitte die markierten Felder prüfen.",
        "NotFound": "Die Automatisierung gibt es nicht mehr — bitte die Seite neu laden.",
        "NameRequired": "Bitte eine Bezeichnung eingeben.",
        "NameTooLong": "Die Bezeichnung darf höchstens 150 Zeichen lang sein.",
        "NameExists": "Eine Automatisierung mit dieser Bezeichnung gibt es schon.",
        "StepsRequired": "Die Automatisierung braucht einen Auslöser und eine Aktion.",
        "TooManySteps": "Die Automatisierung hat zu viele Schritte.",
        "TriggerFirst": "Der Auslöser muss am Anfang stehen.",
        "SingleTrigger": "Eine Automatisierung hat genau einen Auslöser.",
        "ActionRequired": "Die Automatisierung braucht mindestens eine Aktion.",
        "StepKindUnknown": "Unbekannter Schritt.",
        "TriggerKindUnknown": "Bitte die Art wählen.",
        "EventUnknown": "Unbekanntes Ereignis.",
        "CadenceUnknown": "Bitte den Takt wählen.",
        "TimeInvalid": "Bitte eine Uhrzeit wählen.",
        "WeekdayInvalid": "Bitte einen Wochentag wählen.",
        "DayOfMonthInvalid": "Bitte einen Tag im Monat wählen.",
        "PeriodUnknown": "Bitte einen Zeitraum wählen.",
        "FieldUnknown": "Bitte ein Feld wählen.",
        "OperatorUnknown": "Bitte einen Vergleich wählen.",
        "ValueInvalid": "Bitte eine Zahl eingeben (Dezimalstellen mit Punkt).",
        "JoinUnknown": "Unbekannte Verknüpfung.",
        "ActionKindUnknown": "Bitte wählen, was ausgeführt wird.",
        "MailAccountRequired": "Bitte einen Absender wählen.",
        "MailAccountNotSendable": "Über dieses Mailkonto kann Lipp Connect nicht senden.",
        "RecipientRequired": "Bitte mindestens einen Empfänger eingeben.",
        "MailAddressInvalid": "Eine E-Mail-Adresse ist ungültig.",
        "SubjectTooLong": "Der Betreff darf höchstens 200 Zeichen lang sein.",
        "BodyTooLong": "Der Text darf höchstens 4000 Zeichen lang sein.",
        "FormatUnknown": "Unbekanntes Format.",
        "AttachmentUnknown": "Ein gewählter Anhang ist unbekannt.",
        "UserIdsInvalid": "Ein gewählter Benutzer ist unbekannt.",
        "ReportRequired": "Bitte einen Bericht wählen.",
        "ReportUnknown": "Eine gewählte Liste gibt es an der Station nicht mehr.",
        "PrinterRequired": "Bitte einen Drucker wählen.",
        "PrinterUnknown": "Den gewählten Drucker gibt es an der Station nicht mehr.",
        "AccountingExportOpenPeriod": "Den Buchhaltungs-Export gibt es nur für abgeschlossene Zeiträume (Vortag, Vorwoche, Vormonat) — sonst fehlt im nächsten Export der Rest des laufenden Tages.",
        "DailyAccountingPeriodTooLong": "Die Tagesabrechnung geht höchstens über 31 Tage — bitte einen kürzeren Zeitraum wählen.",
        "ConditionWithoutAction": "Nach einer Bedingung muss noch eine Aktion kommen, sonst entscheidet sie nichts.",
        "FieldNotForTrigger": "Dieses Feld gibt es beim gewählten Auslöser nicht — bitte ein anderes wählen.",
        "ValueRequired": "Bitte einen Wert eingeben.",
        "ValueSelect": "Bitte einen Wert wählen.",
        "AccountingExportEvent": "Den Buchhaltungs-Export gibt es bei diesem Ereignis nicht — der Geschäftstag ist noch offen. Dafür „Tagesabschluss erstellt“ oder einen Zeitplan wählen.",
        "EventNeedsPosVersion": "Dieses Ereignis braucht Lipp POS 1.36.0 oder neuer an der Kasse.",
        "FieldNeedsPosVersion": "Dieses Feld braucht Lipp POS 1.36.0 oder neuer an der Kasse."
      }
    },
    "Data": "Stammdaten",
    "LayoutDesign": {
      "Title": "Layout & Design",
      "QrOrdering": {
        "Title": "Gastbestellung"
      },
      "Article": {
        "Articles": {
          "Articles": "Artikel",
          "Article": "Artikel",
          "ArticlePackages": "Artikelpakete",
          "ArticlePackage": "Artikelpaket",
          "Sides": "Beilagen",
          "Side": "Beilage",
          "Comments": "Kommentare",
          "Comment": "Kommentar",
          "Number": "Art.-Nr.",
          "Name": "Bezeichnung",
          "Price": "Preis",
          "SearchArticle": "Artikel suchen...",
          "SearchArticlePackage": "Artikelpaket suchen...",
          "SearchSide": "Beilage suchen...",
          "SearchComment": "Kommentar suchen...",
          "SearchCommodityGroup": "Warengruppe suchen...",
          "AllCommodityGroups": "Alle Warengruppen",
          "SelectAllCommodityGroups": "Alle auswählen",
          "NoArticlesFound": "Keine Artikel gefunden.",
          "NoArticlePackagesFound": "Keine Artikelpakete gefunden.",
          "NoSidesFound": "Keine Beilagen gefunden.",
          "NoCommentsFound": "Keine Kommentare gefunden."
        },
        "Layout": {
          "Title": "Buchungsmaske",
          "Designer": "Buchungsmaske Designer",
          "ClearAll": "Alles löschen",
          "LayoutProfile": "Layoutgruppe",
          "LayoutMainGroup": "Hauptgruppe",
          "LayoutSubGroup": "Untergruppe",
          "RemoveFromLayout": "Vom Layout entfernen"
        },
        "ErrorLoadingSettings": "Einstellungen konnten nicht geladen werden",
        "ErrorLoadingArticles": "Artikel konnten nicht geladen werden",
        "ErrorLoadingCommodityGroups": "Warengruppen konnten nicht geladen werden",
        "ErrorLoadingLayout": "Layout konnten nicht geladen werden",
        "Changed": {
          "Title": "Buchungsmaske geändert",
          "Description": "Die Buchungsmaske wurde erfolgreich geändert.",
          "Error": "Buchungsmaske konnte nicht geändert werden"
        },
        "Conflicts": {
          "Tag": "<i class=\"fas fa-triangle-exclamation\"></i> Überschneidende Änderungen",
          "TooltipTitle": "Folgende Einträge wurden zwischenzeitlich extern geändert und überschneiden sich mit deinen Änderungen:",
          "ChangedExternally": "extern geändert",
          "DeletedExternally": "extern gelöscht",
          "EntityType": {
            "LayoutMainGroup": "Hauptgruppe",
            "LayoutSubGroup": "Untergruppe",
            "LayoutSubGroupItem": "Artikel"
          }
        }
      },
      "Department": {
        "Tables": {
          "Warning": "Verfügbar in ausgewählter Abteilung",
          "Number": "Nummer",
          "Name": "Bezeichnung",
          "SearchTable": "Tisch suchen...",
          "NoTablesFound": "Keine Tische gefunden.",
          "SearchEffort": "Aufwand suchen...",
          "NoEffortsFound": "Keine Aufwände gefunden.",
          "SearchRoom": "Zimmer suchen...",
          "NoRoomsFound": "Keine Zimmer gefunden.",
          "Table": "Tisch",
          "Tables": "Tische",
          "Effort": "Aufwand",
          "Efforts": "Aufwände",
          "Room": "Zimmer",
          "Rooms": "Zimmer"
        },
        "Layout": {
          "Title": "Tischplan",
          "Designer": "Abteilungs- & Tischdesigner",
          "Shape": "Tischform",
          "Department": "Abteilung",
          "Size": "Größe",
          "Color": "Farbe",
          "ClearAll": "Alles löschen"
        },
        "ErrorLoadingSettings": "Einstellungen konnten nicht geladen werden",
        "ErrorLoadingDepartments": "Abteilungen konnten nicht geladen werden",
        "Changed": {
          "Title": "Tischplan geändert",
          "Description": "Der Tischplan wurde erfolgreich geändert.",
          "Error": "Tischplan konnte nicht geändert werden"
        },
        "Conflicts": {
          "Tag": "<i class=\"fas fa-triangle-exclamation\"></i> Überschneidende Änderungen",
          "TooltipTitle": "Folgende Einträge wurden zwischenzeitlich extern geändert und überschneiden sich mit deinen Änderungen:",
          "ChangedExternally": "extern geändert",
          "DeletedExternally": "extern gelöscht",
          "EntityType": {
            "Department": "Abteilung",
            "Table": "Tisch",
            "DepartmentLayout": "Tischplan-Element"
          }
        }
      }
    },
    "Integrations": {
      "Title": "Integrationen",
      "Discover": "Integrationen entdecken",
      "ErrorLoading": "Integrationen konnten nicht geladen werden",
      "Activate": {
        "Title": "Integration aktivieren",
        "Success": {
          "Title": "Integration aktiviert",
          "Description": "Die Integration <b>{0}</b> wurde erfolgreich aktiviert."
        },
        "Error": "Integration konnte nicht aktiviert werden"
      },
      "Deactivate": {
        "Title": "Integration deaktivieren",
        "Success": {
          "Title": "Integration deaktiviert",
          "Description": "Die Integration <b>{0}</b> wurde erfolgreich deaktiviert."
        },
        "Error": "Integration konnte nicht deaktiviert werden"
      },
      "Activated": "Aktiviert",
      "Deactivated": "Deaktiviert"
    },
    "TableReservation": {
      "Title": "Tischreservierung"
    },
    "BonusSystem": {
      "Title": "Bonussystem",
      "Info": "Die Kundenkonten führt die Kasse im Menü „Bonussystem“. Hier stehen nur die Punkteregeln – sie gelten für die ganze Station, für das Bonussystem und den Kartenleser gemeinsam."
    },
    "MessageCenter": {
      "Title": "Nachrichtenzentrale",
      "NewMessage": "Neue Nachricht",
      "PlannedMessages": "Geplante Nachrichten",
      "SentMessages": "Gesendete Nachrichten",
      "Filter": {
        "From": "Von",
        "To": "Bis",
        "Apply": "Filtern",
        "Delete": "Löschen"
      },
      "TabsShort": {
        "New": "Neu",
        "Planned": "Geplant",
        "Sent": "Gesendet"
      },
      "Recipients": "Empfänger",
      "AllUsers": "Alle Benutzer",
      "SelectedUsers": "Bestimmte Benutzer",
      "SelectAll": "Alle auswählen",
      "Users": "Benutzer",
      "Message": "Nachricht",
      "TextPlaceholder": "Text eingeben …",
      "Timing": "Zeitpunkt",
      "Immediate": "Sofort",
      "Scheduled": "Zeitgesteuert",
      "Recurring": "Wiederkehrend",
      "Date": "Datum",
      "Time": "Uhrzeit",
      "Status": "Status",
      "SendNow": "Nachricht senden",
      "SendPlanned": "Geplant senden",
      "LoadError": "Nachrichten konnten nicht geladen werden",
      "Saved": {
        "Title": "Nachricht gespeichert",
        "Description": "Die Nachricht wird von der Kasse zum geplanten Zeitpunkt versendet.",
        "DescriptionImmediate": "Die Nachricht wird von der Kasse versendet, sobald sie verbunden ist, und erscheint dann unter „Gesendete Nachrichten“.",
        "Error": "Nachricht konnte nicht gespeichert werden"
      },
      "AlreadySent": {
        "Title": "Nachricht bereits versendet",
        "Description": "Die Kasse hat diese Nachricht inzwischen versendet. Sie steht jetzt unter den gesendeten Nachrichten."
      },
      "DueReached": {
        "Title": "Zeitpunkt bereits erreicht",
        "Description": "Der geplante Zeitpunkt ist vorbei. Die Kasse versendet die Nachricht gerade oder hat sie schon versendet, deshalb kann sie nicht mehr bearbeitet werden."
      },
      "StatusTexts": {
        "planned": "geplant",
        "recurring": "wiederkehrend",
        "sent": "gesendet",
        "undelivered": "nicht zugestellt"
      },
      "Weekdays": {
        "Title": "Wochentage",
        "0": "So",
        "1": "Mo",
        "2": "Di",
        "3": "Mi",
        "4": "Do",
        "5": "Fr",
        "6": "Sa"
      }
    },
    "DeliveryNotes": {
      "Title": "Lieferscheine",
      "TotalOpen": "Gesamt offen",
      "Tabs": {
        "Open": "Offen",
        "Completed": "Abgeschlossen",
        "Cancelled": "Storniert"
      },
      "Columns": {
        "Number": "Nummer",
        "Date": "Datum",
        "DeliveryDate": "Lieferdatum",
        "Customer": "Kunde",
        "Amount": "Brutto",
        "Note": "Notiz",
        "InvoiceNumber": "Re.-Nr.",
        "Table": "Tisch",
        "User": "Benutzer",
        "Cancelled": "Storno",
        "CancelledOn": "Storniert am"
      },
      "Actions": {
        "Preview": "Vorschau",
        "Print": "Drucken",
        "Download": "Herunterladen",
        "SendMail": "Per E-Mail senden"
      },
      "Cancelled": "Storniert",
      "ErrorLoading": "Lieferscheine konnten nicht geladen werden",
      "ErrorRendering": "Lieferschein konnte nicht geladen werden",
      "NoDeliveryNoteReport": "Es ist kein Lieferschein-Bericht hinterlegt.",
      "SendMail": {
        "Title": "Lieferschein per E-Mail versenden",
        "FilePrefix": "Lieferschein",
        "Success": {
          "Title": "Lieferschein gesendet",
          "Description": "Der Lieferschein wurde per E-Mail an <b>{0}</b> gesendet."
        },
        "Error": "Lieferschein konnte nicht gesendet werden"
      }
    },
    "InvoiceCenter": {
      "Title": "Rechnungszentrale",
      "Columns": {
        "Number": "Re.-Nr.",
        "Date": "Re.-Datum",
        "Table": "Tisch",
        "User": "Benutzer",
        "Amount": "Betrag",
        "Customer": "Kunde",
        "PaymentMethod": "Zahlungsart",
        "Mail": "E-Mail",
        "Cancelled": "Storno",
        "CancellationReason": "Stornogrund"
      },
      "Actions": {
        "Preview": "Vorschau",
        "Print": "Drucken",
        "Download": "Herunterladen",
        "SendMail": "Per E-Mail senden"
      },
      "Cancelled": "Storniert",
      "ErrorLoading": "Rechnungen konnten nicht geladen werden",
      "ErrorRendering": "Rechnung konnte nicht geladen werden",
      "NoInvoiceReport": "Es ist kein Rechnungs-Bericht hinterlegt.",
      "SendMail": {
        "Title": "Rechnung per E-Mail versenden",
        "Account": "E-Mail Konto",
        "NoAccounts": "Für diese Station ist kein Mailkonto hinterlegt.",
        "Recipient": "Empfänger",
        "RequiresReauth": "Dieses Konto muss auf der Kasse neu autorisiert werden.",
        "Cc": "Cc",
        "Subject": "Betreff",
        "Attachments": "Anhang",
        "Upload": "Hochladen",
        "Text": "Text",
        "SelectFromCustomers": "Aus Kundenkartei wählen",
        "CustomerWithoutEmail": "Für diesen Kunden ist keine E-Mail-Adresse hinterlegt.",
        "ExceedsSizeLimit": "Die Anhänge überschreiten das Größenlimit von 10 MB.",
        "FilePrefix": "Rechnung",
        "Success": {
          "Title": "Rechnung gesendet",
          "Description": "Die Rechnung wurde per E-Mail an <b>{0}</b> gesendet."
        },
        "Error": "Rechnung konnte nicht gesendet werden"
      }
    },
    "Lists": {
      "Title": "Listen & Rechnungen",
      "Lists": {
        "Title": "Listen"
      },
      "Reports": {
        "Title": "Berichte",
        "Types": {
          "0": "Rechnung",
          "1": "Bestellbon",
          "2": "Gangabruf",
          "3": "Stornobon",
          "4": "Benutzerabrechnung",
          "5": "Tagesabrechnung",
          "6": "Periodenabrechnung",
          "7": "Kundenliste",
          "8": "Proformarechnung",
          "9": "Tischtransfer",
          "10": "RKSV",
          "11": "Artikelverkauf",
          "12": "Buchungsprotokoll",
          "13": "Änderungsprotokoll",
          "18": "Lagerbestand",
          "19": "Lagerbewegungen",
          "20": "Lagerabgänge",
          "21": "Inventur",
          "22": "Inventur zum Ausfüllen",
          "26": "Rechnungsstatistik"
        },
        "ErrorLoadingReports": "Berichte konnten nicht geladen werden"
      },
      "Criteria": {
        "Title": "Kriterien",
        "Period": "Zeitraum",
        "Filters": "Filter",
        "Departments": "Abteilungen",
        "Tables": "Tische",
        "Efforts": "Aufwände",
        "RevenueGroups": "Umsatzgruppen",
        "CommodityGroups": "Warengruppen",
        "Articles": "Artikel",
        "PaymentMethods": "Zahlungsarten",
        "Weekdays": "Wochentage",
        "SearchPlaceholder": "Suchen...",
        "SelectAll": "Alle auswählen",
        "AllUsers": "Alle Benutzer",
        "AllDepartments": "Alle Abteilungen",
        "AllTables": "Alle Tische",
        "AllEfforts": "Alle Aufwände",
        "AllRevenueGroups": "Alle Umsatzgruppen",
        "AllCommodityGroups": "Alle Warengruppen",
        "AllArticles": "Alle Artikel",
        "AllWeekdays": "Alle Wochentage",
        "AllPaymentMethods": "Alle Zahlungsarten",
        "AllCustomers": "Alle Kunden",
        "AllWorkstations": "Alle Arbeitsstationen",
        "ChangeLogTypes": "Arten",
        "AllChangeLogTypes": "Alle Arten",
        "WeekdayNames": {
          "0": "Sonntag",
          "1": "Montag",
          "2": "Dienstag",
          "3": "Mittwoch",
          "4": "Donnerstag",
          "5": "Freitag",
          "6": "Samstag"
        },
        "ChangeLogTypeNames": {
          "0": "Preisänderung",
          "1": "Rabattänderung",
          "2": "Makro ausgeführt",
          "3": "Storno Buchung",
          "4": "Tischtransfer",
          "5": "Rechnungsstorno",
          "6": "Rechnungskorrektur",
          "7": "Positionen zurückgeholt",
          "8": "Proforma erstellt",
          "9": "Artikel geändert",
          "10": "Bereich geändert",
          "11": "Tisch geändert",
          "12": "Tischübergabe",
          "13": "Sofortstorno",
          "14": "Zimmerbuchung neu zugeordnet oder ohne Zustellung abgeschlossen"
        },
        "Users": {
          "Title": "Benutzer",
          "Name": "Name",
          "ErrorLoadingUsers": "Benutzer konnten nicht geladen werden",
          "SearchPlaceholder": "Suchen..."
        },
        "Inventory": {
          "Title": "Inventur",
          "NoSelection": "Bitte zuerst eine Inventur auswählen.",
          "NoneAvailable": "Keine Inventuren vorhanden."
        },
        "SummarizeUsers": "Benutzer auf Abrechnung zusammenfassen?",
        "AdditionalDays": "Zusätzliche Tage wählen",
        "CloseDay": "Tag abschließen",
        "CloseDayTooltipWhenOffline": "Der Tagesabschluss kann nicht durchgeführt werden, da die Verbindung zur Datenbank der Lipp POS offline ist.",
        "UndoDailyClosingsTooltipWhenOffline": "Der Tagesabschluss kann nicht zurückgesetzt werden, da die Verbindung zur Datenbank der Lipp POS offline ist.",
        "ErrorLoadingLatestDailyClosing": "Letzter Tagesabschluss konnte nicht geladen werden",
        "ErrorLoadingPaymentMethods": "Zahlungsarten konnten nicht geladen werden",
        "SendSalesToPMS": "Umsätze an PMS senden",
        "SendSalesToPMSTooltipWhenOffline": "Die Umsätze können nicht an das PMS gesendet werden, da die Verbindung zur Datenbank der Lipp POS offline ist."
      },
      "Preview": {
        "Title": "Vorschau",
        "Info": "Für deine Auswahl/Kriterien kannst du eine Vorschau erzeugen.",
        "Preview": "Vorschau",
        "ErrorRendering": "Bericht konnte nicht geladen werden",
        "Page": "Seite {0}/{1}",
        "Day": "Tag {0}/{1}"
      }
    },
    "Reports": {
      "Title": "Berichtseinstellungen",
      "Settings": {
        "Sections": {
          "Company": "Kopfzeile & Betriebsdaten",
          "Invoice": "Rechnungen",
          "Receipt": "Bestellbons",
          "Accounting": "Abrechnungen"
        },
        "ErrorLoading": "Einstellungen konnten nicht geladen werden",
        "ErrorChanging": "Einstellungen konnten nicht geändert werden",
        "SuccessChanging": {
          "Title": "Einstellungen geändert",
          "Description": "Die Berichtseinstellungen wurden erfolgreich geändert."
        },
        "Logo": "Logo",
        "ReceiptLogo": "Logo Bon",
        "A4Logo": "Logo A4",
        "UploadImage": "Bild hochladen",
        "ShowEnterpriseName": "Betriebsnamen anzeigen",
        "ShowZeroOnInvoice": "Positionen mit 0,00 € auf Rechnung anzeigen",
        "ShowPricesOnReceipt": "Preis auf Bon anzeigen",
        "ShowArticleDescriptionOnInvoice": "Artikelbeschreibung auf Rechnung anzeigen",
        "ShowArticlePackageDetailsOnInvoice": "Artikelpaketdetails auf Rechnung anzeigen",
        "ShowQRCodeOnInvoice": "QR-Code auf Überweisungsrechnung anzeigen",
        "ShowWebsiteQRCodeOnInvoice": "Website QR-Code auf Rechnung anzeigen",
        "EnableEntertainmentReceipt": "Deutschen Bewirtungsbeleg als Druckoption anbieten",
        "ShowTipFieldOnPMSTransferInfo": "Druckt auf dem PMS-Transfer-Beleg über der Unterschriftszeile ein leeres Trinkgeldfeld zum handschriftlichen Ausfüllen. Es erscheint nur, wenn an der Kasse kein Trinkgeld erfasst wurde.",
        "ShowTipFieldOnPMSTransfer": "Trinkgeldfeld auf PMS-Transfer-Beleg anzeigen",
        "ShowTipFieldOnProformaInvoiceInfo": "Druckt am Fuß der Proformarechnung ein leeres Trinkgeldfeld zum handschriftlichen Ausfüllen.",
        "ShowTipFieldOnProformaInvoice": "Trinkgeldfeld auf Proformarechnung anzeigen",
        "ShowTipFieldOnInvoicePaymentMethodsInfo": "Druckt auf Rechnungen mit einer der ausgewählten Zahlungsarten ein leeres Trinkgeldfeld zum handschriftlichen Ausfüllen. Es erscheint nicht, wenn an der Kasse bereits ein Trinkgeld erfasst wurde, und nicht auf Stornobelegen.",
        "ShowTipFieldOnInvoicePaymentMethods": "Trinkgeldfeld auf Rechnung je Zahlungsart",
        "ShowWebsiteQRCodeOnInvoiceInfo": "QR-Code wird nur angezeigt, wenn in den Standortdaten die Website hinterlegt wurde.",
        "CountSidesInReceiptSummaryInfo": "Legt fest, ob Beilagen in die Gesamtstückzahl am Ende des Bestellbons einfließen. Der gedruckte Betrag bleibt unverändert.",
        "BoldComment": "Kommentar in dicker Schrift",
        "CountSidesInReceiptSummary": "Beilagen in Zusammenfassung mitzählen",
        "ShowCompanyData": "Betriebsdaten anzeigen",
        "AlwaysShowBankDetailsOn80mmInvoice": "Bankverbindung auf 80mm Rechnungen immer anzeigen",
        "AlwaysShowBankDetails": "Bankverbindung auf A4 Rechnungen immer anzeigen",
        "UseDin5008Letterhead": "DIN 5008 Norm für Briefköpfe",
        "UseDin5008LetterheadInfo": "Gilt für Rechnung und Lieferschein (A4). Eingeschaltet steht die Anschrift an der Position für das Sichtfenster eines Fensterkuverts, darüber eine kleine Absenderzeile. Ausgeschaltet entfällt die Absenderzeile, und Anschrift und Rechnung rücken ohne den Abstand für das Sichtfenster nach oben.",
        "ShowTipInDailyAccounting": "Trinkgeld auf Tagesabrechnung anzeigen",
        "ShowTipInPeriodAccounting": "Trinkgeld auf Periodenabrechnung anzeigen",
        "ShowTipInUserAccounting": "Trinkgeld auf Benutzerabrechnung anzeigen",
        "ShowDailyTaxTotalsInPeriodAccounting": "Tagessummen nach Steuersatz auf Periodenabrechnung anzeigen",
        "ShowAdditionalInfoInDailyAccounting": "Zusätzliche Infos auf Tagesabrechnung anzeigen",
        "ShowDailyRevenueGroupsInPeriodAccounting": "Umsatzgruppen pro Tag auf Periodenabrechnung anzeigen",
        "ShowDailyRevenueGroupsInDailyAccounting": "Umsatzgruppen pro Tag auf Tagesabrechnung anzeigen",
        "ShowAdditionalInfoInPeriodAccounting": "Zusätzliche Infos auf Periodenabrechnung anzeigen",
        "ShowAdditionalInfoInUserAccounting": "Zusätzliche Infos auf Benutzerabrechnung anzeigen",
        "ShowAdditionalInfoInAccountingInfo": "Zeigt am Ende des Berichts je nach Vorlage die Steuer pro Zahlungsart, offene und stornierte Buchungen sowie stornierte und zurückgeholte Rechnungen.",
        "ShowPaymentMethodsPerUserInDailyAccounting": "Zahlungsarten pro Benutzer auf Tagesabrechnung anzeigen",
        "ShowPaymentMethodsPerUserInPeriodAccounting": "Zahlungsarten pro Benutzer pro Tag auf Periodenabrechnung anzeigen",
        "ShowOpenBookingsInCommodityGroupsInDailyAccounting": "Nicht abgerechnete Buchungen in Warengruppen auf Tagesabrechnung anzeigen",
        "ShowOpenBookingsInCommodityGroupsInDailyAccountingInfo": "Die Warengruppen zählen dann auch die noch nicht abgerechneten Buchungen des Tages mit (ohne Aufwände), die Überschrift lautet „Buchungen“. Zahlungsarten und Steueraufstellung bleiben bei den abgerechneten Buchungen. Gilt für die mitgelieferten Vorlagen der Tagesabrechnung.",
        "ReceiptFontSize": {
          "Title": "Schriftgröße bei Bestellbons",
          "Small": "Klein",
          "Medium": "Mittel",
          "Large": "Groß"
        },
        "CompanyHeaderAlignment": {
          "Title": "Ausrichtung Betriebsdaten",
          "Left": "Links",
          "Right": "Rechts",
          "LogoFullWidth": "Logo über volle Breite",
          "LogoFullWidthInfo": "Bei „Logo über volle Breite\" stehen die Betriebsdaten unter dem Logo. Der Kopfbereich wird dadurch um die Höhe des Logos höher, und die Rechnungsanschrift rückt entsprechend nach unten. Bei einem flachen, breiten Logo bleibt sie im Sichtfenster eines Fensterkuverts; ab etwa 40 mm Logohöhe rutscht sie darunter. Vor dem Versand im Fensterkuvert eine Probe drucken."
        },
        "RksvQrCodeSize": {
          "Title": "Größe RKSV QR-Code",
          "Small": "Klein",
          "Medium": "Mittel",
          "Large": "Groß"
        },
        "InvoiceAddressFontSize": {
          "Title": "Schriftgröße Rechnungsanschrift",
          "Small": "Klein",
          "Medium": "Mittel",
          "Large": "Groß"
        }
      }
    },
    "Settings": {
      "Title": "Grundeinstellungen",
      "All": {
        "Title": "Alle"
      },
      "General": {
        "Title": "Allgemein"
      },
      "TableLayout": {
        "Title": "Abteilungen & Tische"
      },
      "ArticleLayout": {
        "Title": "Buchungsmaske"
      },
      "Invoicing": {
        "Title": "Rechnungslegung"
      },
      "Warehouse": {
        "Title": "Lagerverwaltung"
      },
      "QrOrdering": {
        "Title": "QR-Tischbestellung",
        "Settings": "Einstellungen",
        "Assortment": "Sortiment",
        "IsActive": "Gastbestellung aktiv",
        "Discard": "Verwerfen",
        "LayoutProfile": "Layoutgruppe",
        "SelectLayoutProfile": "Layoutgruppe wählen …",
        "SelectLayoutProfileHint": "Wähle oben eine Layoutgruppe, um deren Artikel für die Online-Bestellung zu bearbeiten.",
        "MainGroups": "Hauptgruppen",
        "SubGroups": "Untergruppen",
        "All": "Alle",
        "SearchCommodityGroup": "Warengruppe suchen …",
        "Name": "Bezeichnung",
        "EditArticle": "Artikel bearbeiten",
        "GeneralBackground": "Allgemeiner Hintergrund",
        "HeaderText": "Kopfzeile Schrift",
        "MainGroupBackground": "Hauptgruppe Hintergrund",
        "MainGroupText": "Hauptgruppe Schrift",
        "MainGroupSelectedBackground": "Hauptgruppe ausgewählt Hintergrund",
        "MainGroupSelectedText": "Hauptgruppe ausgewählt Schrift",
        "SubGroupText": "Untergruppe Schrift",
        "SubGroupSelectedText": "Untergruppe ausgewählt Schrift",
        "ArticleCardBackground": "Artikelkarte Hintergrund",
        "ArticleNameText": "Artikelbezeichnung Schrift",
        "PriceText": "Preis Schrift",
        "AddButtonBackground": "+ Button Hintergrund",
        "AddButtonText": "+ Button Schrift",
        "Design": "Design",
        "Preview": "Live-Vorschau",
        "Hint": "Lege fest, welche Artikel im QR-Gast-Menü erscheinen, und passe optional Anzeigename, Beschreibung und Preis für die Online-Bestellung an.",
        "Search": "Artikel suchen…",
        "Online": "Online",
        "Article": "Artikel",
        "Number": "Art.-Nr.",
        "Price": "Preis",
        "Image": "Bild",
        "Bookable": "Buchbar",
        "NoArticles": "Keine Artikel gefunden.",
        "EditTitle": "Online-Darstellung bearbeiten",
        "DisplayName": "Anzeigename (optional)",
        "Description": "Beschreibung (optional)",
        "PriceOverride": "Online-Preis (optional)",
        "PriceOverrideHint": "Vorbelegt mit dem Kassenpreis — nur ändern, wenn der Online-Preis abweichen soll.",
        "Saved": "Gespeichert.",
        "ShowCallService": "Service rufen anzeigen",
        "AllowImmediatePay": "Sofort bezahlen erlauben",
        "AllowPayAtStaff": "Beim Personal zahlen erlauben",
        "AllowImmediatePayStripeHint": "Erst verfügbar, wenn ein Stripe-Konto verbunden ist. Ohne Stripe können Gäste nicht online bezahlen — die Bestellung läuft dann offen und wird am Tisch kassiert.",
        "AllowImmediatePayHint": "Gäste können ihre Bestellung direkt online per Karte oder Wallet bezahlen, statt offen zu bestellen und am Tisch zu kassieren. Erfordert ein verbundenes Stripe-Konto.",
        "ShowTipPrompt": "Trinkgeldabfrage auf Bezahlseite",
        "TipPercent": "Prozentsatz",
        "GuestSessionLifetime": "Gültigkeit Gast-Sitzung",
        "GuestSessionLifetimeHint": "Wie lange ein QR-Scan gültig bleibt, bevor der Gast erneut scannen muss.",
        "Payment": "Zahlung",
        "StripeConnected": "Verbunden",
        "StripeNotConnected": "Nicht verbunden",
        "StripeDisconnect": "Trennen",
        "StripeConnect": "Mit Stripe verbinden",
        "StripeConnectedAs": "Verbunden als",
        "StripeOnboardingHint": "Verbinde ein Stripe-Konto, damit Gäste direkt online bezahlen können.",
        "Logo": "Logo",
        "FontSize": "Schriftgröße",
        "FontSizes": {
          "Small": "Klein",
          "Medium": "Mittel",
          "Large": "Groß"
        },
        "Colors": "Farben",
        "ResetColors": "Auf Design-Standard zurücksetzen",
        "UndoColor": "Änderung zurücksetzen",
        "PrimaryColor": "Primärfarbe",
        "AccentColor": "Akzentfarbe",
        "BackgroundColor": "Hintergrund",
        "CardColor": "Kartenfläche",
        "HeadingColor": "Überschriften",
        "BodyTextColor": "Fließtext",
        "CategoryBarColor": "Kategorie-Leiste",
        "ButtonTextColor": "Button-Text",
        "PriceColor": "Preis-Farbe",
        "PreviewMenu": "Karte",
        "PreviewCategory": "Getränke",
        "PreviewEmpty": "Noch keine Artikel veröffentlicht.",
        "TableCodes": "Tisch-QR-Codes",
        "SearchTable": "Tisch suchen …",
        "Table": "Tisch",
        "NoCode": "Kein Code",
        "GenerateCode": "Code erstellen",
        "PrintQr": "QR drucken",
        "RevokeCode": "Widerrufen",
        "NoTables": "Keine Tische gefunden.",
        "ScanToOrder": "Scannen zum Bestellen",
        "AllDepartments": "Alle Abteilungen",
        "GenerateAllFiltered": "Alle gefilterten erstellen",
        "RevokeAllFiltered": "Alle gefilterten widerrufen",
        "TablesUsed": "{0} von {1} Tischen für die Gastbestellung aktiv",
        "TableLimitReached": "Pro Arbeitsstation können höchstens {0} Tische für die Gastbestellung verwendet werden.",
        "MenuCode": "Speisekarten-Code",
        "MenuCodeHint": "Ein Code für den ganzen Standort, ohne Tisch: Gäste sehen nur die Karte und können nicht bestellen. Für Tisch-Aufkleber, Tablets und die Website. Voraussetzung: „Gastbestellung aktiv“ und eine Layoutgruppe unter „Sortiment“.",
        "MenuLink": "Link zur Speisekarte",
        "MenuEmbedCode": "Einbettungscode für die Website",
        "MenuEmbedCodeCopied": "Einbettungscode kopiert.",
        "EmbedHint": "Den Code an der gewünschten Stelle der Website einfügen. Die Größe lässt sich über width und height des äußeren div anpassen (Standard: volle Breite, 800 px hoch).",
        "MenuCardLabel": "Speisekarte",
        "ScanToViewMenu": "Scannen für die Speisekarte"
      },
      "PMSTransfer": {
        "Title": "PMS Transfer"
      },
      "Category": "Kategorie",
      "Name": "Bezeichnung",
      "Value": "Wert",
      "Identifiers": {
        "Application": {
          "Title": "Applikation",
          "DecimalPlacesForPrices": "Nachkommastellen für Preise",
          "Language": "Systemsprache",
          "Updating": "Update läuft",
          "Version": "Version Datenbank",
          "ExitPin": "Code zum Beenden der Lipp POS Applikation",
          "ShowKeyboard": "Bildschirmtastatur anzeigen",
          "AutoLogoutInactivityMinutes": "Benutzer bei Inaktivität automatisch abmelden (min)",
          "HapticFeedback": "Vibration bei Klick auf Bedienelemente (nur mobile Geräte)",
          "NumericKeypadLikeKeyboard": "Nummernblock wie am PC (7 8 9 oben)",
          "PreOrder": "Vorbestellungen"
        },
        "ArticleLayout": {
          "Title": "Buchungsmaske Designer",
          "Colors": {
            "Default": {
              "Background": "Artikelbutton - Standardfarbe Hintergrund",
              "Text": "Artikelbutton - Standardfarbe Text"
            }
          },
          "Columns": {
            "Default": "Neue Untergruppe - Spalten Vorschlag",
            "Max": "Untergruppe - Spalten (max)",
            "Min": "Untergruppe - Spalten (min)"
          },
          "QuickSelectSides": "Beilagen-Schnellfunktion bei Artikel",
          "AllowScrolling": "Scroll bei Untergruppen zulassen",
          "HidePriceList": "Preisliste ausblenden",
          "ConfirmPriceListChange": "Zwischenabfrage beim Wechsel der Preisliste",
          "OnlyShowSidesWithSameCommodityGroup": "Beilagen nur mit gleicher Warengruppe anzeigen",
          "RecallFirstCourseImmediately": "Erste Reihenfolge vom Gang sofort abrufen",
          "DoNotCumulateBookings": "Buchungen nicht kumulieren",
          "CollapsibleMainGroups": "Hauptgruppen einklappbar",
          "HideFollowUpArticlesInSplit": "Folgeartikel beim Splitten ausblenden",
          "BookingRowColor": "Zeilenfarbe der Buchungen",
          "ShowArticleNumber": "Artikelnummer anzeigen",
          "Rows": {
            "Default": "Neue Untergruppe - Reihen Vorschlag",
            "Max": "Untergruppe - Reihen (max)",
            "Min": "Untergruppe - Reihen (min)"
          },
          "ArticleSortOrder": "Sortierung der Artikel",
          "SearchedArticleSortOrder": "Sortierung bei der Artikelsuche",
          "SelectedProfileId": "Ausgewähltes Profil (ID)"
        },
        "Articles": {
          "Title": "Artikel",
          "Comment": {
            "DefaultCommentArticleId": "Standardartikel - Kommentar (ID)"
          },
          "Discount": {
            "DefaultDiscountArticleId": "Standardartikel - Ermäßigung (ID)"
          },
          "Tip": {
            "DefaultTipArticleId": "Standardartikel - Trinkgeld (ID)"
          }
        },
        "Backup": {
          "Title": "Datensicherung",
          "FullBackupTime": "Vollständige Datensicherung"
        },
        "Bookings": {
          "Title": "Buchungen",
          "Cancellation": {
            "DefaultCancellationReasonId": "Standard-Stornogrund (ID)"
          }
        },
        "DepartmentLayout": {
          "Title": "Abteilungs- & Tischdesigner",
          "Colors": {
            "Default": {
              "Background": "Neuer Tisch - Standardfarbe Hintergrund",
              "Text": "Neuer Tisch - Standardfarbe Text"
            },
            "Open": {
              "Background": "Tisch offen - Farbe Hintergrund",
              "Text": "Tisch offen - Farbe Text",
              "Old": {
                "Duration": "Tisch offen - Farbwechsel-Intervall (min)",
                "Background": "Tisch offen - Farbwechsel Hintergrund",
                "Text": "Tisch offen - Farbwechsel Text"
              }
            }
          },
          "SnapGridRatio": "Fangraster-Verhältnis",
          "TableSortOrder": "Sortierung der Tische",
          "ShowTimeSinceLastBooking": "Anzeige der Uhrzeit seit letzter Tischbuchung"
        },
        "Encryption": {
          "Title": "Verschlüsselung",
          "Key": "Schlüssel",
          "Salt": "Salt"
        },
        "Invoicing": {
          "Title": "Rechnung",
          "DefaultCashInvoicePaymentMethodId": "Standard-Zahlungsart (Barrechnung) (ID)",
          "FooterText": "Fußzeile",
          "HeaderText": "Kopfzeile",
          "CashPaymentRequiresConfirmation": "Bestätigungsabfrage bei Barrechnung",
          "DefaultPaymentMethodId": "Standard-Zahlungsart bei Buchungsmaske",
          "ShowTip": "Trinkgeldfunktion anzeigen",
          "PersonInputOnInvoicing": "Personeneingabe bei Rechnungserstellung",
          "PrintCancelledInvoice": "Stornierte Rechnung drucken",
          "ShowReturnMoneyCalculator": "Retourgeldrechner bei Barzahlung anzeigen",
          "EnableZUGFeRD": "E-Rechnung (ZUGFeRD) beim E-Mail-Versand anhängen",
          "ShowNfcTip": "Trinkgeldabfrage bei NFC-Kartenzahlung",
          "ShowSignatureTip": "Trinkgeldanzeige bei Unterschrift",
          "StayInSplitAfterInvoice": "Nach Rechnungserstellung im Splitmodus bleiben",
          "PrintInvoiceOnEmailSend": "Bei E-Mail-Versand zusätzlich Rechnung drucken",
          "CloseEffortTablesOnChangeOfDay": "Aufwände beim Tageswechsel automatisch abschließen",
          "IgnoreDownPaymentForTip": "Anzahlung beim Trinkgeld in % nicht abziehen",
          "CardPaymentOnlyOnCardCapableWorkstations": "Kartenzahlung nur an kartenfähigen Arbeitsstationen anzeigen",
          "ApplyPrintCountOnReprint": "Beim Nachdruck die Anzahl Belege der Zahlungsart drucken"
        },
        "Keycard": {
          "Title": "Kundenkarten",
          "TopUpArticleId": "Artikel - Aufladung",
          "PointsActive": "Punktesystem aktiv",
          "PointsDivisor": "Umsatz je Punkt",
          "PointsRedemptionValue": "Punkte für 1 €",
          "PointsRequiredForRedemption": "Mindestpunkte für eine Einlösung",
          "PointsRedemptionArticleId": "Artikel für die Einlösung"
        },
        "Warehouse": {
          "Title": "Lagerverwaltung",
          "EnforceStockLimit": "Buchung bei negativem Bestand verhindern"
        },
        "PMSTransfer": {
          "Title": "PMS Transfer",
          "SignatureRequired": "Unterschrift bei PMS Transfer verpflichtend"
        },
        "LippPortal": {
          "Title": "Lipp Portal",
          "Url": {
            "Dev": "URL - Development",
            "Production": "URL - Production",
            "SignalR": {
              "Dev": "SignalR URL - Development",
              "Production": "SignalR URL - Production",
              "Staging": "SignalR URL - Staging"
            },
            "Staging": "URL - Staging"
          }
        },
        "RetailMode": {
          "Title": "Handelsmodus",
          "DepartmentId": "Abteilung (ID)"
        },
        "Signing": {
          "Title": "Signierung",
          "ApiKey": "API Key",
          "ApiSecret": "API Secret",
          "CashRegisterId": "Kassa-ID",
          "SCUId": "SCU-ID",
          "TSSId": "TSS-ID",
          "AdminPin": "Admin PIN",
          "TSETimeoutSeconds": "TSE-Zeitlimit je Aufruf (Sekunden)"
        },
        "Statistics": {
          "Title": "Statistik",
          "ChangeOfDay": {
            "Time": "Tageswechsel für Statistik",
            "Type": "Tageswechsel für Statistik - Art"
          }
        },
        "Printing": {
          "Title": "Drucken",
          "DailyAccountingPrinterId": "Automatischer Druck Tagesabrechnung"
        },
        "ReportParameters": {
          "Title": "Berichtseinstellungen",
          "ShowCompanyName": "Betriebsnamen anzeigen",
          "LogoFileId": "Logo File-ID",
          "A4LogoFileId": "Logo A4 File-ID",
          "ShowZeroOnInvoice": "Positionen mit 0,00 € auf Rechnung anzeigen",
          "ShowPricesOnReceipt": "Preis auf Bon anzeigen",
          "ShowArticleDescriptionOnInvoice": "Artikelbeschreibung auf Rechnung anzeigen",
          "ShowArticlePackageDetailsOnInvoice": "Artikelpaketdetails auf Rechnung anzeigen",
          "ShowQRCodeOnInvoice": "QR-Code auf Überweisungsrechnung anzeigen",
          "ShowWebsiteQRCodeOnInvoice": "Website QR-Code auf Rechnung anzeigen",
          "EnableEntertainmentReceipt": "Deutschen Bewirtungsbeleg als Druckoption anbieten",
          "ShowTipFieldOnPMSTransfer": "Trinkgeldfeld auf PMS-Transfer-Beleg anzeigen",
          "ShowTipFieldOnProformaInvoice": "Trinkgeldfeld auf Proformarechnung anzeigen",
          "ShowTipFieldOnInvoicePaymentMethodIds": "Trinkgeldfeld auf Rechnung je Zahlungsart",
          "AlwaysShowBankDetailsOn80mmInvoice": "Bankverbindung auf 80mm Rechnungen immer anzeigen",
          "BoldComment": "Kommentar in dicker Schrift",
          "CountSidesInReceiptSummary": "Beilagen in Zusammenfassung mitzählen",
          "ReceiptFontSize": "Schriftgröße bei Bestellbons",
          "CompanyHeaderAlignment": "Ausrichtung Betriebsdaten",
          "RksvQrCodeSize": "Größe RKSV QR-Code",
          "InvoiceAddressFontSize": "Schriftgröße Rechnungsanschrift",
          "UseDin5008Letterhead": "DIN 5008 Norm für Briefköpfe",
          "ShowOpenBookingsInCommodityGroupsInDailyAccounting": "Nicht abgerechnete Buchungen in Warengruppen auf Tagesabrechnung anzeigen"
        }
      },
      "Enum": {
        "ArticleLayoutSortOrder": {
          "LeftToRight": "Links nach Rechts",
          "TopToBottom": "Oben nach Unten",
          "Alphabetical": "Alphabetisch"
        },
        "DepartmentTableSortOrder": {
          "Number": "Nummer",
          "Name": "Bezeichnung"
        },
        "SearchedArticleSortOrder": {
          "Name": "Bezeichnung",
          "Number": "Nummer"
        },
        "ShowKeyboard": {
          "Automatic": "Automatisch",
          "Yes": "Ja",
          "No": "Nein"
        }
      }
    },
    "Extensions": {
      "Title": "Erweiterungen",
      "Discover": "Erweiterungen entdecken"
    },
    "TimeTracking": {
      "Title": "Zeiterfassung",
      "Weekdays": {
        "Sun": "So",
        "Mon": "Mo",
        "Tue": "Di",
        "Wed": "Mi",
        "Thu": "Do",
        "Fri": "Fr",
        "Sat": "Sa"
      },
      "Export": {
        "Title": "Export",
        "Export": "Exportieren",
        "AllUsers": "Alle Benutzer",
        "Users": "Benutzer",
        "Error": "Export konnte nicht erstellt werden",
        "LatestExportInfo": "Zuletzt exportiert von <b>{0}</b> am <b>{1}</b> um <b>{2}</b>",
        "NoReportAvailable": "Der Bericht \"Zeiterfassungsliste\" ist auf dieser Station noch nicht verfügbar."
      },
      "Entries": {
        "Title": "Arbeitszeiten",
        "Entry": "Eintrag",
        "User": "Benutzer",
        "Date": "Datum",
        "Type": "Art",
        "Start": "Anmeldung",
        "End": "Abmeldung",
        "WorkingTime": "Arbeitszeit",
        "NonWorkingTime": "Nicht Arbeitszeit",
        "Deduction": "Autom. Abzug"
      },
      "Types": {
        "Title": "Zeiterfassungsarten",
        "Type": "Art",
        "Name": "Bezeichnung",
        "Color": "Farbe",
        "AutoPrint": "Autom. Druck",
        "Report": "Bericht",
        "Settings": "Einstellungen",
        "Preview": "Vorschau",
        "NoSettings": "Keine",
        "IsWorkingTime": "Arbeitszeit",
        "ActiveInactive": "Aktiv/Inaktiv",
        "ErrorChanging": "Art konnte nicht geändert werden."
      }
    },
    "OpenItems": {
      "Title": "Offene-Posten-Verwaltung",
      "MenuTitle": "Offene-Posten",
      "Status": {
        "Open": "Offen",
        "PartiallyPaid": "Teilbezahlt",
        "Paid": "Bezahlt"
      },
      "Invoices": {
        "Title": "Rechnungen",
        "TotalOpen": "Gesamt offen",
        "Number": "Re.-Nr.",
        "Date": "Re.-Datum",
        "DueDate": "Fällig am",
        "GrossAmount": "Betrag",
        "PaidAmount": "Bezahlt",
        "PaidOn": "Bezahlt am",
        "OpenAmount": "Restbetrag",
        "PaymentMethod": "Zahlungsart",
        "Customer": "Kunde"
      },
      "PaymentMethods": {
        "Title": "Zahlungsarten",
        "Description": "Rechnungen mit folgenden Zahlungsarten anzeigen",
        "Saved": {
          "Title": "Zahlungsarten gespeichert",
          "Description": "Die in der Offene-Posten-Verwaltung geführten Zahlungsarten wurden gespeichert."
        },
        "Error": "Die Zahlungsarten konnten nicht gespeichert werden"
      },
      "Export": {
        "Title": "Exportieren",
        "ErrorExporting": "Offene Posten konnten nicht exportiert werden"
      },
      "Settlement": {
        "Settle": "Zahlung erfassen",
        "Edit": "Rechnung bearbeiten",
        "Created": {
          "Title": "Zahlung erfasst",
          "Description": "Die Zahlung wurde erfasst."
        },
        "Changed": {
          "Title": "Zahlung geändert",
          "Description": "Die Zahlung wurde geändert."
        },
        "Error": "Die Zahlung konnte nicht gespeichert werden",
        "Dialog": {
          "Title": "Zahlung erstellen",
          "EditTitle": "Rechnung ändern",
          "Amount": "Zahlbetrag",
          "OpenAmount": "Noch offener Betrag",
          "PaidOn": "Bezahlt am",
          "PaymentMethod": "Zahlungsart",
          "InvoiceInformation": "Rechnungsinformationen",
          "InvoiceNumber": "Rechnungsnummer",
          "InvoiceDate": "Rechnungsdatum",
          "InvoiceAmount": "Rechnungsbetrag",
          "InvoicePaymentMethod": "Zahlungsart"
        }
      }
    },
    "Dunning": {
      "Title": "Mahnwesen",
      "Levels": {
        "Title": "Mahnstufen",
        "Add": "Mahnstufe",
        "Level": "Mahnstufe",
        "Name": "Bezeichnung",
        "ToleranceDays": "Toleranztage",
        "MailSubjectAndText": "E-Mail Betreff & Text",
        "Edit": "Mahnstufe ändern",
        "Delete": "Mahnstufe löschen",
        "DeleteDescription": "Möchtest du die Mahnstufe <b>{0}</b> wirklich löschen?",
        "Created": {
          "Title": "Mahnstufe erstellt",
          "Description": "Die Mahnstufe wurde erstellt."
        },
        "Changed": {
          "Title": "Mahnstufe geändert",
          "Description": "Die Mahnstufe wurde geändert."
        },
        "Deleted": {
          "Title": "Mahnstufe gelöscht",
          "Description": "Die Mahnstufe \"{0}\" wurde gelöscht."
        },
        "SaveError": "Die Mahnstufe konnte nicht gespeichert werden",
        "DeleteError": "Die Mahnstufe konnte nicht gelöscht werden",
        "LoadError": "Die Mahnstufen konnten nicht geladen werden"
      },
      "Dialog": {
        "CreateTitle": "Mahnstufe erstellen",
        "EditTitle": "Mahnstufe ändern",
        "MailSubject": "E-Mail Betreff",
        "MailBody": "E-Mail Text",
        "Placeholders": "Platzhalter"
      },
      "Settings": {
        "Title": "Einstellungen",
        "StartDate": "Startdatum für automatischen Mahnlauf",
        "PaymentMethods": "Zahlungsarten beim Mahnlauf berücksichtigen",
        "MailAccount": "E-Mail Konto für den Versand",
        "SendTime": "Uhrzeit für das Versenden der Mahnungen",
        "Saved": {
          "Title": "Einstellungen gespeichert",
          "Description": "Die Mahnwesen-Einstellungen wurden gespeichert."
        },
        "Error": "Die Einstellungen konnten nicht gespeichert werden",
        "LoadError": "Die Mahnwesen-Einstellungen konnten nicht geladen werden"
      },
      "Block": {
        "Title": "Mahnsperre",
        "None": "Ohne",
        "Limited": "Befristet",
        "Unlimited": "Unbefristet",
        "Until": "bis",
        "BlockedUntil": "Befristet bis",
        "Comment": "Mahnsperre Kommentar",
        "Saved": {
          "Title": "Mahnsperre gespeichert",
          "Description": "Die Mahnsperre wurde gespeichert."
        }
      }
    },
    "CashJournal": {
      "Title": "Kassenbuch",
      "StartFirstTooltip": "Das Kassenbuch muss zuerst eröffnet werden!",
      "Overview": {
        "Title": "Übersicht",
        "By": "per {0}",
        "Revenue": "Einnahme",
        "Expense": "Ausgabe",
        "CashBalance": "Kassenstand",
        "Revenues": "Einnahmen",
        "Expenses": "Ausgaben",
        "ErrorLoading": "Übersicht konnte nicht geladen werden"
      },
      "Entries": {
        "Title": "Einträge",
        "StartCashJournal": "Kassenbuch eröffnen",
        "Export": "Exportieren",
        "Number": "Nummer",
        "Date": "Datum",
        "Description": "Bezeichnung",
        "Tax": "Steuer",
        "TaxAmount": "Steuerbetrag",
        "Amount": "Betrag",
        "CashBalance": "Kassenstand",
        "User": "Benutzer",
        "PaymentMethod": "Zahlungsmethode",
        "ExternalReceiptNumber": "Externe Belegnummer",
        "DailyClosing": "Tagesabschluss",
        "ActiveInactive": "Aktiv/Inaktiv",
        "ErrorChanging": "Eintrag konnte nicht geändert werden"
      },
      "Templates": {
        "Title": "Vorlagen",
        "Template": "Vorlage",
        "Type": "Typ",
        "Description": "Bezeichnung",
        "Tax": "Steuer",
        "ActiveInactive": "Aktiv/Inaktiv",
        "ErrorChanging": "Vorlage konnte nicht geändert werden"
      },
      "Settings": {
        "Title": "Einstellungen",
        "AddTipAsExpense": "Trinkgeld automatisch als Ausgabe hinzufügen",
        "DisallowBackdatedEntries": "Keine Einträge an vergangenen Tagen",
        "BackdatedEntriesLocked": "Einträge vergangener Tage sind gesperrt. Gebucht werden kann nur auf den aktuellen Tag; er wechselt mit dem „Tageswechsel für Statistik“ (Einstellung „Keine Einträge an vergangenen Tagen“).",
        "ErrorLoading": "Einstellungen konnten nicht geladen werden",
        "ErrorChanging": "Einstellungen konnten nicht geändert werden",
        "Changed": {
          "Title": "Einstellungen geändert",
          "Description": "Die Einstellungen wurden erfolgreich gespeichert."
        }
      },
      "ErrorExporting": "Kassenbuch konnte nicht exportiert werden"
    },
    "OnlineVouchers": {
      "Title": "Online-Gutscheinverkauf",
      "Settings": "Einstellungen",
      "Saved": "Einstellungen gespeichert.",
      "RequiresVoucherGroup": "Online-Gutscheine sind Verbund-Gutscheine. Die Station muss zuerst auf die betriebsübergreifende Gutscheinverwaltung umgestellt werden (Gutscheinverwaltung → „Gutscheine betriebsübergreifend migrieren“, nur Linecker) — das geht auch für einen einzelnen Betrieb.",
      "ShopStatus": {
        "Selling": "Der Shop verkauft.",
        "DayClosed": "Heute ist der Tag an der Kasse abgeschlossen – der Shop verkauft ab {0} Uhr wieder.",
        "DayClosedNoTime": "Heute ist der Tag an der Kasse abgeschlossen – der Shop verkauft ab dem Tageswechsel wieder.",
        "Incomplete": "Noch nicht online – es fehlt: {0}"
      },
      "Requirements": {
        "voucherType": "Gutscheinart",
        "voucherArticle": "Gutschein-Artikel",
        "taxRate": "Steuersatz des Gutschein-Artikels",
        "paymentMethod": "Zahlungsart",
        "user": "Benutzer",
        "mailAccount": "Mailkonto",
        "termsUrl": "Link zu den AGB",
        "withdrawalUrl": "Link zur Widerrufsbelehrung",
        "amounts": "Beträge",
        "stripeAccount": "Stripe-Konto",
        "voucherGroup": "Verbund-Gutscheinverwaltung",
        "tse": "Station ohne deutsche TSE (nur Österreich)"
      },
      "OptionDefault": "Standard",
      "OptionReconnect": "– im Lipp Portal neu verbinden",
      "Sale": "Verkauf",
      "VoucherType": "Gutscheinart",
      "VoucherArticle": "Gutschein-Artikel (Beleg)",
      "VoucherArticleHint": "Warengruppe und Steuersatz des Belegs — wie beim Gutscheinverkauf an der Kasse.",
      "PaymentMethod": "Zahlungsart des Belegs",
      "PaymentMethodHint": "Unter dieser Zahlungsart stehen die Online-Käufe in den Abrechnungen. Bar, Aufwand, PMS-Transfer, Überweisung und Zahlungsarten für offene Posten sind nicht wählbar – am besten eine eigene Zahlungsart wie „Online (Stripe)“ anlegen, damit Online-Umsatz nicht mit der Kartenzahlung an der Kasse zusammenfällt.",
      "User": "Benutzer des Belegs",
      "MailAccount": "Mailkonto für den Versand an den Gast",
      "MailAccountHint": "Zur Auswahl stehen nur Konten, über die die Cloud senden kann: im Lipp Portal verbundene Google- und Microsoft-Konten sowie SMTP-Konten. An der Kasse verbundene Konten senden nur an der Kasse.",
      "NoMailAccount": "Kein passendes Mailkonto vorhanden. Ohne Mailkonto geht der Shop nicht online – bitte ein Konto im Lipp Portal verbinden (Stammdaten → E-Mail Konten) oder ein SMTP-Konto anlegen.",
      "Amounts": "Beträge",
      "FixedAmounts": "Feste Beträge in € (mit Strichpunkt getrennt)",
      "AllowCustomAmount": "Freien Betrag erlauben",
      "MinAmount": "Mindestbetrag",
      "MaxAmount": "Höchstbetrag",
      "Texts": "Texte",
      "ShopTitle": "Überschrift",
      "IntroText": "Einleitung",
      "VoucherNote": "Hinweis auf dem Gutschein",
      "VoucherNoteHint": "Erscheint auf dem PDF, z. B. Einlösebedingungen.",
      "Legal": "Rechtliches",
      "LegalHint": "Das Lokal ist Verkäufer — die Rechtstexte stellt das Lokal bereit. AGB und Widerrufsbelehrung sind Pflicht.",
      "TermsUrl": "Link zu den AGB",
      "WithdrawalUrl": "Link zur Widerrufsbelehrung",
      "PrivacyUrl": "Link zur Datenschutzerklärung",
      "ImprintUrl": "Link zum Impressum",
      "WithdrawalText": "Widerrufsbelehrung (Wortlaut für die Bestätigungsmail)",
      "WithdrawalTextHint": "Wird in die Kaufbestätigung an den Gast übernommen.",
      "Design": "Design",
      "Logo": "Logo",
      "BackgroundColor": "Hintergrund",
      "CardColor": "Karte",
      "TextColor": "Text",
      "AccentColor": "Akzent (Überschrift, Buttons)",
      "ButtonTextColor": "Button-Text",
      "OrderWindow": "Gutschein Bestellfenster",
      "Voucher": "Gutschein",
      "VoucherBackground": "Hintergrund (PDF)",
      "VoucherBackgroundUpload": "PDF hochladen",
      "VoucherTemplate": "Vorlage",
      "VoucherTemplates": {
        "classic": "Klassisch",
        "bottom": "Karte unten",
        "center": "Karte Mitte",
        "right": "Streifen rechts"
      },
      "VoucherPreviewRetry": "Erneut versuchen",
      "Payment": "Zahlung",
      "StripeHint": "Dasselbe Stripe-Konto wie bei Bestellen am Tisch. Gebühren wie dort.",
      "Embed": "Einbindung auf der Website",
      "ShopLink": "Link zur Gutscheinseite",
      "EmbedCode": "Einbettungscode (iframe)",
      "EmbedHint": "Den Code auf der Website des Lokals einfügen. „allow=payment“ ist nötig, damit Apple Pay und Google Pay im Rahmen funktionieren.",
      "EmbedWhenComplete": "Link und Einbettungscode erscheinen, sobald der Shop vollständig eingerichtet und gespeichert ist.",
      "PreviewStation": "Ihr Lokal",
      "DefaultTitle": "Gutschein verschenken",
      "PreviewAmount": "Betrag",
      "PreviewCustom": "Eigener Betrag ({0} – {1} €)",
      "PreviewTo": "Für",
      "PreviewFrom": "Von",
      "PreviewGreeting": "Gruß (optional)",
      "PreviewEmail": "Ihre E-Mail-Adresse",
      "PreviewAccept": "Ich akzeptiere",
      "TermsShort": "AGB",
      "WithdrawalShort": "Widerrufsbelehrung",
      "PreviewBuy": "Zahlungspflichtig kaufen",
      "Purchases": "Online-Käufe",
      "NoPurchases": "Noch keine Online-Käufe.",
      "MorePurchases": "Es gibt mehr als {0} Online-Käufe – angezeigt werden die neuesten {0}.",
      "MailErrorHint": "Die Mail konnte nicht gesendet werden.",
      "FailureHints": {
        "Failed": "Der Kauf konnte nicht abgeschlossen werden. Die Zahlung wurde nicht eingezogen.",
        "CaptureFailed": "Die Zahlung konnte über Stripe nicht eingezogen werden. Der Gutschein wird deshalb gesperrt.",
        "RefundFailed": "Die Erstattung über Stripe ist fehlgeschlagen.",
        "Default": "Bei diesem Kauf ist ein Fehler aufgetreten."
      },
      "ShowPdf": "Gutschein ansehen",
      "ResendMail": "Mail erneut senden",
      "Cancel": "Stornieren und erstatten",
      "MailSent": "Mail an {0} gesendet.",
      "Cancelled": "Gutschein storniert, Betrag wird über Stripe erstattet.",
      "CancelTitle": "Online-Kauf stornieren",
      "CancelQuestion": "Gutschein Nr. {0} stornieren und € {1} über Stripe erstatten? Geht nur, solange der Gutschein unbenutzt ist.",
      "Errors": {
        "Load": "Der Online-Gutscheinverkauf konnte gerade nicht geladen werden. Bitte die Seite neu laden.",
        "Save": "Die Einstellungen konnten nicht gespeichert werden. Bitte gleich noch einmal versuchen.",
        "Upload": "Das Logo konnte nicht hochgeladen werden. Bitte ein anderes Bild (PNG oder JPG) versuchen.",
        "BackgroundNotPdf": "Als Hintergrund des Gutscheins geht nur eine PDF-Datei.",
        "BackgroundUnreadable": "Das PDF konnte nicht gelesen werden. Ist es beschädigt oder mit einem Passwort geschützt?",
        "BackgroundUpload": "Der Hintergrund konnte nicht hochgeladen werden. Bitte gleich noch einmal versuchen.",
        "VoucherPreview": "Die Vorschau des Gutscheins konnte gerade nicht erstellt werden.",
        "Stripe": "Die Verbindung zu Stripe konnte gerade nicht gestartet werden. Bitte gleich noch einmal versuchen.",
        "Pdf": "Der Gutschein konnte gerade nicht geöffnet werden. Bitte gleich noch einmal versuchen.",
        "Mail": "Die Mail konnte nicht gesendet werden. Bitte gleich noch einmal versuchen.",
        "Cancel": "Der Kauf konnte nicht storniert werden. Bitte gleich noch einmal versuchen.",
        "Purchases": "Die Online-Käufe konnten gerade nicht geladen werden. Bitte gleich noch einmal versuchen."
      },
      "Col": {
        "Date": "Datum",
        "Number": "Gutschein-Nr.",
        "Amount": "Betrag",
        "To": "Für",
        "From": "Von",
        "Email": "E-Mail",
        "Receipt": "Beleg",
        "Status": "Status"
      },
      "Status": {
        "PendingPayment": "Zahlung offen",
        "Fulfilling": "In Bearbeitung",
        "Completed": "Abgeschlossen",
        "Failed": "Fehlgeschlagen",
        "CaptureFailed": "Einzug fehlgeschlagen",
        "Abandoned": "Abgebrochen",
        "Refunding": "Storno läuft",
        "Refunded": "Storniert",
        "RefundFailed": "Erstattung fehlgeschlagen"
      }
    },
    "Voucher": {
      "Title": "Gutscheinverwaltung",
      "ErrorLoadingStatusCounts": "Statusübersicht konnte nicht geladen werden",
      "VoucherGroup": {
        "Description": "Die Gutscheine dieses Betriebs werden betriebsübergreifend verwaltet. Zum Verbund gehören: <b>{0}</b>.",
        "Hint": "Gutscheine und Gutscheinarten findest du jetzt unter „Betriebsübergreifend → Lipp POS → Erweiterungen“.",
        "Open": "Zur betriebsübergreifenden Gutscheinverwaltung",
        "Migrate": "Gutscheine betriebsübergreifend migrieren",
        "ErrorLoading": "Es konnte nicht geprüft werden, ob die Gutscheine dieses Betriebs betriebsübergreifend verwaltet werden. Bitte neu laden.",
        "Reload": "Neu laden"
      },
      "Vouchers": {
        "Title": "Gutscheine",
        "All": "Alle",
        "Open": "Offene",
        "Redeemed": "Eingelöste",
        "Export": "Exportieren",
        "Type": "Art",
        "Number": "Nummer",
        "Date": "Datum",
        "Name": "Bezeichnung",
        "Balance": "Saldo",
        "TotalValue": "Gesamt",
        "InvoiceNumber": "Re.-Nr.",
        "InvoiceTotal": "Gesamt (Re.)",
        "PaymentMethod": "Zahlungsart",
        "ErrorExporting": "Export konnte nicht erstellt werden",
        "NoVoucherListReport": "Kein Gutscheinlisten-Bericht für diese Station vorhanden"
      },
      "VoucherTypes": {
        "Title": "Gutscheinarten",
        "Name": "Bezeichnung",
        "Tax": "Mehrwertsteuer",
        "NumberAssignment": "Nummernvergabe",
        "Automatic": "Automatisch",
        "Manual": "Manuell",
        "StartNumber": "Startnummer",
        "Report": "Bericht",
        "MixedReports": "Unterschiedlich je Betrieb",
        "ActiveInactive": "Aktiv/Inaktiv",
        "VoucherType": "Gutscheinart",
        "Default": "Standard",
        "ErrorChanging": "Gutscheinart konnte nicht geändert werden",
        "ErrorSettingDefault": "Standard-Gutscheinart konnte nicht gesetzt werden"
      },
      "ImportExport": {
        "Title": "Import/Export",
        "Import": "Importieren",
        "Export": "Exportieren",
        "ImportSuccess": {
          "Title": "Import erfolgreich",
          "Description": "{created} Gutschein(e) angelegt, {updated} aktualisiert."
        },
        "ImportPartial": {
          "Title": "Import teilweise durchgeführt",
          "Description": "{created} angelegt, {updated} aktualisiert, {failed} fehlerhaft:"
        },
        "ImportError": {
          "Title": "Import fehlgeschlagen"
        },
        "ExportError": "Export konnte nicht erstellt werden"
      }
    },
    "WarehouseManagement": {
      "Title": "Lagerverwaltung",
      "Loading": "Wird geladen...",
      "Active": "Aktiv",
      "Inactive": "Inaktiv",
      "Export": {
        "Title": "Bericht exportieren",
        "Tooltip": "Bericht exportieren",
        "ErrorExporting": "Bericht konnte nicht exportiert werden",
        "NoReportsAvailable": "Es ist kein Bericht verfügbar."
      },
      "Stock": {
        "Title": "Lagerbestand",
        "Warehouse": "Lagerbereich",
        "ArticleNumber": "Art.-Nr.",
        "ArticleName": "Artikelbezeichnung",
        "Supplier": "Lieferant",
        "Pieces": "Stückzahl",
        "Quantity": "Menge",
        "Unit": "Einheit",
        "PiecesPerPackagingUnit": "Stk. pro VPE",
        "PackagingUnits": "Anz. VPE",
        "MinimumQuantity": "Warnmenge",
        "PurchasePricePerUnit": "Einkaufspreis",
        "PurchaseValue": "Einkaufswert",
        "NoData": "Keine Lagerbestände vorhanden",
        "ErrorLoading": "Lagerbestände konnten nicht geladen werden",
        "MinimumQuantitySaveError": "Warnmenge konnte nicht gespeichert werden",
        "StockSaveError": "Bestand konnte nicht gespeichert werden"
      },
      "Movements": {
        "Title": "Lagerbewegungen",
        "Date": "Buchungsdatum",
        "Type": "Buchungstyp",
        "Warehouse": "Lagerbereich",
        "Article": "Artikelbezeichnung",
        "Supplier": "Lieferant",
        "Pieces": "Stückzahl",
        "Quantity": "Menge",
        "Unit": "Einheit",
        "PricePerUnit": "Einkaufspreis",
        "PurchaseValue": "Einkaufswert",
        "GoodsReceipt": "Wareneingang",
        "StockTransfer": "Umlagerung",
        "InventoryCorrection": "Inventur-Korrektur",
        "GoodsReceiptCorrection": "Wareneingang-Korrektur",
        "ManualCorrection": "Manuelle Korrektur",
        "CorrectError": "Die Korrektur konnte nicht gebucht werden",
        "CorrectConfirm": {
          "Title": "Wareneingang korrigieren",
          "Description": "Für diesen Wareneingang wird eine Gegenbuchung über dieselbe Menge angelegt. Die ursprüngliche Buchung bleibt in den Lagerbewegungen stehen.",
          "Amount": "Gegenbuchung"
        },
        "Corrected": {
          "Title": "Korrektur gebucht",
          "Description": "Die Gegenbuchung wurde angelegt."
        },
        "Consumption": "Verkauf",
        "ConsumptionReversal": "Storno",
        "CurrentMonth": "Aktuelles Monat",
        "Export": "Exportieren",
        "ExportNotAvailable": "Export ist noch nicht verfügbar",
        "ErrorExporting": "Lagerbewegungen konnten nicht exportiert werden",
        "NoInventoryMovementsReport": "Es ist kein Bericht vom Typ \"Lagerbewegungen\" verfügbar.",
        "NoData": "Keine Lagerbewegungen vorhanden",
        "ErrorLoading": "Lagerbewegungen konnten nicht geladen werden"
      },
      "Inventories": {
        "Title": "Inventuren",
        "Overview": "Übersicht",
        "Positions": "Positionen",
        "NewInventory": "Inventur",
        "EditInventory": "Inventur bearbeiten",
        "Close": "Abschließen",
        "Description": "Bezeichnung",
        "Warehouse": "Lagerbereich",
        "CreatedOn": "Erstellt am",
        "ClosedOn": "Abgeschlossen am",
        "StatusColumn": "Status",
        "Status": {
          "Draft": "Entwurf",
          "Closed": "Abgeschlossen"
        },
        "ArticleNumber": "Art.-Nr.",
        "ArticleName": "Artikelbezeichnung",
        "Supplier": "Lieferant",
        "PlannedPieces": "Soll Stk.",
        "PlannedQuantity": "Soll Menge",
        "DiffPieces": "Diff. Stk.",
        "DiffQuantity": "Diff. Menge",
        "ActualPieces": "Ist Stk.",
        "ActualQuantity": "Ist Menge",
        "Unit": "Einheit",
        "PiecesPerPackagingUnit": "Stk. pro VPE",
        "ActualPackagingUnits": "Ist Anz. VPE",
        "NoData": "Keine Inventuren vorhanden",
        "ErrorLoading": "Inventuren konnten nicht geladen werden",
        "SelectInventoryFirst": "Bitte zuerst eine Inventur in der Übersicht auswählen.",
        "OpenPDF": "PDF öffnen",
        "DownloadPDF": "PDF herunterladen",
        "SendByMail": "Per E-Mail senden",
        "FeatureNotYetAvailable": "Diese Funktion ist noch nicht verfügbar",
        "CloseConfirm": {
          "Title": "Inventur abschließen?",
          "Description": "{0} Differenzen werden als Korrekturbuchungen erstellt. Der Lagerbestand wird damit auf den Ist-Wert korrigiert."
        },
        "Created": {
          "Title": "Inventur erstellt",
          "Description": "Die Inventur wurde erfolgreich angelegt."
        },
        "Changed": {
          "Title": "Inventur geändert",
          "Description": "Die Bezeichnung wurde erfolgreich geändert."
        },
        "SaveError": "Inventur konnte nicht gespeichert werden",
        "Closed": {
          "Title": "Inventur abgeschlossen",
          "Description": "Korrekturbuchungen wurden erstellt."
        },
        "ItemSaveError": "Bestand konnte nicht gespeichert werden"
      },
      "Areas": {
        "Title": "Lagerbereiche",
        "Description": "Bezeichnung",
        "IsDefault": "Standard",
        "IsActive": "Aktiv/Inaktiv",
        "NoData": "Keine Lagerbereiche vorhanden",
        "ErrorLoading": "Lagerbereiche konnten nicht geladen werden"
      },
      "Articles": {
        "Title": "Lagerartikel",
        "Add": "Hinzufügen",
        "AddPurchasing": "Einkaufsartikel",
        "ToggleError": "Artikel konnte nicht aktiviert/deaktiviert werden",
        "Standalone": "Eigenständig",
        "Recipe": "Rezeptur",
        "Purchasing": "Einkauf",
        "Type": "Typ",
        "Number": "Art.-Nr.",
        "Name": "Bezeichnung",
        "PriceGross": "Verkaufspreis",
        "Costs": "Einkaufspreis",
        "FillQuantity": "Füllmenge",
        "Unit": "Einheit",
        "PiecesPerPackagingUnit": "Stk. pro VPE",
        "Supplier": "Lieferant",
        "CommodityGroup": "Warengruppe",
        "IsActive": "Aktiv/Inaktiv",
        "Assigned": "Zugeordnet",
        "EditRecipe": "Rezeptur bearbeiten",
        "FillQuantitySaveError": "Füllmenge konnte nicht gespeichert werden",
        "FillQuantityLockedTooltip": "Ändere die Einheit, um die Füllmenge zu setzen",
        "SupplierSaveError": "Lieferant konnte nicht gespeichert werden",
        "UnitSaveError": "Einheit konnte nicht gespeichert werden",
        "NoData": "Keine Lagerartikel vorhanden",
        "ErrorLoading": "Lagerartikel konnten nicht geladen werden",
        "DeactivateArticle": {
          "Title": "Artikel deaktivieren",
          "Description": "Willst du den Artikel <b>{0}</b> wirklich deaktivieren?"
        },
        "RemoveFromStock": {
          "Title": "Aus Lagerverwaltung entfernen",
          "Description": "Willst du den Artikel <b>{0}</b> wirklich aus der Lagerverwaltung entfernen?",
          "Error": "Artikel konnte nicht aus der Lagerverwaltung entfernt werden"
        }
      },
      "Suppliers": {
        "Title": "Lieferanten",
        "SupplierNumber": "Lieferanten-Nr.",
        "Name": "Bezeichnung",
        "City": "Ort",
        "Country": "Land",
        "VatId": "Lieferanten UID-Nummer",
        "IsActive": "Aktiv/Inaktiv",
        "NoData": "Keine Lieferanten vorhanden",
        "ErrorLoading": "Lieferanten konnten nicht geladen werden",
        "New": "Lieferant",
        "CustomerNumber": "Kunden-Nr.",
        "Suffix": "Zusatz",
        "Street": "Straße",
        "ZipCode": "PLZ"
      },
      "RemainingQuantities": {
        "Title": "Restmengen",
        "Number": "Art.-Nr.",
        "Name": "Bezeichnung",
        "Type": "Typ",
        "CommodityGroup": "Warengruppe",
        "IsRemainingQuantityArticle": "Restmengen-Artikel",
        "Quantity": "Restmenge",
        "Warning": "Warnmenge",
        "Unit": "Einheit",
        "IsActive": "Aktiv/Inaktiv",
        "NoData": "Keine Restmengen-Artikel vorhanden",
        "ErrorLoading": "Restmengen konnten nicht geladen werden",
        "BelowWarning": "Unter Warnmenge",
        "SaveError": "Restmenge konnte nicht gespeichert werden",
        "ToggleError": "Restmengen-Artikel konnte nicht umgeschaltet werden",
        "NotAllowedForType": "Nur Artikel und Beilagen können Restmengen-Artikel sein"
      },
      "Requisitions": {
        "Title": "Fassungen",
        "Columns": {
          "Number": "Nummer",
          "Date": "Datum",
          "Department": "An",
          "User": "Bestellt von",
          "Note": "Notiz"
        },
        "Actions": {
          "Preview": "Vorschau",
          "Print": "Drucken",
          "Download": "Herunterladen",
          "SendMail": "Per E-Mail senden"
        },
        "SendMail": {
          "Title": "Fassung per E-Mail versenden",
          "FilePrefix": "Fassung",
          "Success": {
            "Title": "Fassung gesendet",
            "Description": "Die Fassung wurde per E-Mail an <b>{0}</b> gesendet."
          },
          "Error": "Fassung konnte nicht gesendet werden"
        },
        "ErrorRendering": "Fassung konnte nicht geladen werden",
        "NoRequisitionReport": "Es ist kein Fassungs-Bericht hinterlegt."
      },
      "Actions": {
        "NewWarehouse": "Lagerbereich",
        "NewRecipe": "Neue Rezeptur",
        "GoodsReceipt": "Wareneingang",
        "StockTransfer": "Umlagerung",
        "CorrectGoodsReceipt": "Wareneingang korrigieren",
        "Assignment": "Zuordnung",
        "NewInventory": "Neue Inventur",
        "EditArticle": "Lagerartikel bearbeiten",
        "SetDefault": "Als Standard festlegen",
        "ToggleActive": "Aktiv/Inaktiv",
        "DeleteRecipe": "Rezeptur löschen",
        "RemoveFromStock": "Aus Lagerverwaltung entfernen"
      },
      "Dialogs": {
        "Warehouse": {
          "Create": "Lagerbereich erstellen",
          "Edit": "Lagerbereich bearbeiten",
          "Description": "Bezeichnung",
          "IsDefault": "Als Standard festlegen",
          "IsActive": "Aktiv",
          "AssignmentType": "Zuordnungsart",
          "AssignmentWorkstation": "Arbeitsstationen",
          "AssignmentDepartment": "Abteilungen",
          "AssignmentUser": "Benutzer",
          "Created": {
            "Title": "Lagerbereich erstellt",
            "Description": "Der Lagerbereich <b>{0}</b> wurde erfolgreich erstellt.",
            "Error": "Lagerbereich konnte nicht erstellt werden"
          },
          "Changed": {
            "Title": "Lagerbereich geändert",
            "Description": "Der Lagerbereich <b>{0}</b> wurde erfolgreich geändert.",
            "Error": "Lagerbereich konnte nicht geändert werden"
          },
          "ErrorToggling": "Lagerbereich konnte nicht aktiviert/deaktiviert werden",
          "ErrorSettingDefault": "Standard-Lagerbereich konnte nicht gesetzt werden"
        },
        "WarehouseAssignment": {
          "Title": "Zuordnung bearbeiten",
          "Workstations": "Arbeitsstationen",
          "Departments": "Abteilungen",
          "Users": "Benutzer",
          "AssignmentType": "Zuordnungsart",
          "Saved": {
            "Title": "Zuordnung gespeichert",
            "Description": "Die Zuordnung des Lagerbereichs <b>{0}</b> wurde erfolgreich gespeichert."
          },
          "Error": "Zuordnung konnte nicht gespeichert werden",
          "ErrorLoadingLookups": "Auswahldaten konnten nicht geladen werden"
        },
        "Supplier": {
          "Create": "Lieferant erstellen",
          "Edit": "Lieferant bearbeiten",
          "SupplierNumber": "Lieferanten-Nr.",
          "CustomerNumber": "Kunden-Nr.",
          "Name": "Name",
          "Suffix": "Zusatz",
          "Street": "Straße",
          "ZipCode": "PLZ",
          "City": "Ort",
          "Country": "Land",
          "VatId": "Lieferanten UID-Nummer",
          "Created": {
            "Title": "Lieferant erstellt",
            "Description": "Der Lieferant <b>{0}</b> wurde erfolgreich erstellt.",
            "Error": "Lieferant konnte nicht erstellt werden"
          },
          "Changed": {
            "Title": "Lieferant geändert",
            "Description": "Der Lieferant <b>{0}</b> wurde erfolgreich geändert.",
            "Error": "Lieferant konnte nicht geändert werden"
          },
          "ErrorToggling": "Lieferant konnte nicht aktiviert/deaktiviert werden"
        },
        "GoodsReceipt": {
          "Title": "Wareneingang erfassen",
          "Date": "Datum",
          "BookingDate": "Buchungsdatum",
          "Warehouse": "Lagerbereich",
          "Supplier": "Lieferant",
          "Article": "Artikel",
          "Pieces": "Stück",
          "PiecesLong": "Stückzahl",
          "PackagingUnitCount": "Anzahl VPE",
          "PiecesPerPackagingUnit": "Stk. pro VPE",
          "Quantity": "Menge",
          "QuantityLong": "Menge",
          "FillQuantity": "Füllmenge",
          "PreviewPiecesQuantity": "Vorschau (Stk. / Gesamtmenge)",
          "AddMore": "Weitere Wareneingänge erfassen",
          "AddAction": "Hinzufügen",
          "Created": {
            "Title": "Wareneingang erfasst",
            "Description": "Der Wareneingang wurde erfolgreich erfasst."
          },
          "Error": "Wareneingang konnte nicht erfasst werden"
        },
        "StockTransfer": {
          "Title": "Umlagerung durchführen",
          "Date": "Datum",
          "BookingDate": "Buchungsdatum",
          "SourceWarehouse": "Lagerbereich - Quelle",
          "TargetWarehouse": "Lagerbereich - Ziel",
          "Article": "Artikel",
          "Supplier": "Lieferant",
          "Pieces": "Stück",
          "PiecesLong": "Stückzahl",
          "PackagingUnitCount": "Anzahl VPE",
          "PiecesPerPackagingUnit": "Stk. pro VPE",
          "Quantity": "Menge",
          "QuantityLong": "Menge",
          "FillQuantity": "Füllmenge",
          "PreviewSource": "Vorschau Lagerbereich - Quelle Stk. / Menge",
          "PreviewTarget": "Vorschau Lagerbereich - Ziel Stk. / Menge",
          "AddMore": "Weitere Umlagerungen durchführen",
          "TransferAction": "Durchführen",
          "Created": {
            "Title": "Umlagerung erfasst",
            "Description": "Die Umlagerung wurde erfolgreich erfasst."
          },
          "Error": "Umlagerung konnte nicht erfasst werden",
          "SameWarehouseError": "Quell- und Ziel-Lagerbereich müssen unterschiedlich sein"
        },
        "WarehouseRecipe": {
          "Create": "Rezeptur erstellen",
          "Edit": "Rezeptur bearbeiten",
          "Article": "Artikel",
          "Description": "Bezeichnung",
          "Items": "Zutaten",
          "ItemArticle": "Zutat",
          "ItemQuantity": "Menge",
          "AddItem": "Zutat hinzufügen",
          "RemoveItem": "Entfernen",
          "Created": {
            "Title": "Rezeptur erstellt",
            "Description": "Die Rezeptur wurde erfolgreich erstellt."
          },
          "Changed": {
            "Title": "Rezeptur geändert",
            "Description": "Die Rezeptur wurde erfolgreich geändert."
          },
          "Error": "Rezeptur konnte nicht gespeichert werden",
          "NoItems": "Es muss mindestens eine Zutat erfasst werden"
        },
        "RecipeDetails": {
          "Title": "Rezepturdetails",
          "Deduction": "Abzug",
          "Article": "Einkaufsartikel",
          "FillQuantity": "Füllmenge",
          "FillQuantityLockedTooltip": "Die Zutat wird in Stk geführt. Ändere die Einheit beim Lagerartikel, um die Füllmenge zu setzen."
        },
        "AddRecipeArticle": {
          "Title": "Rezeptur hinzufügen",
          "Article": "Artikel"
        },
        "DeleteWarehouseRecipe": {
          "Title": "Rezeptur löschen",
          "Description": "Willst du die Rezeptur <b>{0}</b> wirklich löschen?",
          "Success": {
            "Title": "Rezeptur gelöscht",
            "Description": "Die Rezeptur wurde erfolgreich gelöscht."
          },
          "Error": "Rezeptur konnte nicht gelöscht werden"
        },
        "Inventory": {
          "Title": "Inventur",
          "StubNote": "Inventuren können noch nicht persistiert werden. Diese Ansicht ist eine Design-Vorschau.",
          "Close": "Schließen"
        },
        "StockArticle": {
          "Title": "Einkaufsartikel anlegen",
          "EditTitle": "Einkaufsartikel bearbeiten",
          "Name": "Bezeichnung",
          "Number": "Art.-Nr.",
          "CommodityGroup": "Warengruppe",
          "Supplier": "Lieferant",
          "PriceGross": "Verkaufspreis",
          "Costs": "Einkaufspreis",
          "FillQuantity": "Füllmenge",
          "Unit": "Einheit",
          "PiecesPerPackagingUnit": "Stk. pro VPE",
          "Created": {
            "Title": "Einkaufsartikel angelegt",
            "Description": "Der Einkaufsartikel wurde erfolgreich angelegt."
          },
          "Changed": {
            "Title": "Einkaufsartikel geändert",
            "Description": "Der Einkaufsartikel wurde erfolgreich geändert."
          },
          "Error": "Einkaufsartikel konnte nicht angelegt werden",
          "StubNote": "Das Bearbeiten von Lagerartikeln ist noch nicht im Portal verfügbar. Verwende vorerst das POS-System, um Artikel anzulegen oder zu bearbeiten.",
          "Close": "Schließen"
        },
        "AddStockArticles": {
          "Title": "Artikel als Lagerartikel markieren",
          "Search": "Artikel suchen (Bezeichnung, Art.-Nr.)",
          "SearchCommodityGroup": "Warengruppe suchen",
          "SelectAll": "Alle auswählen",
          "Selected": "{0} von {1} ausgewählt",
          "NoCandidates": "Alle Artikel sind bereits als Lagerartikel markiert.",
          "NoMatches": "Keine Artikel passen zur Suche.",
          "Submit": "{0} Artikel hinzufügen",
          "ErrorLoading": "Artikel konnten nicht geladen werden",
          "ErrorSaving": "Folgende Artikel konnten nicht gespeichert werden",
          "Saved": {
            "Title": "Lagerartikel hinzugefügt",
            "Description": "{0} Artikel wurden als Lagerartikel markiert."
          }
        }
      }
    },
    "DigitalReceipt": {
      "Title": "Digitaler Beleg",
      "Workstations": {
        "Workstations": "Arbeitsstationen",
        "ActiveOnWorkstations": "Digitaler Beleg aktiv auf folgenden Arbeitsstationen",
        "Success": {
          "WorkstationTitle": "Arbeitsstationen geändert",
          "WorkstationDescription": "Die Auswahl wurde erfolgreich geändert."
        },
        "Error": {
          "WorkstationError": "Fehler beim Ändern der Arbeitsstationen!",
          "InterfaceError": "Fehler beim Laden der Einstellungen!",
          "SettingMissing": "Die Einstellung ist auf dieser Station noch nicht verfügbar."
        }
      }
    },
    "ErrorLoadingData": "Lipp POS Daten konnten nicht geladen werden",
    "RequestSyncBaseData": {
      "Title": "Basisdaten",
      "Success": {
        "Title": "Synchronisierung angestoßen",
        "Description": "Es wurde eine Synchronisierung der Basisdaten angestoßen."
      },
      "Error": "Synchronisierung konnte nicht angestoßen werden"
    },
    "RequestSyncTransactionData": {
      "Title": "Transaktionsdaten",
      "Success": {
        "Title": "Synchronisierung angestoßen",
        "Description": "Es wurde eine Synchronisierung der Transaktionsdaten angestoßen."
      },
      "Error": "Synchronisierung konnte nicht angestoßen werden"
    },
    "StartUpdate": {
      "Title": "Update planen",
      "Pending": "Update vorgemerkt",
      "PendingAt": "Update geplant: {0}",
      "Cancel": "Planung aufheben",
      "CancelError": "Planung konnte nicht aufgehoben werden",
      "Error": "Update konnte nicht geplant werden",
      "Success": {
        "Title": "Update geplant",
        "Description": "Auf der Kassa <b>{0}</b> wird das Update am {1} durchgeführt. Ist die Kassa zu diesem Zeitpunkt offline, wird es noch bis zu 1 Stunde danach ausgeführt.",
        "NowTitle": "Update angestoßen",
        "NowDescription": "Auf der Kassa <b>{0}</b> wird das Update jetzt durchgeführt. Ist die Kassa offline, wird es beim nächsten Verbinden ausgeführt (gültig 12 Stunden)."
      },
      "Dialog": {
        "Title": "Update planen",
        "Description": "Wann soll das Update auf der Kassa <b>{0}</b> durchgeführt werden? Die Kassa wird dabei neu gestartet und ist kurz nicht verfügbar.",
        "Moment": "Zeitpunkt",
        "Moments": {
          "Now": "Jetzt",
          "InMinutes": "in {0} Minuten",
          "InHour": "in {0} Stunde",
          "InHours": "in {0} Stunden",
          "Custom": "Benutzerdefiniert"
        },
        "DateTime": "Datum und Uhrzeit",
        "CountdownHint": "Ist die Lipp POS an der Hauptkassa geöffnet, erscheint dort vorher ein Countdown von 5 Minuten.",
        "PlanningRequiresVersion": "Einen Zeitpunkt wählen kann man ab Lipp POS 1.38.0. Bis dahin wird das Update sofort durchgeführt.",
        "TimeInPast": "Der gewählte Zeitpunkt liegt in der Vergangenheit. Bitte einen späteren wählen.",
        "Confirm": "Update planen"
      }
    },
    "Setup": {
      "Title": "Lipp POS muss zuerst eingerichtet werden.",
      "Description": "In diesem Video erklären wir, wie du die Lipp POS einrichtest, sodass du danach deine Daten verwalten kannst.",
      "WatchTutorial": "Video ansehen"
    },
    "Menu": "Auswahl",
    "BMD": {
      "Title": "BMD",
      "Export": {
        "Title": "Export",
        "Export": "Exportieren",
        "Error": "BMD-Export konnte nicht erstellt werden",
        "NoSettingsSavedYet": "Es wurden noch keine Einstellungen gespeichert.",
        "LatestExportInfo": "Zuletzt exportiert von <b>{0}</b> am <b>{1}</b> um <b>{2}</b>",
        "YearBoundary": {
          "Title": "Zeitraum über den Jahreswechsel",
          "Description": "Ein DATEV-Export kann keinen Jahreswechsel überspannen, weil das Belegdatum nur Tag und Monat enthält. Bitte die Jahre getrennt exportieren."
        },
        "MissingText": {
          "Title": "Export nicht möglich",
          "Description": "Bei folgenden Kassenbewegungen fehlt die Bezeichnung. Sie wird im DATEV-Export als Belegtext übernommen und ist dort Pflichtfeld. Bitte ergänzen und erneut exportieren:"
        },
        "NoMovements": {
          "Title": "Keine Kassenbewegungen",
          "Description": "Im gewählten Zeitraum gibt es keine Kassenbewegungen. Die Buchungsdatei wurde exportiert, eine Datei für die Kassenbewegungen nicht. Kassenbewegungen gibt es erst ab dem Start des Kassenbuchs dieser Station, davor bleibt jeder Zeitraum leer."
        },
        "FormatNotDatev": {
          "Title": "DATEV nicht eingestellt",
          "Description": "Diese Station ist nicht auf DATEV als Exportformat eingestellt. Bitte unten unter „Einstellungen“ auf „Speichern“ klicken und erneut exportieren."
        }
      },
      "Settings": {
        "Title": "Einstellungen",
        "BookingFileName": "Buchungen-Dateiname",
        "SuspenseAccountNumber": "Zwischenkontonummer",
        "BookingSymbol": "Buchungssymbol",
        "IncludeEfforts": "Aufwände inkludieren",
        "ErrorLoading": "Einstellungen konnten nicht geladen werden",
        "ErrorChanging": "Einstellungen konnten nicht geändert werden",
        "Changed": {
          "Title": "Einstellungen geändert",
          "Description": "Die Einstellungen wurden erfolgreich geändert."
        }
      },
      "FinancialAccounts": {
        "Title": "Finanzkonten",
        "FinancialAccount": "Finanzkonto",
        "AccountNumber": "Kontonummer",
        "AccountName": "Kontoname",
        "CostCenter": "Kostenstelle",
        "BookingSymbol": "Buchungssymbol",
        "ExternalTaxCode": "Externer Steuercode",
        "OutputType": "Ausgabetyp",
        "OutputTypes": {
          "0": "Summe",
          "1": "Pro Rechnung",
          "2": "Pro Tag",
          "3": "Einzel"
        },
        "ActiveInactive": "Aktiv/Inaktiv",
        "ToggleIsActiveError": "Finanzkonto konnte nicht geändert werden"
      },
      "Assignments": {
        "Title": "Zuordnung",
        "CommodityGroup": "Warengruppe",
        "CommodityGroups": "Warengruppen",
        "PaymentMethod": "Zahlungsmethode",
        "PaymentMethods": "Zahlungsmethoden",
        "Effort": "Aufwand",
        "Efforts": "Aufwände",
        "AccountNumber": "Kontonummer",
        "VAT": "MwSt {0}%",
        "TipCommodityGroup": "Trinkgeld",
        "DiscountCommodityGroup": "Ermäßigung",
        "ErrorLoadingFinancialAccountMappings": "Zuordnungen konnten nicht geladen werden"
      }
    },
    "DATEV": {
      "Title": "DATEV",
      "Settings": {
        "ExportFormat": "Exportformat",
        "Consultant": "Beraternummer",
        "Client": "Mandantennummer",
        "BusinessYearStartMonth": "Wirtschaftsjahr-Beginn (Monat)",
        "GLAccountNoLength": "Sachkontenlänge",
        "Currency": "Währung"
      }
    },
    "AidaX": {
      "Title": "AIDA.x",
      "CommunicationService": {
        "Title": "Kommunikationsserver",
        "ErrorLoadingCommunicationServices": "Kommunikationsserver konnten nicht geladen werden",
        "ErrorLoadingSelectedCommunicationService": "Ausgewählter Kommunicationsserver konnte nicht geladen werden",
        "Changed": {
          "Success": {
            "Title": "Kommunikationsserver ausgewählt",
            "Description": "Der Kommunikationsserver <b>{0}</b> wurde erfolgreich ausgewählt."
          },
          "Error": "Kommunikationsserver konnte nicht ausgewählt werden"
        }
      },
      "Settings": {
        "Title": "Einstellungen",
        "Name": "Bezeichnung",
        "Value": "Wert",
        "Identifiers": {
          "FOLDERPATH": "Datei-Ablage Ordner für Transfers",
          "INVOICECARRIERFORGUESTS": "PMS-Gäste als Rechnungsträger anzeigen",
          "SENDDAILYREVENUEPERUSER": "Tagesumsätze pro Benutzer senden",
          "SENDDAILYREVENUEPERWS": "Tagesumsätze pro Arbeitsstation senden",
          "SENDDAILYREVENUEWITHOUTTIP": "Tagesumsätze ohne Trinkgeld senden",
          "SENDDAILYREVENUEAUTOMATIC": "Tagesumsätze automatisch vom Vortag senden",
          "SENDDAILYREVENUESTARTDATE": "Tagesumsätze automatisch vom Vortag senden - Startdatum",
          "SENDDAILYREVENUETIME": "Tagesumsätze automatisch vom Vortag senden - Uhrzeit"
        },
        "SendDailyRevenueAutomaticOptions": {
          "0": "Nein",
          "1": "Ja - PMS Zimmernummer = Lipp POS Tischnummer",
          "2": "Ja - PMS Tischnummer = Lipp POS Tischnummer"
        }
      }
    },
    "Eucasoft": {
      "Title": "Eucasoft",
      "CommunicationService": {
        "Title": "Kommunikationsserver",
        "ErrorLoadingCommunicationServices": "Kommunikationsserver konnten nicht geladen werden",
        "ErrorLoadingSelectedCommunicationService": "Ausgewählter Kommunikationsserver konnte nicht geladen werden",
        "Changed": {
          "Success": {
            "Title": "Kommunikationsserver ausgewählt",
            "Description": "Der Kommunikationsserver <b>{0}</b> wurde erfolgreich ausgewählt."
          },
          "Error": "Kommunikationsserver konnte nicht ausgewählt werden"
        }
      },
      "Settings": {
        "Title": "Einstellungen",
        "Name": "Bezeichnung",
        "Value": "Wert",
        "Identifiers": {
          "FOLDERPATH": "Kassenpfad",
          "INVOICECARRIERFORGUESTS": "PMS Rechnungsträger automatisch erstellen",
          "SENDDAILYREVENUEAUTOMATIC": "Tagesumsätze automatisch senden",
          "SENDDAILYREVENUESTARTDATE": "Tagesumsätze automatisch senden - Startdatum",
          "SENDDAILYREVENUETIME": "Tagesumsätze automatisch senden - Uhrzeit",
          "EUCASOFT_FILENAMEGUESTS": "Dateiname PMS Kunden",
          "EUCASOFT_FILENAMEBOOKINGS": "Dateiname PMS Buchungen",
          "EUCASOFT_FILENAMEARTICLES": "Dateiname Artikelstamm",
          "EUCASOFT_TRANSFERZEROAMOUNT": "Nullbetrag Buchungen übertragen",
          "EUCASOFT_BOOKINGDATEMODE": "Buchungsdatum",
          "EUCASOFT_CHECKORPHANCARRIERS": "PMS Rechnungsträger von nicht mehr vorhandenen Zimmern überprüfen",
          "EUCASOFT_INCLUDETRANSFERS": "Tagesumsätze - PMS Transfer inkludieren",
          "EUCASOFT_FIXEDTABLES": "Fixe Tischnummern (kommagetrennt, überschreibt 'PMS Rechnungsträger automatisch erstellen')"
        },
        "InvoiceCarrierOptions": {
          "0": "Nein",
          "1": "Ja - PMS Zimmernummer = Lipp POS Tischnummer",
          "2": "Ja - PMS Tischnummer = Lipp POS Tischnummer"
        },
        "BookingDateMode": {
          "BookingTimestamp": "Buchungsdatum",
          "InvoiceTimestamp": "Rechnungsdatum"
        }
      }
    },
    "AsaASCII": {
      "Title": "ASA Ascii",
      "CommunicationService": {
        "Title": "Kommunikationsserver",
        "ErrorLoadingCommunicationServices": "Kommunikationsserver konnten nicht geladen werden",
        "ErrorLoadingSelectedCommunicationService": "Ausgewählter Kommunikationsserver konnte nicht geladen werden",
        "Changed": {
          "Success": {
            "Title": "Kommunikationsserver ausgewählt",
            "Description": "Der Kommunikationsserver <b>{0}</b> wurde erfolgreich ausgewählt."
          },
          "Error": "Kommunikationsserver konnte nicht ausgewählt werden"
        }
      },
      "Settings": {
        "Title": "Einstellungen",
        "Name": "Bezeichnung",
        "Value": "Wert",
        "Identifiers": {
          "FOLDERPATH": "Kassenpfad",
          "INVOICECARRIERFORGUESTS": "PMS Rechnungsträger automatisch erstellen",
          "SENDDAILYREVENUEAUTOMATIC": "Tagesumsätze automatisch senden",
          "SENDDAILYREVENUESTARTDATE": "Tagesumsätze automatisch senden - Startdatum",
          "SENDDAILYREVENUETIME": "Tagesumsätze automatisch senden - Uhrzeit",
          "ASA_SENDUNITPRICEDISCOUNTED": "Einzelpreis rabattiert senden",
          "ASA_ENCODINGCODEPAGE": "Zeichensatz (Codepage, z.B. 1252)"
        },
        "InvoiceCarrierOptions": {
          "0": "Nein",
          "1": "Ja - PMS Zimmernummer = Lipp POS Tischnummer",
          "2": "Ja - PMS Tischnummer = Lipp POS Tischnummer"
        }
      }
    },
    "Sihot": {
      "Title": "SIHOT",
      "CommunicationService": {
        "Title": "Kommunikationsserver",
        "ErrorLoadingCommunicationServices": "Kommunikationsserver konnten nicht geladen werden",
        "ErrorLoadingSelectedCommunicationService": "Ausgewählter Kommunikationsserver konnte nicht geladen werden",
        "Changed": {
          "Success": {
            "Title": "Kommunikationsserver ausgewählt",
            "Description": "Der Kommunikationsserver <b>{0}</b> wurde erfolgreich ausgewählt."
          },
          "Error": "Kommunikationsserver konnte nicht ausgewählt werden"
        }
      },
      "Settings": {
        "Title": "Einstellungen",
        "Name": "Bezeichnung",
        "Value": "Wert",
        "Identifiers": {
          "SIHOT_URL": "SIHOT Server-URL",
          "SIHOT_USERNAME": "Benutzername",
          "SIHOT_PASSWORD": "Passwort",
          "SIHOT_HOTEL": "Hotelnummer",
          "SIHOT_CASHNO": "Kassennummer (1-30)",
          "SIHOT_DAYCLOSECASHNO": "Kassennummer Tagesabschluss (1-30)",
          "SIHOT_DAYCLOSEACCOUNTS": "Sammelzimmer für den Tagesabschluss (SIHOT-Zimmernummern)",
          "SIHOT_DAYCLOSEACCOUNTS_ACCOUNTNUMBERS": "Sammelkonten für den Tagesabschluss (SIHOT-Kontonummern)",
          "INVOICECARRIERFORGUESTS": "PMS Rechnungsträger automatisch erstellen",
          "SENDDAILYREVENUEAUTOMATIC": "Tagesumsätze automatisch senden",
          "SENDDAILYREVENUESTARTDATE": "Tagesumsätze automatisch senden - Startdatum",
          "SENDDAILYREVENUETIME": "Tagesumsätze automatisch senden - Uhrzeit"
        },
        "DaycloseAccountsTooltip": "Zimmernummer des Sammelkontos in SIHOT (z. B. 9000), nicht die Kontonummer. Die Kasse ermittelt das Konto bei jedem Senden über die Zimmerabfrage. Eine Zimmernummer für alle Tage oder sieben durch Komma getrennt für Mo–So.",
        "DaycloseAccountNumbersTooltip": "SIHOT-Kontonummer des Sammelkontos, nicht die Zimmernummer. Eine Nummer für alle Tage oder sieben durch Komma getrennt für Mo–So.",
        "InvoiceCarrierOptions": {
          "0": "Nein",
          "1": "Ja - PMS Zimmernummer = Lipp POS Tischnummer",
          "2": "Ja - PMS Tischnummer = Lipp POS Tischnummer"
        }
      },
      "Assignments": {
        "Title": "Zuordnungen",
        "CommodityGroups": "Warengruppen",
        "PaymentMethods": "Zahlungsarten",
        "CommodityGroup": "Warengruppe",
        "PaymentMethod": "Zahlungsart",
        "Supercat": "Hauptgruppe (supercat)",
        "Middlecat": "Mittelgruppe (middlecat)",
        "Articlecat": "Artikelgruppe (articlecat)",
        "SihotCode": "SIHOT-Zahlungsart"
      }
    },
    "EProtocol": {
      "Title": "E-Protokoll",
      "Description": "Anbindung an Schankanlagen über das klassische E-Protokoll (seriell oder TCP).",
      "SchankSettings": {
        "Title": "Schankeinstellungen"
      },
      "Tabs": {
        "Systems": "Schankanlagen",
        "Articles": "Schankartikel"
      },
      "Deactivate": {
        "Button": "Integration deaktivieren",
        "Error": "Schank-Integration konnte nicht deaktiviert werden"
      },
      "Systems": {
        "Title": "Schank-Anlagen",
        "Empty": "Noch keine Schank-Anlagen angelegt.",
        "LoadError": "Schank-Anlagen konnten nicht geladen werden"
      },
      "System": {
        "Add": "Schankanlage",
        "Articles": "Artikel",
        "Field": {
          "Name": "Bezeichnung",
          "IPAddress": "IP-Adresse",
          "Connection": "Verbindung",
          "Port": "Port",
          "Protocol": "Protokoll",
          "IsActive": "Aktiv",
          "Assignment": "Zuordnung",
          "KeyAssignment": "Schlüsselliste",
          "ArticleAssignment": "Artikelzuordnung",
          "CommunicationServer": "Kommunikationsserver"
        },
        "Saved": {
          "Title": "Schank-Anlage gespeichert",
          "Error": "Schank-Anlage konnte nicht gespeichert werden"
        },
        "Delete": {
          "Confirm": "Soll die Schank-Anlage \"{0}\" wirklich gelöscht werden?",
          "Error": "Schank-Anlage konnte nicht gelöscht werden"
        }
      },
      "Articles": {
        "Title": "Artikel-Zuordnungen",
        "Empty": "Noch keine Artikel zugeordnet.",
        "NoSystems": "Lege zuerst eine Schank-Anlage an, bevor du Artikel zuordnest.",
        "SystemSelector": "Schank-Anlage:",
        "OnlyAssigned": "Nur zugeordnete anzeigen",
        "AllArticlesEmpty": "Keine Artikel verfügbar.",
        "UnsavedChanges": "Es gibt nicht gespeicherte Änderungen an Artikel-Zuordnungen. Wirklich verwerfen und zurück zur Übersicht?",
        "Saved": {
          "Title": "Artikel-Zuordnungen gespeichert",
          "Description": "Die Änderungen an den Schank-Artikeln wurden erfolgreich übernommen."
        }
      },
      "Article": {
        "Add": "Artikel hinzufügen",
        "Field": {
          "ArticleId": "Artikel-ID",
          "ArticleNumber": "Schank-Artikelnummer",
          "Mode": "Modus",
          "Name": "Bezeichnung",
          "Number": "Art.-Nr.",
          "CommodityGroup": "Warengruppe",
          "DispenserArticleNumber": "Schankanlage - Art.-Nr.",
          "DispenserArticleNumberPlaceholder": "Art.-Nr."
        },
        "Mode": {
          "Debit": "Soll (Debit)",
          "Credit": "Haben (Kredit)",
          "Both": "Beides"
        },
        "Saved": {
          "Error": "Artikel-Zuordnung konnte nicht gespeichert werden"
        },
        "Delete": {
          "Confirm": "Soll diese Artikel-Zuordnung wirklich gelöscht werden?",
          "Error": "Artikel-Zuordnung konnte nicht gelöscht werden"
        }
      },
      "Dialog": {
        "ConnectionSection": "Verbindung",
        "ConnectionTypeLabel": "Verbindungsart",
        "ProtocolSection": "Protokoll",
        "ComPort": "COM-Port",
        "BaudRate": "Baud-Rate",
        "DataBits": "Datenbits",
        "ParityLabel": "Parität",
        "StopBits": "Stoppbits",
        "HandshakeLabel": "Handshake",
        "RtsEnable": "RTS aktivieren",
        "RtsEnableHint": "Request to Send: Steuersignal für Hardware-Flow-Control. Sagt der Schank 'POS ist bereit zu senden'. Aktivieren, wenn die Schank RTS/CTS-Handshake erwartet — sonst ignorieren die meisten Geräte das Signal.",
        "DtrEnable": "DTR aktivieren",
        "DtrEnableHint": "Data Terminal Ready: Sagt der Schank, dass der POS betriebsbereit ist (wie ein 'Eingeschaltet'-Signal). Manche Schank-Geräte verweigern jede Kommunikation, solange DTR nicht gesetzt ist.",
        "EProtocolType": "Protokoll-Variante",
        "EProtocolTypeHint": "Bestimmt die Feldbreite der Buchungs- und Kellnernummern im Wire-Format. Die richtige Variante hängt vom Schank-Hersteller ab.",
        "CalcChecksum": "Prüfsumme anhängen",
        "CreditsUserDependent": "Kredite sind kellnerabhängig",
        "CanCreditQty": "Schank unterstützt Mengen-Feld",
        "CanCreditQtyHint": "Aktiv: 3× Bier wird als eine Buchung mit Menge=3 gesendet. Inaktiv: drei einzelne Buchungen mit Menge=1. Welches Format die Schank versteht, hängt vom Hersteller ab.",
        "DeleteOverdueCreditsOnDayChange": "Überfällige Schankkredite beim Tageswechsel automatisch löschen",
        "DeleteOverdueCreditsOnDayChangeHint": "Beim Tageswechsel werden alle noch offenen Kredite auf dieser Schankanlage automatisch gelöscht.",
        "ConnectionType": {
          "SerialPort": "Seriell (RS232)",
          "TcpIp": "TCP/IP"
        },
        "Parity": {
          "None": "Keine",
          "Odd": "Ungerade",
          "Even": "Gerade",
          "Mark": "Mark",
          "Space": "Space"
        },
        "Handshake": {
          "None": "Keiner",
          "XOnXOff": "XOn/XOff",
          "RequestToSend": "RTS",
          "RequestToSendXOnXOff": "RTS + XOn/XOff"
        }
      }
    },
    "Cascade3": {
      "Title": "Cascade 3 (Hart++ / Hart 96)",
      "Description": "Anbindung an Schankanlagen über das Cascade3-Protokoll (Hart++ / Hart 96, seriell oder TCP).",
      "SchankSettings": {
        "Title": "Schankeinstellungen"
      },
      "Tabs": {
        "Systems": "Schankanlagen",
        "Articles": "Schankartikel"
      },
      "Deactivate": {
        "Button": "Integration deaktivieren",
        "Error": "Schank-Integration konnte nicht deaktiviert werden"
      },
      "Systems": {
        "Title": "Schank-Anlagen",
        "Empty": "Noch keine Schank-Anlagen angelegt.",
        "LoadError": "Schank-Anlagen konnten nicht geladen werden"
      },
      "System": {
        "Add": "Schankanlage",
        "Articles": "Artikel",
        "Field": {
          "Name": "Bezeichnung",
          "IPAddress": "IP-Adresse",
          "Connection": "Verbindung",
          "Port": "Port",
          "Protocol": "Protokoll",
          "IsActive": "Aktiv",
          "Assignment": "Zuordnung",
          "KeyAssignment": "Schlüsselliste",
          "ArticleAssignment": "Artikelzuordnung",
          "CommunicationServer": "Kommunikationsserver"
        },
        "Saved": {
          "Title": "Schank-Anlage gespeichert",
          "Error": "Schank-Anlage konnte nicht gespeichert werden"
        },
        "Delete": {
          "Confirm": "Soll die Schank-Anlage \"{0}\" wirklich gelöscht werden?",
          "Error": "Schank-Anlage konnte nicht gelöscht werden"
        }
      },
      "Articles": {
        "Title": "Artikel-Zuordnungen",
        "Empty": "Noch keine Artikel zugeordnet.",
        "NoSystems": "Lege zuerst eine Schank-Anlage an, bevor du Artikel zuordnest.",
        "SystemSelector": "Schank-Anlage:",
        "OnlyAssigned": "Nur zugeordnete anzeigen",
        "AllArticlesEmpty": "Keine Artikel verfügbar.",
        "UnsavedChanges": "Es gibt nicht gespeicherte Änderungen an Artikel-Zuordnungen. Wirklich verwerfen und zurück zur Übersicht?",
        "Saved": {
          "Title": "Artikel-Zuordnungen gespeichert",
          "Description": "Die Änderungen an den Schank-Artikeln wurden erfolgreich übernommen."
        }
      },
      "Article": {
        "Add": "Artikel hinzufügen",
        "Field": {
          "ArticleId": "Artikel-ID",
          "ArticleNumber": "Schank-Artikelnummer",
          "Mode": "Modus",
          "Name": "Bezeichnung",
          "Number": "Art.-Nr.",
          "CommodityGroup": "Warengruppe",
          "DispenserArticleNumber": "Schankanlage - Art.-Nr.",
          "DispenserArticleNumberPlaceholder": "Art.-Nr."
        },
        "Mode": {
          "Debit": "Soll (Debit)",
          "Credit": "Haben (Kredit)",
          "Both": "Beides"
        },
        "Saved": {
          "Error": "Artikel-Zuordnung konnte nicht gespeichert werden"
        },
        "Delete": {
          "Confirm": "Soll diese Artikel-Zuordnung wirklich gelöscht werden?",
          "Error": "Artikel-Zuordnung konnte nicht gelöscht werden"
        }
      },
      "Dialog": {
        "ConnectionSection": "Verbindung",
        "ConnectionTypeLabel": "Verbindungsart",
        "ProtocolSection": "Protokoll",
        "ComPort": "COM-Port",
        "BaudRate": "Baud-Rate",
        "DataBits": "Datenbits",
        "ParityLabel": "Parität",
        "StopBits": "Stoppbits",
        "HandshakeLabel": "Handshake",
        "RtsEnable": "RTS aktivieren",
        "RtsEnableHint": "Request to Send: Steuersignal für Hardware-Flow-Control. Sagt der Schank 'POS ist bereit zu senden'. Aktivieren, wenn die Schank RTS/CTS-Handshake erwartet — sonst ignorieren die meisten Geräte das Signal.",
        "DtrEnable": "DTR aktivieren",
        "DtrEnableHint": "Data Terminal Ready: Sagt der Schank, dass der POS betriebsbereit ist (wie ein 'Eingeschaltet'-Signal). Manche Schank-Geräte verweigern jede Kommunikation, solange DTR nicht gesetzt ist.",
        "ConsiderQtyCd": "Kredit/Debit-Korrekturmenge berücksichtigen",
        "ConsiderQtyCdHint": "Aktiv: Korrekturmengen aus Kredit-/Debit-Buchungen werden berücksichtigt. Inaktiv: Korrekturmengen werden ignoriert.",
        "ConnectionType": {
          "SerialPort": "Seriell (RS232)",
          "TcpIp": "TCP/IP"
        },
        "Parity": {
          "None": "Keine",
          "Odd": "Ungerade",
          "Even": "Gerade",
          "Mark": "Mark",
          "Space": "Space"
        },
        "Handshake": {
          "None": "Keiner",
          "XOnXOff": "XOn/XOff",
          "RequestToSend": "RTS",
          "RequestToSendXOnXOff": "RTS + XOn/XOff"
        }
      }
    },
    "Smartschank": {
      "Title": "Smartschank",
      "Description": "Anbindung an Smartschank-Schankanlagen von Dirmeier. Beim Bonieren entsteht ein Getränke-Credit, den der Gast über seine Kennung (Customer-ID) am Gerät einlöst. Je Anlage wählbar: Credits in der Hersteller-Cloud (SelfserviceCash, filialübergreifend) oder direkt an ein Gerät im LAN.",
      "SchankSettings": {
        "Title": "Schankeinstellungen"
      },
      "Tabs": {
        "Systems": "Schankanlagen",
        "Articles": "Schankartikel"
      },
      "Deactivate": {
        "Button": "Integration deaktivieren",
        "Error": "Schank-Integration konnte nicht deaktiviert werden"
      },
      "Systems": {
        "Title": "Schank-Anlagen",
        "Empty": "Noch keine Schank-Anlagen angelegt.",
        "LoadError": "Schank-Anlagen konnten nicht geladen werden",
        "EditUnavailable": "Die vollständigen Daten dieser Anlage konnten nicht geladen werden — Bearbeiten würde die gespeicherte Konfiguration überschreiben. Bitte die Seite neu laden; besteht das Problem, passt der Connect-Stand nicht zum Portal."
      },
      "System": {
        "Add": "Schankanlage",
        "Articles": "Artikel",
        "Field": {
          "Name": "Bezeichnung",
          "IPAddress": "IP-Adresse",
          "Connection": "Verbindung",
          "Port": "Port",
          "Protocol": "Protokoll",
          "IsActive": "Aktiv",
          "Assignment": "Zuordnung",
          "KeyAssignment": "Schlüsselliste",
          "ArticleAssignment": "Artikelzuordnung",
          "CommunicationServer": "Kommunikationsserver"
        },
        "Saved": {
          "Title": "Schank-Anlage gespeichert",
          "Error": "Schank-Anlage konnte nicht gespeichert werden"
        },
        "Delete": {
          "Confirm": "Soll die Schank-Anlage \"{0}\" wirklich gelöscht werden?",
          "Error": "Schank-Anlage konnte nicht gelöscht werden"
        }
      },
      "Articles": {
        "Title": "Artikel-Zuordnungen",
        "Empty": "Noch keine Artikel zugeordnet.",
        "NoSystems": "Lege zuerst eine Schank-Anlage an, bevor du Artikel zuordnest.",
        "SystemSelector": "Schank-Anlage:",
        "OnlyAssigned": "Nur zugeordnete anzeigen",
        "AllArticlesEmpty": "Keine Artikel verfügbar.",
        "UnsavedChanges": "Es gibt nicht gespeicherte Änderungen an Artikel-Zuordnungen. Wirklich verwerfen und zurück zur Übersicht?",
        "Saved": {
          "Title": "Artikel-Zuordnungen gespeichert",
          "Description": "Die Änderungen an den Schank-Artikeln wurden erfolgreich übernommen."
        }
      },
      "Article": {
        "Add": "Artikel hinzufügen",
        "Field": {
          "ArticleId": "Artikel-ID",
          "ArticleNumber": "Schank-Artikelnummer",
          "Mode": "Modus",
          "Name": "Bezeichnung",
          "Number": "Art.-Nr.",
          "CommodityGroup": "Warengruppe",
          "DispenserArticleNumber": "Schankanlage - Art.-Nr.",
          "DispenserArticleNumberPlaceholder": "Art.-Nr."
        },
        "Mode": {
          "Debit": "Soll (Debit)",
          "Credit": "Haben (Kredit)",
          "Both": "Beides"
        },
        "Saved": {
          "Error": "Artikel-Zuordnung konnte nicht gespeichert werden"
        },
        "Delete": {
          "Confirm": "Soll diese Artikel-Zuordnung wirklich gelöscht werden?",
          "Error": "Artikel-Zuordnung konnte nicht gelöscht werden"
        }
      },
      "DispensingSystems": "Schank-Anlagen",
      "Dialog": {
        "ConnectionSection": "Verbindung",
        "ConnectionTypeLabel": "Verbindungsart",
        "ConnectionTypeHint": "Hersteller-Cloud (SelfserviceCash): die Credits liegen bei Smartschank und sind von jedem Gerät des Betriebs abrufbar. LAN-Direktanbindung: die Credits gehen direkt an ein Gerät im eigenen Netz. Bei einer bestehenden Anlage nicht mehr änderbar — dazu eine neue Anlage anlegen.",
        "ConnectionType": {
          "Cloud": "Hersteller-Cloud (SelfserviceCash)",
          "Local": "LAN-Direktanbindung"
        },
        "ApiBaseUrl": "API-Adresse",
        "IpAddressHint": "IP-Adresse oder Hostname des Geräts — ohne Pfad und ohne Port (der steht im Feld daneben). Ein vorangestelltes https:// wird übernommen; ohne Schema wird http:// verwendet.",
        "ApiBaseUrlHint": "Basis-Adresse der SelfserviceCash-API, z. B. https://app.smartschank.com/ords/dirmeier/selfserviceCash — ohne Schrägstrich am Ende.",
        "ApiUsername": "Benutzername",
        "ApiPassword": "Passwort",
        "TagSection": "Kennung (Customer-ID)",
        "TagIdSourceLabel": "Herkunft der Kennung",
        "TagIdSourceHint": "Generiert: Smartschank gibt je Vorgang einen kurzen freien Code aus, den der Gast am Gerät eingibt. Kundennummer: die Kennung ist die Kundennummer des Kunden am Rechnungsträger des Tisches — Buchungen ohne Kunden erzeugen dann keinen Credit.",
        "TagIdSourceHintLocal": "Keine Kennung: der Credit wird ohne Kundenbezug angelegt und ist von dem am Gerät angemeldeten Kellner zapfbar — der Normalfall. Kundennummer: die Kundennummer des Kunden am Rechnungsträger des Tisches wird als Customer-ID mitgeschrieben. Sie schränkt am Gerät nicht ein, wer zapfen darf.",
        "TagIdSource": {
          "Generated": "Generiert",
          "None": "Keine Kennung",
          "CustomerNumber": "Kundennummer"
        },
        "TagLength": "Länge der Kennung",
        "TagLookBackHours": "Prüfzeitraum (Stunden)",
        "TagLookBackHoursHint": "Rückblickzeitraum der Kollisionsprüfung. Kennungen sind kurz und werden wiederverwendet — ohne diese Prüfung könnte ein Gast den noch offenen Credit eines anderen einlösen. Nicht ohne Grund verkleinern.",
        "CreditType": "Kredit-Art",
        "CreditSection": "Inhalt des Kredits",
        "DeviceId": "Geräte-Id",
        "DeviceIdHint": "Nur nötig, wenn die Anlage mehrere Geräte/Abteilungen unterscheidet. Normalerweise leer — die Abteilung ergibt sich aus den Zugangsdaten.",
        "PlaceNumber": "Platznummer",
        "VoucherSection": "Getränkegutschein",
        "VoucherPrinter": "Gutscheindrucker",
        "VoucherPrinterNone": "Kein Beleg",
        "VoucherPrinterHint": "Druckt nach jeder Buchung einen Beleg mit dem Einlöse-Code, den der Gast an der Schankanlage einlöst. Leer = kein Beleg. Je Kredit ein Beleg: zwei verschiedene Getränke ergeben zwei Codes und zwei Belege, weil sich zwei Kredite eine Kennung nicht teilen können.",
        "VoucherCodeFormat": "Code-Darstellung",
        "VoucherCodeFormatHint": "Wie der Code auf dem Beleg steht. Welche Darstellung der Scanner an Ihrer Anlage liest, hängt von der Hardware ab — im Zweifel ausprobieren. Der Code wird zusätzlich immer im Klartext gedruckt und kann am Gerät eingetippt werden.",
        "VoucherCodeFormatOption": {
          "QrCode": "QR-Code",
          "Barcode": "Strichcode"
        },
        "SendArticleNameAndPrice": "Artikelbezeichnung und Preis mitsenden"
      }
    },
    "Tbt": {
      "Title": "TBT",
      "Description": "Anbindung an TBT-Schankanlagen (seriell oder TCP, Multi-Drop). Buchungen werden direkt in Lipp POS übernommen und Credits zurück an die Schank gesendet.",
      "SchankSettings": {
        "Title": "Schankeinstellungen"
      },
      "Tabs": {
        "Systems": "Schankanlagen",
        "Articles": "Schankartikel"
      },
      "Deactivate": {
        "Button": "Integration deaktivieren",
        "Error": "Schank-Integration konnte nicht deaktiviert werden"
      },
      "Systems": {
        "Title": "Schank-Anlagen",
        "Empty": "Noch keine Schank-Anlagen angelegt.",
        "LoadError": "Schank-Anlagen konnten nicht geladen werden"
      },
      "System": {
        "Add": "Schankanlage",
        "Articles": "Artikel",
        "Field": {
          "Name": "Bezeichnung",
          "IPAddress": "IP-Adresse",
          "Connection": "Verbindung",
          "Port": "Port",
          "Protocol": "Protokoll",
          "IsActive": "Aktiv",
          "Assignment": "Zuordnung",
          "KeyAssignment": "Schlüsselliste",
          "ArticleAssignment": "Artikelzuordnung",
          "CommunicationServer": "Kommunikationsserver"
        },
        "Saved": {
          "Title": "Schank-Anlage gespeichert",
          "Error": "Schank-Anlage konnte nicht gespeichert werden"
        },
        "Delete": {
          "Confirm": "Soll die Schank-Anlage \"{0}\" wirklich gelöscht werden?",
          "Error": "Schank-Anlage konnte nicht gelöscht werden"
        }
      },
      "Articles": {
        "Title": "Artikel-Zuordnungen",
        "Empty": "Noch keine Artikel zugeordnet.",
        "NoSystems": "Lege zuerst eine Schank-Anlage an, bevor du Artikel zuordnest.",
        "SystemSelector": "Schank-Anlage:",
        "OnlyAssigned": "Nur zugeordnete anzeigen",
        "AllArticlesEmpty": "Keine Artikel verfügbar.",
        "UnsavedChanges": "Es gibt nicht gespeicherte Änderungen an Artikel-Zuordnungen. Wirklich verwerfen und zurück zur Übersicht?",
        "Saved": {
          "Title": "Artikel-Zuordnungen gespeichert",
          "Description": "Die Änderungen an den Schank-Artikeln wurden erfolgreich übernommen."
        }
      },
      "Article": {
        "Add": "Artikel hinzufügen",
        "Field": {
          "ArticleId": "Artikel-ID",
          "ArticleNumber": "Schank-Artikelnummer",
          "Mode": "Modus",
          "Name": "Bezeichnung",
          "Number": "Art.-Nr.",
          "CommodityGroup": "Warengruppe",
          "DispenserArticleNumber": "Schankanlage - Art.-Nr.",
          "DispenserArticleNumberPlaceholder": "Art.-Nr."
        },
        "Mode": {
          "Debit": "Soll (Debit)",
          "Credit": "Haben (Kredit)",
          "Both": "Beides"
        },
        "Saved": {
          "Error": "Artikel-Zuordnung konnte nicht gespeichert werden"
        },
        "Delete": {
          "Confirm": "Soll diese Artikel-Zuordnung wirklich gelöscht werden?",
          "Error": "Artikel-Zuordnung konnte nicht gelöscht werden"
        }
      },
      "Dialog": {
        "ConnectionSection": "Verbindung",
        "ConnectionTypeLabel": "Verbindungsart",
        "ProtocolSection": "TBT-Einstellungen",
        "ComPort": "COM-Port",
        "BaudRate": "Baud-Rate",
        "DataBits": "Datenbits",
        "ParityLabel": "Parität",
        "StopBits": "Stoppbits",
        "HandshakeLabel": "Handshake",
        "RtsEnable": "RTS aktivieren",
        "RtsEnableHint": "Request to Send: Steuersignal für Hardware-Flow-Control. Aktivieren, wenn die Schank RTS/CTS-Handshake erwartet — sonst ignorieren die meisten Geräte das Signal.",
        "DtrEnable": "DTR aktivieren",
        "DtrEnableHint": "Data Terminal Ready: Sagt der Schank, dass der POS betriebsbereit ist. Manche Geräte verweigern die Kommunikation, solange DTR nicht gesetzt ist.",
        "DeviceCode": "Geräteadresse",
        "DeviceCodeHint": "2-stellige Busadresse des Geräts (z.B. D0–D9). TBT ist Multi-Drop: mehrere Geräte teilen sich einen COM-Port und werden über diese Adresse unterschieden.",
        "FixedCreditUserNo": "Feste Kellnernummer",
        "FixedCreditUserNoHint": "Wenn gesetzt, werden ALLE ausgehenden Credits dieses Geräts auf diese Kellnernummer gebucht (überschreibt die Kellner-Auflösung).",
        "ProductNoFormat": "Format Artikelnr.",
        "ChannelNoFormat": "Format Kanalnr.",
        "QtyFormat": "Format Menge",
        "UserNoFormat": "Format Kellnernr.",
        "CanQtyTransfer": "Mengenfeld übertragen",
        "CanQtyTransferHint": "Aktiv: die Menge wird als eigenes Feld übertragen. Inaktiv: die Menge wird in einzelne Telegramme ausgerollt (ein Telegramm pro Stück).",
        "CanItemsInOneRecord": "Mehrere Artikel je Telegramm",
        "CanItemsInOneRecordHint": "Aktiv: mehrere Artikel dürfen in einem Telegramm zusammengefasst werden. Inaktiv: ein Telegramm pro Artikel.",
        "RecordNumbering": "Sequenznummerierung (Nx)",
        "RecordNumberingHint": "Aktiv: die Ns/Nr-Sequenzbits werden in den Telegrammen mitgesendet. Nur einschalten, wenn die Anlage das erwartet (Standard: aus).",
        "EncodingCodePage": "Codepage",
        "EncodingCodePageHint": "Zeichensatz für die Telegramme. Standard 28591 (ISO-8859-1). NICHT 1252 verwenden — dabei gehen rund 10 % der Telegramme still verloren.",
        "ReceiveTimeoutMs": "Antwort-Timeout (ms)",
        "PollDeviceIdleMs": "Pause je Gerät (ms)",
        "WaitAfterCreditAcceptedMs": "Pause nach Credit (ms)",
        "ConnectionType": {
          "SerialPort": "Seriell (RS232)",
          "TcpIp": "TCP/IP"
        },
        "Parity": {
          "None": "Keine",
          "Odd": "Ungerade",
          "Even": "Gerade",
          "Mark": "Mark",
          "Space": "Space"
        },
        "Handshake": {
          "None": "Keiner",
          "XOnXOff": "XOn/XOff",
          "RequestToSend": "RTS",
          "RequestToSendXOnXOff": "RTS + XOn/XOff"
        }
      }
    },
    "Incert": {
      "Title": "Incert"
    },
    "Websline": {
      "Title": "Websline"
    },
    "ExternalVouchers": {
      "Settings": "Einstellungen",
      "ApiUrl": "API URL",
      "ApiKey": "API Key",
      "ClientId": "Client ID",
      "ClientSecret": "Client Secret",
      "ErrorLoading": "Schnittstelle konnte nicht geladen werden",
      "Saved": {
        "Title": "Einstellungen gespeichert",
        "Description": "Die {0}-Einstellungen wurden erfolgreich gespeichert."
      },
      "SaveError": "Einstellungen konnten nicht gespeichert werden",
      "NotConfigured": "Bitte zuerst alle Zugangsdaten speichern."
    },
    "DispensingSystemGroup": {
      "Group": "Gruppe",
      "SaveError": "Die Gruppe konnte nicht gespeichert werden."
    },
    "DispensingSystemArticleTools": {
      "ImportExport": "Import/Export",
      "Import": "Importieren",
      "Export": "Exportieren",
      "Copy": "Übertragen",
      "FileName": "Schankartikel",
      "UnsavedChanges": {
        "Title": "Nicht gespeicherte Änderungen",
        "Description": "Bitte zuerst speichern, dann importieren, exportieren oder übertragen."
      },
      "NoMappings": "Diese Schankanlage hat noch keine Artikel-Zuordnung zum Übertragen.",
      "NoTargets": "Es gibt keine weitere Schankanlage, auf die übertragen werden kann.",
      "ImportSuccess": {
        "Title": "Import erfolgreich",
        "Description": "{created} neu, {updated} geändert, {deleted} entfernt."
      },
      "ImportPartial": {
        "Title": "Import teilweise erfolgreich",
        "Description": "{created} neu, {updated} geändert, {deleted} entfernt, {failed} fehlgeschlagen:"
      },
      "ImportRow": "Zeile {row}: {reason}",
      "DuplicatesRemoved": "Entfernte doppelte Zuordnungen aus Altdaten: {count}.",
      "ImportError": "Import fehlgeschlagen",
      "ExportError": "Die Schankartikel konnten nicht exportiert werden"
    },
    "GruberVMPS": {
      "Title": "Gruber VMPS",
      "Description": "Anbindung an Schankanlagen über das Gruber-VMPS-Protokoll (UDP). Schankvorgänge laufen direkt über die Lipp POS.",
      "SchankSettings": {
        "Title": "Schankeinstellungen"
      },
      "Tabs": {
        "Systems": "Schankanlagen",
        "Articles": "Schankartikel"
      },
      "Deactivate": {
        "Button": "Integration deaktivieren",
        "Error": "Schank-Integration konnte nicht deaktiviert werden"
      },
      "Systems": {
        "Title": "Schank-Anlagen",
        "Empty": "Noch keine Schank-Anlagen angelegt.",
        "LoadError": "Schank-Anlagen konnten nicht geladen werden"
      },
      "System": {
        "Add": "Schankanlage",
        "Articles": "Artikel",
        "Field": {
          "Name": "Bezeichnung",
          "IPAddress": "IP-Adresse",
          "Connection": "Verbindung",
          "Port": "Port",
          "Protocol": "Protokoll",
          "IsActive": "Aktiv",
          "Assignment": "Zuordnung",
          "KeyAssignment": "Schlüsselliste",
          "ArticleAssignment": "Artikelzuordnung",
          "CommunicationServer": "Kommunikationsserver"
        },
        "Saved": {
          "Title": "Schank-Anlage gespeichert",
          "Error": "Schank-Anlage konnte nicht gespeichert werden"
        },
        "Delete": {
          "Confirm": "Soll die Schank-Anlage \"{0}\" wirklich gelöscht werden?",
          "Error": "Schank-Anlage konnte nicht gelöscht werden"
        }
      },
      "Articles": {
        "Title": "Artikel-Zuordnungen",
        "Empty": "Noch keine Artikel zugeordnet.",
        "NoSystems": "Lege zuerst eine Schank-Anlage an, bevor du Artikel zuordnest.",
        "SystemSelector": "Schank-Anlage:",
        "OnlyAssigned": "Nur zugeordnete anzeigen",
        "AllArticlesEmpty": "Keine Artikel verfügbar.",
        "UnsavedChanges": "Es gibt nicht gespeicherte Änderungen an Artikel-Zuordnungen. Wirklich verwerfen und zurück zur Übersicht?",
        "Saved": {
          "Title": "Artikel-Zuordnungen gespeichert",
          "Description": "Die Änderungen an den Schank-Artikeln wurden erfolgreich übernommen."
        }
      },
      "Article": {
        "Add": "Artikel hinzufügen",
        "Field": {
          "ArticleId": "Artikel-ID",
          "ArticleNumber": "Schank-Artikelnummer",
          "Mode": "Modus",
          "Name": "Bezeichnung",
          "Number": "Art.-Nr.",
          "CommodityGroup": "Warengruppe",
          "DispenserArticleNumber": "Schankanlage - Art.-Nr.",
          "DispenserArticleNumberPlaceholder": "Art.-Nr."
        },
        "Mode": {
          "Debit": "Debit",
          "Credit": "Kredit",
          "Both": "Beides"
        },
        "Saved": {
          "Error": "Artikel-Zuordnung konnte nicht gespeichert werden"
        },
        "Delete": {
          "Confirm": "Soll diese Artikel-Zuordnung wirklich gelöscht werden?",
          "Error": "Artikel-Zuordnung konnte nicht gelöscht werden"
        }
      }
    },
    "Keycard": {
      "Title": "Kartenleser",
      "ErrorLoadingInterfaces": "Kartenleser konnte nicht geladen werden",
      "NoWorkstationsAssigned": "Es wurde noch keine Arbeitsstation zugewiesen.",
      "Workstations": {
        "Title": "Arbeitsstationen",
        "ActiveOnWorkstations": "Kartenleser aktiv auf folgenden Arbeitsstationen"
      },
      "Reader": {
        "Title": "Lesegerät",
        "ReaderType": "Bauart des Lesegeräts",
        "ReaderTypes": {
          "OrdermanExternal": "Orderman Ordercard Reader (extern)",
          "OrdermanColumbus": "Orderman Columbus (integriert)",
          "ElatecTwn4": "Elatec TWN4 (Simple Protocol)"
        },
        "BaudRate": "Baudrate",
        "ReverseTagBytes": "Karten-ID umkehren",
        "ReverseTagBytesHint": "Dreht die Byte-Reihenfolge der gelesenen Karten-ID um. Nötig, wenn bereits erfasste Kartennummern aus einem anderen System übernommen werden. Achtung: Nach einer Änderung werden bereits erfasste Karten mit neuer Nummer erkannt."
      },
      "Points": {
        "Title": "Punktesystem",
        "Active": "Aktiv",
        "Divisor": "Umsatz je Punkt",
        "DivisorTooltip": "Für je diesen Rechnungsbetrag bekommt der Gast einen Punkt. Beispiel: 10 → eine Rechnung über 100 € bringt 10 Punkte.",
        "RedemptionValue": "Punkte für 1 €",
        "RedemptionValueTooltip": "Wie viele Punkte 1 € Gegenwert entsprechen, wenn der Gast Punkte einlöst. Beispiel: 10 → 50 Punkte ergeben 5 €.",
        "RequiredPoints": "Mindestpunkte für eine Einlösung",
        "RequiredPointsTooltip": "Erst ab diesem Punktestand kann eingelöst werden. Leer lassen, wenn ab dem ersten Punkt eingelöst werden darf.",
        "ErrorLoading": "Einstellungen zum Punktesystem konnten nicht geladen werden",
        "Edit": {
          "Success": {
            "Title": "Punktesystem geändert",
            "Description": "Die Einstellungen zum Punktesystem wurden erfolgreich geändert."
          },
          "Error": "Einstellungen zum Punktesystem konnten nicht geändert werden"
        }
      },
      "Edit": {
        "Success": {
          "Title": "Kartenleser geändert",
          "Description": "Die Einstellungen für den Kartenleser wurden erfolgreich geändert."
        },
        "Error": "Einstellungen für den Kartenleser konnten nicht geändert werden"
      }
    },
    "WaiterLock": {
      "Title": "Kellnerschloss Addimat",
      "ErrorLoadingInterfaces": "Kellnerschloss konnte nicht geladen werden",
      "NoWorkstationsAssigned": "Es wurde noch keine Arbeitsstation zugewiesen.",
      "Workstations": {
        "Title": "Arbeitsstationen",
        "ActiveOnWorkstations": "Kellnerschloss aktiv auf folgenden Arbeitsstationen",
        "Edit": {
          "Success": {
            "Title": "Arbeitsstationen geändert",
            "Description": "Die Arbeitsstationen für das Kellnerschloss wurden erfolgreich geändert."
          },
          "Error": "Arbeitsstationen für das Kellnerschloss konnten nicht geändert werden"
        }
      }
    },
    "CashDrawer": {
      "Title": "Kassenlade",
      "ErrorLoadingInterfaces": "Kassenlade konnte nicht geladen werden",
      "NoWorkstationsAssigned": "Es wurde noch keine Arbeitsstation zugewiesen.",
      "Workstations": {
        "Title": "Arbeitsstationen",
        "ActiveOnWorkstations": "Kassenlade aktiv auf folgenden Arbeitsstationen",
        "Edit": {
          "Success": {
            "Title": "Arbeitsstationen geändert",
            "Description": "Die Arbeitsstationen für die Kassenlade wurden erfolgreich geändert."
          },
          "Error": "Arbeitsstationen für die Kassenlade konnten nicht geändert werden"
        }
      },
      "ErrorLoadingPaymentMethods": "Zahlungmethoden konnten nicht geladen werden",
      "PaymentMethods": {
        "Title": "Zahlungsmethoden",
        "OpenForPaymentMethods": "Kassenlade öffnen bei folgenden Zahlungsarten",
        "Edit": {
          "Success": {
            "Title": "Zahlungsmethoden geändert",
            "Description": "Die Zahlungsmethoden für die Kassenlade wurden erfolgreich geändert."
          },
          "Error": "Zahlungsmethoden für die Kassenlade konnten nicht geändert werden"
        }
      },
      "NoPaymentMethodsAssigned": "Es wurde noch keine Zahlungsmethode zugewiesen."
    },
    "CustomerDisplay2Lines": {
      "Title": "Kundendisplay 2-zeilig",
      "ErrorLoadingInterfaces": "Kundendisplay 2-zeilig konnte nicht geladen werden",
      "NoWorkstationsAssigned": "Es wurde noch keine Arbeitsstation zugewiesen.",
      "Workstations": {
        "Title": "Arbeitsstationen",
        "ActiveOnWorkstations": "Kundendisplay 2-zeilig aktiv auf folgenden Arbeitsstationen",
        "Edit": {
          "Success": {
            "Title": "Arbeitsstationen geändert",
            "Description": "Die Arbeitsstationen für das Kundendisplay 2-zeilig wurden erfolgreich geändert."
          },
          "Error": "Arbeitsstationen für das Kundendisplay 2-zeilig konnten nicht geändert werden"
        }
      },
      "Idlerun": {
        "Title": "Leerlauf",
        "IdleTimeout": "Leerlaufnachricht nach Rechnungsabschluss",
        "Message1": "Leerlaufnachricht 1. Zeile",
        "Message1Placeholder": "Herzlich Willkommen",
        "Message2": "Leerlaufnachricht 2. Zeile",
        "Message2Placeholder": "Kauf 2 nimm 1!",
        "Edit": {
          "Success": {
            "Title": "Leerlauf gespeichert",
            "Description": "Die Leerlaufeinstellungen wurden erfolgreich gespeichert."
          },
          "Error": "Leerlaufeinstellungen konnten nicht gespeichert werden"
        }
      }
    },
    "CustomerDisplay": {
      "Title": "Kundendisplay",
      "Workstations": {
        "Workstations": "Arbeitsstationen",
        "DisplayOnWorkstations": "Kundendisplay aktiv auf folgenden Arbeitsstationen"
      },
      "Design": {
        "Design": "Design",
        "BackgroundColor": "Hintergrundfarbe",
        "TextBackgroundColor": "Überschrift & Buchungstext - Farbe Hintergrund",
        "FontColor": "Überschrift & Buchungstext - Farbe Text",
        "FooterTextBackgroundColor": "Fußzeile - Farbe Hintergrund",
        "FooterFontColor": "Fußzeile - Farbe Text",
        "CashFontColor": "Bargeld erhalten - Farbe Text",
        "ChangeFontColor": "Rückgeld - Farbe Text",
        "Logo": "Logo",
        "UploadPicture": "Bild hochladen",
        "Headline": "Überschrift/Zusatztext",
        "PictureOrVideo": "Bilder/Videos",
        "UpdloadPictureOrVideo": "Bilder/Videos hochladen",
        "Slideshow": "Bilder/Videos nach Rechnungsabschluss zeitverzögert als Slideshow anzeigen"
      },
      "Preview": {
        "Preview": "Vorschau",
        "Text": "Für deine Änderungen kannst du eine digitale Vorschau erzeugen.",
        "Quantity": "Anzahl",
        "Description": "Bezeichnung",
        "Gross": "Brutto",
        "Total": "Gesamt",
        "CashReceived": "Bargeld erhalten",
        "Change": "Rückgeld",
        "Schnitzel": "Schnitzel m. Pommes"
      },
      "Success": {
        "WorkstationTitle": "Arbeitsstation hinzugefügt",
        "WorkstationDescription": "Die Auswahl wurde erfolgreich geändert.",
        "DesignTitle": "Design verändert",
        "DesignDescription": "Design wurde erfolgreich verändert."
      },
      "Error": {
        "WorkstationError": "Fehler beim Ändern der Arbeitsstationen!",
        "DesignError": "Fehler beim Ändern des Designs!",
        "InterfaceError": "Fehler beim Laden der Einstellungen!",
        "LoadFilesError": "Fehler beim Laden der Bilder/Videos!"
      },
      "ActivateIntegration": "Integration aktivieren",
      "DeactivateIntegration": "Integration deaktivieren"
    },
    "ZVT": {
      "Title": "ZVT Zahlungsterminal",
      "Error": "Fehler beim laden der Integration.",
      "Settings": {
        "Title": "Zahlungsterminals",
        "PaymentTerminal": "Zahlungsterminal",
        "Name": "Bezeichnung",
        "IPAddress": "IP-Adresse",
        "Port": "Port",
        "Workstation": "Arbeitsstation",
        "PaymentMethods": "Zahlungsmethoden",
        "ProcessTerminalTip": "Trinkgeld-Abfrage",
        "AutoEndOfDay": "Auto-Tagesabschluss",
        "IsActive": "Aktiv/Inaktiv",
        "Success": "Zahlungterminal wurde erfolgreich aktiviert",
        "ChangeError": "Einstellung konnte nicht geändert werden",
        "SettingNotSynced": "Einstellung noch nicht von der Kasse synchronisiert"
      }
    },
    "SixTIM": {
      "Title": "SIX TIM Zahlungsterminal",
      "Error": "Fehler beim Laden der Integration.",
      "Settings": {
        "Title": "Zahlungsterminals",
        "PaymentTerminal": "Zahlungsterminal",
        "Name": "Bezeichnung",
        "ConnectionMode": "Verbindungsmodus",
        "ConnectionModes": {
          "Broadcast": "Broadcast",
          "FixedIP": "Feste IP"
        },
        "TerminalId": "Terminal-ID",
        "IPAddress": "IP-Adresse",
        "Port": "Port",
        "Workstation": "Arbeitsstation",
        "PaymentMethods": "Zahlungsarten",
        "ProcessTerminalTip": "Trinkgeld am Terminal",
        "AutoEndOfDay": "Auto-Tagesabschluss",
        "IsActive": "Aktiv/Inaktiv",
        "Success": "Zahlungsterminal wurde erfolgreich aktiviert",
        "ChangeError": "Einstellung konnte nicht geändert werden",
        "ErrorLoadingPaymentMethods": "Fehler beim Laden der Zahlungsarten",
        "ActivateError": "Das Zahlungsterminal konnte nicht aktiviert werden."
      },
      "Dialogs": {
        "PaymentTerminal": {
          "Create": "Zahlungsterminal erstellen",
          "Name": "Bezeichnung",
          "ConnectionMode": "Verbindungsmodus",
          "TerminalId": "Terminal-ID",
          "IPAddress": "IP-Adresse",
          "Port": "Port",
          "ActiveWorkstations": "Zahlungsterminal aktiv auf folgender Arbeitsstation",
          "ActivePaymentMethods": "Zahlungsterminal aktiv bei folgenden Zahlungsarten",
          "ProcessTerminalTip": "Trinkgeld am Terminal eingeben",
          "AutoEndOfDay": "Automatischer Tagesabschluss",
          "Created": {
            "Title": "Zahlungsterminal erstellt",
            "Description": "Zahlungsterminal wurde erfolgreich hinzugefügt.",
            "Error": "Fehler beim Hinzufügen des Zahlungsterminals"
          }
        },
        "DeactivatePaymentTerminal": {
          "Title": "Zahlungsterminal deaktivieren",
          "Description": "Willst du das Zahlungsterminal <b>{0}</b> wirklich deaktivieren?",
          "Error": "Zahlungsterminal konnte nicht deaktiviert werden",
          "Success": "Zahlungsterminal wurde erfolgreich deaktiviert"
        }
      }
    },
    "Articles": {
      "Title": "Artikel",
      "Article": "Artikel",
      "Type": "Typ",
      "Types": {
        "0": "Artikel",
        "1": "Ordner",
        "2": "Artikelpaket",
        "3": "Beilage",
        "5": "Kommentar",
        "6": "Trinkgeld",
        "7": "Ermäßigung",
        "9": "Gutschein",
        "10": "Einkauf",
        "11": "Pfandrückgabe",
        "12": "Anzahlung"
      },
      "CommodityGroup": "Warengruppe",
      "Printers": "Drucker",
      "Number": "Art.-Nr.",
      "Name": "Bezeichnung",
      "Price": "Verkaufspreis",
      "ActiveInactive": "Aktiv/Inaktiv",
      "ToggleIsActiveError": "Artikel konnte nicht geändert werden",
      "ImportExport": "Import/Export",
      "Import": "Importieren",
      "Export": "Exportieren",
      "ImportSuccess": {
        "Title": "Import erfolgreich",
        "Description": "{created} Artikel erstellt, {updated} aktualisiert."
      },
      "ImportPartial": {
        "Title": "Import teilweise erfolgreich",
        "Description": "{created} Artikel erstellt, {updated} aktualisiert, {failed} fehlgeschlagen:"
      },
      "ImportError": {
        "Title": "Import fehlgeschlagen",
        "Description": "Artikel konnten nicht importiert werden."
      },
      "ExportError": "Artikel konnten nicht exportiert werden"
    },
    "CancellationReasons": {
      "Title": "Stornogründe",
      "CancellationReason": "Stornogrund",
      "Default": "Standard",
      "Name": "Bezeichnung",
      "ActiveInactive": "Aktiv/Inaktiv",
      "SetDefaultError": "Standard-Stornogrund konnte nicht gesetzt werden",
      "ChangeSortOrderError": "Stornogrund konnte nicht geändert werden",
      "ToggleIsActiveError": "Stornogrund konnte nicht geändert werden"
    },
    "CommodityGroups": {
      "Title": "Warengruppen",
      "CommodityGroup": "Warengruppe",
      "RevenueGroup": "Umsatzgruppe",
      "Name": "Bezeichnung",
      "VAT": "Mehrwertsteuer",
      "ActiveInactive": "Aktiv/Inaktiv",
      "ToggleIsActiveError": "Warengruppe konnte nicht geändert werden",
      "ChangeSortOrderError": "Warengruppe konnte nicht geändert werden",
      "ImportExport": "Import/Export",
      "Import": "Importieren",
      "Export": "Exportieren",
      "ImportSuccess": {
        "Title": "Import erfolgreich",
        "Description": "{created} Warengruppen erstellt, {updated} aktualisiert."
      },
      "ImportPartial": {
        "Title": "Import teilweise erfolgreich",
        "Description": "{created} Warengruppen erstellt, {updated} aktualisiert, {failed} fehlgeschlagen:"
      },
      "ImportError": {
        "Title": "Import fehlgeschlagen",
        "Description": "Warengruppen konnten nicht importiert werden."
      },
      "ImportCreatedRevenueGroups": "Neu angelegte Umsatzgruppen: {names}",
      "ExportError": "Warengruppen konnten nicht exportiert werden"
    },
    "CommunicationServices": {
      "Title": "Kommunikationsserver",
      "CommunicationService": "Kommunikationsserver",
      "Name": "Bezeichnung",
      "DeviceName": "Gerätename",
      "Networks": "Netzwerke",
      "Main": "Hauptserver",
      "Status": "Status",
      "Online": "Online",
      "Offline": "Offline",
      "LogFile": "Log",
      "DownloadLogFile": "Logdatei herunterladen",
      "LogFileDownloadFailed": "Logdatei konnte nicht geladen werden",
      "LogFileOffline": "Der Kommunikationsserver ist nicht verbunden.",
      "LogFileVersionTooOld": "Die Version dieses Kommunikationsservers unterstützt den Logdatei-Download noch nicht.",
      "LogFileTimeout": "Der Kommunikationsserver hat nicht rechtzeitig geantwortet.",
      "LogFileNotFound": "Auf dem Kommunikationsserver wurde keine aktuelle Logdatei gefunden.",
      "LogFileTooLarge": "Die Logdatei ist zu groß für den Download."
    },
    "StationData": {
      "Title": "Standortdaten",
      "Sections": {
        "Address": "Adressdaten",
        "Contact": "Kontaktdaten",
        "Other": "Weitere Daten"
      },
      "CompanyName": "Standortname",
      "Address": "Straße",
      "Zip": "PLZ",
      "City": "Ort",
      "Phone": "Telefonnummer",
      "Email": "E-Mail",
      "Website": "Website",
      "TaxNumber": "Steuernummer",
      "VatId": "UID-Nummer",
      "IBAN": "IBAN",
      "BIC": "BIC",
      "CompanyFooterText": "Fußtext am Beleg",
      "ErrorLoading": "Fehler beim Laden der Standortdaten",
      "ErrorChanging": "Fehler beim Speichern der Standortdaten",
      "SuccessChanging": {
        "Title": "Standortdaten gespeichert",
        "Description": "Die Standortdaten wurden erfolgreich gespeichert."
      }
    },
    "Courses": {
      "Title": "Gänge",
      "Course": "Gang",
      "Code": "Kürzel",
      "Name": "Bezeichnung",
      "AutoRecallAfter": "Automatisch abrufen nach",
      "AutoRecallImmediate": "Sofort",
      "ChangeSortOrderError": "Gang konnte nicht geändert werden"
    },
    "Customers": {
      "Title": "Kundenkartei",
      "SearchPlaceholder": "Suchen...",
      "Customer": "Kunde",
      "Number": "Kunden-Nr.",
      "Salutation": "Anrede",
      "Salutations": {
        "Mr": "Herr",
        "Mrs": "Frau",
        "Company": "Firma",
        "Family": "Familie",
        "Club": "Verein"
      },
      "Name": "Name",
      "Addition": "Zusatz",
      "Phone": "Telefon",
      "Mobile": "Mobil",
      "Remark": "Bemerkung",
      "InternalNote": "Interne Notiz",
      "Email": "E-Mail",
      "Street": "Straße",
      "Zip": "PLZ",
      "City": "Ort",
      "Country": "Land",
      "ActiveInactive": "Aktiv/Inaktiv",
      "ToggleIsActiveError": "Kunde konnte nicht geändert werden",
      "ImportExport": "Import/Export",
      "Import": "Importieren",
      "Export": "Exportieren",
      "ImportSuccess": {
        "Title": "Import erfolgreich",
        "Description": "{created} Kunden erstellt, {updated} aktualisiert."
      },
      "ImportPartial": {
        "Title": "Import teilweise erfolgreich",
        "Description": "{created} Kunden erstellt, {updated} aktualisiert, {failed} fehlgeschlagen:"
      },
      "ImportError": {
        "Title": "Import fehlgeschlagen",
        "Description": "Kunden konnten nicht importiert werden."
      },
      "ExportError": "Kunden konnten nicht exportiert werden"
    },
    "Departments": {
      "Title": "Abteilungen",
      "Department": "Abteilung",
      "Name": "Bezeichnung",
      "Discount": "Ermäßigung",
      "DefaultPriceList": "Voreingestellte Preisliste",
      "ActiveInactive": "Aktiv/Inaktiv",
      "ToggleIsActiveError": "Abteilung konnte nicht geändert werden",
      "ChangeSortOrderError": "Abteilung konnte nicht geändert werden",
      "ImportExport": "Import/Export",
      "Import": "Importieren",
      "Export": "Exportieren",
      "ImportSuccess": {
        "Title": "Import erfolgreich",
        "Description": "{created} Abteilungen erstellt, {updated} aktualisiert."
      },
      "ImportPartial": {
        "Title": "Import teilweise erfolgreich",
        "Description": "{created} Abteilungen erstellt, {updated} aktualisiert, {failed} fehlgeschlagen:"
      },
      "ImportError": {
        "Title": "Import fehlgeschlagen",
        "Description": "Abteilungen konnten nicht importiert werden."
      },
      "ExportError": "Abteilungen konnten nicht exportiert werden"
    },
    "Efforts": {
      "Title": "Aufwände",
      "Effort": "Aufwand",
      "Department": "Abteilung",
      "Type": "Typ",
      "Types": {
        "1": "Eigenverbrauch",
        "2": "Einladung",
        "3": "Personal",
        "4": "Schwund",
        "5": "Werbung",
        "6": "Test"
      },
      "Number": "Nummer",
      "Name": "Bezeichnung",
      "DefaultPriceList": "Voreingestellte Preisliste",
      "AlternativeTax": "Altern. Steuer",
      "PriceMode": "Preis",
      "ActiveInactive": "Aktiv/Inaktiv",
      "ToggleIsActiveError": "Aufwand konnte nicht geändert werden",
      "ImportExport": "Import/Export",
      "Import": "Importieren",
      "Export": "Exportieren",
      "ImportSuccess": {
        "Title": "Import erfolgreich",
        "Description": "{created} Aufwände erstellt, {updated} aktualisiert."
      },
      "ImportPartial": {
        "Title": "Import teilweise erfolgreich",
        "Description": "{created} Aufwände erstellt, {updated} aktualisiert, {failed} fehlgeschlagen:"
      },
      "ImportError": {
        "Title": "Import fehlgeschlagen",
        "Description": "Aufwände konnten nicht importiert werden."
      },
      "ExportError": "Aufwände konnten nicht exportiert werden"
    },
    "InvoiceTexts": {
      "Title": "Rechnungstexte",
      "Type": "Typ",
      "Types": {
        "Invoicing": {
          "HeaderText": "Kopftext",
          "FooterText": "Schlusstext"
        }
      },
      "Text": "Text"
    },
    "Macros": {
      "Title": "Makros",
      "Macro": "Makro",
      "Name": "Bezeichnung",
      "Code": "Kürzel",
      "Prefix": "Text davor",
      "Suffix": "Text danach",
      "PriceType": "Preistyp",
      "PriceTypes": {
        "0": "Fixer Betrag",
        "1": "Addieren"
      },
      "Price": "Preis",
      "Discount": "Rabatt",
      "Action": "Aktion",
      "AlternativeTax": "Altern. Steuer",
      "Preview": "Vorschau",
      "ActiveInactive": "Aktiv/Inaktiv",
      "ToggleIsActiveError": "Makro konnte nicht geändert werden",
      "ChangeSortOrderError": "Makro konnte nicht geändert werden"
    },
    "Promotions": {
      "Title": "Aktionen",
      "Promotion": "Aktion",
      "ShowExpired": "Abgelaufene Aktionen anzeigen",
      "ShowInactive": "Inaktive Aktionen anzeigen",
      "ToggleIsActiveError": "Aktion konnte nicht geändert werden",
      "Name": "Bezeichnung",
      "Date": "Datum",
      "Time": "Uhrzeit",
      "AllDay": "Ganztags",
      "Action": "Aktion",
      "Priority": "Priorität",
      "Discount": "Ermäßigung",
      "PriceChange": "Preisänderung"
    },
    "MailAccounts": {
      "Title": "E-Mail Konten",
      "MailAccount": "E-Mail Konto",
      "Name": "Name",
      "Mail": "E-Mail",
      "Status": "Status",
      "RequiresReauthHint": "Zugriffsberechtigung abgelaufen — bitte erneut autorisieren.",
      "Signature": "Signatur",
      "Templates": {
        "Title": "E-Mail Vorlagen",
        "Template": "Vorlage",
        "Subject": "Betreff",
        "MailAccount": "E-Mail Konto",
        "Recipients": "Empfänger"
      }
    },
    "NumberRanges": {
      "Title": "Nummernkreise",
      "NumberRange": "Nummernkreis",
      "Name": "Bezeichnung",
      "Type": "Typ",
      "Types": {
        "0": "Rechnung",
        "3": "Bestellbon",
        "4": "Kunden-Nr.",
        "5": "Buchungssequenz",
        "6": "PMS Transfer",
        "999999": "Divers"
      },
      "Prefix": "Text davor",
      "Suffix": "Text danach",
      "Length": "Länge",
      "StartNumber": "Startnummer",
      "CurrentNumber": "aktuelle Nummer",
      "Preview": "Vorschau",
      "StartDate": "Startdatum",
      "EndDate": "Enddatum",
      "ActiveInactive": "Aktiv/Inaktiv",
      "ToggleIsActiveError": "Nummernkreis konnte nicht geändert werden"
    },
    "PaymentMethods": {
      "Title": "Zahlungsarten",
      "PaymentMethod": "Zahlungsart",
      "Type": "Typ",
      "Types": {
        "0": "Bar",
        "1": "Kartenzahlung",
        "2": "Überweisung",
        "3": "Aufwand",
        "4": "PMS Transfer",
        "9999": "Divers"
      },
      "Name": "Bezeichnung",
      "PaymentTarget": "Zahlungsziel",
      "PrintCount": "Anzahl Belege",
      "ActiveInactive": "Aktiv/Inaktiv",
      "ToggleIsActiveError": "Zahlungsart konnte nicht geändert werden",
      "ChangeSortOrderError": "Zahlungsart konnte nicht geändert werden"
    },
    "Printers": {
      "Title": "Drucker",
      "Printer": "Drucker",
      "CommunicationService": "Kommunikationsserver",
      "Redirections": "Ausnahmen",
      "PrinterName": "Druckername",
      "Name": "Bezeichnung",
      "Reports": "Berichte",
      "Type": "Format",
      "Types": {
        "0": "80mm",
        "1": "A4",
        "2": "76mm"
      },
      "ChangeSortOrderError": "Drucker konnte nicht geändert werden"
    },
    "RKSV": {
      "Title": "RKSV 2017",
      "RegisteredOn": "RKSV 2017 wurde am {0} um {1} registriert",
      "Deactivate": "Außer Betrieb nehmen",
      "ErrorLoadingRKSV": "RKSV 2017 konnte nicht geladen werden",
      "NotConfigured": {
        "Title": "RKSV 2017 (Signierung) muss zuerst eingerichtet werden.",
        "Description": "Hinterlege deine FinanzOnline Daten vom Registrierkassen-Webservice Benutzer.",
        "Setup": "Jetzt einrichten",
        "DeleteLiveData": "Live-Daten löschen"
      },
      "DEP7": {
        "Title": "Datenerfassungsprotokoll DEP7",
        "Export": "Exportieren",
        "ErrorExporting": "Datenerfassungsprotokoll DEP7 konnte nicht exportiert werden",
        "SystemDocumentation": "Systemdokumentation § 131 BAO"
      },
      "NullReport": {
        "Title": "Vorschau Nullbeleg",
        "ReportDesigner": "Bericht Designer",
        "Preview": "Vorschau",
        "Print": "Drucken"
      }
    },
    "TSE": {
      "Title": "TSE",
      "RegisteredOn": "TSE wurde am {0} um {1} registriert",
      "Deactivate": "Außer Betrieb nehmen",
      "ErrorLoadingTSE": "TSE konnte nicht geladen werden",
      "SuccessSettingUp": {
        "Title": "TSE eingerichtet",
        "Description": "TSE wurde erfolgreich eingerichtet!"
      },
      "ErrorSettingUp": "TSE konnte nicht eingerichtet werden",
      "NotConfigured": {
        "Title": "TSE (Signierung) muss zuerst eingerichtet werden.",
        "Description": "Hinterlege deine Daten für die technische Sicherheitseinrichtung.",
        "Setup": "Jetzt einrichten",
        "DeleteLiveData": "Live-Daten löschen"
      },
      "DSFinVK": {
        "Title": "Digitale Schnittstelle der Finanzverwaltung für Kassensysteme DSFinV-K",
        "Export": "Exportieren",
        "ErrorExporting": "DSFinV-K konnte nicht exportiert werden"
      },
      "ProceduralDocumentation": {
        "Title": "Verfahrensdokumentation",
        "KassenSichV": "Verfahrensdokumentation KassenSichV",
        "GoBD": "Verfahrensdokumentation GoBD"
      },
      "ConformityConfirmation": "GoBD"
    },
    "Tables": {
      "Title": "Tische",
      "Table": "Tisch",
      "Department": "Abteilung",
      "Number": "Nummer",
      "Name": "Bezeichnung",
      "ActiveInactive": "Aktiv/Inaktiv",
      "ToggleIsActiveError": "Tisch konnte nicht geändert werden",
      "Discount": "Ermäßigung",
      "DefaultPriceList": "Voreingestellte Preisliste",
      "PriceMode": "Preis",
      "ImportExport": "Import/Export",
      "Import": "Importieren",
      "Export": "Exportieren",
      "ImportSuccess": {
        "Title": "Import erfolgreich",
        "Description": "{created} Tische erstellt, {updated} aktualisiert."
      },
      "ImportPartial": {
        "Title": "Import teilweise erfolgreich",
        "Description": "{created} Tische erstellt, {updated} aktualisiert, {failed} fehlgeschlagen:"
      },
      "ImportError": {
        "Title": "Import fehlgeschlagen",
        "Description": "Tische konnten nicht importiert werden."
      },
      "ExportError": "Tische konnten nicht exportiert werden"
    },
    "Rooms": {
      "Title": "Zimmer",
      "Room": "Zimmer",
      "Department": "Abteilung",
      "Number": "Nummer",
      "Name": "Bezeichnung",
      "ActiveInactive": "Aktiv/Inaktiv",
      "ToggleIsActiveError": "Zimmer konnte nicht geändert werden",
      "Discount": "Ermäßigung",
      "DefaultPriceList": "Voreingestellte Preisliste",
      "PriceMode": "Preis",
      "ImportExport": "Import/Export",
      "Import": "Importieren",
      "Export": "Exportieren",
      "ImportSuccess": {
        "Title": "Import erfolgreich",
        "Description": "{created} Zimmer erstellt, {updated} aktualisiert."
      },
      "ImportPartial": {
        "Title": "Import teilweise erfolgreich",
        "Description": "{created} Zimmer erstellt, {updated} aktualisiert, {failed} fehlgeschlagen:"
      },
      "ImportError": {
        "Title": "Import fehlgeschlagen",
        "Description": "Zimmer konnten nicht importiert werden."
      },
      "ExportError": "Zimmer konnten nicht exportiert werden"
    },
    "TablePriceModes": {
      "Standard": "Standard",
      "PurchasePrice": "Einkaufspreis",
      "Zero": "0 €",
      "GrossForNet": "Brutto für Netto"
    },
    "TaxRates": {
      "Title": "Steuersätze",
      "Name": "Bezeichnung",
      "Rate": "Steuer",
      "ValidFrom": "Gültig ab",
      "ValidTo": "Gültig bis"
    },
    "Users": {
      "Title": "Benutzer",
      "User": "Benutzer",
      "PermissionRoles": "Berechtigungsrollen",
      "BookingLocks": "Buchungssperren",
      "Name": "Name",
      "Language": "Sprache",
      "RetailMode": "Handelsmodus",
      "IsRetailMode": "Handelsmodus",
      "Type": "Typ",
      "Types": {
        "Gastronomy": "Gastronomie",
        "Retail": "Handel",
        "OrderManager": "Bestellmanager"
      },
      "PermissionRole": "Berechtigungsrolle",
      "BookingLock": "Buchungssperre",
      "Team": "Team",
      "QuickLogin": "Schnellanmeldung",
      "TimeTracking": "Zeiterfassung",
      "ActiveInactive": "Aktiv/Inaktiv",
      "ToggleIsRetailModeError": "Benutzer konnte nicht geändert werden",
      "ToggleQuickLoginError": "Benutzer konnte nicht geändert werden",
      "ToggleTimeTrackingError": "Benutzer konnte nicht geändert werden",
      "ToggleIsActiveError": "Benutzer konnte nicht geändert werden",
      "ChangeSortOrderError": "Benutzer konnte nicht geändert werden"
    },
    "Workstations": {
      "Title": "Arbeitsstationen",
      "Workstation": "Arbeitsstation",
      "Type": "Typ",
      "Types": {
        "0": "Lipp POS",
        "1": "Lipp POS Mobil",
        "2": "Lipp POS Bestellmanager",
        "3": "Lipp POS Gastbestellung"
      },
      "MobileTag": "Mobil",
      "OrderManagerTag": "Bestellmanager",
      "DisconnectDevice": "Gerät trennen",
      "OnlineOrderingTag": "Gastbestellung",
      "Number": "Nummer",
      "Name": "Bezeichnung",
      "Version": "Version",
      "License": "Lizenz",
      "LicensesInUseSingular": "{0} von {1} Lizenz verwendet",
      "LicensesInUsePlural": "{0} von {1} Lizenzen verwendet",
      "ManageLicenses": "Lizenzen verwalten",
      "ActivateLicense": "Lizenz aktivieren",
      "ActivatedLicense": {
        "Title": "Lizenz aktiviert",
        "Description": "Die Lizenz für die Arbeitsstation <b>{0}</b> wurde erfolgreich aktiviert."
      },
      "ActivateLicenseError": "Lizenze konnte nicht aktiviert werden",
      "UnlinkLicense": "Lizenz freigeben",
      "ErrorLoadingLicenses": "Lizenzen konnten nicht geladen werden"
    },
    "SubsequentPositions": {
      "Title": "Folgepositionen",
      "Assignment": "Zuordnung",
      "Count": "Zugeordnet"
    },
    "Dialogs": {
      "BookingLocks": {
        "Title": "Buchungssperren ändern",
        "CommodityGroups": "Gesperrte Warengruppen",
        "Articles": "Gesperrte Artikel",
        "TimePeriods": "Zeiträume",
        "TimePeriodsTitle": "Zeitraum für die Sperre",
        "TimeFrom": "Uhrzeit von",
        "TimeTo": "Uhrzeit bis",
        "AllDay": "Ganztags",
        "Weekdays": "Wochentage",
        "AddTimePeriod": "Zeitraum hinzufügen",
        "Tabs": {
          "Scope": "Warengruppen & Artikel",
          "TimePeriod": "Zeitraum"
        },
        "Changed": {
          "Title": "Buchungssperre geändert",
          "Description": "Die Buchungssperre wurde erfolgreich geändert.",
          "Error": "Buchungssperre konnte nicht geändert werden"
        },
        "ErrorLoading": "Buchungssperren konnten nicht geladen werden"
      },
      "CreateBookingLock": {
        "Title": "Buchungssperre erstellen",
        "Name": "Name",
        "Created": {
          "Title": "Buchungssperre erstellt",
          "Description": "Die Buchungssperre <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Buchungssperre konnte nicht erstellt werden"
        }
      },
      "DeleteBookingLock": {
        "Title": "Buchungssperre löschen",
        "Description": "Möchten Sie die Buchungssperre <b>{0}</b> wirklich löschen?",
        "Deleted": {
          "Title": "Buchungssperre gelöscht",
          "Description": "Die Buchungssperre <b>{0}</b> wurde erfolgreich gelöscht.",
          "Error": "Buchungssperre konnte nicht gelöscht werden"
        }
      },
      "CopyDispensingSystemArticles": {
        "Title": "Zuordnung übertragen",
        "Description": "Die Artikel-Zuordnung von <b>{0}</b> wird mit Schankanlage-Art.-Nr., Debit und Kredit auf die gewählten Schankanlagen übernommen. Hat eine Schankanlage denselben Artikel schon, wird er überschrieben; ihre übrigen Zuordnungen bleiben.",
        "Targets": "Schankanlagen",
        "Copy": "Übertragen",
        "Success": {
          "Title": "Zuordnung übertragen",
          "Description": "{created} neu, {updated} überschrieben, {unchanged} unverändert."
        },
        "Error": "Zuordnung konnte nicht übertragen werden"
      },
      "DeleteDispensingSystem": {
        "Title": "Schankanlage löschen",
        "Description": "Soll die Schankanlage <b>{0}</b> wirklich gelöscht werden? Alle zugehörigen Artikel-Zuordnungen und Schlüssel-Zuordnungen gehen dabei verloren.",
        "Error": "Schankanlage konnte nicht gelöscht werden"
      },
      "DispensingSystemAssignment": {
        "Title": "Schankanlage Zuordnung",
        "Workstations": "Arbeitsstationen",
        "Departments": "Abteilungen",
        "Tables": "Tische",
        "SelectDepartmentHint": "Eine Abteilung links auswählen, um die zugehörigen Tische zu sehen.",
        "Changed": {
          "Title": "Zuordnung gespeichert",
          "Description": "Die Zuordnung für \"{0}\" wurde aktualisiert.",
          "Error": "Zuordnung konnte nicht gespeichert werden"
        }
      },
      "DispensingSystemKeyAssignment": {
        "Title": "Schlüsselzuordnung",
        "Empty": "Keine aktiven Benutzer verfügbar.",
        "SearchTablePlaceholder": "Tisch suchen...",
        "Columns": {
          "Name": "Name",
          "DefaultTable": "Std. Tisch",
          "DefaultTableHint": "Standard-Tisch für Zapfungen dieses Benutzers (wird verwendet, wenn die Schank eine eingehende Zapfung ohne Tischnummer meldet).",
          "SchankKeyNumber": "Schank-Benutzernummer",
          "SchankKeyNumberHint": "Schank-Benutzernummer (1-999). Leer lassen, dann wird die Listen-Reihenfolge des Benutzers als Fallback verwendet.",
          "DoNotBook": "Nicht buchen",
          "DoNotBookHint": "Wenn aktiv, wird für diesen Benutzer an dieser Schank weder ein Kredit gesendet noch eine eingehende Zapfung als POS-Buchung übernommen."
        },
        "Changed": {
          "Title": "Schlüsselzuordnung gespeichert",
          "Description": "Die Schlüsselzuordnung für \"{0}\" wurde aktualisiert.",
          "Error": "Schlüsselzuordnung konnte nicht gespeichert werden"
        }
      },
      "DispensingSystem": {
        "Create": "Schank-Anlage anlegen",
        "Edit": "Schank-Anlage bearbeiten",
        "Name": "Bezeichnung",
        "IPAddress": "IP-Adresse",
        "Port": "Port",
        "CommunicationService": "Kommunikationsserver",
        "CreditDebitSettings": "Kredit & Debit Einstellungen",
        "DefaultUser": "Std. Benutzer",
        "DefaultUserHint": "Benutzer, dessen Schank-Benutzernummer beim Kredit (POS-Buchung an die Schank) verwendet wird, wenn der buchende Benutzer selbst keine hinterlegt hat. Hat der Std. Benutzer selbst keine Schank-Benutzernummer hinterlegt, wird seine Sortierungsreihenfolge als Ausweichoption verwendet. Wird zusätzlich beim Debit als Ausweichoption verwendet, wenn die Schank eine unbekannte Benutzernummer meldet.",
        "DefaultTable": "Std. Tisch",
        "DefaultTableHint": "Tisch, auf den eingehende Zapfungen automatisch gebucht werden, wenn die Schank keine oder eine unbekannte Tischnummer meldet.",
        "DefaultWorkstation": "Std. Arbeitsstation",
        "DefaultWorkstationHint": "Arbeitsstation, unter der eingehende Schank-Buchungen erfasst werden. Wird für die fiskale Signatur (RKSV/TSE) benötigt.",
        "PrintDebitBookingReceipt": "Bestellbon bei Debit-Buchungen drucken",
        "PrintDebitBookingReceiptHint": "Druckt einen Bestellbon, wenn eine Zapfung von der Schank als Buchung hereinkommt (Debit). Ist die Option deaktiviert, wird kein Bon gedruckt; die Buchung selbst und der Bestellbon-Eintrag bleiben unverändert erhalten. Standard ist aktiviert.",
        "DefaultPrinters": "Standarddrucker",
        "DefaultPrintersHint": "Übersteuert die Drucker der Artikel bzw. der Arbeitsstation für alles, was an dieser Schankanlage rausgelassen wird.",
        "DefaultOrderReceiptPrinter": "Bestellbon",
        "DefaultInvoicePrinter": "Rechnung",
        "IsActive": "Aktiv",
        "Created": {
          "Title": "Schank-Anlage angelegt",
          "Description": "Die Schank-Anlage \"{0}\" wurde erfolgreich angelegt.",
          "Error": "Schank-Anlage konnte nicht angelegt werden"
        },
        "Changed": {
          "Title": "Schank-Anlage gespeichert",
          "Description": "Die Schank-Anlage \"{0}\" wurde aktualisiert.",
          "Error": "Schank-Anlage konnte nicht gespeichert werden"
        }
      },
      "Workstation": {
        "Close": "Schließen",
        "SetupCodeValidity": "Code ist noch {0} min gültig",
        "Create": "Arbeitsstation erstellen",
        "Edit": "Arbeitsstation bearbeiten",
        "Type": "Typ",
        "Number": "Nummer",
        "Name": "Bezeichnung",
        "CommunicationService": "Kommunikationsserver",
        "CreateNewCommunicationService": "Neuen erstellen",
        "Printers": "Druckerzuordnung",
        "AllowedWorkstations": "Zulässige Arbeitsstationen",
        "AllowedWorkstationsAll": "Alle",
        "InvoicePrinter": "Rechnungsdrucker",
        "TableTransferPrinter": "Tischtransfer-Drucker",
        "OrderManagerConfirmationPrinter": "Bestätigung drucken auf",
        "ServiceCallPrinter": "Serviceruf Drucker",
        "OnlineOrderingUser": "Buchender Benutzer",
        "OnlineOrderingPaymentMethod": "Zahlungsart",
        "ArticleLayoutProfile": "Layoutgruppe",
        "DefaultLayoutSubGroup": "Voreingestellte Untergruppe",
        "DefaultDepartment": "Voreingestellte Abteilung",
        "DefaultTable": "Voreingestellter Tisch",
        "StayOnTableAfterInvoice": "Nach Rechnung auf Tisch verbleiben",
        "OnlyEffectiveInGastronomyMode": "Wirksam nur im Gastromodus.",
        "PrintReceiptInRetailMode": "Bondruck im Handelsmodus",
        "Created": {
          "Title": "Arbeitsstation erstellt",
          "Description": "Die Arbeitsstation <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Arbeitsstation konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Arbeitsstation geändert",
          "Description": "Die Arbeitsstation <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Arbeitsstation konnte nicht geändert werden"
        },
        "ErrorLoadingCommunicationServices": "Kommunikationsserver konnten nicht geladen werden",
        "ErrorLoadingPrinters": "Drucker konnten nicht geladen werden",
        "ErrorLoadingArticleLayoutProfiles": "Layoutgruppen konnten nicht geladen werden",
        "ErrorLoadingLayoutSubGroups": "Untergruppen konnten nicht geladen werden",
        "ErrorLoadingOrderManagerSettings": "Bestellmanager-Einstellungen konnten nicht geladen werden",
        "ErrorSavingOrderManagerSettings": "Bestellmanager-Einstellungen konnten nicht gespeichert werden",
        "Tabs": {
          "General": "Allgemein",
          "BookingReceipt": "Bestellbon",
          "TimeSettings": "Zeiteinstellungen",
          "Sounds": "Töne",
          "ColorSettings": "Farbeinstellungen",
          "Priority": "Priorität",
          "QrCodes": "QR-Codes",
          "GlobalMessages": "Globale Nachrichten"
        },
        "OrderManagerSettings": {
          "GlobalMessages": {
            "Message": "Nachricht",
            "Suggestion1": "z. B. Küche kurz überlastet – Speisen ca. 5 min später",
            "Suggestion2": "z. B. Essen verzögert sich um ca. 10 min",
            "Suggestion3": "z. B. Koch kurz nicht da – warme Speisen ca. 15 min später",
            "Suggestion4": "z. B. Großer Andrang – Wartezeit auf Speisen ca. 20 min",
            "Suggestion5": "z. B. Küche überlastet – vorerst nur Kaltes bonieren (ca. 25 min)",
            "Duration": "Dauer (Minuten)"
          },
          "BookingReceipt": {
            "Title": "Bestellbon Designer",
            "ConfirmAllWithIntermediate": "Bonbestätigung Alle mit Zwischenabfrage",
            "ShowConfirmedStrikethrough": "Bestätigung von einzelnen Positionen durchgestrichen anzeigen",
            "ShowCoursesOnlyWhenRecalled": "Positionen erst am Bon anzeigen wenn Gang abgerufen wird",
            "ShowCoursesOnlyWhenRecalledInfo": "Kann nicht gleichzeitig mit „Zeit seit Auslieferung des vorherigen abgerufenen Gangs am Folgegang anzeigen\" (Zeiteinstellungen) aktiv sein — beim Aktivieren wird jene Einstellung automatisch deaktiviert.",
            "CollapseNotRecalledCourses": "Nicht abgerufene Gänge automatisch zuklappen",
            "SummarizeReorders": "Nachbestellungen zum Tisch zusammenfassen",
            "SummarizeReordersInfo": "Fasst offene Bons desselben Tisches bzw. Rechnungsträgers im Bestellmanager zu einer Karte zusammen. Die Bons und Buchungen selbst bleiben unverändert.",
            "ShowPrices": "Preise anzeigen",
            "ShowPricesInfo": "Zeigt in jeder Bonzeile rechts den Bruttobetrag der Zeile (Menge × Preis), wie am gedruckten Bestellbon. Beilagen ohne Aufpreis und Kommentare bleiben ohne Preis.",
            "SortByCommodityGroup": "Sortierung am Bon nach Warengruppe",
            "SortByCommodityGroupInfo": "Sortiert die Positionen am Bestellbon nach Warengruppe statt in der Reihenfolge der Buchung, innerhalb jedes Gangs und bei den Positionen ohne Gang (Reihenfolge wie bei „Warengruppen“ in der Seitenleiste des Bestellmanagers). Beilagen und Kommentare bleiben beim Artikel, gedruckte Bons bleiben unverändert.",
            "DisplaySize": "Anzeigegröße am Bestellbon",
            "DisplaySizeOptions": {
              "Small": "Klein",
              "Medium": "Mittel",
              "Large": "Groß",
              "Ultra": "Ultra"
            },
            "HeaderSlots": {
              "DepartmentTable": "Abteilung, Tisch",
              "User": "Benutzer",
              "BonNumber": "Bon-Nr.",
              "Pages": "Seitenanzahl",
              "Time": "Uhrzeit",
              "Order": "Reihenfolge",
              "BonColor": "Bonfarbe",
              "None": "Keine Anzeige"
            },
            "Preview": {
              "Designation": "Bezeichnung",
              "All": "Alle"
            }
          },
          "TimeSettings": {
            "WarningColor": "Warnfarbe der Uhrzeit ab",
            "ShowLongestArticleCountdown": "Der am längsten dauernde Artikel eines Gangs/Bons als Countdown am Bestellbonkopf anzeigen",
            "ShowLongestArticleCountdownInfo": "Diese Einstellung ersetzt die Uhrzeit am Bestellbon",
            "ShowPreviousCourseDeliveredTimer": "Zeit seit Auslieferung des vorherigen abgerufenen Gangs am Folgegang anzeigen",
            "ShowPreviousCourseDeliveredTimerInfo": "Kann nicht gleichzeitig mit „Positionen erst am Bon anzeigen wenn Gang abgerufen wird\" (Bestellbon) aktiv sein — beim Aktivieren wird jene Einstellung automatisch deaktiviert."
          },
          "ColorSettings": {
            "CommodityGroups": "Warengruppen",
            "Name": "Warengruppe",
            "Color": "Farbe",
            "ResetColor": "Auf Standardfarbe zurücksetzen",
            "Number": "Nummer",
            "WorkstationName": "Name",
            "ApplyToAllWorkstations": "Auf alle Bestellmanager-Arbeitsstationen übernehmen",
            "FollowUpArticles": "Folgeartikel",
            "FollowUpArticleTypes": {
              "3": "Beilage",
              "5": "Kommentar",
              "8": "Artikelpaketdetails"
            }
          },
          "Priority": {
            "Title": "Arbeitsstationen nach vorne Reihen"
          },
          "Sounds": {
            "NewOrder": "Eingang eines neuen Bestellbons",
            "CourseRecall": "Gang wurde abgerufen",
            "Tone": "Ton",
            "Groups": {
              "Desktop": "Desktop",
              "Mobile": "Android/iOS"
            },
            "Options": {
              "None": "Kein Ton",
              "WindowsNotify": "Standard-Benachrichtigung",
              "WindowsNotifyCalendar": "Kalender",
              "WindowsNotifyEmail": "E-Mail",
              "WindowsNotifyMessaging": "Nachricht",
              "WindowsNotifySystemGeneric": "System (Generisch)",
              "WindowsMessageNudge": "Anstupser",
              "WindowsInformationBar": "Hinweis",
              "WindowsBalloon": "Sprechblase",
              "WindowsDing": "Windows Ding",
              "WindowsDefault": "Windows Standard",
              "WindowsForeground": "Vordergrund",
              "WindowsBackground": "Hintergrund",
              "Chimes": "Glocken (Chimes)",
              "Chord": "Akkord (Chord)",
              "Ding": "Ding",
              "Notify": "Benachrichtigung",
              "Tada": "Tada",
              "NewOrderBell": "Glocke",
              "BrightPing": "Heller Ping",
              "MarimbaHint": "Marimba (Hinweis)",
              "DoubleBeepAlarm": "Doppel-Beep (Alarm)",
              "SoftPlop": "Sanfter Plopp"
            }
          }
        }
      },
      "User": {
        "Create": "Benutzer erstellen",
        "Edit": "Benutzer bearbeiten",
        "Name": "Name",
        "Language": "Sprache",
        "Theme": "Darstellung",
        "ThemeLight": "Hell",
        "ThemeDark": "Dunkel",
        "PIN": "Code",
        "RetailMode": "Handelsmodus",
        "Type": "Typ",
        "QuickLogin": "Schnellanmeldung",
        "TimeTracking": "Zeiterfassung",
        "ArticleLayoutProfile": "Layoutgruppe",
        "PermissionRole": "Berechtigungsrolle",
        "BookingLock": "Buchungssperre",
        "Team": "Team",
        "TeamTooltip": "Arbeitet der Benutzer in einem Team, werden alle Multibenutzer-Berechtigungen innerhalb des Teams ignoriert.",
        "Created": {
          "Title": "Benutzer erstellt",
          "Description": "Der Benutzer <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Benutzer konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Benutzer geändert",
          "Description": "Der Benutzer <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Benutzer konnte nicht geändert werden"
        },
        "ErrorLoadingArticleLayoutProfiles": "Layoutgruppen konnten nicht geladen werden",
        "ErrorLoadingPermissionRoles": "Berechtigungsrollen konnten nicht geladen werden",
        "ErrorLoadingBookingLocks": "Buchungssperren konnten nicht geladen werden",
        "ErrorLoadingTeams": "Teams konnten nicht geladen werden",
        "TakeFromWorkstation": "Von Arbeitsstation übernehmen"
      },
      "PermissionRoles": {
        "Title": "Berechtigungsrollen ändern",
        "Overview": "Übersicht",
        "Access": "Zugriff",
        "Duplicate": "Duplizieren",
        "Duplicated": {
          "Title": "Berechtigungsrolle dupliziert",
          "Description": "Die Berechtigungsrolle <b>{0}</b> wurde erfolgreich dupliziert.",
          "Error": "Berechtigungen konnten nicht kopiert werden"
        },
        "Permissions": {
          "General": {
            "Title": "Allgemein",
            "EditTableLayout": "Abteilungs- & Tischdesigner",
            "ChangeTableDesignation": "Tischbezeichnung ändern",
            "ShowUserAccounting": "Benutzerabrechnung",
            "EditArticleLayout": "Buchungsmaske Designer",
            "SendMails": "E-Mail versenden",
            "ShowCustomers": "Kundenkartei",
            "ShowPeriodAccounting": "Periodenabrechnung",
            "ShowInvoiceCenter": "Rechnungszentrale",
            "ShowReceiptCenter": "Bonzentrale",
            "ShowDailyAccounting": "Tagesabrechnung",
            "ShowDailySales": "Tagesumsätze",
            "ResetDailyClosing": "Tagesabschluss zurücksetzen",
            "ShowInventoryManagement": "Lagerverwaltung",
            "ShowDeliveryNotes": "Lieferscheine",
            "ShowPreOrders": "Vorbestellungen",
            "EditGlobalDispensingExceptions": "Schankausnahmen global ändern",
            "UserAccountingMultiUsers": "Benutzerabrechnung - Multibenutzer",
            "UserAccountingMultiUsersTooltip": "Benutzer A darf die Benutzerabrechnung von Benutzer B öffnen.",
            "OpenTablesMultiUsers": "Offene Tische - Multibenutzer",
            "OpenTablesMultiUsersTooltip": "Benutzer A darf die offenen Tische von Benutzer B sehen.",
            "InvoiceCenterMultiUsers": "Rechnungszentrale - Multibenutzer",
            "InvoiceCenterMultiUsersTooltip": "Benutzer A darf die Rechnungen von Benutzer B sehen.",
            "Management": "Verwaltung"
          },
          "BookingProcess": {
            "Title": "Buchungsvorgang",
            "ChangeBookingText": "Bezeichnung bei Buchung ändern",
            "BookingMultiUsers": "Buchen - Multibenutzer",
            "BookingMultiUsersTooltip": "Benutzer A darf, obwohl Benutzer B bereits gebucht hat, dazubuchen.",
            "BookNegativeQuantities": "Buchen - Negative Menge",
            "BookNegativePrice": "Buchen - Negativer Preis",
            "BookEfforts": "Buchen auf Aufwände",
            "ParkBookings": "Buchungen parken",
            "ApplyDiscount": "Ermäßigung",
            "ExecuteMacros": "Makros ausführen",
            "ChangePriceBeforeReceipt": "Preisänderung vor Bondruck",
            "ChangePriceAfterReceipt": "Preisänderung nach Bondruck",
            "ChangeInvoiceCarriers": "Rechnungsträger erstellen/bearbeiten",
            "CancelBookingsAfterReceipt": "Storno nach Bondruck",
            "CancelUnsentWithoutLog": "Sofortstorno ohne Protokoll",
            "CancelUnsentWithoutLogTooltip": "Das Entfernen noch nicht weggeschickter Positionen (Sofortstorno) wird für diese Rolle nicht im Änderungsprotokoll festgehalten.",
            "CancelBookingsMultiUsers": "Storno - Multibenutzer",
            "CancelBookingsMultiUsersTooltip": "Benutzer A darf die Buchungen von Benutzer B stornieren.",
            "TransferTables": "Tischtransfer",
            "TableTransferMultiUser": "Tischtransfer - Multibenutzer",
            "TableTransferMultiUserTooltip": "Benutzer A darf die Buchungen von Benutzer B transferieren.",
            "TableTransferToEfforts": "Tischtransfer auf Aufwände",
            "CreatePreOrder": "Vorbestellung erfassen",
            "RecallPreOrder": "Vorbestellung abrufen"
          },
          "Accounting": {
            "Title": "Rechnungslegung",
            "CreateInvoice": "Rechnung",
            "CreateProformaInvoice": "Proformarechnung",
            "InvoiceMultiUsers": "Rechnung - Multibenutzer",
            "InvoiceMultiUsersTooltip": "Benutzer A darf die Buchungen von Benutzer B abrechnen.",
            "ReprintInvoice": "Rechnung erneut drucken",
            "CorrectInvoice": "Rechnung korrigieren",
            "RetrieveInvoice": "Re.-Positionen zurückholen",
            "CreateEffortInvoice": "Aufwände abschließen",
            "ApplyDiscount": "Ermäßigung",
            "CancelInvoice": "Rechnung stornieren",
            "CancelInvoiceMultiUsers": "Rechnung stornieren - Multibenutzer",
            "CancelInvoiceMultiUsersTooltip": "Benutzer A darf die Rechnung von Benutzer B stornieren."
          }
        },
        "Changed": {
          "Title": "Berechtigungsrollen geändert",
          "Description": "Die Berechtigungsrollen wurden erfolgreich geändert.",
          "Error": "Berechtigungsrollen konnten nicht geändert werden"
        },
        "Departments": "Abteilungen",
        "Tables": "Tische",
        "Workstations": "Arbeitsstationen",
        "PaymentMethods": "Zahlungsarten",
        "PaymentMethodsTooltip": "Erlaubte Zahlungsarten an der Kasse. Neu angelegte Zahlungsarten sind automatisch erlaubt.",
        "PaymentMethodsChanged": {
          "Error": "Zahlungsarten der Berechtigungsrolle {0} konnten nicht gespeichert werden"
        },
        "ErrorLoadingPermissionRoles": "Berechtigungsrollen konnten nicht geladen werden",
        "ErrorLoadingPermissions": "Berechtigungen konnten nicht geladen werden",
        "ErrorLoadingDepartments": "Abteilungen konnten nicht geladen werden",
        "ErrorLoadingTables": "Tische konnten nicht geladen werden",
        "ErrorLoadingWorkstations": "Arbeitsstationen konnten nicht geladen werden",
        "ErrorLoadingPaymentMethods": "Zahlungsarten konnten nicht geladen werden"
      },
      "CreatePermissionRole": {
        "Title": "Berechtigungsrolle erstellen",
        "DuplicateTitle": "Berechtigungsrolle duplizieren",
        "Duplicate": "Duplizieren",
        "CopySuffix": "(Kopie)",
        "Name": "Bezeichnung",
        "Created": {
          "Title": "Berechtigungsrolle erstellt",
          "Description": "Die Berechtigungsrolle <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Berechtigungsrolle konnte nicht erstellt werden"
        }
      },
      "DeletePermissionRole": {
        "Title": "Berechtigungsrolle löschen",
        "Description": "Willst du die Berechtigungsrolle <b>{0}</b> wirklich löschen?",
        "Deleted": {
          "Title": "Berechtigungsrolle gelöscht",
          "Description": "Die Berechtigungsrolle <b>{0}</b> wurde erfolgreich gelöscht.",
          "Error": "Berechtigungsrolle konnte nicht gelöscht werden"
        }
      },
      "CreateLayoutProfile": {
        "Title": "Layoutgruppe erstellen",
        "Name": "Bezeichnung",
        "Created": {
          "Title": "Layoutgruppe erstellt",
          "Description": "Die Layoutgruppe <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Layoutgruppe konnte nicht erstellt werden"
        }
      },
      "DeleteLayoutProfile": {
        "Title": "Layoutgruppe löschen",
        "Description": "Willst du die Layoutgruppe <b>{0}</b> wirklich löschen?",
        "Deleted": {
          "Title": "Layoutgruppe gelöscht",
          "Description": "Die Layoutgruppe <b>{0}</b> wurde erfolgreich gelöscht.",
          "Error": "Layoutgruppe konnte nicht gelöscht werden"
        }
      },
      "DeactivateUser": {
        "Title": "Benutzer deaktivieren",
        "Description": "Willst du den Benutzer <b>{0}</b> wirklich deaktivieren?",
        "Error": "Benutzer konnte nicht deaktiviert werden"
      },
      "MailTemplate": {
        "Create": "Vorlage erstellen",
        "Edit": "Vorlage bearbeiten",
        "MailAccount": "E-Mail Konto",
        "Recipients": "E-Mail Empfänger",
        "Cc": "E-Mail CC",
        "Bcc": "E-Mail BCC",
        "Subject": "E-Mail Betreff",
        "Text": "E-Mail Text",
        "Created": {
          "Title": "Vorlage erstellt",
          "Description": "Die Vorlage <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Vorlage konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Vorlage geändert",
          "Description": "Die Vorlage <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Vorlage konnte nicht geändert werden"
        }
      },
      "MailSignature": {
        "Title": "Signatur bearbeiten",
        "MailAccount": "E-Mail Konto",
        "Signature": "Signatur",
        "Hint": "Die Signatur wird an jede E-Mail angehängt, die über dieses Konto versendet wird.",
        "LoadError": "Signatur konnte nicht geladen werden",
        "ImageError": "Bild konnte nicht eingefügt werden",
        "ImageNotEmbedded": {
          "Title": "Bild nicht übernommen",
          "Description": "Bilder bitte über den Bild-Knopf einfügen. Aus anderen Programmen eingefügte Bilder werden nicht mitgeschickt."
        },
        "TooLarge": {
          "Title": "Signatur zu groß",
          "Description": "Die Signatur darf höchstens 1 MB groß sein. Bitte kleinere oder weniger Bilder verwenden."
        },
        "Changed": {
          "Title": "Signatur gespeichert",
          "Description": "Die Signatur von <b>{0}</b> wurde erfolgreich gespeichert.",
          "Error": "Signatur konnte nicht gespeichert werden"
        }
      },
      "MailAccount": {
        "Create": "E-Mail Konto erstellen",
        "Edit": "E-Mail Konto bearbeiten",
        "SenderName": "Absender Name",
        "SenderMail": "Absender E-Mail",
        "Username": "Benutzername",
        "Password": "Passwort",
        "Host": "Postausgangsserver (SMTP)",
        "Port": "Port",
        "Authenticate": "Authentifizieren",
        "CouldNotValidate": "E-Mail konnte nicht validiert werden",
        "NotValid": {
          "Title": "E-Mail-Authentifizierung fehlgeschlagen",
          "Description": "Bitte überprüfe die bereits eingegebenen Felder auf deren Richtigkeit."
        },
        "Created": {
          "Title": "E-Mail Konto erstellt",
          "Description": "Das E-Mail Konto <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "E-Mail Konto konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "E-Mail Konto geändert",
          "Description": "Das E-Mail Konto <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "E-Mail Konto konnte nicht geändert werden"
        },
        "SendTestMail": "Test E-Mail senden",
        "SentTestMail": {
          "Title": "Test E-Mail gesendet",
          "Description": "Die Test E-Mail wurde an <b>{0}</b> gesendet.",
          "Error": "Test E-Mail konnte nicht gesendet werden"
        },
        "Provider": {
          "Microsoft": "Microsoft 365 (Outlook, Hotmail)",
          "Google": "Google (Gmail)",
          "Apple": "iCloud",
          "OtherAccount": "Anderes Konto (POP, IMAP)"
        },
        "iCloud": {
          "Title": "iCloud Mail einrichten",
          "Step1": "Auf <b>appleid.apple.com</b> anmelden und unter <b>Anmelden & Sicherheit</b> → <b>App-spezifische Passwörter</b> ein neues Passwort generieren (z.B. Name <b>LIPP POS</b>).",
          "Step2": "Apple zeigt einmalig ein <b>16-stelliges Passwort</b> an — dieses <b>kopieren</b>.",
          "Step3": "Im Formular unten Absender-Name, iCloud E-Mail-Adresse und das kopierte App-Passwort eintragen.",
          "OpenAppleId": "appleid.apple.com öffnen",
          "AppPassword": "App-spezifisches Passwort"
        },
        "OAuth": {
          "Errors": {
            "ConfigLoadFailed": "Die OAuth-Konfiguration konnte nicht vom Server geladen werden.",
            "ClientIdMissing": "Für den Anbieter \"{0}\" ist auf dem Server keine OAuth-Client-ID konfiguriert.",
            "StateMismatch": "Die OAuth-Sicherheitsprüfung ist fehlgeschlagen (State stimmt nicht überein). Bitte erneut versuchen.",
            "PopupBlocked": "Der Popup-Blocker hat das OAuth-Fenster verhindert. Bitte erlaube Popups für diese Seite und versuche es erneut.",
            "ProviderError": "Der Anbieter hat einen Fehler zurückgegeben: {0}",
            "NoCode": "Die OAuth-Rückmeldung enthielt keinen Code. Bitte versuche es erneut.",
            "WindowClosed": "Das OAuth-Fenster wurde geschlossen, bevor die Anmeldung abgeschlossen war.",
            "Timeout": "Zeitüberschreitung bei der OAuth-Anmeldung (5 Minuten)."
          },
          "Callback": {
            "Success": "OAuth-Anmeldung erfolgreich. Dieses Fenster kann jetzt geschlossen werden.",
            "Failed": "OAuth-Anmeldung fehlgeschlagen: {0}. Dieses Fenster kann jetzt geschlossen werden.",
            "NoOpener": "Dieses Fenster wurde nicht im Rahmen eines OAuth-Flows geöffnet. Bitte schließe es.",
            "Error": "Fehler im OAuth-Callback: {0}"
          }
        }
      },
      "Department": {
        "Create": "Abteilung erstellen",
        "Edit": "Abteilung bearbeiten",
        "Name": "Bezeichnung",
        "ShortNameMobile": "Kürzel Mobil",
        "Discount": "Ermäßigung %",
        "DefaultPriceList": "Voreingestellte Preisliste",
        "Image": "Bild",
        "IsActive": "Aktiv",
        "Created": {
          "Title": "Abteilung erstellt",
          "Description": "Die Abteilung <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Abteilung konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Abteilung geändert",
          "Description": "Die Abteilung <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Abteilung konnte nicht geändert werden"
        }
      },
      "DeactivateDepartment": {
        "Title": "Abteilung deaktivieren",
        "Description": "Willst du die Abteilung <b>{0}</b> wirklich deaktivieren?",
        "Error": "Abteilung konnte nicht deaktiviert werden"
      },
      "InvoiceText": {
        "Edit": "{0} bearbeiten",
        "Text": "Text",
        "Changed": {
          "Title": "Rechnungstext geändert",
          "Description": "<b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Rechnungstext konnte nicht geändert werden"
        }
      },
      "CancellationReason": {
        "Create": "Stornogrund erstellen",
        "Edit": "Stornogrund bearbeiten",
        "Text": "Text",
        "Created": {
          "Title": "Stornogrund erstellt",
          "Description": "Der Stornogrund <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Stornogrund konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Stornogrund geändert",
          "Description": "Der Stornogrund <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Stornogrund konnte nicht geändert werden"
        }
      },
      "DeactivateCancellationReason": {
        "Title": "Stornogrund deaktivieren",
        "Description": "Willst du den Stornogrund <b>{0}</b> wirklich deaktivieren?",
        "Error": "Stornogrund konnte nicht deaktiviert werden"
      },
      "Course": {
        "Create": "Gang erstellen",
        "Edit": "Gang bearbeiten",
        "Name": "Bezeichnung",
        "Code": "Kürzel",
        "BackgroundColor": "Hintergrundfarbe",
        "ForegroundColor": "Textfarbe",
        "AutoRecallAfter": "Automatisch abrufen nach",
        "AutoRecallHint": "Format Stunden:Minuten (z. B. 00:05 = 5 Minuten, 01:30 = 90 Minuten). 00:00 = sofortiger Abruf nach dem vorherigen Gang.",
        "ToggleIsActiveError": "Gang konnte nicht geändert werden",
        "Created": {
          "Title": "Gang erstellt",
          "Description": "Der Gang <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Gang konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Gang geändert",
          "Description": "Der Gang <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Gang konnte nicht geändert werden"
        }
      },
      "DeactivateCourse": {
        "Title": "Gang deaktivieren",
        "Description": "Willst du den Gang <b>{0}</b> wirklich deaktivieren?",
        "Error": "Gang konnte nicht deaktiviert werden"
      },
      "DeactivateSupplier": {
        "Title": "Lieferant deaktivieren",
        "Description": "Willst du den Lieferanten <b>{0}</b> wirklich deaktivieren?",
        "Error": "Lieferant konnte nicht deaktiviert werden"
      },
      "Table": {
        "Create": "Tisch erstellen",
        "Edit": "Tisch bearbeiten",
        "Type": "Typ",
        "TypeStandard": "Standard",
        "TypeRequisition": "Fassung",
        "Department": "Abteilung",
        "Number": "Nummer",
        "NumberFrom": "Nummer von",
        "NumberTo": "Nummer bis",
        "CreateMultiple": "Massenerstellung",
        "NumberAlreadyTaken": "Die Tischnummer <b>{0}</b> wurde bereits vergeben.",
        "NumberTooLarge": "Die Nummer darf höchstens <b>{0}</b> sein.",
        "NameTooLong": "Die Bezeichnungen wären zu lang (höchstens {0} Zeichen).",
        "Preview": "{0} Tische: {1}",
        "PreviewSingle": "1 Tisch: {0}",
        "Name": "Bezeichnung",
        "IsActive": "Aktiv",
        "DefaultPriceList": "Voreingestellte Preisliste",
        "TakeFromDepartment": "Von Abteilung übernehmen",
        "InstantInvoice": "Sofortabrechnung",
        "PriceMode": "Preis",
        "ErrorLoadingDepartments": "Abteilungen konnten nicht geladen werden",
        "Created": {
          "Title": "Tisch erstellt",
          "Description": "Der Tisch <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Tisch konnte nicht erstellt werden"
        },
        "CreatedMultiple": {
          "Title": "Tische erstellt",
          "Description": "<b>{0}</b> Tische wurden erfolgreich erstellt.",
          "Error": "Tische konnten nicht erstellt werden"
        },
        "Changed": {
          "Title": "Tisch geändert",
          "Description": "Der Tisch <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Tisch konnte nicht geändert werden"
        }
      },
      "DeactivateTable": {
        "Title": "Tisch deaktivieren",
        "Description": "Willst du den Tisch <b>{0}</b> wirklich deaktivieren?",
        "Error": "Tisch konnte nicht deaktiviert werden"
      },
      "Room": {
        "Create": "Zimmer erstellen",
        "Edit": "Zimmer bearbeiten",
        "Department": "Abteilung",
        "Number": "Nummer",
        "NumberFrom": "Nummer von",
        "NumberTo": "Nummer bis",
        "CreateMultiple": "Massenerstellung",
        "NumberAlreadyTaken": "Die Nummer <b>{0}</b> wurde bereits vergeben.",
        "NumberTooLarge": "Die Nummer darf höchstens <b>{0}</b> sein.",
        "NameTooLong": "Die Bezeichnungen wären zu lang (höchstens {0} Zeichen).",
        "Preview": "{0} Zimmer: {1}",
        "PreviewSingle": "1 Zimmer: {0}",
        "Name": "Bezeichnung",
        "IsActive": "Aktiv",
        "DefaultPriceList": "Voreingestellte Preisliste",
        "TakeFromDepartment": "Von Abteilung übernehmen",
        "PriceMode": "Preis",
        "ErrorLoadingDepartments": "Abteilungen konnten nicht geladen werden",
        "Created": {
          "Title": "Zimmer erstellt",
          "Description": "Das Zimmer <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Zimmer konnte nicht erstellt werden"
        },
        "CreatedMultiple": {
          "Title": "Zimmer erstellt",
          "Description": "<b>{0}</b> Zimmer wurden erfolgreich erstellt.",
          "Error": "Zimmer konnten nicht erstellt werden"
        },
        "Changed": {
          "Title": "Zimmer geändert",
          "Description": "Das Zimmer <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Zimmer konnte nicht geändert werden"
        }
      },
      "DeactivateRoom": {
        "Title": "Zimmer deaktivieren",
        "Description": "Willst du das Zimmer <b>{0}</b> wirklich deaktivieren?",
        "Error": "Zimmer konnte nicht deaktiviert werden"
      },
      "Effort": {
        "Create": "Aufwand erstellen",
        "Edit": "Aufwand bearbeiten",
        "Department": "Abteilung",
        "Type": "Typ",
        "Number": "Nummer",
        "Name": "Bezeichnung",
        "IsActive": "Aktiv",
        "DefaultPriceList": "Voreingestellte Preisliste",
        "AlternativeTax": "Altern. Steuer",
        "PriceMode": "Preis",
        "ErrorLoadingTaxes": "Steuern konnten nicht geladen werden",
        "Created": {
          "Title": "Aufwand erstellt",
          "Description": "Der Aufwand <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Aufwand konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Aufwand geändert",
          "Description": "Der Aufwand <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Aufwand konnte nicht geändert werden"
        }
      },
      "DeactivateEffort": {
        "Title": "Aufwand deaktivieren",
        "Description": "Willst du den Aufwand <b>{0}</b> wirklich deaktivieren?",
        "Error": "Aufwand konnte nicht deaktiviert werden"
      },
      "PaymentMethod": {
        "Create": "Zahlungsart erstellen",
        "Edit": "Zahlungsart bearbeiten",
        "Type": "Typ",
        "Name": "Bezeichnung",
        "PaymentTarget": "Zahlungsziel",
        "PrintCount": "Anzahl Belege",
        "AppearsInOpenItemsManagement": "In Offene-Posten-Verwaltung anzeigen",
        "Created": {
          "Title": "Zahlungsart erstellt",
          "Description": "Die Zahlungsart <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Zahlungsart konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Zahlungsart geändert",
          "Description": "Die Zahlungsart <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Zahlungsart konnte nicht geändert werden"
        }
      },
      "DeactivatePaymentMethod": {
        "Title": "Zahlungsart deaktivieren",
        "Description": "Willst du die Zahlungsart <b>{0}</b> wirklich deaktivieren?",
        "Error": "Zahlungsart konnte nicht deaktiviert werden"
      },
      "RevenueGroup": {
        "Create": "Umsatzgruppe erstellen",
        "Edit": "Umsatzgruppe bearbeiten",
        "Name": "Bezeichnung",
        "Created": {
          "Title": "Umsatzgruppe erstellt",
          "Description": "Die Umsatzgruppe <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Umsatzgruppe konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Umsatzgruppe geändert",
          "Description": "Die Umsatzgruppe <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Umsatzgruppe konnte nicht geändert werden"
        }
      },
      "Team": {
        "Create": "Team erstellen",
        "Edit": "Team bearbeiten",
        "Name": "Bezeichnung",
        "Created": {
          "Title": "Team erstellt",
          "Description": "Das Team <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Team konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Team geändert",
          "Description": "Das Team <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Team konnte nicht geändert werden"
        }
      },
      "DeleteUserMessage": {
        "Title": "Nachricht löschen",
        "Description": "Willst du diese Nachricht wirklich löschen? Bereits gesendete Nachrichten bleiben erhalten.",
        "Deleted": {
          "Title": "Nachricht gelöscht",
          "Description": "Die Nachricht wurde erfolgreich gelöscht.",
          "Error": "Nachricht konnte nicht gelöscht werden"
        }
      },
      "DeleteTeam": {
        "Title": "Team löschen",
        "Description": "Willst du das Team <b>{0}</b> wirklich löschen?",
        "Deleted": {
          "Title": "Team gelöscht",
          "Description": "Das Team <b>{0}</b> wurde erfolgreich gelöscht.",
          "Error": "Team konnte nicht gelöscht werden"
        }
      },
      "Macro": {
        "Create": "Makro erstellen",
        "Edit": "Makro bearbeiten",
        "Name": "Bezeichnung",
        "Code": "Kürzel",
        "Prefix": "Text davor",
        "Suffix": "Text danach",
        "PriceType": "Preistyp",
        "Price": "Preis",
        "Discount": "Rabatt %",
        "AlternativeTax": "Altern. Steuer",
        "BackgroundColor": "Hintergrundfarbe",
        "ForegroundColor": "Textfarbe",
        "Preview": "Vorschau",
        "Created": {
          "Title": "Makro erstellt",
          "Description": "Das Makro <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Makro konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Makro geändert",
          "Description": "Das Makro <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Makro konnte nicht geändert werden"
        },
        "ErrorLoadingTaxes": "Steuern konnten nicht geladen werden",
        "ErrorLoadingPriceLists": "Preislisten konnten nicht geladen werden",
        "ErrorLoadingRevenueGroups": "Umsatzgruppen konnten nicht geladen werden",
        "ErrorLoadingCommodityGroups": "Warengruppen konnten nicht geladen werden",
        "ErrorLoadingArticles": "Artikel konnten nicht geladen werden",
        "General": "Allgemein",
        "ArticleScope": "Umsatz-, Warengruppen & Artikel",
        "RevenueGroups": "Umsatzgruppen",
        "CommodityGroups": "Warengruppen",
        "Articles": "Artikel",
        "PriceMode": {
          "Pricelist": "Preisliste",
          "Discount": "Ermäßigung",
          "PriceOverride": "Preistyp",
          "Price": "Preis"
        },
        "PriceTypes": {
          "Add": "Addieren",
          "Fixed": "Fixer Betrag"
        }
      },
      "DeactivateMacro": {
        "Title": "Makro deaktivieren",
        "Description": "Willst du das Makro <b>{0}</b> wirklich deaktivieren?",
        "Error": "Makro konnte nicht deaktiviert werden"
      },
      "NumberRange": {
        "Create": "Nummernkreis erstellen",
        "Edit": "Nummernkreis bearbeiten",
        "Type": "Typ",
        "Name": "Bezeichnung",
        "Prefix": "Text davor",
        "Suffix": "Text danach",
        "Length": "Länge",
        "StartNumber": "Startnummer",
        "Preview": "Vorschau",
        "StartDate": "Startdatum",
        "Created": {
          "Title": "Nummernkreis erstellt",
          "Description": "Der Nummernkreis <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Nummernkreis konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Nummernkreis geändert",
          "Description": "Der Nummernkreis <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Nummernkreis konnte nicht geändert werden"
        }
      },
      "DeactivateNumberRange": {
        "Title": "Nummernkreis deaktivieren",
        "Description": "Willst du den Nummernkreis <b>{0}</b> wirklich deaktivieren?",
        "Error": "Nummernkreis konnte nicht deaktiviert werden"
      },
      "CommodityGroup": {
        "Create": "Warengruppe erstellen",
        "Edit": "Warengruppe bearbeiten",
        "RevenueGroup": "Umsatzgruppe",
        "Name": "Bezeichnung",
        "Tax": "Mehrwertsteuer",
        "Created": {
          "Title": "Warengruppe erstellt",
          "Description": "Die Warengruppe <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Die Warengruppe konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Warengruppe geändert",
          "Description": "Die Warengruppe <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Warengruppe konnte nicht geändert werden"
        },
        "ErrorLoadingTaxes": "Steuern konnten nicht geladen werden",
        "ErrorLoadingRevenueGroups": "Umsatzgruppen konnten nicht geladen werden"
      },
      "DeactivateCommodityGroup": {
        "Title": "Warengruppe deaktivieren",
        "Description": "Willst du die Warengruppe <b>{0}</b> wirklich deaktivieren?",
        "Error": "Warengruppe konnte nicht deaktiviert werden"
      },
      "DeactivateIntegration": {
        "Title": "Integration deaktivieren",
        "Description": "Willst du die Integration <b>{0}</b> wirklich deaktivieren?"
      },
      "AidaXSetting": {
        "Title": "Einstellung ändern",
        "Changed": {
          "Title": "Einstellung geändert",
          "Description": "Die Einstellung <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Einstellung konnte nicht geändert werden"
        }
      },
      "EucasoftSetting": {
        "Title": "Einstellung ändern",
        "Changed": {
          "Title": "Einstellung geändert",
          "Description": "Die Einstellung <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Einstellung konnte nicht geändert werden"
        }
      },
      "AsaAsciiSetting": {
        "Title": "Einstellung ändern",
        "Changed": {
          "Title": "Einstellung geändert",
          "Description": "Die Einstellung <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Einstellung konnte nicht geändert werden"
        }
      },
      "SihotSetting": {
        "Title": "Einstellung ändern",
        "Changed": {
          "Title": "Einstellung geändert",
          "Description": "Die Einstellung <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Einstellung konnte nicht geändert werden"
        }
      },
      "SihotCategoryMapping": {
        "Title": "Warengruppe zuordnen",
        "Hint": "Gültig sind ganze Zahlen von 1 bis 100.",
        "Changed": {
          "Title": "Zuordnung geändert",
          "Description": "Die Zuordnung für <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Zuordnung konnte nicht geändert werden"
        }
      },
      "SihotPaymentTypeMapping": {
        "Title": "Zahlungsart zuordnen",
        "Changed": {
          "Title": "Zuordnung geändert",
          "Description": "Die Zuordnung für <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Zuordnung konnte nicht geändert werden"
        }
      },
      "CashJournalEntry": {
        "Create": {
          "Revenue": {
            "Title": "Einnahme hinzufügen",
            "Success": {
              "Title": "Einnahme hinzugefügt",
              "Description": "Die Einnahme <b>{0}</b> ({1}) wurde erfolgreich hinzugefügt."
            },
            "Error": "Einnahme konnte nicht hinzugefügt werden"
          },
          "Expense": {
            "Title": "Ausgabe hinzufügen",
            "Success": {
              "Title": "Ausgabe hinzugefügt",
              "Description": "Die Ausgabe <b>{0}</b> ({1}) wurde erfolgreich hinzugefügt."
            },
            "Error": "Ausgabe konnte nicht hinzugefügt werden"
          }
        },
        "Edit": {
          "Revenue": {
            "Title": "Einnahme bearbeiten",
            "Success": {
              "Title": "Einnahme bearbeitet",
              "Description": "Die Einnahme <b>{0}</b> ({1}) wurde erfolgreich bearbeitet."
            },
            "Error": "Einnahme konnte nicht bearbeitet werden"
          },
          "Expense": {
            "Title": "Ausgabe bearbeiten",
            "Success": {
              "Title": "Ausgabe bearbeitet",
              "Description": "Die Ausgabe <b>{0}</b> ({1}) wurde erfolgreich bearbeitet."
            },
            "Error": "Ausgabe konnte nicht bearbeitet werden"
          }
        },
        "Date": "Datum",
        "Description": "Bezeichnung",
        "Templates": "Vorlagen",
        "Amount": "Betrag",
        "TaxRate": "Steuer",
        "ExternalReceiptNumber": "Externe Belegnummer",
        "TaxAmount": "Steuerbetrag",
        "CashBalance": "Kassenstand Vorschau",
        "ErrorLoadingTemplates": "Vorlagen konnten nicht geladen werden"
      },
      "DeleteCashJournalEntry": {
        "Revenue": {
          "Title": "Einnahme löschen",
          "Description": "Willst du die Einnahme <b>{0}</b> ({1}) wirklich löschen?",
          "Error": "Einnahme konnte nicht gelöscht werden"
        },
        "Expense": {
          "Title": "Ausgabe löschen",
          "Description": "Willst du die Ausgabe <b>{0}</b> ({1}) wirklich löschen?",
          "Error": "Ausgabe konnte nicht gelöscht werden"
        }
      },
      "DeactivateCashJournalTemplate": {
        "Title": "Vorlage deaktivieren",
        "Description": "Willst du die Vorlage <b>{0}</b> wirklich deaktivieren?",
        "Error": "Vorlage konnte nicht deaktiviert werden"
      },
      "DeactivateVoucherType": {
        "Title": "Gutscheinart deaktivieren",
        "Description": "Willst du die Gutscheinart <b>{0}</b> wirklich deaktivieren?",
        "Error": "Gutscheinart konnte nicht deaktiviert werden"
      },
      "MigrateVouchers": {
        "Title": "Gutscheine betriebsübergreifend migrieren",
        "Question": "Möchtest du wirklich alle Gutscheine der <b>{0}</b> Betriebe betriebsübergreifend migrieren?",
        "AddStation": "Weiteren Betrieb hinzufügen",
        "SearchPlaceholder": "Betrieb suchen",
        "TestPhaseWarning": "{0} ist noch in der Testphase (ohne RKSV/TSE). Ihre Testgutscheine kommen mit in den Verbund und lassen sich danach nicht mehr über „Live-Daten löschen“ entfernen. Vorher Live-Daten löschen und RKSV/TSE einrichten — oder bewusst so migrieren (z. B. für Tests).",
        "Hint": "Danach gelten die Gutscheine in allen gewählten Betrieben. Ausstellen und Einlösen geht nur noch mit Internetverbindung, Gutscheinarten werden nur noch betriebsübergreifend gepflegt. Vorher an allen Kassen den Tagesabschluss machen: Rechnungen von vor der Migration können ihre Gutschein-Einlösungen beim Storno sonst nicht automatisch zurückbuchen. Außerdem prüfen, dass alle Kassen der gewählten Betriebe auf Version 1.37 oder neuer laufen — auch Zweitserver im Netzwerk. Eine ältere Kasse kennt den Verbund nicht und würde Gutscheine nur lokal einlösen.",
        "Migrating": "Die Migration läuft. Das kann bis zu einer Minute dauern.",
        "Migrate": "Migrieren",
        "Error": "Migration fehlgeschlagen",
        "State": {
          "Checking": "Wird geprüft",
          "Ready": "Bereit",
          "Offline": "Offline",
          "Version": "Version {0}, mindestens {1} nötig",
          "Group": "Bereits im Verbund {0}",
          "Error": "Nicht prüfbar",
          "TestPhase": "Testphase"
        },
        "Result": {
          "Title": "Die Migration ist abgeschlossen.",
          "Migrated": "Übernommene Gutscheine",
          "NextNumber": "Nächste Gutscheinnummer",
          "Duplicates": "Mehrfach vergebene Nummern",
          "DuplicatesHint": "Gleiche Nummern aus verschiedenen Betrieben bleiben gültig. An der Kasse unterscheidet sie der Betrieb.",
          "VoucherTypes": "Übernommene Gutscheinarten",
          "Open": "Zur Gutscheinverwaltung"
        }
      },
      "DeactivateTimeTrackingType": {
        "Title": "Zeiterfassungsart deaktivieren",
        "Description": "Willst du die Zeiterfassungsart <b>{0}</b> wirklich deaktivieren?",
        "Error": "Zeiterfassungsart konnte nicht deaktiviert werden"
      },
      "CashJournalTemplate": {
        "Create": "Vorlage erstellen",
        "Edit": "Vorlage bearbeiten",
        "Type": "Typ",
        "Description": "Bezeichnung",
        "Tax": "Steuer",
        "Created": {
          "Success": {
            "Title": "Vorlage erstellt",
            "Description": "Die Vorlage <b>{0}</b> wurde erfolgreich erstellt."
          },
          "Error": "Vorlage konnte nicht erstellt werden"
        },
        "Changed": {
          "Success": {
            "Title": "Vorlage geändert",
            "Description": "Die Vorlage <b>{0}</b> wurde erfolgreich geändert."
          },
          "Error": "Vorlage konnte nicht geändert werden"
        }
      },
      "TimeTrackingType": {
        "Create": "Zeiterfassungsart erstellen",
        "Edit": "Zeiterfassungsart bearbeiten",
        "Name": "Bezeichnung",
        "Report": "Bericht",
        "BackgroundColor": "Hintergrundfarbe",
        "TextColor": "Textfarbe",
        "Preview": "Vorschau",
        "Settings": "Einstellungen",
        "IsWorkingTime": "Arbeitszeit",
        "IsLoginAllowed": "Anmeldung erlaubt",
        "IsSelectableByUser": "Auswählbar für Benutzer",
        "HasAutomaticDeduction": "Automatischer Abzug",
        "DeductionThreshold": "Bei Überschreitung ab",
        "DeductionAmount": "Abzug",
        "CreateMore": "Weitere Einträge erstellen",
        "AutoPrint": {
          "Title": "Autom. Druck",
          "None": "Nein",
          "OnLogin": "Anmeldung",
          "OnLogout": "Abmeldung",
          "OnLoginAndLogout": "Anmeldung + Abmeldung"
        },
        "Created": {
          "Success": {
            "Title": "Art erstellt",
            "Description": "Die Art „{0}“ wurde erstellt."
          },
          "Error": "Art konnte nicht erstellt werden"
        },
        "Changed": {
          "Success": {
            "Title": "Art geändert",
            "Description": "Die Art „{0}“ wurde geändert."
          },
          "Error": "Art konnte nicht geändert werden"
        }
      },
      "TimeTrackingEntry": {
        "Create": "Eintrag erstellen",
        "Edit": "Eintrag bearbeiten",
        "User": "Benutzer",
        "Date": "Datum",
        "Type": "Art",
        "Start": "Anmeldung",
        "End": "Abmeldung",
        "WorkingTime": "Arbeitszeit",
        "AutomaticDeduction": "Autom. Abzug",
        "CreateMore": "Weitere Einträge erstellen",
        "ErrorLoadingTypes": "Zeiterfassungsarten konnten nicht geladen werden",
        "ErrorLoadingUsers": "Benutzer konnten nicht geladen werden",
        "Created": {
          "Success": {
            "Title": "Eintrag erstellt",
            "Description": "Der Eintrag wurde erstellt."
          },
          "Error": "Eintrag konnte nicht erstellt werden"
        },
        "Edited": {
          "Success": {
            "Title": "Eintrag geändert",
            "Description": "Der Eintrag wurde geändert."
          },
          "Error": "Eintrag konnte nicht geändert werden"
        }
      },
      "DeleteTimeTrackingEntry": {
        "Title": "Eintrag löschen",
        "Description": "Willst du den Eintrag <b>{0}</b> wirklich löschen?",
        "Error": "Eintrag konnte nicht gelöscht werden"
      },
      "VoucherType": {
        "Create": "Gutscheinart erstellen",
        "Edit": "Gutscheinart bearbeiten",
        "Name": "Bezeichnung",
        "CloudReportHint": "Gilt für alle Betriebe des Verbunds. Wählbar sind die Berichte, die es in jedem Betrieb unter diesem Namen gibt.",
        "CloudReportsError": "Die Berichte konnten nicht geladen werden.",
        "MixedReportsUnchanged": "Unterschiedlich je Betrieb (bleibt so)",
        "Created": {
          "Success": {
            "Title": "Gutscheinart erstellt",
            "Description": "Die Gutscheinart <b>{0}</b> wurde erfolgreich erstellt."
          },
          "Error": "Gutscheinart konnte nicht erstellt werden"
        },
        "Changed": {
          "Success": {
            "Title": "Gutscheinart geändert",
            "Description": "Die Gutscheinart <b>{0}</b> wurde erfolgreich geändert."
          },
          "Error": "Gutscheinart konnte nicht geändert werden"
        }
      },
      "CommunicationService": {
        "Edit": "Kommunikationsserver bearbeiten",
        "Name": "Bezeichnung",
        "DeviceName": "Gerätename",
        "Networks": "Netzwerke",
        "Changed": {
          "Title": "Kommunikationsserver geändert",
          "Description": "Der Kommunikationsserver <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Kommunikationsserver konnte nicht geändert werden"
        }
      },
      "Folder": {
        "Create": "Ordner erstellen",
        "Edit": "Ordner bearbeiten"
      },
      "Article": {
        "Create": "Artikel erstellen",
        "Edit": "Artikel bearbeiten",
        "Type": "Typ",
        "CommodityGroup": "Warengruppe",
        "CommodityGroupSearchPlaceholder": "Warengruppe suchen...",
        "Barcodes": "Barcodes",
        "SubsequentPositions": "Folgepositionen",
        "Number": "Art.-Nr.",
        "Name": "Bezeichnung",
        "Prices": "Preise",
        "PriceLists": "Preislisten",
        "PriceListsTooltip": "Beliebig viele Preislisten können erstellt und benannt werden. In der Lipp POS kannst du zwischen Preislisten umschalten, sodass Positionen mit der gewählten Preisliste gebucht werden.",
        "Price": "Verkaufspreis",
        "Costs": "Einkaufspreis",
        "MarkupOnCost": "% Aufschlag vom EK",
        "Settings": "Einstellungen",
        "Sign": "Vorzeichen",
        "Course": "Gang",
        "PackageDetails": "Paketdetails",
        "Article": "Artikel",
        "Group": "Gruppe",
        "Printers": "Drucker",
        "BookingProcess": "Buchungsvorgang",
        "TextEntryForBooking": "Texteingabe pro Buchung",
        "IsDiscountable": "Ermäßigungsfähig",
        "PriceEntryForBooking": "Preiseingabe pro Buchung",
        "ExternalDocumentNumberEntryForBooking": "Externe Belegnummer pro Buchung",
        "Invoicing": "Rechnungslegung",
        "IsIncludedInParentPrice": "Separat ausweisen deaktivieren – im Artikelpreis enthalten",
        "IsIncludedInParentPriceTooltip": "Weicht die gebuchte Beilage vom Steuersatz des Artikels ab, wird diese Einstellung ignoriert und die Beilage wird trotzdem auf der Rechnung angezeigt.",
        "Tabs": {
          "General": "Allgemein",
          "Weight": "Gewicht"
        },
        "Additions": "Zusätze",
        "Preparation": "Zubereitung",
        "Deposit": {
          "Tab": "Pfand",
          "Title": "Pfand",
          "Hint": "Beim Buchen dieses Artikels wird das Pfand automatisch als eigene Position mitgebucht (wie eine Beilage) und auf der Rechnung separat ausgewiesen.",
          "Type": "Pfandart",
          "Amount": "Pfandbetrag",
          "Types": {
            "None": "Kein Pfand",
            "SingleUse": "Einweg",
            "Reusable": "Mehrweg"
          },
          "AmountRequired": "Bitte einen Pfandbetrag größer als 0 angeben.",
          "TaxInfoRKSV": "Die Pfandart bestimmt den Steuersatz automatisch:<br><b>Einwegpfand</b> = nicht steuerbar (durchlaufender Posten)<br><b>Mehrweg</b> = gleiche Steuer wie der Artikel",
          "TaxInfoTSE": "Pfand gilt in Deutschland als unselbständige Nebenleistung und wird — bei Einweg wie Mehrweg — mit dem Steuersatz des Artikels versteuert."
        },
        "Weight": {
          "Title": "Verkauf nach Gewicht",
          "Hint": "Bei einem Gewichtsartikel gilt der Verkaufspreis pro Kilogramm bzw. pro Gramm. Die Kasse fragt beim Buchen das Gewicht ab und berechnet daraus den Preis.",
          "IsWeightArticle": "Gewichtsartikel",
          "PriceType": "Preistyp",
          "PriceTypes": {
            "PerKilogram": "Preis pro Kilogramm",
            "PerGram": "Preis pro Gramm"
          },
          "Tare": "Tara",
          "TareTooltip": "Gewicht der Verpackung (z. B. Schale oder Teller). Es wird beim Wiegen in der Kasse automatisch vom eingegebenen Gewicht abgezogen. Die Einheit richtet sich nach dem Preistyp.",
          "Preview": "Am Kassenknopf:",
          "Validation": {
            "Title": "Ungültiger Gewichtsartikel",
            "TareNegative": "Die Tara darf nicht negativ sein.",
            "NegativeArticle": "Ein Gewichtsartikel kann kein Minusartikel sein. Bitte das Vorzeichen auf „+“ stellen oder den Haken „Gewichtsartikel“ entfernen."
          }
        },
        "DepositReturn": {
          "Validation": {
            "Title": "Ungültiger Pfandbetrag",
            "Message": "Bitte einen Verkaufspreis (Pfandbetrag pro Stück) größer als 0 angeben."
          },
          "SystemGroupMissing": {
            "Message": "Die System-Warengruppe \"Einwegpfand\" konnte nicht ermittelt werden. Bitte sicherstellen, dass die Station auf POS 1.27.0 aktualisiert und synchronisiert ist."
          },
          "FiscalContextMissing": {
            "Message": "Die Fiskal-Konfiguration der Station konnte nicht geladen werden. Bitte den Dialog erneut öffnen."
          },
          "CommodityGroupRequired": {
            "Message": "Bitte eine gültige Warengruppe auswählen."
          }
        },
        "CopySuffix": "(Kopie)",
        "ProductionTime": {
          "Title": "Zubereitungszeit nach Menge",
          "Hint": "Lege fest, wie lange die Zubereitung dauert — gestaffelt nach Stückzahl pro Buchung. Der Bestellmanager rechnet daraus die Fertig-Prognose.",
          "FromQuantity": "Ab Menge",
          "ToQuantity": "Bis Menge",
          "Minutes": "Zeit (Minuten)",
          "AddTier": "Staffel",
          "PreviewTitle": "Beispiel-Vorschau",
          "PreviewItems": "Stk. gebucht",
          "PreviewInfinite": "unendlich",
          "MinutesShort": "Min",
          "Validation": {
            "Title": "Ungültige Staffeln",
            "Message": "Die Zubereitungszeit-Staffeln müssen aufsteigend sein: „Bis“ darf nicht kleiner als „Ab“ sein, und die „Ab“-Menge jeder Staffel muss größer als die „Bis“-Menge der vorigen Staffel sein."
          }
        },
        "Description": "Beschreibung",
        "DescriptionTooltip": "Wird nur auf Bestellbons angedruckt.",
        "Image": "Bild",
        "ImageForBookingMask": "Bild für die Buchungsmaske",
        "IsActive": "Aktiv",
        "CreateMultiple": "Massenerstellung",
        "Created": {
          "Title": "Artikel erstellt",
          "Description": "Der Artikel <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Artikel konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Artikel geändert",
          "Description": "Der Artikel <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Artikel konnte nicht geändert werden"
        },
        "NoPrintersWarning": {
          "Title": "Kein Drucker zugewiesen",
          "Description": "Diesem Artikel ist kein Drucker zugewiesen. Trotzdem speichern?",
          "SaveAnyway": "Trotzdem speichern"
        },
        "ErrorLoadingCommodityGroups": "Warengruppen konnten nicht geladen werden",
        "ErrorLoadingCourses": "Gänge konnten nicht geladen werden",
        "ErrorLoadingPrinters": "Drucker konnten nicht geladen werden",
        "ErrorLoadingPriceLists": "Preislisten konnten nicht geladen werden"
      },
      "Articles": {
        "SelectArticle": "Artikel auswählen"
      },
      "ArticlePackageDetail": {
        "Create": "Artikelpaket-Detail hinzufügen",
        "Edit": "Artikelpaket-Detail bearbeiten",
        "Quantities": "Mengen",
        "MinQuantity": "Minimum",
        "Suggested": "Vorgeschlagen",
        "MaxQuantity": "Maximum",
        "CourseFromArticlePackage": "Von Artikelpaket übernehmen"
      },
      "ArticlePackageGroup": {
        "Create": "Artikelpaket-Gruppe hinzufügen",
        "Edit": "Artikelpaket-Gruppe bearbeiten",
        "MinQuantity": "Minimum",
        "MaxQuantity": "Maximum",
        "Note": "Hinweis",
        "Articles": "Artikel",
        "Article": "Artikel"
      },
      "DeactivateArticle": {
        "Title": "Artikel deaktivieren",
        "Description": "Willst du den Artikel <b>{0}</b> wirklich deaktivieren?",
        "Error": "Artikel konnte nicht deaktiviert werden"
      },
      "Customer": {
        "Create": "Kunde erstellen",
        "Edit": "Kunde bearbeiten",
        "Salutation": "Anrede",
        "FirstName": "Vorname",
        "LastName": "Nachname",
        "Name": "Name",
        "Addition": "Zusatz",
        "Street": "Straße",
        "Zip": "PLZ",
        "City": "Ort",
        "Country": "Land",
        "VAT": "UID-Nummer",
        "ContactDetails": "Kontaktdaten",
        "Email": "E-Mail",
        "Phone": "Telefon",
        "Mobile": "Mobil",
        "Birthdate": "Geburtsdatum",
        "Notes": "Zusätze",
        "Remark": "Bemerkung",
        "InternalNote": "Interne Notiz",
        "Payment": "Zahlung",
        "PaymentTermDays": "Zahlungsziel (Tage)",
        "PaymentTarget": "Zahlungsziel (Hinweis)",
        "Created": {
          "Title": "Kunde erstellt",
          "Description": "Der Kunde <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Kunde konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Kunde geändert",
          "Description": "Der Kunde <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Kunde konnte nicht geändert werden"
        },
        "ErrorLoadingSalutations": "Anreden konnten nicht geladen werden",
        "ErrorLoadingCountries": "Länder konnten nicht geladen werden"
      },
      "DeactivateCustomer": {
        "Title": "Kunde deaktivieren",
        "Description": "Willst du den Kunden <b>{0}</b> wirklich deaktivieren?",
        "Error": "Kunde konnte nicht deaktiviert werden"
      },
      "DeleteMailAccount": {
        "Title": "E-Mail Konto löschen",
        "Description": "Willst du das E-Mail Konto <b>{0}</b> ({1}) wirklich löschen?",
        "Error": "E-Mail Konto konnte nicht gelöscht werden"
      },
      "DeleteMailTemplate": {
        "Title": "Vorlage löschen",
        "Description": "Willst du die Vorlage <b>{0}</b> wirklich löschen?",
        "Error": "Vorlage konnte nicht gelöscht werden"
      },
      "ResetSetting": {
        "Title": "Einstellung zurücksetzen",
        "Description": "Willst du die Einstellung <b>{0}</b> wirklich zurücksetzen?",
        "Reset": {
          "Title": "Einstellung zurückgesetzt",
          "Description": "Die Einstellung <b>{0}</b> wurde erfolgreich zurückgesetzt."
        },
        "Error": "Einstellung konnte nicht zurückgesetzt werden"
      },
      "Setting": {
        "Title": "Einstellung bearbeiten",
        "Changed": {
          "Title": "Einstellung geändert",
          "Description": "Die Einstellung <b>{0}</b> wurde erfolgreich geändert."
        },
        "Error": "Einstellung konnte nicht bearbeitet werden"
      },
      "NfcTipPrompt": {
        "NoDisplay": "Keine Anzeige",
        "Percentage": "Prozentsatz"
      },
      "Printer": {
        "Create": "Drucker erstellen",
        "Edit": "Drucker bearbeiten",
        "General": "Allgemein",
        "Redirections": "Ausnahmen",
        "AdditionalPrints": "Zusätzlicher Druck",
        "Name": "Bezeichnung",
        "CommunicationService": "Kommunikationsserver",
        "SystemPrinter": "Drucker",
        "Type": "Format",
        "Reports": {
          "Title": "Berichtzuordnung",
          "BookingsReceipt": "Bestellbon",
          "BookingsReceiptPrintCount": "Anzahl Bestellbons",
          "OrderManagerConfirmation": "Bestellmanager Bestätigung",
          "DeliveryNote": "Lieferschein",
          "BookingsCancellationReceipt": "Stornobon",
          "TableTransfer": "Tischtransfer",
          "CourseRecall": "Gangabruf",
          "ProformaInvoice": "Proforma-Rechnung",
          "Invoice": "Rechnung"
        },
        "Margin": {
          "Title": "Seitenränder anpassen",
          "Left": "Links",
          "Top": "Oben"
        },
        "If": "Wenn",
        "Then": "Dann",
        "Workstation": "Arbeitsstation",
        "User": "Benutzer",
        "Department": "Abteilung",
        "Table": "Tisch",
        "Printer": "Drucker",
        "AtLeastOneConditionRequired": "Pro Umleitung muss mindestens eine Bedingung (Arbeitsstation, Benutzer, Abteilung oder Tisch) aktiviert und ausgewählt sein.",
        "AdditionalPrintAtLeastOneConditionRequired": "Pro zusätzlichem Druck muss mindestens eine Bedingung (Arbeitsstation, Benutzer, Abteilung oder Tisch) aktiviert und ausgewählt sein.",
        "Created": {
          "Title": "Drucker erstellt",
          "Description": "Die Drucker <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Die Drucker konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Drucker geändert",
          "Description": "Die Drucker <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Drucker konnte nicht geändert werden"
        },
        "ErrorLoadingCommunicationServices": "Kommunicationsserver konnten nicht geladen werden",
        "ErrorLoadingSystemPrinters": "Drucker konnten nicht geladen werden",
        "ErrorLoadingReports": "Berichte konnten nicht geladen werden",
        "ErrorLoadingUsers": "Benutzer konnten nicht geladen werden"
      },
      "DeletePrinter": {
        "Title": "Drucker löschen",
        "Description": "Willst du den Drucker <b>{0}</b> ({1}) wirklich löschen?",
        "PrinterStillAssignedDescription": "Dem Drucker <b>{0}</b> ({1}) sind noch <b>Artikel, Arbeitsstationen oder Druckumleitungen</b> zugeordnet.<br><br>Möchtest du ihn wirklich löschen?",
        "Error": "Drucker konnte nicht gelöscht werden"
      },
      "PriceList": {
        "Create": "Preisliste erstellen",
        "Edit": "Preisliste bearbeiten",
        "Name": "Bezeichnung",
        "Created": {
          "Title": "Preisliste erstellt",
          "Description": "Die Preisliste <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Die Preisliste konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Preisliste geändert",
          "Description": "Die Preisliste <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Preisliste konnte nicht geändert werden"
        }
      },
      "DeletePriceList": {
        "Title": "Preisliste löschen",
        "Description": "Willst du die Preisliste <b>{0}</b> wirklich löschen?",
        "Error": "Preisliste konnte nicht gelöscht werden"
      },
      "Promotion": {
        "Create": "Aktion erstellen",
        "Edit": "Aktion bearbeiten",
        "General": "Allgemein",
        "TableScope": "Abteilungen & Tische",
        "ArticleScope": "Umsatz-, Warengruppen & Artikel",
        "Name": "Bezeichnung",
        "Priority": "Priorität",
        "DateFrom": "Datum von",
        "DateTo": "Datum bis",
        "AllDay": "Ganztags",
        "TimeFrom": "Uhrzeit von",
        "TimeTo": "Uhrzeit bis",
        "Weekdays": "Wochentage",
        "WeekdaysRequired": "Mindestens ein Wochentag muss ausgewählt sein.",
        "Departments": "Abteilungen",
        "Tables": "Tische",
        "TableScopeRequired": "Mindestens eine Abteilung oder ein Tisch muss ausgewählt sein.",
        "RevenueGroups": "Umsatzgruppen",
        "CommodityGroups": "Warengruppen",
        "Articles": "Artikel",
        "ArticleScopeRequired": "Mindestens eine Umsatzgruppe, Warengruppe oder ein Artikel muss ausgewählt sein.",
        "PriceMode": {
          "Title": "Preismodus",
          "Pricelist": "Preisliste",
          "Discount": "Ermäßigung",
          "PriceOverride": "Preistyp",
          "Price": "Preis"
        },
        "PriceTypes": {
          "Add": "Addieren",
          "Fixed": "Fixer Betrag"
        },
        "ErrorLoadingPriceLists": "Preislisten konnten nicht geladen werden",
        "ErrorLoadingDepartments": "Abteilungen konnten nicht geladen werden",
        "ErrorLoadingTables": "Tische konnten nicht geladen werden",
        "ErrorLoadingRevenueGroups": "Umsatzgruppen konnten nicht geladen werden",
        "ErrorLoadingCommodityGroups": "Warengruppen konnten nicht geladen werden",
        "ErrorLoadingArticles": "Artikel konnten nicht geladen werden",
        "Created": {
          "Title": "Aktion erstellt",
          "Description": "Die Aktion <b>{0}</b> wurde erfolgreich erstellt.",
          "Error": "Aktion konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Aktion geändert",
          "Description": "Die Aktion <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Aktion konnte nicht geändert werden"
        }
      },
      "DeactivatePromotion": {
        "Title": "Aktion deaktivieren",
        "Description": "Willst du die Aktion <b>{0}</b> wirklich deaktivieren?",
        "Error": "Aktion konnte nicht deaktiviert werden"
      },
      "UnlinkLicense": {
        "Title": "Lizenz freigeben",
        "Description": "Willst du die Lizenz der Arbeitsstation <b>{0}</b> wirklich freigeben?",
        "Unlink": "Lizenz freigeben",
        "Unlinked": {
          "Title": "Lizenz freigegeben",
          "Description": "Die Lizenz für die Arbeitsstation <b>{0}</b> wurde erfolgreich freigegeben.",
          "Error": "Lizenz konnte nicht freigegeben werden"
        }
      },
      "DisconnectMobileDevice": {
        "Title": "Gerät trennen",
        "Description": "Willst du das gekoppelte Gerät der Arbeitsstation <b>{0}</b> wirklich trennen? Das Gerät wird getrennt und kann sich danach mit dem QR-Code neu verbinden.",
        "Disconnect": "Trennen",
        "Disconnected": {
          "Title": "Gerät getrennt",
          "Description": "Die Trennung des Geräts für die Arbeitsstation <b>{0}</b> wurde ausgelöst.",
          "Error": "Gerät konnte nicht getrennt werden"
        }
      },
      "RemoveLicencesAndBackups": {
        "Title": "Lizenzen & Datensicherungen löschen",
        "Description": "Willst du wirklich <b>alle Lizenzen und Datensicherungen</b> vom Standort <b>{0}</b> des Betriebes <b>{1}</b> löschen?",
        "Remove": "Löschen",
        "Error": "Lizenzen & Datensicherungen konnten nicht gelöscht werden",
        "Success": {
          "Title": "Lizenzen & Datensicherungen gelöscht",
          "Description": "Die Lizenzen & Datensicherungen vom Standort <b>{0}</b> des Betriebes <b>{1}</b> wurden erfolgreich gelöscht."
        }
      },
      "DeleteLiveData": {
        "Title": "Live-Daten löschen",
        "DateDescription": "Möchtest du die Live-Daten ab <b>{0}</b> wirklich löschen?",
        "Description": "<b>Achtung!</b> Beim Löschen der Live-Daten werden alle Umsatzdaten, Rechnungen und digitalen Belege unwiderruflich gelöscht.",
        "Deleted": {
          "Title": "Live-Daten löschen angestoßen",
          "Description": "Das Löschen der Live-Daten wurde erfolgreich angestoßen!"
        },
        "DigitalReceiptsError": {
          "Title": "Digitale Belege nicht gelöscht",
          "Description": "Die Live-Daten werden gelöscht, die digitalen Belege konnten aber nicht entfernt werden."
        },
        "Error": "Live-Daten konnte nicht gelöscht werden"
      },
      "RKSV": {
        "Title": "RKSV 2017 einrichten",
        "ParticipantId": "Teilnehmer-Identifikation",
        "UserId": "Benutzer-Identifikation",
        "PIN": "PIN",
        "VatId": "UID-Nummer",
        "TaxNumber": "Steuernummer",
        "Setup": "Einrichten",
        "SuccessSettingUp": {
          "Title": "RKSV 2017 eingerichtet",
          "Description": "RKSV 2017 wurde erfolgreich eingerichtet!"
        },
        "ErrorSettingUp": "RKSV konnte nicht eingerichtet werden"
      },
      "DeactivateRKSV": {
        "Title": "RKSV 2017 deaktivieren",
        "Description": "<b>Achtung!</b> Beim Deaktivieren der RKSV 2017 wird ein Schlussbeleg erstellt und automatisch an deine hinterlegten FinanzOnline Daten des Registrierkassen-Webservice Benutzers gesendet.",
        "Deactivated": {
          "Title": "RKSV 2017 deaktiviert",
          "Description": "RKSV 2017 wurde erfolgreich deaktiviert!"
        },
        "Error": "RKSV 2017 konnte nicht deaktiviert werden"
      },
      "DeactivateTSE": {
        "Title": "TSE deaktivieren",
        "Description": "<b>Achtung!</b> Wenn die TSE deaktiviert wird, werden deine Rechnungen nicht mehr gesetzeskonform signiert.",
        "Deactivated": {
          "Title": "TSE deaktiviert",
          "Description": "TSE wurde erfolgreich deaktiviert!"
        },
        "Error": "TSE konnte nicht deaktiviert werden"
      },
      "FinancialAccount": {
        "Create": "Finanzkonto erstellen",
        "Edit": "Finanzkonto bearbeiten",
        "AccountNumber": "Kontonummer",
        "AccountName": "Kontoname",
        "CostCenter": "Kostenstelle",
        "BookingSymbol": "Buchungssymbol",
        "ExternalTaxCode": "Externer Steuercode",
        "OutputType": "Ausgabetyp",
        "Created": {
          "Title": "Finanzkonto erstellt",
          "Description": "Das Finanzkonto <b>{0} ({1})</b> wurde erfolgreich erstellt.",
          "Error": "Finanzkonto konnte nicht erstellt werden"
        },
        "Changed": {
          "Title": "Finanzkonto geändert",
          "Description": "Das Finanzkonto <b>{0} ({1})</b> wurde erfolgreich geändert.",
          "Error": "Finanzkonto konnte nicht geändert werden"
        }
      },
      "DeactivateFinancialAccount": {
        "Title": "Finanzkonto deaktivieren",
        "Description": "Willst du das Finanzkonto <b>{0} ({1})</b> wirklich deaktivieren?",
        "MappingsWarningOne": "Diesem Konto ist noch <b>1 Zuordnung</b> zugewiesen. Nach dem Deaktivieren fehlen deren Beträge im BMD-/DATEV-Export.",
        "MappingsWarningMany": "Diesem Konto sind noch <b>{0} Zuordnungen</b> zugewiesen. Nach dem Deaktivieren fehlen deren Beträge im BMD-/DATEV-Export.",
        "Error": "Finanzkonto konnte nicht deaktiviert werden"
      },
      "ExportWarnings": {
        "Title": "Warnungen zum Export",
        "Description": "Im Zeitraum <b>{0} – {1}</b> fehlen folgende Beträge im Export:",
        "CheckFailed": "Die Prüfung auf fehlende Finanzkontozuordnungen konnte nicht durchgeführt werden. Du kannst trotzdem exportieren.",
        "InactiveFinancialAccountsTitle": "Deaktivierte Finanzkonten",
        "MissingMappingsTitle": "Fehlende Finanzkontozuordnungen",
        "InactiveFinancialAccount": "ist dem deaktivierten Finanzkonto {0} ({1}) zugeordnet",
        "MissingMapping": "hat keine Finanzkontozuordnung",
        "InactiveSubjectInactiveFinancialAccount": "ist deaktiviert und dem deaktivierten Finanzkonto {0} ({1}) zugeordnet",
        "InactiveSubjectMissingMapping": "ist deaktiviert und hat keine Finanzkontozuordnung",
        "InactiveSubjectsHint": "Deaktivierte Einträge zeigt die Zuordnung erst an, wenn du sie in den Stammdaten wieder aktivierst.",
        "CommodityGroup": "Warengruppe {0} (MwSt {1}%)",
        "UnknownCommodityGroup": "Unbekannte Warengruppe (MwSt {0}%)",
        "UnknownCommodityGroupWithSample": "Unbekannte Warengruppe, z. B. „{0}“ (MwSt {1}%)",
        "PaymentMethod": "Zahlungsmethode {0}",
        "UnknownPaymentMethod": "Unbekannte Zahlungsmethode",
        "Effort": "Aufwand {0}",
        "UnknownEffort": "Unbekannter Aufwand",
        "BookingsOne": "{0} Buchung",
        "BookingsMany": "{0} Buchungen",
        "PaymentsOne": "{0} Zahlung",
        "PaymentsMany": "{0} Zahlungen",
        "InvoicesOne": "{0} Rechnung",
        "InvoicesMany": "{0} Rechnungen",
        "ExportAnyway": "Trotzdem exportieren"
      },
      "FinancialAccountMapping": {
        "Title": "Zuordnung ändern",
        "PaymentMethod": "Zahlungsart",
        "CommodityGroup": "Warengruppe",
        "Effort": "Aufwand",
        "FinancialAccount": "Finanzkonto",
        "ErrorLoadingFinancialAccounts": "Finanzkonten konnten nicht geladen werden",
        "ChangePaymentMethod": {
          "Success": {
            "Title": "Zuweisung geändert",
            "Description": "Die Zuweisung für die Zahlungsmethode <b>{0}</b> wurde geändert."
          },
          "Error": "Zuweisung konnte nicht aktiviert werden"
        },
        "ChangeCommodityGroup": {
          "Success": {
            "Title": "Zuweisung geändert",
            "Description": "Die Zuweisung für die Warengruppe <b>{0}</b> wurde geändert."
          },
          "Error": "Zuweisung konnte nicht aktiviert werden"
        },
        "ChangeEffort": {
          "Success": {
            "Title": "Zuweisung geändert",
            "Description": "Die Zuweisung für den Aufwand <b>{0}</b> wurde geändert."
          },
          "Error": "Zuweisung konnte nicht aktiviert werden"
        }
      },
      "CloseDays": {
        "Title": "Tag(e) abschließen",
        "Description": "Willst du den Tagesabschluss bis zum <b>{0}</b> wirklich durchführen?",
        "Success": {
          "Title": "Tage abgeschlossen",
          "Description": "Der Tagesabschschluss wurde bis zum <b>{0}</b> durchgeführt."
        },
        "Error": "Tagesabschluss konnte nicht durchgeführt werden"
      },
      "UndoDailyClosings": {
        "Title": "Tagesabschluss rückgängig machen",
        "Description": "Willst du den Tagesabschluss bis zum <b>{0}</b> wirklich rückgängig machen?",
        "Success": {
          "Title": "Tagesabschluss rückgängig gemacht",
          "Description": "Der Tagesabschschluss wurde bis zum <b>{0}</b> rückgängig gemacht."
        },
        "Error": "Tagesabschluss konnte nicht rückgängig gemacht werden"
      },
      "SendSalesToPMS": {
        "Title": "Umsätze an PMS senden",
        "Description": "Willst du die Umsätze vom <b>{0}</b> wirklich ans das PMS senden?",
        "Success": {
          "Title": "Umsätze gesendet",
          "Description": "Die Umsätze vom <b>{0}</b> wurden an das PMS gesendet."
        },
        "Error": "Umsätze konnten nicht gesendet werden"
      },
      "TableLayout": {
        "Text": {
          "Create": "Text erstellen",
          "Edit": "Text bearbeiten",
          "Text": "Text",
          "FontSize": "Schriftgröße",
          "TextColor": "Schriftfarbe"
        },
        "Shape": {
          "Edit": "Form bearbeiten",
          "TableShape": "Tischform",
          "Color": "Farbe",
          "Width": "Breite",
          "Height": "Höhe",
          "Rotation": "Rotation"
        },
        "Size": {
          "Width": "Breite",
          "Height": "Höhe"
        },
        "Color": {
          "Background": "Hintergrund",
          "Text": "Schrift"
        },
        "SaveLayout": {
          "Title": "Abteilungs- & Tischdesigner speichern",
          "Description": "Soll der geänderte Abteilungs- & Tischdesigner gespeichert werden?",
          "ConflictTitle": "Achtung! Folgende Einträge wurden zwischenzeitlich von jemand anderem geändert. Wenn du speicherst, überschreibst du diese Änderungen:",
          "SaveAnyway": "Trotzdem speichern"
        }
      },
      "ArticleLayout": {
        "SaveLayout": {
          "Title": "Buchungsmaske speichern",
          "Description": "Soll die geänderte Buchungsmaske gespeichert werden?",
          "ConflictTitle": "Achtung! Folgende Einträge wurden zwischenzeitlich von jemand anderem geändert. Wenn du speicherst, überschreibst du diese Änderungen:",
          "SaveAnyway": "Trotzdem speichern"
        },
        "LayoutMainGroup": {
          "Create": "Hauptgruppe erstellen",
          "Edit": "Hauptgruppe \"{0}\" bearbeiten",
          "Name": "Bezeichnung",
          "ShortNameMobile": "Kürzel Mobil",
          "CreateMultiple": "Massenerstellung"
        },
        "LayoutSubGroup": {
          "Create": "Untergruppe erstellen",
          "Edit": "Untergruppe \"{0}\" bearbeiten",
          "Name": "Bezeichnung",
          "ShortNameMobile": "Kürzel Mobil",
          "Rows": "Reihen",
          "Columns": "Spalten",
          "ArticlePositionFontSize": "Schriftgröße Artikelpositionen",
          "ArticlePositionFontSizes": {
            "Small": "Klein",
            "Medium": "Mittel",
            "Large": "Groß"
          },
          "Preview": "Vorschau",
          "Slots": "Plätze",
          "IsActive": "Aktiv",
          "IndicatorColor": "Indikatorfarbe",
          "ResetIndicatorColor": "Auf Standard zurücksetzen",
          "OnlineDescription": "Beschreibung Gastbestellung",
          "CreateMultiple": "Massenerstellung"
        }
      },
      "ArticleAddon": {
        "Edit": "Folgeposition ändern",
        "Sequence": "Abfrage"
      },
      "ArticleAddons": {
        "Edit": "Folgepositionen zuordnen",
        "NotAssigned": "Nicht zugeordnet",
        "Assigned": "Zugeordnet",
        "Sequence": "Abfrage",
        "Position": "{0} Position",
        "Positions": "{0} Positionen",
        "Changed": {
          "Title": "Folgepositionen zugeordnet",
          "Description": "Die Folgepositionen für den Artikel <b>{0}</b> wurden erfolgreich zugeordnet.",
          "Error": "Folgepositionen konnten nicht zugeordnet werden"
        }
      },
      "CashJournalTransaction": {
        "RevenueTitle": "Einnahme hinzufügen",
        "ExpenseTitle": "Ausgabe hinzufügen",
        "EditExpenseTitle": "Ausgabe bearbeiten",
        "EditRevenueTitle": "Einnahme bearbeiten",
        "Date": "Datum",
        "Template": "Vorlage",
        "Amount": "Betrag",
        "Tax": "Steuer",
        "TaxAmount": "Steuerbetrag",
        "Preview": "Kassenstand Vorschau",
        "Add": "Hinzufügen"
      },
      "Template": {
        "CreateTitle": "Vorlage erstellen",
        "EditTitle": "Vorlage bearbeiten",
        "Type": "Typ",
        "Description": "Bezeichnung",
        "Tax": "Steuer",
        "Revenue": "Einnahme",
        "Expense": "Ausgabe"
      },
      "PaymentTerminal": {
        "Create": "Zahlungsterminal erstellen",
        "Edit": "Zahlungsterminal bearbeiten",
        "Name": "Bezeichnung",
        "IPAddress": "IP-Adresse",
        "Port": "Port",
        "ActiveWorkstations": "Zahlungsterminal aktiv auf folgender Arbeitsstation",
        "ActivePaymentMethods": "Zahlungsterminal aktiv bei folgenden Zahlungsarten",
        "ProcessTip": "Trinkgeld beim Terminal explizit abfragen",
        "ProcessTipInfo": "Manche Terminals benötigen diese Option, damit die Trinkgeld-Abfrage am Terminal erscheint. Bei anderen übernimmt das der Terminal-Hersteller selbst – dann ist die Option nicht nötig. Ein am Terminal eingegebenes Trinkgeld wird in beiden Fällen berücksichtigt.",
        "Created": {
          "Title": "Zahlungsterminal erstellt",
          "Description": "Zahlungsterminal wurde erfolgreich hinzugefügt.",
          "Error": "Fehler beim Hinzufügen des Zahlungsterminals"
        },
        "Changed": {
          "Title": "Zahlungsterminal bearbeitet",
          "Description": "Zahlungsterminal wurde erfolgreich bearbeitet.",
          "Error": "Fehler beim Bearbeiten des Zahlungsterminals"
        }
      },
      "DeactivatePaymentTerminal": {
        "Title": "Zahlungsterminal deaktivieren",
        "Description": "Willst du das Zahlungsterminal <b>{0} </b> wirklich deaktivieren?",
        "Error": "Zahlungsterminal konnte nicht deaktiviert werden",
        "Success": "Zahlungterminal wurde erfolgreich deaktiviert"
      },
      "COMPort": {
        "Title": "COM-Port zuweisen",
        "COMPort": "COM-Port",
        "Assign": "Zuweisen"
      },
      "StartCashJournal": {
        "Title": "Kassenbuch eröffnen",
        "Start": "Eröffnen",
        "Date": "Startdatum",
        "Amount": "Startsaldo",
        "Success": {
          "Title": "Kassenbuch eröffnet",
          "Description": "Das Kassenbuch wurde erfolgreich eröffnet."
        },
        "Error": "Kassenbuch konnte nicht eröffnet werden"
      },
      "AsaSoapSetting": {
        "Title": "Einstellung ändern",
        "Changed": {
          "Title": "Einstellung geändert",
          "Description": "Die Einstellung <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Einstellung konnte nicht geändert werden"
        }
      },
      "PreOrder": {
        "RequireTable": "Tischzwang",
        "LayoutProfile": "Layoutgruppe",
        "PersonTypes": "Personentypen",
        "PersonTypePlaceholder": "Bezeichnung, z. B. Erwachsene",
        "AddPersonType": "Personentyp",
        "NoPersonTypes": "Es sind keine Personentypen angelegt.",
        "MaxPersonTypes": "Es sind maximal {0} Personentypen möglich.",
        "PersonTypeCount": "{0} Personentypen",
        "PersonTypeWithoutName": "Jeder Personentyp braucht eine Bezeichnung."
      },
      "DailyAccountingPrinterSetting": {
        "Hint": "5 Minuten nach dem Tageswechsel für Statistik druckt die Kasse die Tagesabrechnung des beendeten Tages auf diesem Drucker. War die Kasse zu der Zeit aus, wird beim nächsten Start nachgedruckt. \"-\" = kein automatischer Druck."
      },
        "ScaleSetting": {
          "Title": "Einstellung ändern",
          "Changed": {
            "Title": "Einstellung geändert",
            "Description": "Die Einstellung <b>{0}</b> wurde erfolgreich geändert.",
            "Error": "Einstellung konnte nicht geändert werden"
          }
        },
      "LippPmsSetting": {
        "Title": "Einstellung ändern",
        "Changed": {
          "Title": "Einstellung geändert",
          "Description": "Die Einstellung <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Einstellung konnte nicht geändert werden"
        }
      },
      "BookInSetting": {
        "Title": "Einstellung ändern",
        "Changed": {
          "Title": "Einstellung geändert",
          "Description": "Die Einstellung <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Einstellung konnte nicht geändert werden"
        }
      },
      "ApaleoSetting": {
        "Title": "Einstellung ändern",
        "SecretUnchanged": "Hinterlegt – leer lassen, um es beizubehalten",
        "Changed": {
          "Title": "Einstellung geändert",
          "Description": "Die Einstellung <b>{0}</b> wurde erfolgreich geändert.",
          "Error": "Einstellung konnte nicht geändert werden"
        }
      }
    },
    "OnlineStatus": {
      "Online": "Live-Daten",
      "Offline": "Offline",
      "LastSyncOn": "Daten wurden zuletzt synchronisiert am {0} um {1}",
      "Error": "Online-Status konnte nicht geladen werden"
    },
    "SyncStatus": {
      "TransFullActive": "Transaktionsdaten werden synchronisiert ({0} %)",
      "TransFullActiveWithoutTotal": "Transaktionsdaten werden synchronisiert ({0} Tabelle(n) übertragen)",
      "TransFullPending": "Transaktionsdaten werden in Kürze synchronisiert",
      "FiscalFullActive": "Fiskaldaten werden synchronisiert ({0}/{1})",
      "FiscalFullActiveWithoutTotal": "Fiskaldaten werden synchronisiert ({0} Tabelle(n) übertragen)",
      "FiscalFullPending": "Fiskaldaten werden in Kürze synchronisiert",
      "TableProgress": "<b>{0}</b> {1} von {2}",
      "TableCompleted": "<b>{0}</b> ✓ ({1})",
      "TableEmpty": "<b>{0}</b> -",
      "Tables": {
        "Booking": "Buchungen",
        "Invoice": "Rechnungen",
        "DeliveryNote": "Lieferscheine",
        "InvoicePayment": "Zahlungen",
        "InvoiceCardPayment": "Kartenzahlungen",
        "ATRKSVDEP": "RKSV-Signaturen",
        "DETSETransaction": "TSE-Transaktionen",
        "PMSTransfer": "PMS-Übertragungen"
      }
    },
    "Syncing": {
      "Title": "Stammdaten werden synchronisiert",
      "Description": "Die Stammdaten dieses Standortes werden gerade in die Cloud übertragen. Bitte warten, bis der Vorgang abgeschlossen ist.",
      "Progress": "{0} von {1} Tabellen übertragen",
      "ProgressWithoutTotal": "{0} Tabelle(n) übertragen",
      "PowerHint": "Falls die Kassa ausgeschaltet ist, bitte einschalten und eingeschaltet lassen, damit die Synchronisation fertig durchlaufen kann."
    },
    "AsaSoap": {
      "Title": "ASA-SOAP",
      "CommunicationService": {
        "Title": "Kommunikationsserver",
        "ErrorLoadingCommunicationServices": "Kommunikationsserver konnten nicht geladen werden",
        "ErrorLoadingSelectedCommunicationService": "Ausgewählter Kommunikationsserver konnte nicht geladen werden",
        "Changed": {
          "Success": {
            "Title": "Kommunikationsserver ausgewählt",
            "Description": "Der Kommunikationsserver <b>{0}</b> wurde erfolgreich ausgewählt."
          },
          "Error": "Kommunikationsserver konnte nicht ausgewählt werden"
        }
      },
      "Settings": {
        "Title": "Einstellungen",
        "Name": "Bezeichnung",
        "Value": "Wert",
        "Identifiers": {
          "ASASOAP_URL": "Service-URL",
          "ASASOAP_USERNAME": "Benutzername",
          "ASASOAP_PASSWORD": "Passwort",
          "ASASOAP_SYSTEMID": "System-ID",
          "INVOICECARRIERFORGUESTS": "PMS Rechnungsträger automatisch erstellen",
          "SENDDAILYREVENUEAUTOMATIC": "Tagesumsätze automatisch senden",
          "SENDDAILYREVENUESTARTDATE": "Tagesumsätze automatisch senden - Startdatum",
          "SENDDAILYREVENUETIME": "Tagesumsätze automatisch senden - Uhrzeit"
        },
        "InvoiceCarrierOptions": {
          "0": "Nein",
          "1": "Ja - PMS Zimmernummer = Lipp POS Tischnummer",
          "2": "Ja - PMS Tischnummer = Lipp POS Tischnummer"
        }
      }
    },
      "Scale": {
        "Title": "Waage",
        "CommunicationService": {
          "Title": "Kommunikationsserver",
          "Hint": "Die Waage hängt am Rechner dieses Kommunikationsservers — der COM-Port gilt genau dort. Eine zweite Theke ist eine zweite Installation mit eigener Waage.",
          "ErrorLoadingCommunicationServices": "Kommunikationsserver konnten nicht geladen werden",
          "ErrorLoadingSelectedCommunicationService": "Ausgewählter Kommunikationsserver konnte nicht geladen werden",
          "Changed": {
            "Success": {
              "Title": "Kommunikationsserver ausgewählt",
              "Description": "Der Kommunikationsserver <b>{0}</b> wurde erfolgreich ausgewählt."
            },
            "Error": "Kommunikationsserver konnte nicht ausgewählt werden"
          }
        },
        "Settings": {
          "Title": "Einstellungen",
          "Name": "Bezeichnung",
          "Value": "Wert",
          "MissingSerialNo": "Ohne Seriennummer startet die Schnittstelle nicht, auch wenn sie aktiv geschaltet ist: Eine Wägung ließe sich sonst keinem geeichten Gerät zuordnen.",
          "Placeholders": {
            "SCALE_SERIALNO": "Seriennummer vom Typenschild der Waage"
          },
          "Identifiers": {
            "SCALE_COMMANDSETVERSION": "Befehlssatz",
            "SCALE_CHECKSUMUSERANDOM": "Prüfsumme mit Zufallszahl verwürfeln",
            "SCALE_SENDARTICLETEXT": "Artikeltext an die Waage senden",
            "SCALE_BASEPRICEDIGITS": "Stellen des Grundpreisfelds",
            "SCALE_RECEIVEWEIGHTDECIMALS": "Nachkommastellen des empfangenen Gewichts",
            "SCALE_SERIALNO": "Seriennummer der Waage",
            "SCALE_TIMEOUTMS": "Zeitschranke je Antwort (ms)",
            "SCALE_RETRYCOUNT": "Wiederholungen nach einer Ablehnung",
            "SCALE_POLLINTERVALMS": "Abstand erneuter Gewichtsabfragen (ms)",
            "SCALE_PROTOCOLLEVEL": "Protokollierung",
            "SCALE_CONNECTIONTYPE": "Verbindungsart",
            "SCALE_IPADDRESS": "IP-Adresse",
            "SCALE_PORT": "Netzwerk-Port",
            "COMPORT": "COM-Port",
            "SCALE_BAUDRATE": "Baudrate",
            "SCALE_PARITY": "Parität",
            "SCALE_DATABITS": "Datenbits",
            "SCALE_STOPBITS": "Stoppbits",
            "SCALE_HANDSHAKE": "Datenflusssteuerung",
            "SCALE_RTSENABLE": "RTS-Leitung setzen",
            "SCALE_DTRENABLE": "DTR-Leitung setzen",
            "SCALE_ENCODINGCODEPAGE": "Zeichensatz (Codepage)"
          },
          "Hints": {
            "SCALE_COMMANDSETVERSION": "Befehlssatz 1 ist das dokumentierte Protokoll der Mettler-Toledo Ariva. Befehlssatz 2 nimmt die Bizerba-Erweiterung dazu, mit der die Waage auch ihre eigene Tara meldet — nur bei Waagen, die das können.",
            "SCALE_CHECKSUMUSERANDOM": "Die Waage fordert die Prüfsumme der eichrelevanten Kassensoftware an und verwürfelt sie dabei mit einer Zufallszahl. Einzelne Geräte (Digi DS782) verlangen den Weg ohne Zufallszahl.",
            "SCALE_SENDARTICLETEXT": "Übergibt den Artikelnamen an die Waage, damit er in ihrer Anzeige steht. Die Waage übernimmt 13 Zeichen.",
            "SCALE_BASEPRICEDIGITS": "Breite des Preisfelds im Telegramm. Passt der Grundpreis nicht hinein, wird die Wägung abgelehnt, statt einen abgeschnittenen Preis zu buchen.",
            "SCALE_RECEIVEWEIGHTDECIMALS": "Nur bei Befehlssatz 2: Nachkommastellen des Gewichts in Kilogramm, meist 3 — also ganze Gramm. Bei Befehlssatz 1 meldet die Waage die Stellen selbst. Preise laufen immer mit 2 Nachkommastellen je Kilogramm; die Waage muss so eingestellt sein.",
            "SCALE_SERIALNO": "Steht im Waagenprotokoll jeder Wägung und weist das geeichte Gerät aus. Pflichtfeld: Ohne Seriennummer startet die Schnittstelle nicht.",
            "SCALE_TIMEOUTMS": "Wie lange die Kassa auf eine Antwort wartet, bevor sie die Wägung abbricht. Wird auf 2500 bis 10000 ms begrenzt.",
            "SCALE_RETRYCOUNT": "Wie oft dasselbe Telegramm wiederholt wird, wenn die Waage es ablehnt. Danach fragt die Kassa deren Statusmeldung ab und zeigt den Grund.",
            "SCALE_POLLINTERVALMS": "Wartezeit, bis erneut nach dem Gewicht gefragt wird, solange die Waage noch in Bewegung ist oder nichts aufliegt.",
            "SCALE_PROTOCOLLEVEL": "Auf der höchsten Stufe schreibt die Kassa jedes Telegramm in beide Richtungen ins Log. Für die Fehlersuche gedacht, nicht für den Dauerbetrieb.",
            "SCALE_CONNECTIONTYPE": "Seriell ist der Normalfall. Netzwerk ist für einen seriellen Netzwerkadapter gedacht, wenn die Waage nicht neben dem Rechner steht.",
            "SCALE_IPADDRESS": "Nur bei Verbindungsart Netzwerk: Adresse des seriellen Netzwerkadapters.",
            "SCALE_PORT": "Nur bei Verbindungsart Netzwerk: Port des seriellen Netzwerkadapters.",
            "COMPORT": "Nummer des seriellen Anschlusses am Rechner des oben gewählten Kommunikationsservers.",
            "SCALE_BAUDRATE": "Muss mit der Einstellung an der Waage übereinstimmen. Vorgabe der Ariva ist 9600.",
            "SCALE_PARITY": "Muss mit der Einstellung an der Waage übereinstimmen. Vorgabe der Ariva ist ungerade.",
            "SCALE_DATABITS": "Muss mit der Einstellung an der Waage übereinstimmen. Vorgabe der Ariva ist 7.",
            "SCALE_STOPBITS": "Muss mit der Einstellung an der Waage übereinstimmen. Vorgabe der Ariva ist 1.",
            "SCALE_HANDSHAKE": "Vorgabe ist keine. Nur ändern, wenn die Waage es ausdruecklich verlangt.",
            "SCALE_RTSENABLE": "Setzt die RTS-Leitung des seriellen Anschlusses. Nur für Kabel, die ihre Versorgung daraus ziehen.",
            "SCALE_DTRENABLE": "Setzt die DTR-Leitung des seriellen Anschlusses. Nur für Kabel, die ihre Versorgung daraus ziehen.",
            "SCALE_ENCODINGCODEPAGE": "Zeichensatz der Telegramme. Vorgabe 28591 (Latin-1) hält Umlaute im Artikeltext zusammen."
          },
          "Options": {
            "SCALE_COMMANDSETVERSION": {
              "1": "1 — Dialog 06 (Mettler-Toledo)",
              "2": "2 — mit Bizerba-Erweiterung"
            },
            "SCALE_PROTOCOLLEVEL": {
              "1": "Nur Fehler",
              "3": "Alle Telegramme (Fehlersuche)"
            },
            "SCALE_CONNECTIONTYPE": {
              "Serial": "Seriell (COM)",
              "Tcp": "Netzwerk (seriell über TCP)"
            },
            "SCALE_PARITY": {
              "None": "keine",
              "Odd": "ungerade",
              "Even": "gerade"
            },
            "SCALE_STOPBITS": {
              "One": "1",
              "Two": "2"
            },
            "SCALE_HANDSHAKE": {
              "None": "keine",
              "XOnXOff": "XON/XOFF",
              "RequestToSend": "RTS/CTS",
              "RequestToSendXOnXOff": "RTS/CTS und XON/XOFF"
            }
          }
        }
      },
    "LippPms": {
      "Title": "Lipp PMS",
      "CommunicationService": {
        "Title": "Kommunikationsserver",
        "ErrorLoadingCommunicationServices": "Kommunikationsserver konnten nicht geladen werden",
        "ErrorLoadingSelectedCommunicationService": "Ausgewählter Kommunikationsserver konnte nicht geladen werden",
        "Changed": {
          "Success": {
            "Title": "Kommunikationsserver ausgewählt",
            "Description": "Der Kommunikationsserver <b>{0}</b> wurde erfolgreich ausgewählt."
          },
          "Error": "Kommunikationsserver konnte nicht ausgewählt werden"
        }
      },
      "Settings": {
        "Title": "Einstellungen",
        "Name": "Bezeichnung",
        "Value": "Wert",
        "Identifiers": {
          "LIPPPMS_URL": "Adresse des Lipp PMS",
          "LIPPPMS_WORKSTATIONID": "Arbeitsstation für Zimmerbuchungen aus dem PMS",
          "LIPPPMS_USERID": "Benutzer für Zimmerbuchungen aus dem PMS",
          "SENDDAILYREVENUEAUTOMATIC": "Tagesumsätze automatisch senden",
          "SENDDAILYREVENUESTARTDATE": "Tagesumsätze automatisch senden - Startdatum",
          "SENDDAILYREVENUETIME": "Tagesumsätze automatisch senden - Uhrzeit"
        },
        "Automatic": "automatisch",
        "AutomaticPlaceholder": "leer = automatisch",
        "Hints": {
          "LIPPPMS_URL": "Für alle Betriebe gleich: https://pms-api.lipp.cloud. Den Betrieb erkennt das PMS an der Kassa selbst. Ab Lipp POS 1.38.0 nimmt die Kassa die Adresse von allein.",
          "LIPPPMS_URL_AUTOMATIC": "Leer lassen, die Kassa nimmt die Adresse selbst. Eintragen nur zum Testen gegen ein anderes PMS.",
          "LIPPPMS_WORKSTATIONID": "Löst die Rezeption im Hotelprogramm „Auf Zimmer buchen“ aus, ist an der Kassa niemand angemeldet. Unter dieser Arbeitsstation wird die Rechnung erstellt und signiert — sie bestimmt Kassenkennung und Belegnummernkreis.",
          "LIPPPMS_USERID": "Dieser Benutzer steht auf Rechnungen, die aus dem Hotelprogramm ausgelöst wurden. Empfohlen ist ein eigener Benutzer wie „Rezeption“, damit im Beleg erkennbar bleibt, wer gebucht hat."
        }
      }
    },
    "BookIn": {
      "Title": "book-in",
      "CommunicationService": {
        "Title": "Kommunikationsserver",
        "ErrorLoadingCommunicationServices": "Kommunikationsserver konnten nicht geladen werden",
        "ErrorLoadingSelectedCommunicationService": "Ausgewählter Kommunikationsserver konnte nicht geladen werden",
        "Changed": {
          "Success": {
            "Title": "Kommunikationsserver ausgewählt",
            "Description": "Der Kommunikationsserver <b>{0}</b> wurde erfolgreich ausgewählt."
          },
          "Error": "Kommunikationsserver konnte nicht ausgewählt werden"
        }
      },
      "Settings": {
        "Title": "Einstellungen",
        "Name": "Bezeichnung",
        "Value": "Wert",
        "Identifiers": {
          "BOOKIN_URL": "Adresse der Schnittstelle",
          "BOOKIN_HOTELID": "Hotel-ID",
          "BOOKIN_COMPANYCODE": "Company-Code",
          "INVOICECARRIERFORGUESTS": "PMS Rechnungsträger automatisch erstellen"
        },
        "InvoiceCarrierOptions": {
          "0": "Nein",
          "1": "Ja - PMS Zimmernummer = Lipp POS Tischnummer",
          "2": "Ja - PMS Tischnummer = Lipp POS Tischnummer"
        },
        "Hints": {
          "BOOKIN_URL": "Basisadresse ohne Hotel-ID, z. B. https://server02.book-in.eu/pos/hotelmaestro",
          "BOOKIN_HOTELID": "Hotel-ID des Betriebs bei book-in",
          "BOOKIN_COMPANYCODE": "Zugangscode von book-in – vertraulich"
        }
      }
    },
    "Apaleo": {
      "Title": "Apaleo",
      "CommunicationService": {
        "Title": "Kommunikationsserver",
        "ErrorLoadingCommunicationServices": "Kommunikationsserver konnten nicht geladen werden",
        "ErrorLoadingSelectedCommunicationService": "Ausgewählter Kommunikationsserver konnte nicht geladen werden",
        "Changed": {
          "Success": {
            "Title": "Kommunikationsserver ausgewählt",
            "Description": "Der Kommunikationsserver <b>{0}</b> wurde erfolgreich ausgewählt."
          },
          "Error": "Kommunikationsserver konnte nicht ausgewählt werden"
        }
      },
      "Settings": {
        "Title": "Einstellungen",
        "Name": "Bezeichnung",
        "Value": "Wert",
        "Identifiers": {
          "APALEO_CLIENTID": "Client-ID",
          "APALEO_CLIENTSECRET": "Client-Secret",
          "APALEO_PROPERTYID": "Property-ID (Hotel)",
          "INVOICECARRIERFORGUESTS": "PMS Rechnungsträger automatisch erstellen"
        },
        "InvoiceCarrierOptions": {
          "0": "Nein",
          "1": "Ja - PMS Zimmernummer = Lipp POS Tischnummer",
          "2": "Ja - PMS Tischnummer = Lipp POS Tischnummer"
        },
        "Hints": {
          "APALEO_CLIENTID": "Client-ID der individuellen App im Apaleo-Konto des Hotels (Apps → Verknüpfte Apps)",
          "APALEO_CLIENTSECRET": "Secret dieser App – vertraulich",
          "APALEO_PROPERTYID": "Kürzel des Hotels in Apaleo, z. B. VIE"
        }
      }
    },
    "FoodNotify": {
      "Title": "FoodNotify",
      "Settings": {
        "Title": "Einstellungen",
        "Hint": "Standort-ID und API-Key bekommst du von FoodNotify. Ist die Integration aktiviert, gehen Artikelstamm und Verkäufe ab dem Zeitpunkt der Aktivierung an FoodNotify.",
        "AccountIdentifier": "FoodNotify-Standort-ID",
        "ApiKey": "API-Key",
        "SaveBeforeActivating": "Speichere zuerst die FoodNotify-Standort-ID und den API-Key.",
        "ErrorLoading": "Einstellungen konnten nicht geladen werden",
        "ErrorChanging": "Einstellungen konnten nicht geändert werden",
        "Changed": {
          "Title": "Einstellungen geändert",
          "Description": "Die Einstellungen wurden erfolgreich geändert."
        }
      },
      "ShrinkageReasons": {
        "Title": "Stornogründe",
        "Hint": "Ist ein Stornogrund als Schwund markiert, gilt die damit stornierte Ware bei FoodNotify als verbraucht: Bei einer stornierten Rechnung wird sie nicht ins Lager zurückgebucht, ein Storno am Tisch wird als Verbrauch ohne Umsatz gemeldet. Die Markierung gilt für Stornos ab dem Speichern. Standardmäßig ist kein Grund Schwund.",
        "Shrinkage": "Schwund in FoodNotify",
        "ErrorChanging": "Stornogründe konnten nicht geändert werden",
        "Changed": {
          "Title": "Stornogründe geändert",
          "Description": "Die Stornogründe wurden erfolgreich geändert."
        }
      }
    }
  },
  "Download": {
    "Error": "Download fehlgeschlagen"
  },
  "Users": {
    "Title": "Benutzer",
    "User": "Benutzer",
    "Email": "E-Mail",
    "Confirmed": "Bestätigt",
    "NotConfirmed": "Nicht bestätigt",
    "SendConfirmationLink": {
      "Title": "Bestätigungslink senden",
      "Success": {
        "Title": "E-Mail gesendet",
        "Description": "E-Mail zum Bestätigen des Benutzers <b>{0}</b> wurde versendet."
      },
      "Error": "E-Mail konnte nicht gesendet werden"
    },
    "ResetPassword": {
      "Title": "Passwort zurücksetzen",
      "Success": {
        "Title": "E-Mail gesendet",
        "Description": "E-Mail zum Zurücksetzen des Passworts für den Benutzer <b>{0}</b> wurde versendet."
      },
      "Error": "Passwort konnte nicht zurückgesetzt werden"
    },
    "Name": "Name",
    "Language": "Sprache",
    "Enterprises": "Betriebe",
    "ActiveInactive": "Aktiv/Inaktiv",
    "Activated": {
      "Success": {
        "Title": "Benutzer aktiviert",
        "Description": "Der Benutzer <b>{0}</b> wurde erfolgreich aktiviert."
      },
      "Error": "Benutzer konnte nicht aktiviert werden"
    }
  },
  "DeactivateUserDialog": {
    "Title": "Benutzer deaktivieren",
    "Description": "Willst du den Benutzer <b>{0}</b> wirklich deaktivieren?",
    "Success": {
      "Title": "Benutzer deaktiviert",
      "Description": "Der Benutzer <b>{0}</b> wurde erfolgreich deaktiviert."
    },
    "Error": "Benutzer konnte nicht deaktiviert werden"
  },
  "Tutorials": {
    "Categories": {
      "Title": "Kategorien",
      "All": "Alle"
    },
    "Title": "Erklärvideos",
    "Tutorial": "Erklärvideo",
    "SearchBarPlaceholder": "Videos suchen...",
    "ErrorLoading": "Erklärvideos konnten nicht geladen werden",
    "Views": "Aufrufe"
  },
  "DeleteTutorialDialog": {
    "Title": "Erklärvideo löschen",
    "Description": "Willst du das Erklärvideo <b>{0}</b> wirklich löschen?",
    "Success": {
      "Title": "Erklärvideo gelöscht",
      "Description": "Das Erklärvideo <b>{0}</b> wurde erfolgreich gelöscht."
    },
    "Error": "Erklärvideo konnte nicht gelöscht werden"
  },
  "TutorialDialog": {
    "Title": {
      "Create": "Erklärvideo erstellen",
      "Edit": "Erklärvideo bearbeiten"
    },
    "Create": {
      "Success": {
        "Title": "Erklärvideo erstellt",
        "Description": "Das Erklärvideo <b>{0}</b> wurde erfolgreich erstellt."
      },
      "Error": "Erklärvideo konnte nicht erstellt werden",
      "UploadVideo": "Video hochladen",
      "UploadThumbnail": "Vorschaubild hinzufügen"
    },
    "Edit": {
      "Success": {
        "Title": "Erklärvideo bearbeitet",
        "Description": "Das Erklärvideo <b>{0}</b> wurde erfolgreich bearbeitet."
      },
      "Error": "Erklärvideo konnte nicht bearbeitet werden",
      "RemoveThumbnail": "Vorschaubild entfernen"
    },
    "UploadVideo": "Video hochladen",
    "UploadFailed": "Erklärvideo konnte nicht hochgeladen werden",
    "Category": "Kategorie",
    "VideoTitle": "Titel",
    "Description": "Beschreibung"
  },
  "LippPOSDialog": {
    "Title": "Lipp POS abonnieren",
    "StartTitle": "Lipp POS starten",
    "ExpandTitle": "Lipp POS erweitern",
    "ReduceTitle": "Lipp POS reduzieren",
    "ExpandAction": "Erweitern",
    "ReduceAction": "Reduzieren",
    "Tabs": {
      "Workstations": "Arbeitsplätze",
      "Extensions": "Erweiterungen",
      "Integrations": "Integrationen"
    },
    "Addons": {
      "Title": "Leistungen",
      "Total": "Leistungen {0} / Monat",
      "BasePrice": "Basispreis",
      "AdditionalWorkstations": "Weitere Lipp POS Arbeitsplätze",
      "Integrations": "Integrationen",
      "Extensions": "Erweiterungen",
      "Additional": "Zusätzlich",
      "Services": {
        "1": "Kassensoftware Gastro & Handel",
        "2": "Cloudsicherung",
        "3": "Erklärvideos",
        "4": "365 Tage Kundensupport",
        "5": "Erstinstallation vor Ort"
      },
      "IntegrationsInUse": "Deaktiviere zuerst aktive Integrationen.",
      "ExtensionsInUse": "Deaktiviere zuerst aktive Erweiterungen."
    },
    "LippCare": {
      "Title": "All-In-Sorglos-Paket",
      "Total": "All-In-Sorglos-Paket {0} / Monat"
    },
    "Summary": {
      "Title": "Zusammenfassung",
      "Total": "Gesamt {0} / Monat",
      "TotalLabel": "Gesamt",
      "Before": "Vorher",
      "After": "Nachher",
      "CountWithPrice": "{0}x — {1} / Monat"
    },
    "Workstations": {
      "Title": "Arbeitsstationen & Lizenzen",
      "ActiveOfTarget": "{0} von {1} Lizenzen aktiv",
      "OverflowHint": "Deaktiviere zuerst eine oder mehrere Lizenzen, um mit der Reduktion fortzufahren."
    },
    "Extensions": {
      "Title": "Aktive Erweiterungen",
      "Name": "Erweiterung",
      "Active": "Aktiv",
      "ActiveOfTarget": "{0} von {1} Erweiterungen aktiv",
      "ToggleError": "Erweiterung konnte nicht umgeschaltet werden"
    },
    "Integrations": {
      "Title": "Aktive Integrationen",
      "Name": "Integration",
      "Active": "Aktiv",
      "ActiveOfTarget": "{0} von {1} Integrationen aktiv",
      "ToggleError": "Integration konnte nicht umgeschaltet werden"
    },
    "PricePerMonth": "{0} / Monat",
    "PaymentStart": "Zahlungsstart",
    "Prepare": {
      "Success": {
        "Title": "Lipp POS abonniert",
        "Description": "Lipp POS wurde erfolgreich abonniert."
      },
      "Error": "Lipp POS konnte nicht abonniert werden"
    },
    "Update": {
      "Success": {
        "Title": "Lipp POS geändert",
        "Description": "Lipp POS wurde erfolgreich geändert."
      },
      "Error": "Lipp POS konnte nicht geändert werden"
    },
    "Activate": {
      "Success": {
        "Title": "Lipp POS aktiviert",
        "Description": "Lipp POS wurde erfolgreich aktiviert."
      },
      "Error": "Lipp POS konnte nicht aktiviert werden"
    }
  },
  "LippPMSDialog": {
    "Title": "Lipp PMS abonnieren",
    "StartTitle": "Lipp PMS starten",
    "ExpandTitle": "Lipp PMS ändern",
    "UpdateAction": "Ändern",
    "Tabs": {
      "Rooms": "Zimmer",
      "Integrations": "Integrationen und Erweiterungen",
      "Summary": "Zusammenfassung"
    },
    "Rooms": {
      "Title": "Zimmer",
      "ActiveInPms": "Aktiv im PMS: {0}",
      "ActiveInPmsUnavailable": "Aktive Zimmer im PMS gerade nicht abrufbar. Senken ist deshalb gesperrt.",
      "ActiveInPmsLoading": "Aktive Zimmer im PMS werden geladen …"
    },
    "Integrations": {
      "Title": "Integrations-Slots",
      "InUse": "{0} Slots sind belegt. Zum Senken zuerst Integrationen freigeben."
    },
    "Extensions": {
      "Title": "Erweiterungs-Slots",
      "InUse": "{0} Slots sind belegt. Zum Senken zuerst Erweiterungen freigeben."
    },
    "BasePrice": "Lipp PMS Basissoftware",
    "PricePerRoom": "{0} je Zimmer und Monat",
    "PricePerSlot": "{0} je Slot und Monat",
    "PricePerMonth": "{0} / Monat",
    "Included": {
      "Title": "Im Grundpreis enthalten",
      "Backup": "Cloudsicherung",
      "Videos": "Erklärvideos",
      "Support": "365 Tage Kundenservice",
      "Installation": "Erstinstallation",
      "Fiscal": "RKSV oder TSE"
    },
    "Summary": {
      "Total": "Gesamt {0} / Monat",
      "TotalLabel": "Gesamt",
      "Before": "Vorher",
      "After": "Nachher",
      "CountWithPrice": "{0}x, {1} / Monat"
    },
    "Prepare": {
      "Success": {
        "Title": "Lipp PMS abonniert",
        "Description": "Lipp PMS wurde erfolgreich abonniert."
      },
      "Error": "Lipp PMS konnte nicht abonniert werden"
    },
    "Update": {
      "Success": {
        "Title": "Lipp PMS geändert",
        "Description": "Lipp PMS wurde erfolgreich geändert."
      },
      "Error": "Lipp PMS konnte nicht geändert werden"
    },
    "Activate": {
      "Success": {
        "Title": "Lipp PMS aktiviert",
        "Description": "Lipp PMS wurde erfolgreich aktiviert."
      },
      "Error": "Lipp PMS konnte nicht aktiviert werden"
    }
  },
  "LippPOSPaymentDialog": {
    "Title": "Lipp POS abonnieren",
    "BasePrice": "Basispreis",
    "PricePerMonth": " {0} € / Monat",
    "AdditionalWorkstations": "Weitere Lipp POS Arbeitsplätze",
    "Rksv2017": "§ RKSV 2017 (Signierung)",
    "AllInCarefreePackage": "All-in-Sorglos-Paket",
    "ChoosePaymentInterval": "Zahlungsintervall auswählen",
    "Yearly": "jährlich",
    "ThreeYearsBinding": "(3 Jahre Bindung)",
    "FiveYearsBinding": "(5 Jahre Bindung)",
    "PaymentStart": "Zahlungsstart",
    "SubscribeWithCosts": "Kostenpflichtig abonnieren"
  },
  "LippCare": {
    "Devices": {
      "Title": "Geräte",
      "CashSystems": "Kassensysteme",
      "Printers": "Drucker",
      "MobileDevices": "Mobile Geräte",
      "ArticleNumber": "Artikelnummer",
      "Name": "Bezeichnung",
      "SerialNumber": "SN",
      "Return": "Retoure",
      "NextReplacement": "Nächster 5-Jahres-Austausch",
      "ErrorLoading": "Geräte konnten nicht geladen werden"
    },
    "History": {
      "Title": "Historie",
      "Balance": "Saldo",
      "5YearReturn": "5-Jahres-Austausch",
      "ErrorLoading": "Historie konnten nicht geladen werden",
      "ErrorLoadingInvoice": "Rechnung konnten nicht geladen werden"
    },
    "Dialogs": {
      "ReturnDevice": {
        "Title": "Retoure erstellen",
        "Description": "Willst du wirklich eine Retoure für das Gerät <b>{0}</b> mit der Seriennummer <b>{1}</b> erstellen?",
        "Return": "Retoure erstellen",
        "Success": {
          "Title": "Retoure erstellt",
          "Description": "Die Retoure für das Gerät <b>{0}</b> mit der Seriennummer <b>{1}</b> wurde erfolgreich erstellt."
        },
        "Error": "Retoure konnte nicht erstellt werden"
      },
      "LippCareSelection": {
        "Title": "Lipp Care Auswahl",
        "ExpandTitle": "Lipp Care erweitern",
        "ReduceTitle": "Lipp Care reduzieren",
        "ExpandAction": "Erweitern",
        "ReduceAction": "Reduzieren",
        "ErrorLoadingProducts": "Produkte konnten nicht geladen werden",
        "PosSystems": "Kassensysteme/Küchen- & Schankmonitore",
        "Printer": "Drucker",
        "Handhelds": "Handhelds",
        "SumPerMonth": "Gesamt {0} / Monat",
        "Discount": "Nachlass",
        "PricePerMonth": "= {0} / Monat",
        "Confirm": "Bestätigen",
        "SelectedCountPrice": "{0} ausgewählt {1} / Monat",
        "DefaultPrice": "{0} / Monat pro Gerät",
        "Tabs": {
          "CashSystem": "Kassensysteme",
          "Printer": "Drucker",
          "Mobile": "Handhelds",
          "Summary": "Zusammenfassung"
        },
        "Summary": {
          "Before": "Vorher",
          "After": "Nachher",
          "CountWithPrice": "{0}x — {1} / Monat",
          "TotalLabel": "Gesamt"
        },
        "Devices": {
          "Title": "Geräte",
          "ArticleNumber": "Artikelnummer",
          "ArticleDescription": "Bezeichnung",
          "SerialNumber": "Seriennummer",
          "MarkForReturn": "Retoure markieren",
          "MarkedForReturn": "Für Retoure vorgemerkt",
          "MarkedInCategory": "{0} für Retoure markiert"
        },
        "Success": {
          "ActivationTitle": "Lipp Care vorbereitet",
          "ActivationSubject": "Lipp Care wurde erfolgreich vorbereitet.",
          "UpdateTitle": "Lipp Care geändert",
          "UpdateSubject": "Lipp Care wurde erfolgreich geändert.",
          "ReduceTitle": "Lipp Care reduziert",
          "ReduceSubject": "{0} Gerät(e) wurden für die Retoure vorgemerkt."
        },
        "Error": {
          "Title": "Lipp Care konnte nicht abonniert werden"
        }
      },
      "LippCareSubscription": {
        "Title": "Lipp Care abonnieren",
        "AllInCarefreePackage": "All-in-Sorglos-Paket",
        "PricePerMonth": " {0} / Monat",
        "ChoosePaymentInterval": "Zahlungsintervall auswählen",
        "PaymentStart": "Zahlungsstart",
        "SubscribeWithCosts": "Kostenpflichtig abonnieren",
        "Yearly": "jährlich",
        "ThreeYearsBinding": "(3 Jahre Bindung)",
        "FiveYearsBinding": "(5 Jahre Bindung)",
        "BasePrice": "{0}x Basispreis",
        "FurtherWorkstations": "{0}x Weitere Lipp POS Arbeitsplätze",
        "RKSV": "{0}x § RKSV 2017 (Signierung)",
        "Success": {
          "Title": "Lipp Care abonniert",
          "Description": "Lipp Care wurde erfolgreich abonniert."
        },
        "Error": {
          "Title": "Lipp Care konnte nicht abonniert werden"
        }
      }
    },
    "EnterpriseNotAllowedForTests": {
      "Title": "Betrieb nicht zugelassen für Lipp Care",
      "Description": "Nur Betriebe mit Kundennummer <b>{0}</b> sind erlaubt für Tests in Dev & Staging."
    },
    "Errors": {
      "ErrorLoadingLippCareDevices": "Fehler beim Laden der Lipp Care Geräte."
    }
  },
  "RKSVDialog": {
    "Title": "RKSV 2017 abonnieren",
    "Basic": "Basic",
    "Advanced": "Advanced",
    "Premium": "Premium",
    "Per5Years": "{0} € / 5 Jahre",
    "BasicDescription": "Bis zu 10.000 Signaturen / Jahr",
    "AdvancedDescription": "Bis zu 30.000 Signaturen / Jahr",
    "PremiumDescription": "Unbegrenzte Signaturen",
    "SelectPaymentInterval": "Zahlungsintervall auswählen",
    "OneTimePayment": "Einmalig (Für die nächsten 5 Jahre)",
    "SubscribeWithCosts": "Kostenpflichtig abonnieren"
  },
  "CreateVersion": {
    "Title": "Update erstellen",
    "UpdateTitle": "Update bearbeiten",
    "VersionTitle": "Titel",
    "Headline": "Überschrift",
    "Description": "Beschreibung",
    "CreateEntry": "Eintrag hinzufügen",
    "SelectType": "Typ wählen",
    "News": "Neuigkeit",
    "BugFix": "Fehlerbehebung",
    "Info": "Information",
    "Button": "Button",
    "ButtonSettings": "Buttoneinstellungen",
    "ButtonText": "Button-Text",
    "ButtonLink": "Button-Link",
    "PublishNow": "Jetzt veröffentlichen",
    "Create": "Erstellen",
    "Edit": "Bearbeiten",
    "Category": "Kategorie",
    "Version": "Version",
    "FromVersion": "Ab 0.0.0",
    "StorjKey": "Storj Key",
    "File": "Datei",
    "Type": "Typ",
    "Discover": "Entdecken",
    "ExplanatoryVideo": "Erklärvideo",
    "Link": "Link"
  },
  "DeleteVersionDialog": {
    "Title": "Version löschen",
    "Description": "Willst du die Version <b>{0}</b> wirklich löschen?",
    "Delete": "Löschen"
  },
  "VersionOverview": {
    "Title": "Es gibt Neuigkeiten!",
    "UpdateHistory": "Updateverlauf",
    "Ready": "Gelesen und los geht's!"
  },
  "Updates": {
    "CreateUpdate": "Update erstellen",
    "Updates": "Updates",
    "NewsAndImprovements": "Neuigkeiten & Verbesserungen",
    "PublishUpdate": "Update veröffentlichen",
    "LoadingError": "Fehler beim Laden der Versionen.",
    "Discover": "Entdecken",
    "ExplanatoryVideo": "Erklärvideo"
  },
  "InputPlaceholders": {
    "CharsPlaceholder": "{0}-{1} Zeichen",
    "MinCharsPlaceholder": "min. {0} Zeichen"
  },
  "Marketplace": {
    "Subscriptions": {
      "Title": "Abonnements",
      "Subscription": "Abonnement",
      "Quantity": "Anzahl",
      "Module": "Abonnement",
      "Description": "Beschreibung",
      "TotalPriceNet": "Gesamtpreis netto",
      "PriceInfo": "Preisinfo",
      "PaymentInterval": "Zahlungsintervall",
      "PaymentMethod": "Zahlungsmethode",
      "Note": "Anmerkung",
      "ErrorLoading": "Abonnements konnten nicht geladen werden",
      "ChangeLicenceQuantityDisabledTooltip": "Um die Lizenzmenge ändern zu können, muss das Abonnement vorerst gekündigt und erneut mit der gewünschten Menge lizenziert werden.",
      "PaymentIntervals": {
        "Once": "einmalig",
        "Daily": "täglich",
        "Monthly": "monatlich",
        "Yearly": "jährlich",
        "YearsCommitment": "jährlich ({0} Jahre Bindung)",
        "SeasonalWithMonths": "saisonell ({0} Monate)"
      },
      "FromDate": "ab {0}",
      "PerUnit": "pro {0}",
      "Units": {
        "Hour": "Stunde",
        "SMS": "SMS",
        "Report": "Bericht",
        "POS": "Kassa",
        "Device": "Gerät",
        "5Years": "5 Jahre",
        "Station": "Standort"
      },
      "TrialUntil": "Kostenlos bis {0}",
      "AvailableUntil": "{0}x {1} verfügbar bis {2}",
      "DeactivationOn": "Deaktivierung am {0}",
      "ActivationOn": "Aktivierung am {0}",
      "CertificateRenewedOn": "Zertifikat wird erneuert am {0}",
      "PaymentPending": "Zahlung ausstehend",
      "WaitingForPaymentReceipt": "Warten auf Zahlungseingang",
      "PaymentBy": "Zahlung via {0}",
      "PaymentMethods": {
        "0": "Unbekannt",
        "1": "Kreditkarte",
        "2": "S€PA",
        "3": "Hogast",
        "9999": "manueller Abbuchung"
      },
      "PrepareForActivation": "Bereit zur Zahlung",
      "Scheduled": "Geplant",
      "PendingDeactivation": "Deaktivierung ausstehend",
      "PaymentFailed": "Zahlung fehlgeschlagen",
      "Deactivated": "Deaktiviert",
      "Suspended": "Aufgeschoben",
      "Expired": "Ausgelaufen",
      "SwitchToManualPayment": "Auf manuelle Zahlung umstellen",
      "SwitchedToManualPayment": {
        "Success": {
          "Title": "Zahlung umgestellt",
          "Description": "Die Zahlung wurde erfolgreich auf manuelle Abbuchung umgestellt."
        },
        "Error": "Zahlung konnte nicht umgestellt werden"
      },
      "AddPaymentMethodTooltip": "Bitte Zahlungsmethode hinzufügen!",
      "ErrorLoadingPaymentMethods": "Zahlungmethoden konnten nicht geladen werden",
      "AddPaymentMethod": "Bitte <u>Zahlungsmethode</u> hinzufügen!",
      "ErrorRedirectingToCheckout": "Weiterleitung zur Zahlung fehlerhaft",
      "CancelSubscriptions": "Abonnements kündigen",
      "Device": "{0} Gerät",
      "Devices": "{0} Geräte"
    },
    "Log": {
      "Title": "Änderungsprotokoll",
      "ModuleName": "Abonnement",
      "Description": "Beschreibung",
      "InternalNotes": "Interne Notizen",
      "User": "Benutzer",
      "DateTime": "Datum/Uhrzeit"
    },
    "Lipp": {
      "Title": "Lipp"
    },
    "Integrations": {
      "Title": "Integrationen",
      "ManageLicences": "Lizenzen verwalten",
      "NoLicenseRequired": "Benötigt keine Integrationslizenz",
      "Categories": {
        "All": "Alle",
        "Accounting": "Finanzbuchhaltung",
        "Vouchers": "Gutscheinverwaltung",
        "HotelSoftware": "Hotelsoftware",
        "CardPayment": "Kartenzahlung",
        "CashDrawer": "Kassenlade",
        "WaiterLock": "Kellnerschloss",
        "CustomerDisplay": "Kundendisplay",
        "CustomerCards": "Kundenkarten",
        "DispensingSystem": "Schankanlage",
        "InventoryManagement": "Warenwirtschaft",
        "ChannelManager": "Channel Manager",
        "GuestLoyalty": "Gästebindung",
        "POS": "Kassensystem",
        "Correspondence": "Korrespondenz",
        "GuestRegistration": "Meldewesen",
        "RevenueManagement": "Revenue Management",
        "AccessControl": "Zutrittssysteme"
      },
      "LippPMS": {
        "Title": "Lipp PMS",
        "SlotsInUseSingular": "{0} von {1} Slot belegt",
        "SlotsInUsePlural": "{0} von {1} Slots belegt",
        "ManageSlots": "Slots verwalten",
        "NotBookedTitle": "Für diese Integrationen brauchst du Lipp PMS.",
        "NotBookedDescription": "Die Integrationen für dein Hotel hängen am Lipp-PMS-Abo. Sobald Lipp PMS gebucht ist, kannst du sie hier aktivieren.",
        "Book": "Lipp PMS buchen",
        "RequiresBase": "Braucht Lipp PMS",
        "NotAvailableTitle": "Lipp PMS nicht verfügbar",
        "NotAvailableDescription": "Lipp PMS kann für diese Station gerade nicht gebucht werden. Bitte melde dich beim Lipp-Support."
      }
    },
    "Extensions": {
      "Title": "Erweiterungen",
      "ManageLicences": "Lizenzen verwalten",
      "LippPMS": {
        "Title": "Lipp PMS",
        "NotBookedTitle": "Für diese Erweiterungen brauchst du Lipp PMS.",
        "NotBookedDescription": "Die Erweiterungen für dein Hotel hängen am Lipp-PMS-Abo. Sobald Lipp PMS gebucht ist, kannst du sie hier aktivieren."
      }
    },
    "SetupRequired": {
      "Title": "Lipp POS muss zuerst eingerichtet werden.",
      "DescriptionExtensions": "Sobald die Einrichtung deiner Lipp POS abgeschlossen ist, siehst du hier alle für deine Version verfügbaren Erweiterungen.",
      "DescriptionIntegrations": "Sobald die Einrichtung deiner Lipp POS abgeschlossen ist, siehst du hier alle für deine Version verfügbaren Integrationen.",
      "GoToSetup": "Zur Einrichtung"
    },
    "Shop": {
      "Title": "Shop"
    }
  },
  "CancelSubscriptionsDialog": {
    "Title": "Abonnements kündigen",
    "Warning": "Auf Inhalte von gekündigten Abonnements kann nicht mehr zugegriffen werden!",
    "Error": "Abonnements konnten nicht gekündigt werden",
    "Cancel": "Kündigen",
    "CancellationDate": "per {0}"
  },
  "UnsavedChanges": {
    "Title": "Seite verlassen?",
    "Description": "Du hast ungespeicherte Änderungen. Seite wirklich verlassen?"
  },
  "CrossEnterpriseVouchers": {
    "Title": "Gutscheinverwaltung",
    "StationName": "Betrieb",
    "CustomerName": "Kunde",
    "NoVoucherGroup": "Keiner deiner Betriebe ist in einem Verbund mit gemeinsamer Gutscheinverwaltung.",
    "ErrorLoading": "Die Verbünde konnten nicht geladen werden.",
    "NoShopStation": "Keiner deiner Betriebe in diesem Verbund hat die Gutscheinverwaltung aktiv – den Online-Gutscheinverkauf gibt es nur dort.",
    "ShopVersion": "Der Online-Gutscheinverkauf braucht an „{0}“ Lipp POS 1.38.0 oder neuer (gemeldet: {1}).",
    "VersionUnknown": "unbekannt"
  },
  "CrossEnterpriseUsers": {
    "NotAvailableYet": "Die Benutzer der Standorte lassen sich hier erst nach dem nächsten Update von Lipp Connect zuweisen.",
    "NoEntries": "Keine Einträge",
    "Active": "Aktiv",
    "PermissionRoleDiffers": "unterschiedlich",
    "AddToStation": "An diesem Standort anlegen",
    "ActiveAt": "Aktiv an: {0}",
    "InactiveEverywhere": "An keinem Standort aktiv",
    "SearchPlaceholder": "Suchen...",
    "NotUnique": "Nicht eindeutig – nur auf der Seite des Standorts zu pflegen",
    "NotUniqueIn": "mehrfach in {0}",
    "ErrorLoading": "Die Benutzer der Standorte konnten nicht geladen werden.",
    "ErrorLoadingRetry": "Die Benutzer der Standorte konnten nicht geladen werden. Zuweisen geht erst wieder nach „Aktualisieren“.",
    "ErrorSaving": "Die Zuweisung konnte nicht gespeichert werden.",
    "SavePartlyFailed": "Nicht an allen Standorten gespeichert",
    "Dialog": {
      "Title": "Standorte zuweisen – {0}",
      "ConfirmTitle": "Zuweisung übernehmen – {0}",
      "Station": "Standort",
      "NotCreated": "nicht angelegt",
      "WillBeCreated": "wird angelegt",
      "ConfirmDescription": "Beim Übernehmen ändert sich je Standort:",
      "NoChanges": "Nichts zu ändern – der Stand ist an den Standorten schon so.",
      "Created": "Wird angelegt, Berechtigungsrolle {0}",
      "Activated": "Wird aktiv",
      "Deactivated": "Wird inaktiv",
      "RoleChanged": "Berechtigungsrolle {0} → {1}",
      "WaiterLockHint": "Den Kellnerschlüssel einmal an der Kasse dieses Standorts zuweisen.",
      "Apply": "Übernehmen"
    }
  },
  "CrossEnterpriseArticles": {
    "HasDeviations": "Die Standorte unterscheiden sich bei diesem Artikel, z. B. beim Preis oder den Druckern.",
    "MixedIsActive": "In den Standorten unterschiedlich. Ein Klick aktiviert ihn überall.",
    "OtherArticles": {
      "NotEditable": "{0} Artikel nicht in allen Standorten gleich (Typ, Warengruppe, Nummer, Bezeichnung) – hier nicht bearbeitbar",
      "NotSelectable": "{0} Artikel nicht in allen Standorten gleich (Typ, Warengruppe, Nummer, Bezeichnung) – nicht wählbar",
      "Show": "Anzeigen",
      "Hide": "Ausblenden"
    },
    "MoreNotShown": "… und {0} weitere – über die Suche eingrenzen",
    "MoreCount": "… und {0} weitere",
    "ImageNumber": "Bild {0}",
    "ArticleNotInAllStations": "Diesen Artikel gibt es nicht in allen gewählten Standorten gleich. Bearbeiten geht nur auf der Seite des Standorts.",
    "ErrorLoadingRetry": "Der Vergleich der Standorte konnte nicht geladen werden. Bearbeiten geht erst wieder nach „Aktualisieren“.",
    "Reload": "Neu laden",
    "MissingIn": "fehlt in",
    "DifferentIn": "weicht ab in",
    "DifferentValue": "{0} „{1}“",
    "DifferentTypeOrTax": "Typ oder Steuersatz/Umsatzgruppe der Warengruppe",
    "LockedAddon": "Diesen Artikel gibt es nicht in allen Standorten gleich. Die Folgeposition bleibt in jedem Standort, wie sie ist, auch Folge und Reihenfolge.",
    "LockedPackageItem": "Enthält einen Artikel, den es nicht in allen Standorten gleich gibt, und bleibt deshalb in jedem Standort, wie er ist. Ändern geht nur auf der Seite des Standorts.",
    "ErrorLoading": "Die Artikel der Standorte konnten nicht geladen werden.",
    "ErrorChangingIsActive": "Der Artikel konnte nicht in allen Standorten umgestellt werden.",
    "SavePartlyFailed": "Nicht in allen Standorten gespeichert",
    "Layout": {
      "Deviations": "Die Standorte unterscheiden sich. Beim Speichern erhalten alle Standorte dieses Profil:",
      "OnlyInOtherStations": "{0}: nur in {1}, bleibt dort unverändert",
      "DeleteInAllStations": "Sie wird in allen gewählten Standorten gelöscht: {0}",
      "ProfilesNotInAllStations": "Nicht wählbar, weil nicht in jedem Standort genau einmal vorhanden: {0}. Fehlt eine Layoutgruppe in einem Standort, mit „+“ neben der Layoutgruppe unter demselben Namen anlegen; gibt es sie dort doppelt, auf der Seite des Standorts eine davon umbenennen.",
      "ProfileConcerns": "betrifft: {0}"
    },
    "Dialog": {
      "Deviations": "Die Standorte unterscheiden sich. Beim Speichern erhalten alle Standorte die Werte aus diesem Dialog.",
      "DeviationsDetails": "Unterschiede (werden beim Speichern überschrieben)",
      "NotInAllStationsDetails": "Nicht in allen Standorten vorhanden (bleibt je Standort unverändert)",
      "NotInAllStations": "Nicht alle Warengruppen, Gänge, Drucker und Preislisten gibt es in allen Standorten; diese sind nicht wählbar."
    },
    "Confirm": {
      "Title": "In allen Standorten übernehmen?",
      "Description": "Beim Speichern ändert sich je Standort:",
      "NoChanges": "keine Änderung",
      "Apply": "Übernehmen"
    },
    "Fields": {
      "Name": "Bezeichnung",
      "Number": "Art.-Nr.",
      "Description": "Beschreibung",
      "Image": "Bild",
      "CommodityGroup": "Warengruppe",
      "PriceGross": "Preis",
      "PriceLists": "Preislisten",
      "Costs": "Einkaufspreis",
      "MarkupPercent": "Aufschlag",
      "IsNegative": "Vorzeichen",
      "Course": "Gang",
      "Printers": "Drucker",
      "Barcodes": "Barcodes",
      "TextEntryForBooking": "Texteingabe beim Buchen",
      "PriceEntryForBooking": "Preiseingabe beim Buchen",
      "ExternalDocumentNumberEntryForBooking": "Fremdbelegnummer beim Buchen",
      "IsDiscountable": "Ermäßigungsfähig",
      "IsIncludedInParentPrice": "Im Preis des Hauptartikels enthalten",
      "Addons": "Folgepositionen",
      "Package": "Paketbestandteile",
      "ProductionTimes": "Zubereitungszeiten",
      "Deposit": "Pfand",
      "Weight": "Gewicht",
      "IsActive": "Aktiv",
      "LayoutItems": "Kacheln in der Buchungsmaske",
      "LayoutGroupCreated": "Hauptgruppe neu",
      "LayoutGroupChanged": "Hauptgruppe überschrieben",
      "LayoutGroupDeleted": "Hauptgruppe gelöscht",
      "LayoutTilesEmpty": "Kacheln ohne passenden oder aktiven Artikel (bleiben leer)",
      "LayoutTilesReplaced": "Kacheln, die nur dieser Standort so hat (werden ersetzt oder entfernt)"
    }
  },
  "CrossEnterpriseLippPOS": {
    "SelectEnterprise": "Betrieb auswählen",
    "Stations": "Standorte",
    "All": "Alle",
    "Lists": {
      "NoCommonReport": "Keine Vorlage ist an allen gewählten Standorten vorhanden.",
      "StationsWithoutReport": "Nicht auswählbar, keine Vorlage für diese Liste gefunden: {0}",
      "StationsWithoutMatch": "Ohne Treffer für die Kriterien, nicht im Dokument: {0}",
      "ErrorLoadingCriteria": "Kriterien konnten nicht geladen werden"
    },
    "BMDExport": {
      "Title": "Export",
      "Export": "Exportieren",
      "Error": "BMD-Export konnte nicht erstellt werden",
      "ErrorLoadingSettings": "Einstellungen konnten nicht geladen werden",
      "NoSettingsSavedYet": "Es wurden noch keine BMD-Einstellungen für die Standorte <b>{0}</b> gespeichert.",
      "LatestExportInfo": "Zuletzt exportiert von <b>{0}</b> am <b>{1}</b> um <b>{2}</b>"
    }
  },
  "Vouchers": {
    "Title": "Gutscheine",
    "CreateVoucher": "Gutschein erstellen",
    "Status": {
      "Active": "Aktiv",
      "Open": "Offen",
      "Redeemed": "Eingelöst",
      "Canceled": "Storniert"
    },
    "Grid": {
      "Description": "Bezeichnung",
      "Number": "Nummer",
      "Date": "Datum",
      "Creator": "Ersteller",
      "Amount": "Betrag",
      "RemainingAmount": "Offen",
      "Status": "Status"
    },
    "Templates": {
      "Title": "Gutscheinvorlagen",
      "Grid": {
        "Name": "Bezeichnung",
        "IsActive": "Aktiv"
      }
    },
    "ErrorLoading": "Gutscheine konnten nicht geladen werden",
    "ErrorLoadingTemplates": "Gutscheinvorlagen konnten nicht geladen werden"
  },
  "Stripe": {
    "Error": "Fehler bei Zahlungsanbieter",
    "ErrorLoading": "Stripe konnte nicht geladen werden.",
    "NotInitialized": "Stripe wurde noch nicht initialisiert."
  },
  "CancellationReasons": {
    "0": "Kundenanfrage",
    "1": "Aufhebung des Vertrags",
    "2": "Doppelte Zahlung",
    "3": "Produkt nicht zufriedenstellend",
    "4": "Änderung der Bestellung",
    "5": "Betrügerische Zahlung",
    "6": "Angefochtene Zahlung",
    "99": "Sonstiges"
  },
  "Lipp": {
    "Abstractions": {
      "Messages": {
        "NoQuantityChangeMessage": "Anzahl wurde nicht geändert.",
        "EnterpriseAdministrationNotPermittedMessage": "Du darfst den Betrieb {0} nicht verwalten.",
        "SeasonalRequiresStripeProductMessage": "Saisonale Buchung erfordert ein verknüpftes Stripe-Produkt am Modul {0}.",
        "SeasonalRequiresMonthlyBasePriceMessage": "Saisonale Buchung erfordert einen monatlichen Basispreis am Modul {0}.",
        "SeasonRangeMismatchMessage": "Aktive Monate ({0}) passen nicht zum Saisonbereich {1}–{2} (berechnet: {3}).",
        "SeasonalFieldsMissingMessage": "Saisonale Buchung erfordert aktive Monate, Saisonbeginn und Saisonende.",
        "SeasonalFieldsOutOfRangeMessage": "Aktive Monate (1–11), Saisonbeginn und Saisonende (1–12) müssen gültig sein. Start ≠ Ende."
      }
    }
  }
}
